webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(362);
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _index = __webpack_require__(330);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _timetravel = __webpack_require__(350);
	
	var _timetravel2 = _interopRequireDefault(_timetravel);
	
	var _App = __webpack_require__(714);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _PrettySelect = __webpack_require__(127);
	
	var _PrettySelect2 = _interopRequireDefault(_PrettySelect);
	
	var _GenericInput = __webpack_require__(269);
	
	var _GenericInput2 = _interopRequireDefault(_GenericInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('pretty-select', _PrettySelect2.default);
	_vue2.default.component('generic-input', _GenericInput2.default);
	
	window.eventBus = new _vue2.default();
	
	window.application = new _vue2.default({
	  store: _index2.default,
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});
	
	_timetravel2.default.init(_index2.default);
	
	var threeJSModuleScript = document.createElement('script');
	threeJSModuleScript.setAttribute('src', '3DViewer/libtest_lib.js');
	document.head.appendChild(threeJSModuleScript);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(369);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(57);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _toConsumableArray2 = __webpack_require__(38);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.ringEquals = ringEquals;
	exports.distanceBetweenPoints = distanceBetweenPoints;
	exports.fitToAspectRatio = fitToAspectRatio;
	exports.edgeDirection = edgeDirection;
	exports.haveSimilarAngles = haveSimilarAngles;
	exports.unitPerpVector = unitPerpVector;
	exports.unitVector = unitVector;
	exports.projectionOfPointToLine = projectionOfPointToLine;
	exports.pointDistanceToSegment = pointDistanceToSegment;
	exports.ptsAreCollinear = ptsAreCollinear;
	exports.repeatingWindowCenters = repeatingWindowCenters;
	exports.cleanInvalidPoly = cleanInvalidPoly;
	exports.vertInRing = vertInRing;
	exports.replaceIdsForCloning = replaceIdsForCloning;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(192);
	
	var turf = _interopRequireWildcard(_helpers);
	
	var _areaPolygon = __webpack_require__(276);
	
	var _areaPolygon2 = _interopRequireDefault(_areaPolygon);
	
	var _polygonClipping = __webpack_require__(703);
	
	var _booleanPointInPolygon = __webpack_require__(274);
	
	var _booleanPointInPolygon2 = _interopRequireDefault(_booleanPointInPolygon);
	
	var _utilities = __webpack_require__(102);
	
	var _generateId = __webpack_require__(55);
	
	var _generateId2 = _interopRequireDefault(_generateId);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toTurfPoly(vertices) {
	  var coords = vertices.map(function (v) {
	    return [v.x, v.y];
	  });
	  if (coords[0][0] !== coords[coords.length - 1][0] || coords[0][1] !== coords[coords.length - 1][1]) {
	    coords.push(coords[0]);
	  }
	  return turf.polygon([coords]);
	}
	
	function ringEqualsWithSameWindingOrder(vs, ws) {
	  var pivotVert = vs[0];
	  var pivotIx = _lodash2.default.findIndex(ws, _lodash2.default.pick(pivotVert, ['x', 'y']));
	
	  if (pivotIx === -1) return false;
	  var wsp = _lodash2.default.map([].concat((0, _toConsumableArray3.default)(ws.slice(pivotIx)), (0, _toConsumableArray3.default)(ws.slice(0, pivotIx))), function (w) {
	    return _lodash2.default.pick(w, ['x', 'y']);
	  });
	  return _lodash2.default.isEqualWith(vs, wsp, function (v, w) {
	    return _lodash2.default.isMatch(v, w);
	  });
	}
	
	function dropClosingVertex(vs) {
	  if (vs.length <= 3) return vs;
	  if (_lodash2.default.isEqual(vs[0], vs[vs.length - 1])) return vs.slice(0, -1);
	  return vs;
	}
	
	function ringEquals(vs_, ws_) {
	  if (vs_.length !== ws_.length) return false;
	  if (vs_.length === 0) return true;
	
	  var vs = dropClosingVertex(vs_);
	  var ws = dropClosingVertex(ws_);
	  return ringEqualsWithSameWindingOrder(vs, ws) || ringEqualsWithSameWindingOrder(vs, [].concat((0, _toConsumableArray3.default)(ws)).reverse());
	}
	
	function distanceBetweenPoints(p1, p2) {
	  var dx = p1.x - p2.x,
	      dy = p1.y - p2.y;
	  return Math.sqrt(dx * dx + dy * dy);
	}
	
	function fitToAspectRatio(xExtent, yExtent, widthOverHeight) {
	  var adjustToFit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'expand';
	
	  var xSpan = xExtent[1] - xExtent[0],
	      ySpan = yExtent[1] - yExtent[0],
	      xAccordingToY = ySpan * widthOverHeight,
	      yAccordingToX = xSpan / widthOverHeight,
	      xDiff = xAccordingToY - xSpan,
	      yDiff = yAccordingToX - ySpan;
	
	  if (xDiff > 0 === (adjustToFit === 'expand')) {
	    return {
	      xExtent: [xExtent[0] - xDiff / 2, xExtent[1] + xDiff / 2],
	      yExtent: yExtent
	    };
	  }
	  return {
	    xExtent: xExtent,
	    yExtent: [yExtent[0] - yDiff / 2, yExtent[1] + yDiff / 2]
	  };
	}
	
	function edgeDirection(_ref) {
	  var start = _ref.start,
	      end = _ref.end;
	
	  var deltaX = end.x - start.x,
	      deltaY = end.y - start.y;
	  return deltaX === 0 ? 0.5 * Math.PI : Math.atan(deltaY / deltaX);
	}
	
	function haveSimilarAngles(edge1, edge2) {
	  var angleDiff = edgeDirection(edge1) - edgeDirection(edge2),
	      correctedDiff = Math.min(Math.abs(angleDiff), Math.PI - angleDiff);
	  return correctedDiff < 0.05 * Math.PI;
	}
	function normalize(_ref2) {
	  var dx = _ref2.dx,
	      dy = _ref2.dy;
	
	  if (dx === 0 && dy === 0) {
	    return { dx: 0, dy: 0 };
	  }
	  var normalization = Math.sqrt(dx * dx + dy * dy);
	  return {
	    dx: dx / normalization,
	    dy: dy / normalization
	  };
	}
	function unitPerpVector(p1, p2) {
	  var dx = void 0,
	      dy = void 0;
	  if (p1.x !== p2.x) {
	    dy = 1;
	    dx = (p1.y - p2.y) / (p1.x - p2.x);
	  } else if (p1.y !== p2.y) {
	    dx = 1;
	    dy = (p1.x - p2.x) / (p1.y - p2.y);
	  } else {
	    dx = dy = 1;
	  }
	  return normalize({ dx: dx, dy: dy });
	}
	
	function unitVector(p1, p2) {
	  var dx = p2.x - p1.x,
	      dy = p2.y - p1.y;
	  return normalize({ dx: dx, dy: dy });
	}
	
	function projectionOfPointToLine(point, line) {
	  var _line$p = line.p1,
	      x1 = _line$p.x,
	      y1 = _line$p.y,
	      _line$p2 = line.p2,
	      x2 = _line$p2.x,
	      y2 = _line$p2.y;
	
	  var A = point.x - x1,
	      B = point.y - y1,
	      C = x2 - x1,
	      D = y2 - y1,
	      dot = A * C + B * D,
	      lenSq = C * C + D * D || 2,
	      param = dot / lenSq;
	
	  if (param <= 0) {
	    return line.p1;
	  } else if (param > 1) {
	    return line.p2;
	  }
	
	  return {
	    x: x1 + param * C,
	    y: y1 + param * D
	  };
	}
	
	function pointDistanceToSegment(pt, _ref3) {
	  var start = _ref3.start,
	      end = _ref3.end;
	
	  var proj = projectionOfPointToLine(pt, { p1: start, p2: end });
	  return {
	    dist: distanceBetweenPoints(pt, proj),
	    proj: proj
	  };
	}
	
	function ptsAreCollinear(p1, p2, p3) {
	  var _ref4 = [p1.x, p1.y],
	      a = _ref4[0],
	      b = _ref4[1],
	      _ref5 = [p2.x, p2.y],
	      m = _ref5[0],
	      n = _ref5[1],
	      x = p3.x,
	      y = p3.y;
	
	  return Math.abs((n - b) * (x - m) - (y - n) * (m - a)) < 0.00001;
	}
	
	function repeatingWindowCenters(_ref6) {
	  var start = _ref6.start,
	      end = _ref6.end,
	      spacing = _ref6.spacing,
	      width = _ref6.width;
	
	  var maxDist = distanceBetweenPoints(start, end),
	      centers = [],
	      direction = unitVector(start, end);
	
	  var nextCenterDist = width / 2;
	  while (nextCenterDist + width / 2 < maxDist) {
	    var _offX = direction.dx * nextCenterDist,
	        _offY = direction.dy * nextCenterDist;
	    centers.push({ x: start.x + _offX, y: start.y + _offY, distFromStart: nextCenterDist });
	    nextCenterDist += width + (spacing || 1);
	  }
	  if (centers.length === 0) return [];
	  var margin = (distanceBetweenPoints(centers[centers.length - 1], end) - width / 2) / 2,
	      totalDist = distanceBetweenPoints(start, end),
	      offX = direction.dx * margin,
	      offY = direction.dy * margin;
	
	  return centers.map(function (c) {
	    return {
	      x: c.x + offX,
	      y: c.y + offY,
	      alpha: (c.distFromStart + margin) / totalDist
	    };
	  });
	}
	
	function cleanInvalidPoly(vertices) {
	  for (var ix = 1; ix < vertices.length - 1; ix++) {
	    var a = vertices[ix - 1],
	        b = vertices[ix],
	        c = vertices[ix + 1];
	    if (!ptsAreCollinear(a, b, c)) continue;
	
	    var positionAlongEdge = _lodash2.default.reject([(a.x - b.x) / (c.x - b.x), (a.y - b.y) / (c.y - b.y)], isNaN)[0];
	
	    if (positionAlongEdge > 1 || positionAlongEdge < 0) continue;
	
	    return cleanInvalidPoly([].concat((0, _toConsumableArray3.default)(vertices.slice(0, ix)), (0, _toConsumableArray3.default)(vertices.slice(ix + 1))));
	  }
	
	  return vertices;
	}
	
	var helpers = {
	  setOperation: function setOperation(type, f1Points, f2Points) {
	    var f1Poly = toTurfPoly(f1Points).geometry.coordinates,
	        f2Poly = toTurfPoly(f2Points).geometry.coordinates;
	    var operation = type === 'union' ? _polygonClipping.union : type === 'intersection' ? _polygonClipping.intersection : type === 'difference' ? _polygonClipping.difference : null;
	    if (operation === null) {
	      throw new Error('invalid operation "' + type + '". expected union, intersection, or difference');
	    }
	    var result = operation(f1Poly, f2Poly);
	    if (result === null || result.length === 0) {
	      return [];
	    }
	    if (result.length > 1) return { error: 'no split faces' };
	    if (result[0].length > 1) return { error: 'no holes' };
	    return dropClosingVertex(result[0][0].map(function (_ref7) {
	      var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
	          x = _ref8[0],
	          y = _ref8[1];
	
	      return { x: x, y: y };
	    }));
	  },
	  intersection: function intersection(f1, f2) {
	    return this.setOperation('intersection', f1, f2);
	  },
	  union: function union(f1, f2) {
	    return this.setOperation('union', f1, f2);
	  },
	  difference: function difference(f1, f2) {
	    return this.setOperation('difference', f1, f2);
	  },
	  areaOfSelection: function areaOfSelection(points) {
	    if (points.length < 3) return 0;
	    return (0, _areaPolygon2.default)(points);
	  },
	  splittingVerticesForEdgeId: function splittingVerticesForEdgeId(edge, geometry, spacing, vertices) {
	    var _this = this;
	
	    var vertexMap = createEdgeMap(geometry, true)[2];
	    if (!vertices) {
	      vertices = geometry.vertices;
	    }
	
	    var v1 = vertexMap[edge.v1];
	    if (!v1) {
	      v1 = geometry.vertices.find(function (v) {
	        return v.id === edge.v1;
	      });
	    }
	
	    var v2 = vertexMap[edge.v2];
	    if (!v2) {
	      v2 = geometry.vertices.find(function (v) {
	        return v.id === edge.v2;
	      });
	    }
	    var denormalizedEdge = (0, _extends3.default)({}, edge, {
	      v1: v1,
	      v2: v2
	    });
	
	    return vertices.filter(function (vertex) {
	      if (!denormalizedEdge.v1 || !denormalizedEdge.v2) {
	        return false;
	      }
	
	      var vertexIsEndpointById = denormalizedEdge.v1.id === vertex.id || denormalizedEdge.v2.id === vertex.id,
	          vertexIsLeftEndpointByValue = denormalizedEdge.v1.x === vertex.x && denormalizedEdge.v1.y === vertex.y,
	          vertexIsRightEndpointByValue = denormalizedEdge.v2.x === vertex.x && denormalizedEdge.v2.y === vertex.y,
	          vertexIsEndpoint = vertexIsEndpointById || vertexIsLeftEndpointByValue || vertexIsRightEndpointByValue;
	
	      if (vertexIsEndpoint) {
	        return false;
	      }
	
	      var projection = _this.projectionOfPointToLine(vertex, {
	        p1: denormalizedEdge.v1,
	        p2: denormalizedEdge.v2
	      });
	      var distBetween = _this.distanceBetweenPoints(vertex, projection);
	      var shouldSplit = distBetween <= spacing / 20;
	      return shouldSplit;
	    });
	  },
	
	
	  projectionOfPointToLine: projectionOfPointToLine,
	
	  distanceBetweenPoints: distanceBetweenPoints,
	
	  intersectionOfLines: function intersectionOfLines(p1, p2, p3, p4) {
	    var eps = 0.0000001;
	
	    var between = function between(a, b, c) {
	      return a - eps <= b && b <= c + eps;
	    };
	
	    var x = ((p1.x * p2.y - p1.y * p2.x) * (p3.x - p4.x) - (p1.x - p2.x) * (p3.x * p4.y - p3.y * p4.x)) / ((p1.x - p2.x) * (p3.y - p4.y) - (p1.y - p2.y) * (p3.x - p4.x));
	    var y = ((p1.x * p2.y - p1.y * p2.x) * (p3.y - p4.y) - (p1.y - p2.y) * (p3.x * p4.y - p3.y * p4.x)) / ((p1.x - p2.x) * (p3.y - p4.y) - (p1.y - p2.y) * (p3.x - p4.x));
	
	    if (isNaN(x) || isNaN(y) || this.distanceBetweenPoints({ x: x, y: y }, p1) < eps || this.distanceBetweenPoints({ x: x, y: y }, p2) < eps || this.distanceBetweenPoints({ x: x, y: y }, p3) < eps || this.distanceBetweenPoints({ x: x, y: y }, p4) < eps) {
	      return false;
	    } else {
	      if (p1.x >= p2.x) {
	        if (!between(p2.x, x, p1.x)) {
	          return false;
	        }
	      } else {
	        if (!between(p1.x, x, p2.x)) {
	          return false;
	        }
	      }
	      if (p1.y >= p2.y) {
	        if (!between(p2.y, y, p1.y)) {
	          return false;
	        }
	      } else {
	        if (!between(p1.y, y, p2.y)) {
	          return false;
	        }
	      }
	      if (p3.x >= p4.x) {
	        if (!between(p4.x, x, p3.x)) {
	          return false;
	        }
	      } else {
	        if (!between(p3.x, x, p4.x)) {
	          return false;
	        }
	      }
	      if (p3.y >= p4.y) {
	        if (!between(p4.y, y, p3.y)) {
	          return false;
	        }
	      } else {
	        if (!between(p3.y, y, p4.y)) {
	          return false;
	        }
	      }
	    }
	    return {
	      x: x,
	      y: y
	    };
	  },
	  vertexForId: function vertexForId(vertex_id, geometry) {
	    return geometry.vertices.find(function (v) {
	      return v.id === vertex_id;
	    });
	  },
	  vertexForCoordinates: function vertexForCoordinates(coordinates, geometry) {
	    var _this2 = this;
	
	    return geometry.vertices.find(function (v) {
	      return _this2.distanceBetweenPoints(v, coordinates) < 0.00001;
	    });
	  },
	  verticesForFaceId: function verticesForFaceId(face_id, geometry) {
	    var _this3 = this;
	
	    return geometry.faces.find(function (f) {
	      return f.id === face_id;
	    }).edgeRefs.map(function (edgeRef) {
	      var edge = _this3.edgeForId(edgeRef.edge_id, geometry),
	          vertexId = edgeRef.reverse ? edge.v2 : edge.v1;
	      return _this3.vertexForId(vertexId, geometry);
	    });
	  },
	  edgeForId: function edgeForId(edge_id, geometry) {
	    return geometry.edges.find(function (e) {
	      return e.id === edge_id;
	    });
	  },
	  edgesForVertexId: function edgesForVertexId(vertex_id, geometry) {
	    return geometry.edges.filter(function (e) {
	      return e.v1 === vertex_id || e.v2 === vertex_id;
	    });
	  },
	  edgesForFaceId: function edgesForFaceId(face_id, geometry) {
	    var _this4 = this;
	
	    return geometry.faces.find(function (f) {
	      return f.id === face_id;
	    }).edgeRefs.map(function (eR) {
	      return _this4.edgeForId(eR.edge_id, geometry);
	    });
	  },
	  faceForId: function faceForId(face_id, geometry) {
	    return geometry.faces.find(function (f) {
	      return f.id === face_id;
	    });
	  },
	  facesForVertexId: function facesForVertexId(vertex_id, geometry) {
	    var _this5 = this;
	
	    return geometry.faces.filter(function (face) {
	      return face.edgeRefs.find(function (edgeRef) {
	        var edge = _this5.edgeForId(edgeRef.edge_id, geometry);
	        return edge.v1 === vertex_id || edge.v2 === vertex_id;
	      });
	    });
	  },
	  facesForEdgeId: function facesForEdgeId(edge_id, geometry) {
	    return geometry.faces.filter(function (face) {
	      return face.edgeRefs.find(function (eR) {
	        return eR.edge_id === edge_id;
	      });
	    });
	  },
	  pointInFace: function pointInFace(point, faceVertices) {
	    var facePoly = toTurfPoly(faceVertices);
	    var testPoint = turf.point([point.x, point.y]);
	    return (0, _booleanPointInPolygon2.default)(testPoint, facePoly);
	  },
	
	
	  ptsAreCollinear: ptsAreCollinear,
	  syntheticRectangleSnaps: function syntheticRectangleSnaps(points, rectStart, cursorPt) {
	    var xMid = (rectStart.x + cursorPt.x) / 2;
	    var yMid = (rectStart.y + cursorPt.y) / 2;
	
	    return [].concat((0, _toConsumableArray3.default)(points.map(function (_ref9) {
	      var x = _ref9.x,
	          y = _ref9.y;
	      return { y: y, x: x + 2 * (xMid - x), synthetic: true, originalPt: { x: x, y: y } };
	    })), (0, _toConsumableArray3.default)(points.map(function (_ref10) {
	      var x = _ref10.x,
	          y = _ref10.y;
	      return { x: x, y: y + 2 * (yMid - y), synthetic: true, originalPt: { x: x, y: y } };
	    })));
	  },
	
	  edgeDirection: edgeDirection,
	  haveSimilarAngles: haveSimilarAngles,
	  pointDistanceToSegment: pointDistanceToSegment,
	
	  exceptFace: function exceptFace(geometry, face_id) {
	    if (!face_id) {
	      return geometry;
	    }
	    return (0, _extends3.default)({}, geometry, {
	      faces: _lodash2.default.reject(geometry.faces, { id: face_id })
	    });
	  },
	  denormalize: function denormalize(geometry) {
	    var _createEdgeMap = createEdgeMap(geometry),
	        _createEdgeMap2 = (0, _slicedToArray3.default)(_createEdgeMap, 2),
	        edges = _createEdgeMap2[0],
	        edgeMap = _createEdgeMap2[1];
	
	    var faces = geometry.faces.map(function (face) {
	      return {
	        id: face.id,
	        edges: face.edgeRefs.map(function (_ref11) {
	          var edge_id = _ref11.edge_id,
	              reverse = _ref11.reverse;
	          return (0, _extends3.default)({}, edgeMap[edge_id], {
	            edge_id: edge_id,
	            reverse: reverse
	          });
	        }),
	        get vertices() {
	          return (0, _utilities.dropConsecutiveDups)(_lodash2.default.flatMap(this.edges, function (e) {
	            return e.reverse ? [e.v2, e.v1] : [e.v1, e.v2];
	          }), function (v) {
	            return v.id;
	          });
	        }
	      };
	    });
	    return (0, _extends3.default)({}, geometry, {
	      edges: edges,
	      faces: faces
	    });
	  },
	  normalize: function normalize(geometry) {
	    var edges = _lodash2.default.uniqBy([].concat((0, _toConsumableArray3.default)(geometry.edges), (0, _toConsumableArray3.default)(_lodash2.default.flatMap(geometry.faces, function (f) {
	      return f.edges;
	    }))), 'id'),
	        vertices = _lodash2.default.uniqBy([].concat((0, _toConsumableArray3.default)(geometry.vertices), (0, _toConsumableArray3.default)(_lodash2.default.flatMap(edges, function (e) {
	      return [e.v1, e.v2];
	    }))), 'id');
	    return {
	      id: geometry.id,
	      vertices: vertices.map(function (v) {
	        return _lodash2.default.pick(v, ['id', 'x', 'y']);
	      }),
	      edges: edges.map(function (e) {
	        return {
	          id: e.id,
	          v1: e.v1.id,
	          v2: e.v2.id
	        };
	      }),
	      faces: geometry.faces.map(function (f) {
	        return {
	          id: f.id,
	          edgeRefs: f.edges.map(function (er) {
	            return { edge_id: er.id, reverse: er.reverse };
	          })
	        };
	      })
	    };
	  }
	};
	
	var lastEdges = null;
	var lastVertices = null;
	var lastMap = null;
	var lastArr = null;
	var lastVertexMap = null;
	
	function createEdgeMap(geometry, memoize) {
	  if (!memoize || lastEdges !== geometry.edges || lastVertices !== geometry.vertices) {
	    var vertexMap = geometry.vertices.reduce(function (acc, cur) {
	      acc[cur.id] = cur;
	      return acc;
	    }, {});
	
	    lastMap = {};
	    lastArr = geometry.edges.map(function (edge) {
	      var newObj = (0, _extends3.default)({}, edge, {
	        v1: vertexMap[edge.v1],
	        v2: vertexMap[edge.v2]
	      });
	      lastMap[edge.id] = newObj;
	      return newObj;
	    });
	
	    if (memoize) {
	      lastEdges = geometry.edges;
	      lastVertices = geometry.vertices;
	      lastVertexMap = vertexMap;
	    }
	  }
	
	  return [lastArr, lastMap, lastVertexMap];
	}
	
	function isPointCoord(coord) {
	  return coord.length === 2 && _lodash2.default.isNumber(coord[0]) && _lodash2.default.isNumber(coord[1]);
	}
	
	function isRingCoords(coords) {
	  return coords.length >= 1 && _lodash2.default.every(coords, isPointCoord);
	}
	
	function isPolygonCoords(coords) {
	  return coords.length >= 1 && _lodash2.default.every(coords, isRingCoords);
	}
	
	helpers.inside = function (pt, poly) {
	  var ignoreBoundary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!isPointCoord(pt)) throw new Error('point does not have correct coords: ' + pt);
	  if (!isPolygonCoords(poly)) throw new Error('polygon does not have correct coords: ' + poly);
	
	  var bbox = helpers.bboxOfRing(poly[0]);
	
	  if (bbox && helpers.inBBox(pt, bbox) === false) return false;
	
	  var insidePoly = false;
	  for (var i = 0; i < poly.length && !insidePoly; i++) {
	    if (helpers.inRing(pt, poly[0], ignoreBoundary)) {
	      var inHole = false;
	      var k = 1;
	
	      while (k < poly.length && !inHole) {
	        if (helpers.inRing(pt, poly[k], !ignoreBoundary)) {
	          inHole = true;
	        }
	        k++;
	      }
	      if (!inHole) insidePoly = true;
	    }
	  }
	  return insidePoly;
	};
	
	helpers.bboxOfRing = function (ring) {
	  return [_lodash2.default.min(_lodash2.default.map(ring, 0)), _lodash2.default.min(_lodash2.default.map(ring, 1)), _lodash2.default.max(_lodash2.default.map(ring, 0)), _lodash2.default.max(_lodash2.default.map(ring, 1))];
	};
	
	helpers.inRing = function (pt, ring, ignoreBoundary) {
	  var isInside = false;
	  if (ring[0][0] === ring[ring.length - 1][0] && ring[0][1] === ring[ring.length - 1][1]) ring = ring.slice(0, ring.length - 1);
	
	  for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
	    var xi = ring[i][0],
	        yi = ring[i][1];
	    var xj = ring[j][0],
	        yj = ring[j][1];
	    var onBoundary = pt[1] * (xi - xj) + yi * (xj - pt[0]) + yj * (pt[0] - xi) === 0 && (xi - pt[0]) * (xj - pt[0]) <= 0 && (yi - pt[1]) * (yj - pt[1]) <= 0;
	    if (onBoundary) return !ignoreBoundary;
	    var intersect = yi > pt[1] !== yj > pt[1] && pt[0] < (xj - xi) * (pt[1] - yi) / (yj - yi) + xi;
	    if (intersect) isInside = !isInside;
	  }
	  return isInside;
	};
	
	function vertInRing(vert, ring) {
	  var toLst = function toLst(_ref12) {
	    var x = _ref12.x,
	        y = _ref12.y;
	    return [x, y];
	  };
	  return helpers.inRing(toLst(vert), ring.map(toLst));
	}
	
	function replaceIdsForCloning(newStory) {
	  var clonedGeometry = _lodash2.default.cloneDeep(newStory);
	  var idMap = {};
	  var origVertexIDs = (0, _values2.default)(newStory.vertices).map(function (vertex) {
	    return vertex.id;
	  });
	  origVertexIDs.forEach(function (origID) {
	    var vertex = clonedGeometry.vertices.find(function (clonedVertex) {
	      return clonedVertex.id === origID;
	    });
	    var newID = _generateId2.default.generate();
	    idMap[origID] = newID;
	    vertex.id = newID;
	    var index = clonedGeometry.vertices.findIndex(function (vertexByIndex) {
	      return vertexByIndex.id === newID;
	    });
	    clonedGeometry.vertices[index] = vertex;
	  });
	  clonedGeometry.edges.forEach(function (edge) {
	    var newID = _generateId2.default.generate();
	    idMap[edge.id] = newID;
	    edge.id = newID;
	    edge.v1 = idMap[edge.v1];
	    edge.v2 = idMap[edge.v2];
	  });
	  clonedGeometry.faces.forEach(function (face) {
	    face.edgeRefs.forEach(function (edge) {
	      edge.edge_id = idMap[edge.edge_id];
	    });
	    var newID = _generateId2.default.generate();
	    idMap[face.id] = newID;
	    face.id = newID;
	  });
	
	  return { clonedGeometry: clonedGeometry, idMap: idMap };
	}
	
	exports.default = helpers;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var assignableProperties = exports.assignableProperties = ['building_units', 'thermal_zones', 'space_types', 'construction_sets', 'pitched_roofs'];
	var componentTypes = exports.componentTypes = ['window_definitions', 'daylighting_control_definitions', 'door_definitions'];
	var libraryTypes = exports.libraryTypes = [].concat(assignableProperties, componentTypes);
	var textures = exports.textures = ['circles-2', 'circles-5', 'circles-8', 'diagonal-stripe-1', 'diagonal-stripe-4', 'diagonal-stripe-6', 'dots-5', 'dots-8', 'vertical-line', 'crosshatch'];
	
	var config = {
	  modes: {
	    stories: 'Story',
	    images: 'Image',
	    spaces: 'Space',
	    shading: 'Shading',
	    building_units: 'Building Unit',
	    thermal_zones: 'Thermal Zone',
	    space_types: 'Space Type',
	    pitched_roofs: 'Pitched Roof',
	    construction_sets: 'Construction Set',
	    window_definitions: 'Window Definitions',
	    daylighting_control_definitions: 'Daylighting Control Definitions'
	  },
	  componentTypes: componentTypes,
	  assignableProperties: assignableProperties,
	  palette: {
	    shading: '#E8E3E5',
	    neutral: '#bbc3c7',
	
	    colors: ['#aa4499', '#88ccee', '#332288', '#117733', '#999933', '#ddcc77', '#cc6677', '#882255', '#44aa99', '#6699cc', '#661100', '#aa4466']
	  }
	};
	
	exports.default = config;

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(76);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _libconfig = __webpack_require__(101);
	
	var _libconfig2 = _interopRequireDefault(_libconfig);
	
	var _generateId = __webpack_require__(55);
	
	var _generateId2 = _interopRequireDefault(_generateId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  map: _libconfig2.default,
	
	  displayNameForKey: function displayNameForKey(type, key) {
	    if (this.map[type].keymap[key]) {
	      return this.map[type].keymap[key].private ? null : this.map[type].keymap[key].displayName;
	    }
	    return key;
	  },
	  valueForKey: function valueForKey(object, state, type, key) {
	    if (this.map[type].keymap[key] && this.map[type].keymap[key].get) {
	      return this.map[type].keymap[key].get(object, state);
	    }
	    return object[key];
	  },
	  setValueForKey: function setValueForKey(object, store, type, key, value) {
	    var result = { success: true };
	
	    if (this.map[type].keymap[key] && this.map[type].keymap[key].converter) {
	      value = this.map[type].keymap[key].converter(value, this.map[type].keymap[key]);
	    }
	
	    if (this.map[type].keymap[key] && this.map[type].keymap[key].validator) {
	      var validationResult = this.map[type].keymap[key].validator(object, store, value, type);
	      result.success = validationResult.success;
	      if (!validationResult.success) {
	        result.error = validationResult.error;
	        return result;
	      }
	    }
	
	    if (type === 'stories') {
	      store.dispatch('models/updateStoryWithData', (0, _defineProperty3.default)({
	        story: object
	      }, key, value));
	    } else if (type === 'spaces') {
	      store.dispatch('models/updateSpaceWithData', (0, _defineProperty3.default)({
	        space: object
	      }, key, value));
	    } else if (type === 'shading') {
	      store.dispatch('models/updateShadingWithData', (0, _defineProperty3.default)({
	        shading: object
	      }, key, value));
	    } else if (type === 'images') {
	      store.dispatch('models/updateImageWithData', (0, _defineProperty3.default)({
	        image: object
	      }, key, value));
	    } else if (type === 'window_definitions') {
	      store.dispatch('models/updateWindowDefinitionWithData', (0, _defineProperty3.default)({
	        object: object
	      }, key, value));
	    } else {
	      store.dispatch('models/updateObjectWithData', (0, _defineProperty3.default)({
	        object: object
	      }, key, value));
	    }
	
	    return result;
	  },
	  inputTypeForKey: function inputTypeForKey(type, key) {
	    return this.map[type].keymap[key] && !this.map[type].keymap[key].readonly ? this.map[type].keymap[key].input_type : null;
	  },
	  selectOptionsForKey: function selectOptionsForKey(object, state, type, key) {
	    return this.map[type].keymap[key] && !this.map[type].keymap[key].readonly && this.map[type].keymap[key].input_type === 'select' ? this.map[type].keymap[key].select_data(object, state) : [];
	  },
	  libraryObjectWithId: function libraryObjectWithId(state, id) {
	    var result;
	
	    for (var type in state.library) {
	      if (state.library.hasOwnProperty(type) && !result && state.library[type].find(function (i) {
	        return i.id === id;
	      })) {
	        result = state.library[type].find(function (i) {
	          return i.id === id;
	        });
	        result.type = type;
	      }
	    }
	
	    if (!result && state.stories.find(function (s) {
	      return s.id === id;
	    })) {
	      result = state.stories.find(function (s) {
	        return s.id === id;
	      });
	      result.type = 'story';
	    }
	
	    if (!result) {
	      for (var i = 0; i < state.stories.length; i++) {
	        var story = state.stories[i];
	        if (!result && story.spaces.find(function (s) {
	          return s.id === id;
	        })) {
	          result = story.spaces.find(function (s) {
	            return s.id === id;
	          });
	          result.type = 'space';
	        }
	        if (!result && story.shading.find(function (s) {
	          return s.id === id;
	        })) {
	          result = story.shading.find(function (s) {
	            return s.id === id;
	          });
	          result.type = 'shading';
	        }
	        if (!result && story.images.find(function (i) {
	          return i.id === id;
	        })) {
	          result = story.images.find(function (i) {
	            return i.id === id;
	          });
	          result.type = 'image';
	        }
	      }
	    }
	    return result;
	  },
	  modelForFace: function modelForFace(state, face_id) {
	    for (var i = 0; i < state.stories.length; i++) {
	      var story = state.stories[i],
	          shading = story.shading.find(function (s) {
	        return s.face_id === face_id;
	      }),
	          space = story.spaces.find(function (s) {
	        return s.face_id === face_id;
	      });
	      if (shading) {
	        shading.type = 'shading';
	        return shading;
	      } else if (space) {
	        space.type = 'space';
	        return space;
	      }
	    }
	  },
	  generateName: function generateName(state, type, story) {
	    var models = this.modelsForType(state, type);
	    var prefix = _libconfig2.default[type].displayName + ' ';
	    if (story) {
	      var level = state.stories.findIndex(function (s) {
	        return s.id === story.id;
	      }) + 1;
	      prefix = prefix.concat(level + ' - ');
	    }
	
	    var name = '';
	    var i = 1;
	    while (!name) {
	      name = prefix + i;
	      if (models.find(function (m) {
	        return m.name === name;
	      })) {
	        name = '';
	      }
	      i += 1;
	    }
	    return name;
	  },
	  modelsForType: function modelsForType(state, type) {
	    switch (type) {
	      case 'stories':
	        return state.stories;
	
	      case 'shading':
	      case 'spaces':
	      case 'images':
	        return state.stories.reduce(function (accum, s) {
	          return accum.concat(s[type]);
	        }, []);
	
	      default:
	        return state.library[type];
	    }
	  },
	  replaceIdsUpdateInfoForCloning: function replaceIdsUpdateInfoForCloning(story, idMap) {
	    var clonedStory = _lodash2.default.cloneDeep(story);
	    clonedStory.doors = clonedStory.doors.map(function (door) {
	      var newID = _generateId2.default.generate();
	      idMap[door.id] = newID;
	      door.id = newID;
	      return door;
	    });
	    clonedStory.windows = clonedStory.windows.map(function (window) {
	      var newID = _generateId2.default.generate();
	      idMap[window.id] = newID;
	      window.id = newID;
	      return window;
	    });
	    clonedStory.spaces = clonedStory.spaces.map(function (space) {
	      var newID = _generateId2.default.generate();
	      idMap[space.id] = newID;
	      space.id = newID;
	      space.name = '';
	      space.face_id = idMap[space.face_id];
	      return space;
	    });
	    clonedStory.shading = clonedStory.shading.map(function (shade) {
	      var newID = _generateId2.default.generate();
	      idMap[shade.id] = newID;
	      shade.id = newID;
	      shade.name = '';
	      shade.face_id = idMap[shade.face_id];
	      return shade;
	    });
	    return { clonedStory: clonedStory };
	  },
	  replaceSpaceNamesForCloning: function replaceSpaceNamesForCloning(state, type, story) {
	    var _this = this;
	
	    story.spaces = story.spaces.map(function (space) {
	      space.name = _this.generateName(state, type, story);
	      return space;
	    });
	  }
	};
	exports.default = helpers;

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.genName = genName;
	var id = 1;
	exports.default = {
	    setId: function setId(newVal) {
	        id = newVal;
	    },
	
	
	    generate: function () {
	        return function () {
	            return String(id++);
	        };
	    }()
	};
	
	
	var nameCounts = {};
	function genName(prefix) {
	    var nextSuffix = (nameCounts[prefix] || 0) + 1;
	    nameCounts[prefix] = nextSuffix;
	    return prefix + " - " + nextSuffix;
	}

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.displayNameForMode = displayNameForMode;
	exports.componentInstanceById = componentInstanceById;
	exports.spacePropertyById = spacePropertyById;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _appconfig = __webpack_require__(28);
	
	var _appconfig2 = _interopRequireDefault(_appconfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function displayNameForMode(mode) {
	  return _appconfig2.default.modes[mode];
	}
	
	var helpers = {
	  displayNameForMode: displayNameForMode,
	  config: _appconfig2.default
	};
	exports.default = helpers;
	function componentInstanceById(currStory, compInstId) {
	  var windew = _lodash2.default.find(currStory.windows, { id: compInstId });
	  if (windew) {
	    return (0, _extends3.default)({}, windew, { type: 'windows' });
	  }
	
	  var dc = _lodash2.default.find(_lodash2.default.flatMap(currStory.spaces, function (s) {
	    return s.daylighting_controls;
	  }), { id: compInstId });
	  if (dc) {
	    return (0, _extends3.default)({}, dc, { type: 'daylighting_controls' });
	  }
	
	  var door = _lodash2.default.find(currStory.doors, { id: compInstId });
	  if (door) {
	    return (0, _extends3.default)({}, door, { type: 'doors' });
	  }
	
	  return null;
	}
	
	function spacePropertyById(library, spacePropId) {
	  var type = void 0,
	      prop = void 0;
	  _appconfig.assignableProperties.some(function (ap) {
	    if (prop = _lodash2.default.find(library[ap], { id: spacePropId })) {
	      type = ap;
	    }
	    return !!prop;
	  });
	
	  return prop ? (0, _extends3.default)({}, prop, { type: type }) : null;
	}

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(56);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(38);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _factory = __webpack_require__(131);
	
	var _factory2 = _interopRequireDefault(_factory);
	
	var _validators = __webpack_require__(345);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _converters = __webpack_require__(341);
	
	var converters = _interopRequireWildcard(_converters);
	
	var _appconfig = __webpack_require__(28);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var map = {
	  building_units: {
	    displayName: 'Building Unit',
	    definitionName: 'BuildingUnit',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      readonly: true,
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text',
	      validator: _validators2.default.name
	    }, {
	      name: 'color',
	      displayName: 'Color',
	      input_type: 'color',
	      validator: _validators2.default.color
	    }],
	    init: _factory2.default.BuildingUnit
	  },
	  thermal_zones: {
	    displayName: 'Thermal Zone',
	    definitionName: 'ThermalZone',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      readonly: true,
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text',
	      validator: _validators2.default.name
	    }, {
	      name: 'color',
	      displayName: 'Color',
	      input_type: 'color',
	      validator: _validators2.default.color
	    }],
	    init: _factory2.default.ThermalZone
	  },
	  door_definitions: {
	    displayName: 'Door',
	    definitionName: 'DoorDefinition',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      readonly: true,
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text',
	      validator: _validators2.default.name
	    }, {
	      name: 'height',
	      displayName: 'Height',
	      input_type: 'text',
	      validator: _validators2.default.gt0,
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'width',
	      displayName: 'Width',
	      input_type: 'text',
	      validator: _validators2.default.gt0,
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'door_type',
	      displayName: 'Type',
	      input_type: 'select',
	      select_data: function select_data() {
	        var options = ['Door', 'Glass Door', 'Overhead Door'];
	        return _lodash2.default.zipObject(options, options);
	      },
	
	      validator: _validators2.default.oneOf('Door', 'Glass Door', 'Overhead Door')
	    }, {
	      name: 'texture',
	      displayName: 'Texture',
	      input_type: 'texture',
	      validator: _validators2.default.oneOf.apply(_validators2.default, (0, _toConsumableArray3.default)(_appconfig.textures))
	    }],
	    init: _factory2.default.DoorDefinition
	  },
	  window_definitions: {
	    displayName: 'Window',
	    definitionName: 'WindowDefinition',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      readonly: true,
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text',
	      validator: _validators2.default.name
	    }, {
	      name: 'window_definition_mode',
	      displayName: 'Mode',
	      input_type: 'select',
	      select_data: function select_data() {
	        var options = ['Single Window', 'Repeating Windows', 'Window to Wall Ratio'];
	        return _lodash2.default.zipObject(options, options);
	      },
	
	      validator: _validators2.default.oneOf('Single Window', 'Repeating Windows', 'Window to Wall Ratio')
	    }, {
	      name: 'wwr',
	      displayName: 'Window to Wall ratio',
	      input_type: 'text',
	      validator: _validators2.default.halfOpenInterval(0, 1),
	      converter: converters.number,
	      numeric: true,
	      enabled: function enabled(row) {
	        return row.window_definition_mode === 'Window to Wall Ratio';
	      }
	    }, {
	      name: 'height',
	      displayName: 'Height',
	      input_type: 'text',
	      validator: _validators2.default.gt0,
	      converter: converters.number,
	      numeric: true,
	      enabled: function enabled(row) {
	        return row.window_definition_mode === 'Single Window' || row.window_definition_mode === 'Repeating Windows';
	      }
	    }, {
	      name: 'width',
	      displayName: 'Width',
	      input_type: 'text',
	      validator: _validators2.default.gt0,
	      converter: converters.number,
	      numeric: true,
	      enabled: function enabled(row) {
	        return row.window_definition_mode === 'Single Window' || row.window_definition_mode === 'Repeating Windows';
	      }
	    }, {
	      name: 'sill_height',
	      displayName: 'Sill Height',
	      input_type: 'text',
	      validator: _validators2.default.gt0,
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'window_spacing',
	      displayName: 'Spacing',
	      input_type: 'text',
	      validator: _validators2.default.gt0,
	      converter: converters.number,
	      numeric: true,
	      enabled: function enabled(row) {
	        return row.window_definition_mode === 'Repeating Windows';
	      }
	    }, {
	      name: 'window_type',
	      displayName: 'Window Type',
	      input_type: 'select',
	      select_data: function select_data() {
	        var options = ['Fixed', 'Operable'];
	        return _lodash2.default.zipObject(options, options);
	      },
	
	      validator: _validators2.default.oneOf('Fixed', 'Operable')
	    }, {
	      name: 'overhang_projection_factor',
	      displayName: 'Overhang Projection Factor',
	      input_type: 'text',
	      validator: _validators2.default.gt0orNull,
	      converter: converters.gt0orNull,
	      numeric: true
	    }, {
	      name: 'fin_projection_factor',
	      displayName: 'Fin Projection Factor',
	      input_type: 'text',
	      validator: _validators2.default.gt0orNull,
	      converter: converters.gt0orNull,
	      numeric: true
	    }, {
	      name: 'texture',
	      displayName: 'Texture',
	      input_type: 'texture',
	      validator: _validators2.default.oneOf.apply(_validators2.default, (0, _toConsumableArray3.default)(_appconfig.textures)),
	      enabled: function enabled(row) {
	        return row.window_definition_mode === 'Window to Wall Ratio';
	      }
	    }, {
	      name: 'total_count',
	      displayName: 'Total Count',
	      readonly: true,
	      numeric: true,
	      get: function get(windowDefn, state) {
	        return _lodash2.default.chain(state.models.stories).flatMap('windows').filter({ window_definition_id: windowDefn.id }).value().length;
	      }
	    }],
	    init: _factory2.default.WindowDefn
	  },
	  space_types: {
	    displayName: 'Space Type',
	    definitionName: 'SpaceType',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      readonly: true,
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text',
	      validator: _validators2.default.name
	    }, {
	      name: 'color',
	      displayName: 'Color',
	      input_type: 'color',
	      validator: _validators2.default.color
	    }],
	    init: _factory2.default.SpaceType
	  },
	  construction_sets: {
	    displayName: 'Construction Set',
	    definitionName: 'ConstructionSet',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      readonly: true,
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text',
	      validator: _validators2.default.name
	    }, {
	      name: 'color',
	      displayName: 'Color',
	      input_type: 'color',
	      validator: _validators2.default.color
	    }],
	    init: _factory2.default.ConstructionSet
	  },
	  daylighting_control_definitions: {
	    displayName: 'Daylighting Control',
	    definitionName: 'DaylightingControlDefinition',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      readonly: true,
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text',
	      validator: _validators2.default.name
	    }, {
	      name: 'height',
	      displayName: 'Height',
	      input_type: 'text',
	      validator: _validators2.default.gt0,
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'illuminance_setpoint',
	      displayName: 'Illuminance Setpoint (lux)',
	      input_type: 'text',
	      validator: _validators2.default.gt0,
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'total_count',
	      displayName: 'Total Count',
	      readonly: true,
	      numeric: true,
	      get: function get(dcDefn, state) {
	        return _lodash2.default.chain(state.models.stories).flatMap('spaces').flatMap('daylighting_controls').filter({ daylighting_control_definition_id: dcDefn.id }).value().length;
	      }
	    }],
	    init: _factory2.default.DaylightingControlDefn
	  },
	  stories: {
	    displayName: 'Story',
	    definitionName: 'Story',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      readonly: true,
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text',
	      validator: _validators2.default.name
	    }, {
	      name: 'handle',
	      readonly: true,
	      private: true
	    }, {
	      name: 'geometry_id',
	      readonly: true,
	      private: true
	    }, {
	      name: 'below_floor_plenum_height',
	      displayName: 'Below Floor Plenum Height',
	      input_type: 'text',
	      converter: converters.number,
	      numeric: true,
	      validator: _validators2.default.number
	    }, {
	      name: 'above_ceiling_plenum_height',
	      displayName: 'Above Ceiling Plenum Height',
	      input_type: 'text',
	      converter: converters.number,
	      numeric: true,
	      validator: _validators2.default.number
	    }, {
	      name: 'floor_to_ceiling_height',
	      displayName: 'Floor To Ceiling Height',
	      input_type: 'text',
	      converter: converters.number,
	      numeric: true,
	      validator: _validators2.default.gt0
	    }, {
	      name: 'multiplier',
	      displayName: 'Multiplier',
	      input_type: 'text',
	      converter: converters.number,
	      numeric: true,
	      validator: _validators2.default.gt0
	    }, {
	      name: 'spaces',
	      displayName: 'Spaces',
	      readonly: true,
	      numeric: true,
	      get: function get(story, state) {
	        return story.spaces.length;
	      }
	    }, {
	      name: 'shading',
	      displayName: 'Shading',
	      readonly: true,
	      numeric: true,
	      get: function get(story, state) {
	        return story.shading.length;
	      }
	    }, {
	      name: 'images',
	      readonly: true,
	      private: true
	    }, {
	      name: 'color',
	      displayName: 'Color',
	      input_type: 'color',
	      validator: _validators2.default.color
	    }]
	  },
	  spaces: {
	    displayName: 'Space',
	    definitionName: 'Space',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      readonly: true,
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text',
	      validator: _validators2.default.name
	    }, {
	      name: 'handle',
	      readonly: true,
	      private: true
	    }, {
	      name: 'face_id',
	      readonly: true,
	      private: true
	    }, {
	      name: 'daylighting_controls',
	      displayName: 'Daylighting Controls',
	      readonly: true,
	      private: true,
	      get: function get(space, state) {
	        return space.daylighting_controls.map(function (d) {
	          return d.name;
	        }).join(', ');
	      }
	    }, {
	      name: 'story',
	      displayName: 'Story',
	      readonly: true,
	      get: function get(space, state) {
	        var story = state.models.stories.find(function (story) {
	          return ~story.spaces.map(function (s) {
	            return s.id;
	          }).indexOf(space.id);
	        });
	        return story.name;
	      }
	    }, {
	      name: 'building_unit_id',
	      displayName: 'Building Unit',
	      input_type: 'select',
	      select_data: function select_data(space, state) {
	        var options = { '(none)': null };
	        state.models.library.building_units.forEach(function (b) {
	          options[b.name] = b.id;
	        });
	        return options;
	      },
	      get: function get(space, state) {
	        var buildingUnit = state.models.library.building_units.find(function (b) {
	          return b.id === space.building_unit_id;
	        });
	        return buildingUnit ? buildingUnit.name : null;
	      }
	    }, {
	      name: 'thermal_zone_id',
	      displayName: 'Thermal Zone',
	      input_type: 'select',
	      select_data: function select_data(space, state) {
	        var options = { '(none)': null };
	        state.models.library.thermal_zones.forEach(function (t) {
	          options[t.name] = t.id;
	        });
	        return options;
	      },
	      get: function get(space, state) {
	        var thermalZone = state.models.library.thermal_zones.find(function (b) {
	          return b.id === space.thermal_zone_id;
	        });
	        return thermalZone ? thermalZone.name : null;
	      }
	    }, {
	      name: 'space_type_id',
	      displayName: 'Space Type',
	      input_type: 'select',
	      select_data: function select_data(space, state) {
	        var options = { '(none)': null };
	        state.models.library.space_types.forEach(function (s) {
	          options[s.name] = s.id;
	        });
	        return options;
	      },
	      get: function get(space, state) {
	        var spaceType = state.models.library.space_types.find(function (s) {
	          return s.id === space.space_type_id;
	        });
	        return spaceType ? spaceType.name : null;
	      }
	    }, {
	      name: 'construction_set_id',
	      displayName: 'Construction Set',
	      input_type: 'select',
	      select_data: function select_data(space, state) {
	        var options = { '(none)': null };
	        state.models.library.construction_sets.forEach(function (c) {
	          options[c.name] = c.id;
	        });
	        return options;
	      },
	      get: function get(space, state) {
	        var constructionSet = state.models.library.construction_sets.find(function (c) {
	          return c.id === space.construction_set_id;
	        });
	        return constructionSet ? constructionSet.name : null;
	      }
	    }, {
	      name: 'pitched_roof_id',
	      displayName: 'Pitched Roof',
	      input_type: 'select',
	      select_data: function select_data(space, state) {
	        return (0, _extends3.default)({
	          '(none)': null
	        }, _lodash2.default.fromPairs(state.models.library.pitched_roofs.map(function (prt) {
	          return [prt.name, prt.id];
	        })));
	      },
	      get: function get(space, state) {
	        var prt = _lodash2.default.find(state.models.library.pitched_roofs, { id: space.pitched_roof_id });
	        return prt ? prt.name : null;
	      }
	    }, {
	      name: 'below_floor_plenum_height',
	      displayName: 'Below Floor Plenum Height',
	      input_type: 'text',
	      numeric: true,
	      validator: _validators2.default.number,
	      converter: converters.number
	    }, {
	      name: 'floor_to_ceiling_height',
	      displayName: 'Floor to Ceiling Height',
	      input_type: 'text',
	      numeric: true,
	      validator: _validators2.default.number,
	      converter: converters.number
	    }, {
	      name: 'above_ceiling_plenum_height',
	      displayName: 'Above Ceiling Plenum Height',
	      input_type: 'text',
	      numeric: true,
	      validator: _validators2.default.number,
	      converter: converters.number
	    }, {
	      name: 'floor_offset',
	      displayName: 'Floor Offset',
	      input_type: 'text',
	      numeric: true,
	      validator: _validators2.default.number,
	      converter: converters.number
	    }, {
	      name: 'open_to_below',
	      displayName: 'Open To Below',
	      input_type: 'select',
	      select_data: function select_data() {
	        return { False: false, True: true };
	      },
	
	      converter: converters.bool
	    }, {
	      name: 'color',
	      displayName: 'Color',
	      input_type: 'color',
	      validator: _validators2.default.color
	    }]
	  },
	  shading: {
	    displayName: 'Shading',
	    definitionName: 'Shading',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      readonly: true,
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text',
	      validator: _validators2.default.name
	    }, {
	      name: 'handle',
	      readonly: true,
	      private: true
	    }, {
	      name: 'face_id',
	      readonly: true,
	      private: true
	    }, {
	      name: 'color',
	      readonly: true,
	      private: true
	    }]
	  },
	  images: {
	    displayName: 'Image',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      readonly: true,
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text',
	      validator: _validators2.default.name
	    }, {
	      name: 'width',
	      displayName: 'Width',
	      input_type: 'text',
	      validator: _validators2.default.number,
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'height',
	      displayName: 'Height',
	      input_type: 'text',
	      validator: _validators2.default.number,
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'z',
	      displayName: 'z',
	      input_type: 'text',
	      validator: _validators2.default.number,
	      private: true
	    }, {
	      name: 'scale',
	      displayName: 'Scale',
	      input_type: 'text',
	      validator: _validators2.default.number,
	      converter: converters.number,
	      numeric: true,
	      get: function get(img) {
	        return img.width / img.naturalWidth;
	      }
	    }, {
	      name: 'opacity',
	      displayName: 'opacity',
	      input_type: 'text',
	      validator: _validators2.default.closedInterval(0, 1),
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'x',
	      displayName: 'x',
	      input_type: 'text',
	      validator: _validators2.default.number,
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'y',
	      displayName: 'y',
	      input_type: 'text',
	      validator: _validators2.default.number,
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'src',
	      readonly: true,
	      private: true
	    }]
	  },
	  windows: {
	    displayName: 'Window',
	    columns: [{
	      name: 'id',
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text'
	    }, {
	      name: 'window_definition_id',
	      displayName: 'Definition',
	      input_type: 'select',
	      select_data: function select_data(space, state) {
	        return _lodash2.default.fromPairs(state.models.library.window_definitions.map(function (b) {
	          return [b.name, b.id];
	        }));
	      }
	    }]
	  },
	  daylighting_controls: {
	    displayName: 'Daylighting Control',
	    columns: [{
	      name: 'id',
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text'
	    }, {
	      name: 'daylighting_control_definition_id',
	      displayName: 'Definition',
	      input_type: 'select',
	      select_data: function select_data(space, state) {
	        return _lodash2.default.fromPairs(state.models.library.daylighting_control_definitions.map(function (b) {
	          return [b.name, b.id];
	        }));
	      }
	    }]
	  },
	  doors: {
	    displayName: 'Door',
	    columns: [{
	      name: 'id',
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text'
	    }, {
	      name: 'door_definition_id',
	      displayName: 'Definition',
	      input_type: 'select',
	      select_data: function select_data(space, state) {
	        return _lodash2.default.fromPairs(state.models.library.door_definitions.map(function (b) {
	          return [b.name, b.id];
	        }));
	      }
	    }]
	  },
	  pitched_roofs: {
	    displayName: 'Pitched Roof',
	    columns: [{
	      name: 'id',
	      displayName: 'ID',
	      private: true
	    }, {
	      name: 'name',
	      displayName: 'Name',
	      input_type: 'text'
	    }, {
	      name: 'pitched_roof_type',
	      displayName: 'Type',
	      input_type: 'select',
	      select_data: function select_data() {
	        var options = ['Gable', 'Hip', 'Shed'];
	        return _lodash2.default.zipObject(options, options);
	      },
	
	      validator: _validators2.default.oneOf('Gable', 'Hip', 'Shed')
	    }, {
	      name: 'pitch',
	      displayName: 'Pitch',
	      input_type: 'text',
	      validator: _validators2.default.gt0,
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'shed_direction',
	      displayName: 'Shed Direction',
	      input_type: 'text',
	      validator: _validators2.default.number,
	      converter: converters.number,
	      numeric: true
	    }, {
	      name: 'color',
	      displayName: 'Color',
	      input_type: 'color'
	    }],
	    init: _factory2.default.PitchedRoof
	  }
	};
	
	(0, _keys2.default)(map).forEach(function (k) {
	  map[k].keymap = _lodash2.default.zipObject(_lodash2.default.map(map[k].columns, 'name'), map[k].columns);
	
	  map[k].columns.forEach(function (col) {
	    if (_lodash2.default.has(map[k], 'definitionName') && _lodash2.default.get(_factory.allowableTypes, map[k].definitionName) && _lodash2.default.includes(_factory.allowableTypes[map[k].definitionName][col.name], 'null')) {
	      col.nullable = true;
	    }
	
	    if (_lodash2.default.has(map[k], 'definitionName') && (0, _factory.getDefaults)(map[k].definitionName) && _lodash2.default.has((0, _factory.getDefaults)(map[k].definitionName), col.name)) {
	      col.default = (0, _factory.getDefaults)(map[k].definitionName)[col.name];
	    }
	  });
	});
	
	exports.default = map;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.debounce = debounce;
	exports.uniq = uniq;
	exports.allPairs = allPairs;
	exports.dropConsecutiveDups = dropConsecutiveDups;
	exports.getSiblings = getSiblings;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function debounce(func, wait) {
	  var timeout;
	
	  return function () {
	    var _this = this;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    clearTimeout(timeout);
	
	    timeout = setTimeout(function () {
	      timeout = null;
	      func.apply(_this, args);
	    }, wait);
	  };
	};
	
	function uniq(arr) {
	  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _stringify2.default;
	
	  var alreadySeen = {};
	  return arr.filter(function (elem) {
	    var theKey = key(elem);
	    if (alreadySeen[theKey]) {
	      return false;
	    } else {
	      alreadySeen[theKey] = true;
	      return true;
	    }
	  });
	}
	
	function allPairs(elems) {
	  return _lodash2.default.flatten(elems.map(function (p, ix) {
	    return elems.slice(ix + 1).map(function (p2) {
	      return [p, p2];
	    });
	  }));
	}
	
	function dropConsecutiveDups(arr) {
	  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _stringify2.default;
	
	  return arr.filter(function (item, pos) {
	    return pos === 0 || key(item) !== key(arr[pos - 1]);
	  });
	}
	
	function getSiblings(el) {
	  var siblings = [];
	  for (var sibling = el.parentNode.firstChild; sibling; sibling = sibling.nextSibling) {
	    if (sibling.nodeType === 1 && sibling !== el) {
	      siblings.push(sibling);
	    }
	  }
	  return siblings;
	}

/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(690)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(323),
	  /* template */
	  __webpack_require__(758),
	  /* scopeId */
	  "data-v-8f6e6820",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(38);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.gridSnapTargets = gridSnapTargets;
	exports.vertexSnapTargets = vertexSnapTargets;
	exports.snapTargets = snapTargets;
	exports.expandWindowAlongEdge = expandWindowAlongEdge;
	exports.findClosestEdge = findClosestEdge;
	exports.findClosestWindow = findClosestWindow;
	exports.snapWindowToEdge = snapWindowToEdge;
	exports.snapToVertexWithinFace = snapToVertexWithinFace;
	exports.windowLocation = windowLocation;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function gridSnapTargets(gridSpacing, _ref) {
	  var x = _ref.x,
	      y = _ref.y;
	
	  return [{ x: Math.floor(x / gridSpacing) * gridSpacing, y: Math.floor(y / gridSpacing) * gridSpacing }, { x: (Math.floor(x / gridSpacing) + 1) * gridSpacing, y: Math.floor(y / gridSpacing) * gridSpacing }, { x: Math.floor(x / gridSpacing) * gridSpacing, y: (Math.floor(y / gridSpacing) + 1) * gridSpacing }, { x: (Math.floor(x / gridSpacing) + 1) * gridSpacing, y: (Math.floor(y / gridSpacing) + 1) * gridSpacing }].map(function (t) {
	    return (0, _extends3.default)({}, t, { type: 'grid' });
	  });
	}
	
	function vertexSnapTargets(vertices, gridSpacing, location) {
	  return vertices.filter(function (v) {
	    return (0, _helpers.distanceBetweenPoints)(location, v) <= gridSpacing;
	  }).map(function (v) {
	    return (0, _extends3.default)({}, v, { type: 'vertex' });
	  });
	}
	
	function snapTargets(vertices, gridSpacing, cursor) {
	  var targets = [].concat((0, _toConsumableArray3.default)(gridSnapTargets(gridSpacing, cursor)), (0, _toConsumableArray3.default)(vertexSnapTargets(vertices, gridSpacing, cursor))).map(function (target) {
	    return (0, _extends3.default)({}, target, {
	      dist: (0, _helpers.distanceBetweenPoints)(target, cursor),
	      dx: cursor.x - target.x,
	      dy: cursor.y - target.y
	    });
	  });
	
	  return _lodash2.default.orderBy(targets, ['dist', 'origin', 'type'], ['asc', 'asc', 'desc']);
	}
	
	function expandWindowAlongEdge(edge, center, _ref2) {
	  var width = _ref2.width,
	      spacing = _ref2.spacing,
	      window_definition_mode = _ref2.window_definition_mode,
	      texture = _ref2.texture;
	
	  if (window_definition_mode === 'Window to Wall Ratio' || window_definition_mode === 'Repeating Windows') {
	    return {
	      edge_id: edge.id,
	      center: {
	        x: (edge.v1.x + edge.v2.x) / 2,
	        y: (edge.v1.y + edge.v2.y) / 2
	      },
	      edge_start: edge.v1,
	      alpha: 0.5,
	      start: edge.v1,
	      end: edge.v2,
	      window_definition_mode: window_definition_mode,
	      width: width,
	      spacing: spacing,
	      texture: texture
	    };
	  }
	  var theta = (0, _helpers.edgeDirection)({ start: edge.v1, end: edge.v2 }),
	      windowDeltaX = width * Math.cos(theta) / 2,
	      windowDeltaY = width * Math.sin(theta) / 2,
	      alpha = edge.v2.x === edge.v1.x ? (center.y - edge.v1.y) / (edge.v2.y - edge.v1.y) : (center.x - edge.v1.x) / (edge.v2.x - edge.v1.x);
	  return {
	    edge_id: edge.id,
	    center: center,
	    edge_start: edge.v1,
	    alpha: alpha,
	    start: {
	      x: center.x - windowDeltaX,
	      y: center.y - windowDeltaY
	    },
	    end: {
	      x: center.x + windowDeltaX,
	      y: center.y + windowDeltaY
	    },
	    window_definition_mode: window_definition_mode
	  };
	}
	
	function findClosestEdge(edges, cursor) {
	  var withDistance = edges.map(function (e) {
	    return (0, _extends3.default)({}, e, (0, _helpers.pointDistanceToSegment)(cursor, { start: e.v1, end: e.v2 }));
	  });
	
	  var ret = undefined;
	  var smallest = NaN;
	  withDistance.forEach(function (d) {
	    if (!(d.dist >= smallest)) {
	      smallest = d.dist;
	      ret = d;
	    }
	  });
	
	  return ret;
	}
	
	function findClosestWindow(windows, cursor) {
	  var withDistance = windows.map(function (w) {
	    var dist = w.window_definition_mode === 'Single Window' ? { dist: (0, _helpers.distanceBetweenPoints)(cursor, w.center), proj: w.center } : (0, _helpers.pointDistanceToSegment)(cursor, w);
	
	    return (0, _extends3.default)({}, w, dist, {
	      v1: w.start,
	      v2: w.end
	    });
	  });
	  return _lodash2.default.minBy(withDistance, 'dist');
	}
	
	function snapWindowToEdgeAnywhere(edges, cursor, windowDefn, maxSnapDist) {
	  var closestEdge = findClosestEdge(edges, cursor);
	  if (!closestEdge || closestEdge.dist > maxSnapDist) {
	    return null;
	  }
	  return expandWindowAlongEdge(closestEdge, closestEdge.proj, windowDefn);
	}
	
	function snapWindowToEdgeAtGridIntervals(edges, cursor, windowDefn, maxSnapDist, gridSpacing) {
	  var closestEdge = findClosestEdge(edges, cursor);
	  if (!closestEdge || closestEdge.dist > maxSnapDist) {
	    return null;
	  }
	
	  var dist = (0, _helpers.distanceBetweenPoints)(closestEdge.v1, closestEdge.proj),
	      roundedDist = Math.round(dist / gridSpacing) * gridSpacing,
	      dx = closestEdge.v2.x - closestEdge.v1.x,
	      dy = closestEdge.v2.y - closestEdge.v1.y,
	      norm = Math.sqrt(dx * dx + dy * dy),
	      snapLoc = {
	    x: closestEdge.v1.x + roundedDist * (dx / norm),
	    y: closestEdge.v1.y + roundedDist * (dy / norm)
	  };
	
	  return expandWindowAlongEdge(closestEdge, snapLoc, windowDefn);
	}
	
	function snapWindowToEdge(snapMode) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  if (snapMode === 'grid-strict') {
	    return snapWindowToEdgeAtGridIntervals.apply(undefined, args);
	  }
	  return snapWindowToEdgeAnywhere.apply(undefined, args);
	}
	
	function snapToVertexWithinFace(snapMode, faces, cursor, gridSpacing) {
	  var existingVerts = snapMode === 'grid-strict' ? [] : [cursor];
	
	  return _lodash2.default.chain(snapTargets(existingVerts, gridSpacing, cursor)).map(function (g) {
	    return (0, _extends3.default)({}, g, {
	      face_id: _lodash2.default.find(faces, function (f) {
	        return (0, _helpers.vertInRing)(g, f.vertices);
	      })
	    });
	  }).filter('face_id').map(function (g) {
	    return (0, _extends3.default)({}, g, { face_id: g.face_id.id });
	  }).first().value();
	}
	
	function windowLocation(edge, windw) {
	  var alpha = windw.alpha || 0.5;
	  return {
	    x: edge.v1.x + alpha * (edge.v2.x - edge.v1.x),
	    y: edge.v1.y + alpha * (edge.v2.y - edge.v1.y)
	  };
	}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResizeEvents = undefined;
	
	var _ResizeEvents = __webpack_require__(194);
	
	var _ResizeEvents2 = _interopRequireDefault(_ResizeEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ResizeEvents = _ResizeEvents2.default;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _generateId = __webpack_require__(55);
	
	var _generateId2 = _interopRequireDefault(_generateId);
	
	var _helpers = __webpack_require__(16);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    Vertex: function Vertex(x, y) {
	        return {
	            id: _generateId2.default.generate(),
	            x: x,
	            y: y
	        };
	    },
	    Edge: function Edge(v1, v2) {
	        return {
	            id: _generateId2.default.generate(),
	            v1: v1,
	            v2: v2
	        };
	    },
	    Face: function Face(edgeRefs) {
	        return {
	            id: _generateId2.default.generate(),
	            edgeRefs: edgeRefs
	        };
	    },
	    Geometry: function Geometry() {
	        return {
	            id: _generateId2.default.generate(),
	            vertices: [],
	            edges: [],
	            faces: []
	        };
	    }
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.allowableTypes = exports.getDefaults = undefined;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _generateId = __webpack_require__(55);
	
	var _generateId2 = _interopRequireDefault(_generateId);
	
	var _generateColor = __webpack_require__(352);
	
	var _generateColor2 = _interopRequireDefault(_generateColor);
	
	var _generateTexture = __webpack_require__(353);
	
	var _generateTexture2 = _interopRequireDefault(_generateTexture);
	
	var _appconfig = __webpack_require__(28);
	
	var _appconfig2 = _interopRequireDefault(_appconfig);
	
	var _geometry_schema = __webpack_require__(264);
	
	var _geometry_schema2 = _interopRequireDefault(_geometry_schema);
	
	var _unitConversion = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeReadPropertyAttr = function makeReadPropertyAttr(attribute) {
	  var readPropertyAttr = function readPropertyAttr(definition) {
	    if (_lodash2.default.has(definition, 'default')) return definition[attribute];
	    if (definition.type === 'null') return null;
	    if (definition.type === 'array') return [];
	    if (definition.type === 'object') {
	      return _lodash2.default.mapValues(definition.properties, readPropertyAttr);
	    }
	    if (_lodash2.default.has(definition, attribute)) return definition[attribute];
	    return null;
	  };
	  return readPropertyAttr;
	};
	
	var readPropertyAttrs = function readPropertyAttrs(attr) {
	  return _lodash2.default.mapValues(_geometry_schema2.default.definitions, makeReadPropertyAttr(attr));
	};
	
	var ip_defaults = readPropertyAttrs('default');
	if (ip_defaults.Project.config.units !== 'ip') {
	  throw new Error('Expected default units to be ip. Code changes are required to change the default units');
	}
	var si_defaults = _lodash2.default.mapValues(ip_defaults, function (value, key) {
	  return (0, _unitConversion.getConverter)(key, 'ip', 'si')(value);
	});
	
	var getDefaults = exports.getDefaults = function getDefaults(key) {
	  return _lodash2.default.cloneDeep(_lodash2.default.get(window, 'application.$store.state.project.config.units', 'ip') === 'ip' ? ip_defaults[key] : si_defaults[key]);
	};
	
	var allowableTypes = exports.allowableTypes = readPropertyAttrs('type');
	
	exports.default = {
	  Story: function Story(name) {
	    return (0, _extends3.default)({}, getDefaults('Story'), {
	      id: _generateId2.default.generate(),
	      name: name,
	      color: (0, _generateColor2.default)('story')
	    });
	  },
	  Space: function Space(name) {
	    return (0, _extends3.default)({}, getDefaults('Space'), {
	      id: _generateId2.default.generate(),
	      name: name,
	      color: (0, _generateColor2.default)('space'),
	      type: 'space'
	    });
	  },
	  Shading: function Shading(name) {
	    return (0, _extends3.default)({}, getDefaults('Shading'), {
	      id: _generateId2.default.generate(),
	      name: name,
	      color: _appconfig2.default.palette.shading
	    });
	  },
	  Image: function Image(name, src) {
	    return {
	      id: _generateId2.default.generate(),
	      src: src,
	      name: name,
	      visible: true,
	      height: 0,
	      width: 0,
	      x: 0,
	      y: 0,
	      z: 0,
	      r: 0,
	      opacity: 0.6,
	      naturalWidth: 0,
	      naturalHeight: 0
	    };
	  },
	  BuildingUnit: function BuildingUnit() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return {
	      id: _generateId2.default.generate(),
	      color: (0, _generateColor2.default)('building_unit'),
	      name: opts.name,
	      handle: opts.handle || null
	    };
	  },
	  ThermalZone: function ThermalZone() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _extends3.default)({}, getDefaults('ThermalZone'), {
	      id: _generateId2.default.generate(),
	      color: (0, _generateColor2.default)('thermal_zone'),
	      name: opts.name
	    });
	  },
	  SpaceType: function SpaceType() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _extends3.default)({}, getDefaults('SpaceType'), {
	      id: _generateId2.default.generate(),
	      color: (0, _generateColor2.default)('space_type'),
	      name: opts.name
	    });
	  },
	  ConstructionSet: function ConstructionSet() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _extends3.default)({}, getDefaults('ConstructionSet'), {
	      id: _generateId2.default.generate(),
	      name: opts.name,
	      color: (0, _generateColor2.default)('construction_set')
	    });
	  },
	  WindowDefn: function WindowDefn() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _extends3.default)({}, getDefaults('WindowDefinition'), {
	      id: _generateId2.default.generate(),
	      name: opts.name,
	      wwr: null,
	      window_spacing: null,
	      texture: (0, _generateTexture2.default)('window_definition')
	    });
	  },
	  DaylightingControlDefn: function DaylightingControlDefn() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _extends3.default)({}, getDefaults('DaylightingControlDefinition'), {
	      id: _generateId2.default.generate(),
	      name: opts.name
	    });
	  },
	  DoorDefinition: function DoorDefinition() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _extends3.default)({}, getDefaults('DoorDefinition'), {
	      id: _generateId2.default.generate(),
	      name: opts.name,
	      texture: (0, _generateTexture2.default)('door_definition')
	    });
	  },
	  PitchedRoof: function PitchedRoof() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _extends3.default)({}, getDefaults('PitchedRoof'), {
	      id: _generateId2.default.generate(),
	      name: opts.name,
	      color: (0, _generateColor2.default)('pitched_roof')
	    });
	  }
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertLibrary = exports.convertState = exports.convertSchema = exports.getConverter = exports.conversionFactor = exports.units = undefined;
	
	var _typeof2 = __webpack_require__(77);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _geometry_schema = __webpack_require__(264);
	
	var _geometry_schema2 = _interopRequireDefault(_geometry_schema);
	
	var _appconfig = __webpack_require__(28);
	
	var _deepFreeze = __webpack_require__(360);
	
	var _deepFreeze2 = _interopRequireDefault(_deepFreeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var readUnits = function readUnits(definition) {
	  if (_lodash2.default.has(definition, 'si_units')) {
	    return _lodash2.default.pick(definition, ['si_units', 'ip_units']);
	  }
	  if (definition.type === 'object') {
	    var res = _lodash2.default.pickBy(_lodash2.default.mapValues(definition.properties, readUnits), _lodash2.default.identity);
	    if (_lodash2.default.isEmpty(res)) {
	      return null;
	    }
	    return res;
	  }
	  if (definition.type === 'array' && _lodash2.default.get(definition, 'items.$ref')) {
	    return {
	      arrayOf: definition.items.$ref.replace('#/definitions/', '')
	    };
	  }
	  if (definition.$ref) {
	    return {
	      $ref: definition.$ref.replace('#/definitions/', '')
	    };
	  }
	  return null;
	};
	
	var rawUnits = (0, _extends3.default)({
	  $schema: _lodash2.default.pickBy(_lodash2.default.mapValues(_geometry_schema2.default.properties, readUnits), _lodash2.default.identity)
	}, _lodash2.default.pickBy(_lodash2.default.mapValues(_geometry_schema2.default.definitions, readUnits), _lodash2.default.identity));
	
	rawUnits.$state = _lodash2.default.pickBy({
	  application: rawUnits.Application,
	  project: rawUnits.Project,
	  geometry: { arrayOf: 'Geometry' },
	  models: {
	    stories: { arrayOf: 'Story' },
	    library: _lodash2.default.fromPairs(_appconfig.libraryTypes.map(function (lt) {
	      return [lt, rawUnits.$schema[lt]];
	    }))
	  }
	}, _lodash2.default.identity);
	
	var units = exports.units = (0, _deepFreeze2.default)(rawUnits);
	
	var factorTable = {
	  'm -> ft': 3.280839895,
	  'ft -> m': 0.3048,
	  'fc -> lux': 10.7639,
	  'lux -> fc': 0.092903
	};
	var conversionFactor = exports.conversionFactor = function conversionFactor(fromUnits, toUnits) {
	  var factor = factorTable[fromUnits + ' -> ' + toUnits];
	  if (!factor) {
	    throw new Error('Unable to find conversion from ' + fromUnits + ' to ' + toUnits);
	  }
	  return factor;
	};
	
	var getConverter = exports.getConverter = function getConverter(path, _fromSystem, _toSystem) {
	  if (!_lodash2.default.includes(['si', 'ip'], _fromSystem)) {
	    throw new Error('expected fromSystem to be \'si\' or \'ip\'. received ' + _fromSystem);
	  }
	  if (!_lodash2.default.includes(['si', 'ip'], _toSystem)) {
	    throw new Error('expected toSystem to be \'si\' or \'ip\'. received ' + _toSystem);
	  }
	
	  if (_fromSystem === _toSystem) {
	    return _lodash2.default.identity;
	  }
	
	  var fromSystem = _fromSystem + '_units';
	  var toSystem = _toSystem + '_units';
	
	  var pathUnits = _lodash2.default.get(units, path);
	  if (!pathUnits || _lodash2.default.has(pathUnits, 'si_units') && pathUnits.si_units === pathUnits.ip_units) {
	    return _lodash2.default.identity;
	  }
	  if (_lodash2.default.has(pathUnits, 'si_units')) {
	    var factor = conversionFactor(pathUnits[fromSystem], pathUnits[toSystem]);
	    return function (val) {
	      return (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === (0, _typeof3.default)(0) ? val * factor : val;
	    };
	  }
	  if (pathUnits.$ref) {
	    return getConverter(pathUnits.$ref, _fromSystem, _toSystem);
	  }
	  if (pathUnits.arrayOf) {
	    var converter = getConverter(pathUnits.arrayOf, _fromSystem, _toSystem);
	    return function (arr) {
	      return arr.map(converter);
	    };
	  }
	  if (_lodash2.default.isObject(pathUnits)) {
	    var converters = _lodash2.default.mapValues(pathUnits, function (val, key) {
	      return getConverter(path + '.' + key, _fromSystem, _toSystem);
	    });
	    return function (obj) {
	      return _lodash2.default.mapValues(obj, function (val, key) {
	        return (converters[key] || _lodash2.default.identity)(val);
	      });
	    };
	  }
	  throw new Error('Path ' + path + ' did not lead to a useful spot in \'units\'');
	};
	
	var convertSchema = exports.convertSchema = function convertSchema(data, fromSystem, toSystem) {
	  return getConverter('$schema', fromSystem, toSystem)(data);
	};
	
	var convertState = exports.convertState = function convertState(data, fromSystem, toSystem) {
	  return getConverter('$state', fromSystem, toSystem)(data);
	};
	
	var convertLibrary = exports.convertLibrary = convertSchema;

/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"10","cy":"10","fill":"#bf0049","r":"5.6"}}),_c('path',{attrs:{"d":"M10.8 9.9L12.7 8c.2-.2.2-.6 0-.8-.2-.2-.6-.2-.8 0L10 9 8.1 7.1c-.2-.2-.6-.2-.8 0s-.3.7-.1.9l1.9 1.9-1.9 1.9c-.2.2-.2.6 0 .8.1.1.3.2.4.2s.3-.1.4-.2l1.9-1.9 1.9 1.9c.1.1.3.2.4.2s.3-.1.4-.2c.2-.2.2-.6 0-.8l-1.8-1.9z","fill":"#fff"}})])}}};

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = new _vue2.default();

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _open_floorplan = __webpack_require__(780);
	
	var _open_floorplan2 = _interopRequireDefault(_open_floorplan);
	
	var _save_floorplan = __webpack_require__(786);
	
	var _save_floorplan2 = _interopRequireDefault(_save_floorplan);
	
	var _import_library = __webpack_require__(778);
	
	var _import_library2 = _interopRequireDefault(_import_library);
	
	var _globe_icon = __webpack_require__(775);
	
	var _globe_icon2 = _interopRequireDefault(_globe_icon);
	
	var _undo = __webpack_require__(797);
	
	var _undo2 = _interopRequireDefault(_undo);
	
	var _redo = __webpack_require__(785);
	
	var _redo2 = _interopRequireDefault(_redo);
	
	var _tab_floorplan = __webpack_require__(790);
	
	var _tab_floorplan2 = _interopRequireDefault(_tab_floorplan);
	
	var _tab_shading = __webpack_require__(791);
	
	var _tab_shading2 = _interopRequireDefault(_tab_shading);
	
	var _tab_assign = __webpack_require__(788);
	
	var _tab_assign2 = _interopRequireDefault(_tab_assign);
	
	var _tab_components = __webpack_require__(789);
	
	var _tab_components2 = _interopRequireDefault(_tab_components);
	
	var _tool_draw_rectangle = __webpack_require__(794);
	
	var _tool_draw_rectangle2 = _interopRequireDefault(_tool_draw_rectangle);
	
	var _tool_draw_polygon = __webpack_require__(793);
	
	var _tool_draw_polygon2 = _interopRequireDefault(_tool_draw_polygon);
	
	var _tool_erase = __webpack_require__(795);
	
	var _tool_erase2 = _interopRequireDefault(_tool_erase);
	
	var _tool_move_size = __webpack_require__(796);
	
	var _tool_move_size2 = _interopRequireDefault(_tool_move_size);
	
	var _tool_color = __webpack_require__(792);
	
	var _tool_color2 = _interopRequireDefault(_tool_color);
	
	var _image_icon = __webpack_require__(777);
	
	var _image_icon2 = _interopRequireDefault(_image_icon);
	
	var _fill_icon = __webpack_require__(774);
	
	var _fill_icon2 = _interopRequireDefault(_fill_icon);
	
	var _lego_brick_icon = __webpack_require__(779);
	
	var _lego_brick_icon2 = _interopRequireDefault(_lego_brick_icon);
	
	var _zoom_to_fit = __webpack_require__(800);
	
	var _zoom_to_fit2 = _interopRequireDefault(_zoom_to_fit);
	
	var _zoom_in = __webpack_require__(798);
	
	var _zoom_in2 = _interopRequireDefault(_zoom_in);
	
	var _zoom_out = __webpack_require__(799);
	
	var _zoom_out2 = _interopRequireDefault(_zoom_out);
	
	var _pan = __webpack_require__(781);
	
	var _pan2 = _interopRequireDefault(_pan);
	
	var _add_image = __webpack_require__(764);
	
	var _add_image2 = _interopRequireDefault(_add_image);
	
	var _ground_props_icon = __webpack_require__(776);
	
	var _ground_props_icon2 = _interopRequireDefault(_ground_props_icon);
	
	var _components_window = __webpack_require__(772);
	
	var _components_window2 = _interopRequireDefault(_components_window);
	
	var _components_daylighting = __webpack_require__(771);
	
	var _components_daylighting2 = _interopRequireDefault(_components_daylighting);
	
	var _assign_bldgmodule = __webpack_require__(767);
	
	var _assign_bldgmodule2 = _interopRequireDefault(_assign_bldgmodule);
	
	var _assign_constructions = __webpack_require__(768);
	
	var _assign_constructions2 = _interopRequireDefault(_assign_constructions);
	
	var _assign_activity = __webpack_require__(766);
	
	var _assign_activity2 = _interopRequireDefault(_assign_activity);
	
	var _assign_thermalzone = __webpack_require__(770);
	
	var _assign_thermalzone2 = _interopRequireDefault(_assign_thermalzone);
	
	var _assign_roof = __webpack_require__(769);
	
	var _assign_roof2 = _interopRequireDefault(_assign_roof);
	
	var _quickstart_icon_new_map_floorplan = __webpack_require__(782);
	
	var _quickstart_icon_new_map_floorplan2 = _interopRequireDefault(_quickstart_icon_new_map_floorplan);
	
	var _quickstart_icon_newfloorplan = __webpack_require__(783);
	
	var _quickstart_icon_newfloorplan2 = _interopRequireDefault(_quickstart_icon_newfloorplan);
	
	var _quickstart_icon_openfloorplan = __webpack_require__(784);
	
	var _quickstart_icon_openfloorplan2 = _interopRequireDefault(_quickstart_icon_openfloorplan);
	
	var _info_icon = __webpack_require__(273);
	
	var _info_icon2 = _interopRequireDefault(_info_icon);
	
	var _settings_gear = __webpack_require__(787);
	
	var _settings_gear2 = _interopRequireDefault(_settings_gear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComponentIcon = {
	  name: 'ComponentIcon',
	  props: ['which'],
	  template: '\n    <ComponentsWindow v-if="which === \'window_definitions\'" class="button" />\n    <ComponentsDaylighting v-else-if="which === \'daylighting_control_definitions\'" class="button" />\n  ',
	  components: {
	    ComponentsWindow: _components_window2.default,
	    ComponentsDaylighting: _components_daylighting2.default
	  }
	};
	
	var AssignSpacePropIcon = {
	  name: 'AssignSpacePropIcon',
	  props: ['which'],
	  template: '\n    <AssignBldgModule v-if="which === \'building_units\'" class="button" />\n    <AssignThermalZone v-else-if="which === \'thermal_zones\'" class="button" />\n    <AssignActivity v-else-if="which === \'space_types\'" class="button" />\n    <AssignRoof v-else-if="which === \'pitched_roofs\'" class="button" />\n  ',
	  components: {
	    AssignBldgModule: _assign_bldgmodule2.default,
	    AssignThermalZone: _assign_thermalzone2.default,
	    AssignActivity: _assign_activity2.default,
	    AssignRoof: _assign_roof2.default
	  }
	};
	
	exports.default = {
	  'open-floorplan-svg': _open_floorplan2.default,
	  'save-floorplan-svg': _save_floorplan2.default,
	  'import-library-svg': _import_library2.default,
	  'globe-icon-svg': _globe_icon2.default,
	  'undo-svg': _undo2.default,
	  'redo-svg': _redo2.default,
	  'tab-floorplan-svg': _tab_floorplan2.default,
	  'tab-shading-svg': _tab_shading2.default,
	  'tab-assign-svg': _tab_assign2.default,
	  'tab-components-svg': _tab_components2.default,
	
	  'tool-color-svg': _tool_color2.default,
	  'tool-draw-rectangle-svg': _tool_draw_rectangle2.default,
	  'tool-draw-polygon-svg': _tool_draw_polygon2.default,
	  'tool-erase-svg': _tool_erase2.default,
	  'tool-move-size-svg': _tool_move_size2.default,
	  'tool-image-svg': _image_icon2.default,
	  'tool-fill-svg': _fill_icon2.default,
	  'tool-component-svg': _lego_brick_icon2.default,
	
	  'zoom-in-svg': _zoom_in2.default,
	  'zoom-out-svg': _zoom_out2.default,
	  'pan-svg': _pan2.default,
	  'add-image': _add_image2.default,
	  ZoomToFitSvg: _zoom_to_fit2.default,
	
	  ComponentIcon: ComponentIcon,
	  AssignSpacePropIcon: AssignSpacePropIcon,
	
	  QuickstartIconNewMapFloorplan: _quickstart_icon_new_map_floorplan2.default,
	  QuickstartIconNewFloorplan: _quickstart_icon_newfloorplan2.default,
	  QuickstartIconOpenFloorplan: _quickstart_icon_openfloorplan2.default,
	
	  InfoIcon: _info_icon2.default,
	  SettingsGear: _settings_gear2.default,
	  GroundPropertiesIcon: _ground_props_icon2.default
	};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(76);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(56);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.withPreservedComponents = withPreservedComponents;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(16);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _snapping = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function facesContainingEdge(faces, edge_id) {
	  return _lodash2.default.filter(faces, function (f) {
	    return _lodash2.default.chain(f.edges).map('id').includes(edge_id).value();
	  });
	}
	
	function componentsOnStory(state, geometry_id) {
	  var geom = _helpers2.default.denormalize(state.geometry.find(function (g) {
	    return g.id === geometry_id;
	  })),
	      story = state.models.stories.find(function (s) {
	    return s.geometry_id === geometry_id;
	  });
	
	  var perFaceComponents = story.spaces.map(function (space) {
	    return {
	      daylighting_controls: space.daylighting_controls.map(function (d) {
	        return (0, _extends3.default)({}, d, { vertex: _lodash2.default.find(geom.vertices, { id: d.vertex_id }) });
	      }),
	      space_id: space.id,
	      face_id: space.face_id
	    };
	  });
	  return {
	    geometry_id: geometry_id,
	    story_id: story.id,
	    windows: story.windows.map(function (w) {
	      var edge = _lodash2.default.find(geom.edges, { id: w.edge_id }),
	          faces = facesContainingEdge(geom.faces, w.edge_id);
	      return (0, _extends3.default)({}, w, {
	        originalLoc: (0, _snapping.windowLocation)(edge, w),
	        originalFaceIds: _lodash2.default.map(faces, 'id')
	      });
	    }),
	    doors: story.doors.map(function (d) {
	      var edge = _lodash2.default.find(geom.edges, { id: d.edge_id }),
	          faces = facesContainingEdge(geom.faces, d.edge_id);
	      return (0, _extends3.default)({}, d, {
	        originalLoc: (0, _snapping.windowLocation)(edge, d),
	        originalFaceIds: _lodash2.default.map(faces, 'id')
	      });
	    }),
	    perFaceComponents: perFaceComponents
	  };
	}
	
	function replaceComponents(context, components) {
	  var movementsByFaceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var geometry_id = components.geometry_id,
	      story_id = components.story_id,
	      windows = components.windows,
	      doors = components.doors,
	      perFaceComponents = components.perFaceComponents,
	      geometry = _helpers2.default.denormalize(_lodash2.default.find(context.rootState.geometry, { id: geometry_id })),
	      story = _lodash2.default.find(context.rootState.models.stories, { id: story_id }),
	      spaceFaces = geometry.faces.filter(function (f) {
	    return _lodash2.default.find(story.spaces, { face_id: f.id });
	  }),
	      spacing = context.rootState.project.grid.spacing;
	
	  context.dispatch('models/destroyAllComponents', { story_id: story_id }, { root: true });
	
	  var edgesPresentOnFaces = _lodash2.default.flatMap(spaceFaces, 'edges');
	
	  var replaceWindowOrDoor = function replaceWindowOrDoor(arr, windowOrDoor) {
	    var windowsOrDoors = [];
	    arr.forEach(function (w) {
	      var _ref = movementsByFaceId[w.originalFaceIds[0]] || { dx: 0, dy: 0 },
	          dx = _ref.dx,
	          dy = _ref.dy,
	          newLoc = { x: w.originalLoc.x + dx, y: w.originalLoc.y + dy },
	          loc = (0, _snapping.snapWindowToEdge)('nonstrict', edgesPresentOnFaces, newLoc, { width: 1 }, spacing / 4);
	
	      if (!loc) {
	        return;
	      }
	
	      var facesWithEdge = facesContainingEdge(spaceFaces, loc.edge_id).map(function (f) {
	        return f.id;
	      });
	      if (w.originalFaceIds.length !== facesWithEdge.length || w.originalFaceIds.length > 1 && _lodash2.default.intersection((0, _keys2.default)(movementsByFaceId), w.originalFaceIds)) {
	        return;
	      }
	
	      windowsOrDoors.push((0, _defineProperty3.default)({
	        story_id: story_id,
	        edge_id: loc.edge_id,
	        alpha: loc.alpha
	      }, windowOrDoor.toLowerCase() + '_definition_id', w.window_definition_id || w.door_definition_id));
	    });
	
	    context.dispatch('models/create' + windowOrDoor + 's', windowsOrDoors, { root: true });
	  };
	
	  replaceWindowOrDoor(windows, 'Window');
	  replaceWindowOrDoor(doors, 'Door');
	
	  perFaceComponents.forEach(function (_ref2) {
	    var face_id = _ref2.face_id,
	        daylighting_controls = _ref2.daylighting_controls;
	
	    daylighting_controls.forEach(function (d) {
	      var _ref3 = movementsByFaceId[face_id] || { dx: 0, dy: 0 },
	          dx = _ref3.dx,
	          dy = _ref3.dy,
	          newLoc = { x: d.vertex.x + dx, y: d.vertex.y + dy },
	          loc = (0, _snapping.snapToVertexWithinFace)('nonstrict', spaceFaces, newLoc, spacing / 4);
	
	      if (!loc) {
	        return;
	      }
	
	      context.dispatch('models/createDaylightingControl', {
	        daylighting_control_definition_id: d.daylighting_control_definition_id,
	        x: loc.x,
	        y: loc.y,
	        story_id: story_id,
	        face_id: loc.face_id
	      }, { root: true });
	    });
	  });
	}
	
	function withPreservedComponents() {
	  var context = void 0,
	      geometry_id = void 0,
	      action = void 0,
	      movementsByFaceId = void 0;
	
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (args.length === 3) {
	    context = args[0];
	    geometry_id = args[1];
	    action = args[2];
	
	    movementsByFaceId = {};
	  } else if (args.length === 4) {
	    context = args[0];
	    geometry_id = args[1];
	    movementsByFaceId = args[2];
	    action = args[3];
	  } else {
	    throw new Error('usage: withPreservedComponents(context, geometry_id, action [,movementsByFaceId])');
	  }
	
	  var components = componentsOnStory(context.rootState, geometry_id);
	  action();
	  replaceComponents(context, components, movementsByFaceId);
	}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(346);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _mutations = __webpack_require__(348);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _getters = __webpack_require__(347);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  namespaced: true,
	  state: {
	    config: {
	      units: 'ip',
	      unitsEditable: true,
	      language: 'EN-US'
	    },
	    north_axis: 0,
	    ground: {
	      floor_offset: 0,
	      azimuth_angle: 0,
	      tilt_slope: 0
	    },
	    grid: {
	      visible: true,
	      spacing: 5
	    },
	    view: {
	      min_x: -250,
	      min_y: -150,
	      max_x: 250,
	      max_y: 150
	    },
	    map: {
	      initialized: false,
	      enabled: true,
	      visible: true,
	      latitude: 39.7653,
	      longitude: -104.9863,
	      zoom: 4.5,
	      rotation: 0,
	      elevation: 0
	    },
	    previous_story: {
	      visible: true
	    },
	    show_import_export: true,
	    preview3D: {
	      enabled: true
	    }
	  },
	  actions: _actions2.default,
	  mutations: _mutations2.default,
	  getters: _getters2.default
	};

/***/ }),
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports) {

	module.exports = {"$schema":"http://json-schema.org/draft-04/schema#","version":"0.7.0","description":"Comment describing your JSON Schema","type":"object","properties":{"version":{"description":"File format version","type":"string"},"application":{"$ref":"#/definitions/Application"},"project":{"$ref":"#/definitions/Project"},"stories":{"type":"array","items":{"$ref":"#/definitions/Story"}},"building_units":{"type":"array","items":{"$ref":"#/definitions/BuildingUnit"}},"thermal_zones":{"type":"array","items":{"$ref":"#/definitions/ThermalZone"}},"space_types":{"type":"array","items":{"$ref":"#/definitions/SpaceType"}},"construction_sets":{"type":"array","items":{"$ref":"#/definitions/ConstructionSet"}},"window_definitions":{"type":"array","items":{"$ref":"#/definitions/WindowDefinition"}},"door_definitions":{"type":"array","items":{"$ref":"#/definitions/DoorDefinition"}},"daylighting_control_definitions":{"type":"array","items":{"$ref":"#/definitions/DaylightingControlDefinition"}},"pitched_roofs":{"type":"array","items":{"$ref":"#/definitions/PitchedRoof"}}},"required":["version","application","project","stories","building_units","thermal_zones","space_types","construction_sets","window_definitions","door_definitions","daylighting_control_definitions","pitched_roofs"],"definitions":{"Application":{"description":"Reserved for application data, not for external use","type":"object"},"Project":{"description":"Information that applies to the entire project","type":"object","properties":{"config":{"type":"object","properties":{"units":{"type":["string","null"],"enum":["ip","si"],"default":"ip"},"language":{"type":["string","null"],"default":"EN-US"}},"required":["units","language"]},"north_axis":{"description":"Angle between building north and true north in degrees (clockwise is positive)","type":["number","null"],"default":0,"si_units":"deg","ip_units":"deg"},"ground":{"type":"object","properties":{"floor_offset":{"description":"Specifies the vertical offset between the building floor and the ground plane. Use a value < 0 for buildings with below-grade spaces, or a value > 0 for, e.g., buildings on piers.","type":["number","null"],"default":0,"si_units":"m","ip_units":"ft"},"azimuth_angle":{"description":"Direction of the ground plane, in clockwise degrees from the positive y-axis when viewed from above.","type":["number","null"],"default":0,"si_units":"deg","ip_units":"deg"},"tilt_slope":{"description":"Slope of the ground plane from horizontal. For example, a value of 1 implies a 45-deg angle.","type":["number","null"],"default":0}},"required":["floor_offset","azimuth_angle","tilt_slope"]},"grid":{"type":"object","properties":{"visible":{"type":["boolean","null"]},"spacing":{"type":["number","null"],"si_units":"m","ip_units":"ft"}},"required":["visible","spacing"]},"view":{"type":"object","properties":{"min_x":{"type":["number","null"],"si_units":"m","ip_units":"ft"},"min_y":{"type":["number","null"],"si_units":"m","ip_units":"ft"},"max_x":{"type":["number","null"],"si_units":"m","ip_units":"ft"},"max_y":{"type":["number","null"],"si_units":"m","ip_units":"ft"}},"required":["min_x","min_y","max_x","max_y"]},"map":{"type":"object","properties":{"visible":{"type":["boolean","null"]},"latitude":{"type":["number","null"]},"longitude":{"type":["number","null"]},"zoom":{"type":["number","null"]},"elevation":{"type":["number","null"],"si_units":"m","ip_units":"ft"},"enabled":{"type":["boolean","null"]},"initialized":{"type":["boolean","null"]},"rotation":{"type":["number","null"],"si_units":"deg","ip_units":"deg"}},"required":["visible","latitude","longitude","zoom","elevation","enabled","initialized","rotation"]},"previous_story":{"type":"object","properties":{"visible":{"type":["boolean","null"]}},"required":["visible"]},"show_import_export":{"type":["boolean","null"]}},"required":["config","north_axis","ground","grid","view","map","previous_story","show_import_export"]},"Geometry":{"type":"object","properties":{"id":{"type":"string"},"vertices":{"type":"array","items":{"$ref":"#/definitions/Vertex"}},"edges":{"type":"array","items":{"$ref":"#/definitions/Edge"}},"faces":{"type":"array","items":{"$ref":"#/definitions/Face"}}},"required":["id","vertices","edges","faces"]},"Vertex":{"type":"object","properties":{"id":{"type":"string"},"x":{"type":"number","si_units":"m","ip_units":"ft"},"y":{"type":"number","si_units":"m","ip_units":"ft"},"edge_ids":{"type":"array","items":{"type":"string"}}},"required":["id","x","y","edge_ids"]},"Edge":{"type":"object","properties":{"id":{"type":"string"},"vertex_ids":{"type":"array","minItems":2,"maxItems":2,"uniqueItems":true,"items":{"type":"string"}},"face_ids":{"type":"array","minItems":1,"maxItems":2,"items":{"type":"string"}}},"required":["id","vertex_ids","face_ids"]},"Face":{"type":"object","properties":{"id":{"type":"string"},"edge_ids":{"type":"array","minItems":3,"items":{"type":"string"}},"edge_order":{"type":"array","minItems":3,"items":{"type":"number","enum":[0,1]}}},"required":["id","edge_ids","edge_order"]},"Story":{"type":"object","properties":{"id":{"type":"string"},"handle":{"type":["string","null"]},"name":{"type":["string","null"]},"image_visible":{"type":["boolean","null"],"default":true},"below_floor_plenum_height":{"type":["number","null"],"minimum":0,"default":0,"si_units":"m","ip_units":"ft"},"floor_to_ceiling_height":{"type":["number","null"],"minimum":0,"default":8,"si_units":"m","ip_units":"ft"},"above_ceiling_plenum_height":{"type":["number","null"],"minimum":0,"default":0,"si_units":"m","ip_units":"ft"},"multiplier":{"type":["integer","null"],"minimum":1,"multipleOf":1,"default":1},"color":{"$ref":"#/definitions/HexColor"},"geometry":{"$ref":"#/definitions/Geometry"},"images":{"type":"array"},"spaces":{"type":"array","items":{"$ref":"#/definitions/Space"}},"shading":{"type":"array","items":{"$ref":"#/definitions/Shading"}},"windows":{"type":"array","items":{"type":"object","properties":{"window_definition_id":{"type":"string"},"edge_id":{"type":"string"},"alpha":{"description":"Distance along edge to center point of window, starting from first vertex of edge at a = 0 and ending at second vertex of edge at a =1.  v = v1 + a*(v2-v1).  Does not apply if window_definition_mode is \"Window to Wall Ratio\". Will be an array of such values if window_definition_mode is \"Repeating Windows\".","type":["array","number","null"],"minimum":0,"maximum":1,"items":{"type":"number","minimum":0,"maximum":1}}},"required":["window_definition_id","edge_id","alpha"]}},"doors":{"type":"array","items":{"type":"object","properties":{"door_definition_id":{"type":"string"},"edge_id":{"type":"string"},"alpha":{"description":"Distance along edge to center point of door, starting from first vertex of edge at a = 0 and ending at second vertex of edge at a =1.  v = v1 + a*(v2-v1). ","type":"number","minimum":0,"maximum":1}},"required":["door_definition_id","edge_id","alpha"]}}},"required":["id","handle","name","image_visible","below_floor_plenum_height","floor_to_ceiling_height","above_ceiling_plenum_height","multiplier","color","geometry","images","spaces","shading","windows","doors"]},"Space":{"type":"object","properties":{"id":{"type":"string"},"handle":{"type":["string","null"]},"name":{"type":["string","null"]},"face_id":{"type":["string","null"]},"building_unit_id":{"type":["string","null"]},"thermal_zone_id":{"type":["string","null"]},"space_type_id":{"type":["string","null"]},"construction_set_id":{"type":["string","null"]},"pitched_roof_id":{"type":["string","null"]},"daylighting_controls":{"type":"array","items":{"type":"object","properties":{"daylighting_control_definition_id":{"type":"string"},"vertex_id":{"type":"string"}},"required":["daylighting_control_definition_id","vertex_id"]}},"below_floor_plenum_height":{"description":"If provided, overrides the story below_floor_plenum_height.","type":["number","null"],"minimum":0,"si_units":"m","ip_units":"ft"},"floor_to_ceiling_height":{"description":"If provided, overrides the story floor_to_ceiling_height.","type":["number","null"],"minimum":0,"si_units":"m","ip_units":"ft"},"above_ceiling_plenum_height":{"description":"If provided, overrides the story above_ceiling_plenum_height.","type":["number","null"],"minimum":0,"si_units":"m","ip_units":"ft"},"floor_offset":{"description":"If provided, specifies the vertical offset between the space floor and the story floor.","type":["number","null"],"si_units":"m","ip_units":"ft"},"open_to_below":{"description":"If true, defines a space that is open to below (has no floor).","type":["boolean","null"]}},"required":["id","handle","name","face_id","building_unit_id","thermal_zone_id","space_type_id","construction_set_id","pitched_roof_id","daylighting_controls","below_floor_plenum_height","floor_to_ceiling_height","above_ceiling_plenum_height","floor_offset","open_to_below"]},"Shading":{"type":"object","properties":{"id":{"type":"string"},"handle":{"type":["string","null"]},"name":{"type":["string","null"]},"face_id":{"type":["string","null"]}},"required":["id","handle","name","face_id"]},"ThermalZone":{"type":"object","properties":{"id":{"type":"string"},"handle":{"type":["string","null"]},"name":{"type":["string","null"]},"color":{"$ref":"#/definitions/HexColor"}},"required":["id","handle","name","color"]},"SpaceType":{"type":"object","properties":{"id":{"type":"string"},"handle":{"type":["string","null"]},"name":{"type":["string","null"]},"color":{"$ref":"#/definitions/HexColor"}},"required":["id","handle","name","color"]},"BuildingUnit":{"type":"object","properties":{"id":{"type":"string"},"handle":{"type":["string","null"]},"name":{"type":["string","null"]},"color":{"$ref":"#/definitions/HexColor"}},"required":["id","handle","name","color"]},"ConstructionSet":{"type":"object","properties":{"id":{"type":"string"},"handle":{"type":["string","null"]},"name":{"type":["string","null"]}},"required":["id","handle","name"]},"WindowDefinition":{"type":"object","properties":{"id":{"type":"string"},"name":{"type":["string","null"]},"window_definition_mode":{"type":"string","enum":["Single Window","Repeating Windows","Window to Wall Ratio"],"default":"Single Window"},"wwr":{"description":"Target window to wall ratio, only used if window_definition_mode is \"Window to Wall Ratio\"","type":["number","null"],"minimum":0,"maximum":1,"exclusiveMaximum":true,"default":0.2},"sill_height":{"description":"Vertical distance from the floor to the window sill. In drawing units.","type":["number","null"],"minimum":0,"exclusiveMinimum":true,"default":3,"si_units":"m","ip_units":"ft"},"window_spacing":{"description":"Spacing between windows.  Only used if window_definition_mode is  \"Repeating Windows\".","type":["number","null"],"minimum":0,"exclusiveMinimum":true,"default":4,"si_units":"m","ip_units":"ft"},"height":{"description":"Vertical height of each window. In drawing units. Used if window_definition_mode is \"Single Window\" or \"Repeating Windows\".","type":["number","null"],"minimum":0,"exclusiveMinimum":true,"default":4,"si_units":"m","ip_units":"ft"},"width":{"description":"Horizontal width of each window. In drawing units. Used if window_definition_mode is \"Single Window\" or \"Repeating Windows\".","type":["number","null"],"minimum":0,"exclusiveMinimum":true,"default":2,"si_units":"m","ip_units":"ft"},"window_type":{"type":"string","enum":["Fixed","Operable"],"default":"Fixed"},"overhang_projection_factor":{"description":"Projection factor for overhangs, set to null for no overhang.  Overhang depth = overhang_projection_factor*height.","type":["number","null"],"minimum":0,"exclusiveMinimum":true,"default":null},"fin_projection_factor":{"description":"Projection factor for fins, set to null for no overhang. Projection factor for overhangs, set to null for no overhang.  Fin depth = fin_projection_factor*height.","type":["number","null"],"minimum":0,"exclusiveMinimum":true,"default":null},"texture":{"description":"Internal attribute representing how this window group is displayed. Applies only if window_definition_mode is \"Window to Wall Ratio\".","type":["string","null"],"default":null}},"required":["id","name","window_definition_mode","wwr","sill_height","window_spacing","height","width","window_type","overhang_projection_factor","fin_projection_factor"]},"DoorDefinition":{"type":"object","properties":{"id":{"type":"string"},"name":{"type":["string","null"]},"height":{"description":"Vertical height of each door. In drawing units.","type":"number","minimum":0,"exclusiveMinimum":true,"default":6.67,"si_units":"m","ip_units":"ft"},"width":{"description":"Horizontal width of each door. In drawing units.","type":"number","minimum":0,"exclusiveMinimum":true,"default":3,"si_units":"m","ip_units":"ft"},"door_type":{"type":"string","enum":["Door","Glass Door","Overhead Door"],"default":"Door"}},"required":["id","name","height","width","door_type"]},"DaylightingControlDefinition":{"type":"object","properties":{"id":{"type":"string"},"name":{"type":["string","null"]},"illuminance_setpoint":{"description":"Setpoint for daylighting control.","type":"number","default":300,"si_units":"lux","ip_units":"fc"},"height":{"description":"Vertical distance of sensor above floor.  In drawing units.","type":"number","default":3,"si_units":"m","ip_units":"ft"}},"required":["id","name","illuminance_setpoint","height"]},"PitchedRoof":{"type":"object","properties":{"id":{"type":"string"},"name":{"type":["string","null"]},"pitched_roof_type":{"type":"string","enum":["Gable","Hip","Shed"],"default":"Gable"},"pitch":{"description":"Pitch of roof. A value of 6, for example, implies a 6 in 12 pitch (or 26.57 degrees).","type":"number","minimum":0,"default":6},"shed_direction":{"description":"Direction of shed roof, from low edge to high edge, in clockwise degrees from the positive y-axis when viewed from above.","type":["number","null"],"default":0,"si_units":"deg","ip_units":"deg"},"color":{"$ref":"#/definitions/HexColor"}},"required":["id","name","pitched_roof_type","pitch","shed_direction","color"]},"HexColor":{"type":["string","null"],"pattern":"^#[a-fA-F0-9]{6}$"}}}

/***/ }),
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(674)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(309),
	  /* template */
	  __webpack_require__(738),
	  /* scopeId */
	  "data-v-14ece691",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(686)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(315),
	  /* template */
	  __webpack_require__(753),
	  /* scopeId */
	  "data-v-6bbb2c29",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(675)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(318),
	  /* template */
	  __webpack_require__(739),
	  /* scopeId */
	  "data-v-20be75f3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"fill":"#FFF","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},[_c('switch',[_c('g',[_c('path',{attrs:{"d":"M82.992 97.5h-49.23a3.853 3.853 0 0 1-3.852-3.852V23.101a3.853 3.853 0 0 1 3.852-3.851h49.23a3.853 3.853 0 0 1 3.852 3.851v70.548a3.853 3.853 0 0 1-3.852 3.851zm-45.379-7.703H79.14V26.952H37.613v62.845z"}}),_c('path',{attrs:{"d":"M25.834 80.751h-8.826a3.854 3.854 0 0 1-3.852-3.852V6.352A3.853 3.853 0 0 1 17.008 2.5h50.523a3.853 3.853 0 0 1 3.852 3.852v8.826H63.68v-4.975H20.859v62.845h4.975v7.703z"}})])])])}}};

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 100 100"}},[_c('title',[_v("Artboard 10")]),_c('path',{attrs:{"d":"M50 18a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm4 49h-8V47h8zm0-26h-8v-8h8z"}})])}}};

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(27);
	
	var _portalVue = __webpack_require__(265);
	
	var _Navigation = __webpack_require__(731);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Grid = __webpack_require__(722);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Canvas = __webpack_require__(715);
	
	var _Canvas2 = _interopRequireDefault(_Canvas);
	
	var _Toolbar = __webpack_require__(736);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _ImageUpload = __webpack_require__(723);
	
	var _ImageUpload2 = _interopRequireDefault(_ImageUpload);
	
	var _Inspector = __webpack_require__(725);
	
	var _Inspector2 = _interopRequireDefault(_Inspector);
	
	var _Textures = __webpack_require__(735);
	
	var _Textures2 = _interopRequireDefault(_Textures);
	
	var _Resize = __webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      error: null,
	      success: null,
	      navigationExpanded: false
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    this.$store.dispatch('models/initStory');
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.eventBus.$on('error', function (err) {
	      _this.error = err;
	      setTimeout(function () {
	        _this.error = null;
	      }, 5000);
	    });
	    window.eventBus.$on('success', function (msg) {
	      _this.success = msg;
	      setTimeout(function () {
	        _this.success = null;
	      }, 5000);
	    });
	    window.eventBus.$on('reload-grid', function () {
	      document.getElementById('svg-grid').dispatchEvent(new Event('reloadGrid'));
	    });
	
	    document.addEventListener('keydown', function (e) {
	      if (!_this.$store.timetravel) {
	        return;
	      }
	      if (e.keyCode === 90 && (e.ctrlKey || e.metaKey)) {
	        e.shiftKey ? _this.$store.timetravel.redo() : _this.$store.timetravel.undo();
	        e.preventDefault();
	      } else if (e.keyCode == 89 && (e.ctrlKey || e.metaKey)) {
	        _this.$store.timetravel.redo();
	        e.preventDefault();
	      }
	    });
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({ tool: function tool(state) {
	      return state.application.currentSelections.tool;
	    } })),
	  components: {
	    'grid-view': _Grid2.default,
	    'canvas-view': _Canvas2.default,
	    'inspector-view': _Inspector2.default,
	    navigation: _Navigation2.default,
	    toolbar: _Toolbar2.default,
	    ImageUpload: _ImageUpload2.default,
	    Textures: _Textures2.default,
	    PortalTarget: _portalVue.PortalTarget
	  }
	};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Map = __webpack_require__(716);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _vuex = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'app',
	    data: function data() {
	        return {};
	    },
	
	    computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	        mapEnabled: function mapEnabled(state) {
	            return state.project.map.enabled;
	        },
	        mapVisible: function mapVisible(state) {
	            return state.project.map.visible;
	        },
	        northAxis: function northAxis(state) {
	            return state.project.north_axis;
	        }
	    })),
	    components: {
	        'map-view': _Map2.default
	    }
	};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(27);
	
	var _Resize = __webpack_require__(129);
	
	var _MapModal = __webpack_require__(728);
	
	var _MapModal2 = _interopRequireDefault(_MapModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var googleMaps = __webpack_require__(696)('AIzaSyDIja3lnhq63SxukBm9_mA-jn5R0Bj9RN8', ['places']);
	var ol = __webpack_require__(702);
	var d3 = __webpack_require__(85);
	
	exports.default = {
	  name: 'map-view',
	  data: function data() {
	    return {
	      view: null,
	      map: null,
	      startResolution: null,
	      autocomplete: null,
	      mapModalVisible: window.api ? window.api.config.showMapDialogOnStart : true,
	      showGrid: false
	    };
	  },
	  mounted: function mounted() {
	    this.showGrid = this.gridVisible;
	
	    this.initAutoComplete();
	    this.loadMap();
	    _Resize.ResizeEvents.$on('resize', this.updateMapView);
	    window.eventBus.$on('boundsResolved', this.clearStartResolution);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _Resize.ResizeEvents.$off('resize', this.updateMapView);
	    window.eventBus.$off('boundsResolved', this.clearStartResolution);
	  },
	
	
	  methods: {
	    clearStartResolution: function clearStartResolution() {
	      this.startResolution = null;
	      this.updateMapView();
	    },
	    initAutoComplete: function initAutoComplete() {
	      var _this = this;
	
	      googleMaps().then(function (maps) {
	        var autocomplete = new maps.places.Autocomplete(_this.$refs.addressSearch);
	
	        autocomplete.addListener('place_changed', function () {
	          var place = autocomplete.getPlace();
	          if (place.geometry) {
	            _this.latitude = place.geometry.location.lat();
	            _this.longitude = place.geometry.location.lng();
	            _this.updateMapView();
	          }
	        });
	      });
	    },
	    loadMap: function loadMap() {
	      var _this2 = this;
	
	      window.ol = ol;
	      this.$refs.map.innerHTML = '';
	      this.view = new ol.View();
	      this.map = new ol.Map({
	        layers: [new ol.layer.Tile({ source: new ol.source.OSM() })],
	        target: 'map',
	        view: this.view
	      });
	      this.view.on('propertychange', function (e) {
	        if (e.key === 'rotation') {
	          _this2.rotation = _this2.view.getRotation();
	        }
	      });
	
	      this.updateMapView();
	
	      _.defer(function () {
	        return _this2.updateMapView();
	      });
	    },
	    updateMapView: function updateMapView() {
	      console.log('updateMapView');
	      this.map.updateSize();
	
	      var mapCenter = ol.proj.fromLonLat([this.longitude, this.latitude]);
	
	      var resolution = this.unAdjustedResolution;
	      var deltaY = this.unAdjustedDelta.y;
	      var deltaX = this.unAdjustedDelta.x;
	
	      if (this.view.getCenter()) {
	        this.startResolution = this.startResolution || ol.proj.getPointResolution(this.view.getProjection(), this.view.getResolution(), this.view.getCenter());
	        var resolutionAdjustment = 1 / ol.proj.getPointResolution(this.view.getProjection(), 1, this.view.getCenter());
	
	        resolution *= resolutionAdjustment;
	        deltaY *= resolutionAdjustment;
	        deltaX *= resolutionAdjustment;
	      }
	
	      mapCenter[0] += deltaY;
	      mapCenter[1] += deltaX;
	
	      this.view.setResolution(resolution);
	      this.view.setCenter(mapCenter);
	      this.view.setRotation(this.rotation);
	    },
	    finishSetup: function finishSetup() {
	      var center = ol.proj.transform(this.view.getCenter(), 'EPSG:3857', 'EPSG:4326');
	      this.longitude = center[0];
	      this.latitude = center[1];
	
	      var resolution = ol.proj.getPointResolution(this.view.getProjection(), this.view.getResolution(), this.view.getCenter());
	      var scale = this.startResolution / resolution;
	      console.log('scaling to ' + this.startResolution + ' / ' + resolution + ' == ' + scale);
	      window.eventBus.$emit('scaleTo', scale);
	
	      this.rotation = this.view.getRotation();
	
	      this.$store.dispatch('project/setMapInitialized', { initialized: true });
	
	      this.tool = 'Rectangle';
	
	      d3.select('#reticle').remove();
	
	      this.gridVisible = this.showGrid;
	    },
	    showReticle: function showReticle() {
	      if (this.tool !== 'Map') {
	        return;
	      }
	
	      this.gridVisible = false;
	
	      var size = 100;
	      var x = this.$refs.map.clientWidth / 2;
	      var y = this.$refs.map.clientHeight / 2;
	
	      d3.select('#reticle').selectAll('#reticle path').data([[{ x: x, y: y - size }, { x: x, y: y + size }], [{ x: x - size, y: y }, { x: x + size, y: y }]]).enter().append('path').attr('stroke-width', '1').attr('stroke', 'gray').attr('d', d3.line().x(function (d) {
	        return d.x;
	      }).y(function (d) {
	        return d.y;
	      }));
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    projectView: function projectView(state) {
	      return state.project.view;
	    },
	    min_x: function min_x(state) {
	      return state.project.view.min_x;
	    },
	    max_x: function max_x(state) {
	      return state.project.view.max_x;
	    },
	    min_y: function min_y(state) {
	      return state.project.view.min_y;
	    },
	    max_y: function max_y(state) {
	      return state.project.view.max_y;
	    },
	    units: function units(state) {
	      return state.project.config.units;
	    },
	    mapInitialized: function mapInitialized(state) {
	      return state.project.map.initialized;
	    }
	  }), {
	    mPerFt: function mPerFt() {
	      return ol.proj.METERS_PER_UNIT['us-ft'];
	    },
	    unAdjustedResolutionMeters: function unAdjustedResolutionMeters() {
	      return (this.max_x - this.min_x) / this.$refs.map.clientWidth;
	    },
	    unAdjustedResolution: function unAdjustedResolution() {
	      return this.units === 'ip' ? this.mPerFt * this.unAdjustedResolutionMeters : this.unAdjustedResolutionMeters;
	    },
	    gridCenterMeters: function gridCenterMeters() {
	      return {
	        x: (this.min_x + this.max_x) / 2,
	        y: (this.min_y + this.max_y) / 2
	      };
	    },
	    gridCenter: function gridCenter() {
	      var _this3 = this;
	
	      return this.units === 'ip' ? _.mapValues(this.gridCenterMeters, function (v) {
	        return v * _this3.mPerFt;
	      }) : this.gridCenterMeters;
	    },
	    unAdjustedDelta: function unAdjustedDelta() {
	      var deltaY = this.gridCenter.x * Math.cos(this.rotation) - this.gridCenter.y * Math.sin(this.rotation);
	      var deltaX = this.gridCenter.y * Math.cos(this.rotation) + this.gridCenter.x * Math.sin(this.rotation);
	      return { x: deltaX, y: deltaY };
	    },
	
	
	    gridVisible: {
	      get: function get() {
	        return this.$store.state.project.grid.visible;
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/setGridVisible', { visible: val });
	      }
	    },
	    tool: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.tool;
	      },
	      set: function set(val) {
	        this.$store.dispatch('application/setCurrentTool', { tool: val });
	      }
	    },
	    latitude: {
	      get: function get() {
	        return this.$store.state.project.map.latitude;
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/setMapLatitude', { latitude: val });
	      }
	    },
	    longitude: {
	      get: function get() {
	        return this.$store.state.project.map.longitude;
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/setMapLongitude', { longitude: val });
	      }
	    },
	    rotation: {
	      get: function get() {
	        return this.$store.state.project.map.rotation;
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/setMapRotation', { rotation: val });
	      }
	    }
	  }),
	  watch: {
	    units: function units() {
	      this.updateMapView();
	    },
	
	    projectView: {
	      handler: function handler() {
	        this.updateMapView();
	      },
	
	      deep: true
	    }
	  },
	  components: {
	    MapModal: _MapModal2.default
	  }
	};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _libconfig = __webpack_require__(101);
	
	var _libconfig2 = _interopRequireDefault(_libconfig);
	
	var _vuex = __webpack_require__(27);
	
	var _EditBar = __webpack_require__(718);
	
	var _EditBar2 = _interopRequireDefault(_EditBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    componentInstance: 'application/currentComponentInstance',
	    currentStory: 'application/currentStory',
	    currentComponent: 'application/currentComponent'
	  }), {
	    instanceType: function instanceType() {
	      return this.componentInstance && this.componentInstance.type;
	    },
	    columns: function columns() {
	      if (!this.componentInstance) {
	        return [];
	      }
	      return _libconfig2.default[this.instanceType].columns;
	    },
	    visibleColumns: function visibleColumns() {
	      return _.reject(this.columns, 'private');
	    },
	    showInstanceEditor: function showInstanceEditor() {
	      return this.instanceType && this.currentComponent.type.replace(/_definitions$/, 's') === this.instanceType;
	    }
	  }),
	  methods: {
	    destroyComponent: function destroyComponent() {
	      if (this.instanceType === 'windows') {
	        this.$store.dispatch('models/destroyWindow', { story_id: this.currentStory.id, object: this.componentInstance });
	      } else if (this.instanceType === 'daylighting_controls') {
	        this.$store.dispatch('models/destroyDaylightingControl', { story_id: this.currentStory.id, object: this.componentInstance });
	      } else if (this.instanceType === 'doors') {
	        this.$store.dispatch('models/destroyDoor', { story_id: this.currentStory.id, object: this.componentInstance });
	      } else {
	        throw new Error('Unrecognized component type ' + this.instanceType);
	      }
	    },
	    modifyComponentInstance: function modifyComponentInstance(id, key, value) {
	      if (this.instanceType === 'windows') {
	        this.$store.dispatch('models/modifyWindow', { id: id, key: key, value: value, story_id: this.currentStory.id });
	      } else if (this.instanceType === 'daylighting_controls') {
	        this.$store.dispatch('models/modifyDaylightingControl', { id: id, key: key, value: value, story_id: this.currentStory.id });
	      } else if (this.instanceType === 'doors') {
	        this.$store.dispatch('models/modifyDoor', { id: id, key: key, value: value, story_id: this.currentStory.id });
	      } else {
	        throw new Error('unrecognized component mode "' + this.mode + '"');
	      }
	    }
	  },
	  components: {
	    EditBar: _EditBar2.default
	  }
	};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GenericInput = __webpack_require__(269);
	
	var _GenericInput2 = _interopRequireDefault(_GenericInput);
	
	var _delete = __webpack_require__(191);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['row', 'columns', 'updateRow', 'destroy'],
	  components: {
	    GenericInput: _GenericInput2.default,
	    Delete: _delete2.default
	  }
	};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EditableTable = __webpack_require__(720);
	
	var _EditableTable2 = _interopRequireDefault(_EditableTable);
	
	var _LibrarySelect = __webpack_require__(270);
	
	var _LibrarySelect2 = _interopRequireDefault(_LibrarySelect);
	
	var _PrettySelect = __webpack_require__(127);
	
	var _PrettySelect2 = _interopRequireDefault(_PrettySelect);
	
	var _double_arrows = __webpack_require__(773);
	
	var _double_arrows2 = _interopRequireDefault(_double_arrows);
	
	var _add_new = __webpack_require__(765);
	
	var _add_new2 = _interopRequireDefault(_add_new);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EditableSelectList',
	  props: ['columns', 'rows', 'addRow', 'editRow', 'destroyRow', 'selectRow', 'selectedRowId', 'objectTypes', 'selectedObjectType', 'searchAvailable', 'compact', 'duplicateRow'],
	  data: function data() {
	    return {
	      search: ''
	    };
	  },
	
	  computed: {
	    visibleColumns: function visibleColumns() {
	      return _.reject(this.columns, 'private');
	    },
	    searchedRows: function searchedRows() {
	      var _this = this;
	
	      return this.rows.filter(function (row) {
	        return _.chain(row).omit(['color']).values().compact().some(function (val) {
	          return val.toLowerCase && val.toLowerCase().includes(_this.search.toLowerCase());
	        }).value();
	      });
	    }
	  },
	  methods: {
	    toggleCompact: function toggleCompact() {
	      this.$emit('toggleCompact', !this.compact);
	    }
	  },
	  watch: {
	    rows: function rows(newRows, oldRows) {
	      if (newRows !== oldRows) {
	        return;
	      }
	      if (newRows.length > oldRows.length) {
	        this.selectRow(_.maxBy(this.rows, function (r) {
	          return +r.id;
	        }));
	      }
	    }
	  },
	  components: {
	    EditableTable: _EditableTable2.default,
	    LibrarySelect: _LibrarySelect2.default,
	    PrettySelect: _PrettySelect2.default,
	    DoubleArrows: _double_arrows2.default,
	    AddNew: _add_new2.default
	  }
	};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _elementUi = __webpack_require__(655);
	
	__webpack_require__(672);
	
	var _vuex = __webpack_require__(27);
	
	var _delete = __webpack_require__(191);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _copy_icon = __webpack_require__(272);
	
	var _copy_icon2 = _interopRequireDefault(_copy_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'EditableTable',
	  props: ['columns', 'rows', 'deleteRow', 'updateRow', 'selectRow', 'selectedItemId', 'duplicateRow'],
	  data: function data() {
	    return {
	      sortKey: function sortKey(r) {
	        return +r.id;
	      },
	      sortDescending: false
	    };
	  },
	
	  computed: {
	    visibleColumns: function visibleColumns() {
	      return _lodash2.default.reject(this.columns, 'private');
	    },
	    sortedRows: function sortedRows() {
	      var sRows = _lodash2.default.sortBy(this.rows, this.sortKey);
	      if (this.sortDescending) {
	        sRows.reverse();
	      }
	      return sRows;
	    }
	  },
	  methods: {
	    sortChange: function sortChange(_ref) {
	      var prop = _ref.prop,
	          order = _ref.order;
	
	      this.sortKey = prop;
	      this.sortDescending = order === 'descending';
	    },
	    sortBy: function sortBy(colName) {
	      this.sortDescending = this.sortKey === colName ? !this.sortDescending : true;
	      this.sortKey = colName;
	    }
	  },
	  components: {
	    Delete: _delete2.default,
	    Copy: _copy_icon2.default,
	    'el-table': _elementUi.Table,
	    TableColumn: _elementUi.TableColumn
	  }
	};

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['title'],
	  data: function data() {
	    return {
	      expanded: false
	    };
	  },
	
	  computed: {
	    caret: function caret() {
	      return this.expanded ? '\u25BC' : '\u25BA';
	    }
	  }
	};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(57);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _TextureSelect = __webpack_require__(734);
	
	var _TextureSelect2 = _interopRequireDefault(_TextureSelect);
	
	var _ColorPickerModal = __webpack_require__(727);
	
	var _ColorPickerModal2 = _interopRequireDefault(_ColorPickerModal);
	
	var _color = __webpack_require__(358);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GenericInput',
	  props: ['col', 'row', 'onChange'],
	  data: function data() {
	    return {
	      showColorModal: false
	    };
	  },
	
	  methods: {
	    blurOnEnter: function blurOnEnter(evt) {
	      if (evt.keyCode === 13) {
	        this.$el.blur();
	      }
	      if (evt.keyCode == 27) {
	        this.$el.value = row[col.name];
	        this.$el.blur();
	      }
	      return;
	    }
	  },
	  computed: {
	    selectData: function selectData() {
	      return _lodash2.default.toPairs(this.col.select_data(this.row, this.$store.state)).map(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            k = _ref2[0],
	            v = _ref2[1];
	
	        return { val: v, display: k };
	      });
	    },
	    rootState: function rootState() {
	      return this.$store.state;
	    },
	    disabled: function disabled() {
	      if (!this.col.enabled) {
	        return false;
	      }
	      return !this.col.enabled(this.row);
	    },
	    colorStyles: function colorStyles() {
	      var value = this.row[this.col.name],
	          r = parseInt(value.slice(1, 3), 16),
	          g = parseInt(value.slice(3, 5), 16),
	          b = parseInt(value.slice(5, 7), 16);
	      return {
	        color: (0, _color.brightness)(r, g, b) < 123 ? '#fff' : '#000',
	        background: value
	      };
	    },
	    value: function value() {
	      return this.col.get ? this.col.get(this.row, this.rootState) : this.row[this.col.name];
	    }
	  },
	  components: {
	    TextureSelect: _TextureSelect2.default,
	    ColorPickerModal: _ColorPickerModal2.default
	  }
	};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(38);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(27);
	
	var _utilities = __webpack_require__(102);
	
	var _d3AwareThrottle = __webpack_require__(359);
	
	var _d3AwareThrottle2 = _interopRequireDefault(_d3AwareThrottle);
	
	var _methods = __webpack_require__(329);
	
	var _methods2 = _interopRequireDefault(_methods);
	
	var _helpers = __webpack_require__(16);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _helpers3 = __webpack_require__(50);
	
	var _helpers4 = _interopRequireDefault(_helpers3);
	
	var _helpers5 = __webpack_require__(75);
	
	var _helpers6 = _interopRequireDefault(_helpers5);
	
	var _Resize = __webpack_require__(129);
	
	var _drawing = __webpack_require__(328);
	
	var _drawing2 = _interopRequireDefault(_drawing);
	
	var _snapping = __webpack_require__(128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var d3 = __webpack_require__(85);
	
	exports.default = {
	  name: 'grid',
	  data: function data() {
	    var _this = this;
	
	    var xScale = function xScale(v) {
	      return _this.rwuToGrid(v, 'x');
	    },
	        yScale = function yScale(v) {
	      return _this.rwuToGrid(v, 'y');
	    };
	
	    return (0, _extends3.default)({
	      points: [],
	      axis: {
	        x: null,
	        y: null
	      },
	      axis_generator: {
	        x: null,
	        y: null
	      },
	      reduceTicks: false,
	      componentFacingSelection: null,
	      transform: { k: 1, x: 0, y: 0 },
	      transformAtLastRender: d3.zoomIdentity,
	      lastMousePosition: null,
	      handleMouseMove: null }, (0, _drawing2.default)({
	      xScale: xScale,
	      yScale: yScale,
	      selectImage: function selectImage(img) {
	        _this.currentImage = img;
	      },
	      updateImage: function updateImage(data) {
	        return window.application.$store.dispatch('models/updateImageWithData', data);
	      }
	    }), {
	      crosshatchModifiers: {
	        '-highlight': 'green',
	        '-selected': 'green',
	        '-facing-selection': 'blue',
	        '': '#222'
	      }
	    });
	  },
	  mounted: function mounted() {
	    this.handleMouseMove = (0, _d3AwareThrottle2.default)(this.highlightSnapTarget, 100);
	
	    this.renderGrid();
	
	    this.renderGrid = (0, _utilities.debounce)(this.renderGrid, 5);
	
	    this.$refs.grid.addEventListener('reloadGrid', this.reloadGridAndScales);
	
	    window.addEventListener('keyup', this.escapeAction);
	    window.addEventListener('keydown', this.handleKeyDown);
	    window.addEventListener('resize', this.reloadGridAndScales);
	
	    _Resize.ResizeEvents.$on('resize', this.reloadGridAndScales);
	
	    window.eventBus.$on('zoomToFit', this.zoomToFit);
	    window.eventBus.$on('scaleTo', this.scaleTo);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.$refs.grid.removeEventListener('reloadGrid', this.reloadGridAndScales);
	
	    window.removeEventListener('keyup', this.escapeAction);
	    window.removeEventListener('keydown', this.handleKeyDown);
	    window.removeEventListener('resize', this.reloadGridAndScales);
	
	    _Resize.ResizeEvents.$off('resize', this.reloadGridAndScales);
	
	    window.eventBus.$off('zoomToFit', this.zoomToFit);
	    window.eventBus.$off('scaleTo', this.scaleTo);
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    currentMode: function currentMode(state) {
	      return state.application.currentSelections.mode;
	    },
	    modeTab: function modeTab(state) {
	      return state.application.currentSelections.modeTab;
	    },
	    currentTool: function currentTool(state) {
	      return state.application.currentSelections.tool;
	    },
	    snapMode: function snapMode(state) {
	      return state.application.currentSelections.snapMode;
	    },
	    previousStoryVisible: function previousStoryVisible(state) {
	      return state.project.previous_story.visible;
	    },
	    gridVisible: function gridVisible(state) {
	      return state.project.grid.visible;
	    },
	    units: function units(state) {
	      return state.project.config.units;
	    },
	    spacing: function spacing(state) {
	      return state.project.grid.spacing;
	    },
	
	    scaleX: function scaleX(state) {
	      return state.application.scale.x;
	    },
	    scaleY: function scaleY(state) {
	      return state.application.scale.y;
	    },
	    windowDefs: function windowDefs(state) {
	      return state.models.library.window_definitions;
	    },
	    doorDefs: function doorDefs(state) {
	      return state.models.library.door_definitions;
	    },
	    windowWidths: function windowWidths(state) {
	      return _.sumBy(state.models.library.window_definitions, 'width');
	    },
	    allVertices: function allVertices(state) {
	      return _.flatMap(state.geometry, 'vertices');
	    }
	  }), (0, _vuex.mapGetters)({
	    currentStory: 'application/currentStory',
	    currentStoryGeometry: 'application/currentStoryGeometry',
	    denormalizedGeometry: 'application/currentStoryDenormalizedGeom',
	    currentSpace: 'application/currentSpace',
	    currentShading: 'application/currentShading',
	    currentComponent: 'application/currentComponent',
	    currentComponentInstance: 'application/currentComponentInstance',
	    currentSpaceProperty: 'application/currentSpaceProperty'
	  }), {
	    spacePropertyKey: function spacePropertyKey() {
	      switch (this.currentSpaceProperty.type) {
	        case 'building_units':
	          return 'building_unit_id';
	        case 'thermal_zones':
	          return 'thermal_zone_id';
	        case 'space_types':
	          return 'space_type_id';
	        case 'pitched_roofs':
	          return 'pitched_roof_id';
	        case 'construction_sets':
	          return 'construction_set_id';
	        default:
	          throw new Error('unrecognized space property type ' + this.currentSpaceProperty.type);
	      }
	    },
	    windowAndDoorDefs: function windowAndDoorDefs() {
	      return [].concat((0, _toConsumableArray3.default)(this.windowDefs), (0, _toConsumableArray3.default)(this.doorDefs.map(function (d) {
	        return (0, _extends3.default)({}, d, {
	          window_definition_mode: 'Single Window'
	        });
	      })));
	    },
	
	    currentImage: {
	      get: function get() {
	        return this.$store.getters['application/currentImage'];
	      },
	      set: function set(item) {
	        this.$store.dispatch('application/setCurrentSubSelectionId', { id: item.id });
	      }
	    },
	    currentComponentType: function currentComponentType() {
	      return this.currentComponent.type;
	    },
	    currentComponentDefinition: function currentComponentDefinition() {
	      return this.currentComponent.definition;
	    },
	
	    currentSubSelection: {
	      get: function get() {
	        return this.$store.getters['application/currentSubSelection'];
	      },
	      set: function set(item) {
	        this.$store.dispatch('application/setCurrentSubSelectionId', { id: item.id });
	      }
	    },
	    currentComponentInstanceId: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.modeTab === 'components' && this.$store.state.application.currentSelections.component_instance_id;
	      },
	      set: function set(id) {
	        this.$store.dispatch('application/setCurrentComponentInstanceId', { id: id });
	      }
	    },
	
	    min_x: {
	      get: function get() {
	        return this.$store.state.project.view.min_x;
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/setViewMinX', { min_x: val });
	      }
	    },
	    min_y: {
	      get: function get() {
	        return this.$store.state.project.view.min_y;
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/setViewMinY', { min_y: val });
	      }
	    },
	    max_x: {
	      get: function get() {
	        return this.$store.state.project.view.max_x;
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/setViewMaxX', { max_x: val });
	      }
	    },
	    max_y: {
	      get: function get() {
	        return this.$store.state.project.view.max_y;
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/setViewMaxY', { max_y: val });
	      }
	    },
	
	    dimensions: {
	      get: function get() {
	        return {
	          min_x: this.$store.state.project.view.min_x,
	          max_x: this.$store.state.project.view.max_x,
	          min_y: this.$store.state.project.view.min_y,
	          max_y: this.$store.state.project.view.max_y
	        };
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/setDimensions', val);
	      }
	    },
	    previousStory: function previousStory() {
	      var _this2 = this;
	
	      var currentStoryNumber = this.$store.state.models.stories.findIndex(function (s) {
	        return s === _this2.currentStory;
	      });
	      if (currentStoryNumber === 0) {
	        return null;
	      }
	      return this.$store.state.models.stories[currentStoryNumber - 1];
	    },
	    previousStoryGeometry: function previousStoryGeometry() {
	      var _this3 = this;
	
	      if (!this.previousStory) {
	        return null;
	      }
	      return this.$store.state.geometry.find(function (g) {
	        return g.id === _this3.previousStory.geometry_id;
	      });
	    },
	    previousStoryPolygons: function previousStoryPolygons() {
	      if (this.previousStoryVisible && this.previousStoryGeometry) {
	        return this.polygonsFromGeometry(this.previousStoryGeometry, { previous_story: true });
	      }
	      return [];
	    },
	    images: function images() {
	      var _this4 = this;
	
	      return this.currentStory.images.map(function (img) {
	        return (0, _extends3.default)({}, img, {
	          current: _this4.currentTool === 'Image' && _this4.currentImage && _this4.currentImage.id === img.id,
	          clickable: _this4.currentTool === 'Image' && (!_this4.currentImage || _this4.currentImage.id !== img.id)
	        });
	      });
	    },
	    polygons: function polygons() {
	      var currentStoryPolygons = this.polygonsFromGeometry(this.currentStoryGeometry);
	      return this.previousStoryPolygons ? this.previousStoryPolygons.concat(currentStoryPolygons) : currentStoryPolygons;
	    },
	    walls: function walls() {
	      var edgesLookup = _.keyBy(this.currentStoryGeometry.edges, 'id');
	      var vertsLookup = _.keyBy(this.currentStoryGeometry.vertices, 'id');
	
	      return _.chain(this.currentStoryGeometry.faces).flatMap(function (fc) {
	        return _.map(fc.edgeRefs, 'edge_id');
	      }).sortBy(_.identity).groupBy(_.identity).mapValues('length').map(function (numOccurences, edgeId) {
	        var edge = edgesLookup[edgeId];
	        return {
	          id: edgeId,
	          start: vertsLookup[edge.v1],
	          end: vertsLookup[edge.v2],
	          interior: numOccurences > 1
	        };
	      }).value();
	    },
	    daylightingControlLocs: function daylightingControlLocs() {
	      var _this5 = this;
	
	      return _.flatten(this.currentStory.spaces.map(function (space) {
	        return space.daylighting_controls.map(function (dc) {
	          return (0, _extends3.default)({}, dc, _helpers2.default.vertexForId(dc.vertex_id, _this5.currentStoryGeometry), {
	            id: dc.id,
	            type: 'daylighting_controls',
	            face_id: space.face_id
	          });
	        });
	      }));
	    },
	    spaceFaces: function spaceFaces() {
	      var _this6 = this;
	
	      return this.denormalizedGeometry.faces.filter(function (f) {
	        return _.find(_this6.currentStory.spaces, { face_id: f.id });
	      });
	    },
	    spaceEdges: function spaceEdges() {
	      return _.flatMap(this.spaceFaces, 'edges');
	    },
	    visibleVerts: function visibleVerts() {
	      var _this7 = this;
	
	      return this.allVertices.filter(function (d) {
	        return _this7.min_x <= d.x && d.x <= _this7.max_x && _this7.min_y <= d.y && d.y <= _this7.max_y;
	      });
	    }
	  }),
	  watch: {
	    gridVisible: function gridVisible() {
	      this.showOrHideAxes();
	    },
	    spacing: function spacing() {
	      this.updateGrid();
	    },
	    units: function units() {
	      this.reloadGridAndScales();
	    },
	    currentMode: function currentMode() {
	      this.draw();
	    },
	    polygons: function polygons() {
	      this.draw();
	    },
	    images: function images() {
	      this.draw();
	    },
	    windowDefs: function windowDefs() {
	      this.draw();
	    },
	    doorDefs: function doorDefs() {
	      this.draw();
	    },
	    currentTool: function currentTool() {
	      this.points = [];
	      this.draw();
	      this.clearHighlights();
	      if (this.currentTool === 'Image' && this.currentStory.images.length) {
	        if (!this.currentImage || !_.includes(_.map(this.currentStory.images, 'id'), this.currentImage.id)) {
	          this.currentImage = this.currentStory.images[0];
	        }
	      } else if (!_.includes(_.map(this.currentStory.spaces, 'id'), this.currentSubSelection.id)) {
	        this.currentSubSelection = this.currentStory.spaces[0];
	      }
	    },
	    currentSpace: function currentSpace() {
	      this.points = [];
	      this.draw();
	    },
	    currentShading: function currentShading() {
	      this.points = [];
	      this.draw();
	    },
	    transform: function transform(newTransform, lastTransform) {
	      if (newTransform.k < 0.5) {
	        d3.select('#svg-grid').selectAll('.polygon-text').style('display', 'none');
	      } else {
	        d3.select('#svg-grid').selectAll('.polygon-text').style('display', 'initial');
	      }
	    }
	  },
	  methods: (0, _extends3.default)({}, _methods2.default, {
	    windowCenterLocs: function windowCenterLocs(cursor) {
	      var _this8 = this;
	
	      return this.currentStory.windows.map(function (w) {
	        return { w: w, e: _.find(_this8.denormalizedGeometry.edges, { id: w.edge_id }) };
	      }).map(function (_ref) {
	        var w = _ref.w,
	            e = _ref.e;
	
	        var wind = _this8.denormalizeWindowOrDoor(e, w);
	
	        var _pointDistanceToSegme = (0, _helpers.pointDistanceToSegment)(cursor, wind),
	            proj = _pointDistanceToSegme.proj;
	
	        return (0, _extends3.default)({}, wind, {
	          id: w.id,
	          type: 'windows'
	        }, proj);
	      });
	    },
	    doorCenterLocs: function doorCenterLocs(cursor) {
	      var _this9 = this;
	
	      return this.currentStory.doors.map(function (w) {
	        return { w: w, e: _.find(_this9.denormalizedGeometry.edges, { id: w.edge_id }) };
	      }).map(function (_ref2) {
	        var w = _ref2.w,
	            e = _ref2.e;
	
	        var wind = _this9.denormalizeWindowOrDoor(e, w);
	
	        var _pointDistanceToSegme2 = (0, _helpers.pointDistanceToSegment)(cursor, wind),
	            proj = _pointDistanceToSegme2.proj;
	
	        return (0, _extends3.default)({}, wind, {
	          id: w.id,
	          type: 'doors'
	        }, proj);
	      });
	    },
	    currentComponentTypeLocs: function currentComponentTypeLocs(cursor) {
	      if (this.currentComponentType === 'window_definitions') {
	        return this.windowCenterLocs(cursor);
	      } else if (this.currentComponentType === 'daylighting_control_definitions') {
	        return this.daylightingControlLocs;
	      } else if (this.currentComponentType === 'door_definitions') {
	        return this.doorCenterLocs(cursor);
	      } else {
	        throw new Error('unrecognized componentType: ' + this.currentComponentType);
	      }
	    },
	    denormalizeWindowOrDoor: function denormalizeWindowOrDoor(edge, _ref3) {
	      var edge_id = _ref3.edge_id,
	          alpha = _ref3.alpha,
	          window_definition_id = _ref3.window_definition_id,
	          door_definition_id = _ref3.door_definition_id;
	
	      var defn = _.find(this.windowAndDoorDefs, { id: window_definition_id || door_definition_id }),
	          center = (0, _snapping.windowLocation)(edge, { alpha: alpha });
	      return (0, _extends3.default)({}, (0, _snapping.expandWindowAlongEdge)(edge, center, defn), {
	        window_definition_mode: defn.window_definition_mode,
	        windowOrDoor: defn.window_definition_mode ? 'window' : 'door',
	        width: defn.width,
	        spacing: defn.window_spacing,
	        texture: defn.texture
	      });
	    },
	    windowsOnFace: function windowsOnFace(face) {
	      var _this10 = this;
	
	      return _.flatMap(face.edges, function (e) {
	        return _.filter(_this10.currentStory.windows, { edge_id: e.id }).map(function (w) {
	          return (0, _extends3.default)({}, _this10.denormalizeWindowOrDoor(e, w), {
	            selected: w.id === _this10.currentComponentInstanceId,
	            facingSelection: w.id === _this10.componentFacingSelection
	          });
	        });
	      });
	    },
	    doorsOnFace: function doorsOnFace(face) {
	      var _this11 = this;
	
	      return _.flatMap(face.edges, function (e) {
	        return _.filter(_this11.currentStory.doors, { edge_id: e.id }).map(function (d) {
	          return (0, _extends3.default)({}, _this11.denormalizeWindowOrDoor(e, d), {
	            windowOrDoor: 'door',
	            selected: d.id === _this11.currentComponentInstanceId,
	            facingSelection: d.id === _this11.componentFacingSelection
	          });
	        });
	      });
	    },
	    polygonsFromGeometry: function polygonsFromGeometry(geometry) {
	      var _this12 = this;
	
	      var extraPolygonAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var geom = _helpers2.default.denormalize(geometry);
	      var polygons = geom.faces.map(function (face) {
	        var model = _helpers4.default.modelForFace(_this12.$store.state.models, face.id);
	
	        var points = face.vertices.slice(0, -1);
	        var polygon = (0, _extends3.default)({
	          face_id: face.id,
	          name: model.name,
	          modelType: model.type,
	          color: model.color,
	          points: points,
	          labelPosition: _this12.polygonLabelPosition(points),
	          windows: _this12.windowsOnFace(face),
	          doors: _this12.doorsOnFace(face),
	          current: _this12.currentTool !== 'Apply Property' && _this12.currentSpace && face.id === _this12.currentSpace.face_id || _this12.currentTool !== 'Apply Property' && _this12.currentShading && face.id === _this12.currentShading.face_id || _this12.currentTool === 'Apply Property' && _this12.currentSpaceProperty && model[_this12.spacePropertyKey] === _this12.currentSpaceProperty.id,
	          daylighting_controls: (model.daylighting_controls || []).map(function (dc) {
	            return (0, _extends3.default)({}, _helpers2.default.vertexForId(dc.vertex_id, geometry), {
	              selected: dc.id === _this12.currentComponentInstanceId,
	              facingSelection: dc.id === _this12.componentFacingSelection
	            });
	          })
	        }, extraPolygonAttrs);
	        if (!points.length) {
	          return null;
	        }
	
	        if (model.type === 'space') {
	          if (_this12.currentMode === 'thermal_zones') {
	            var thermalZone = _helpers4.default.libraryObjectWithId(_this12.$store.state.models, model.thermal_zone_id);
	            polygon.color = thermalZone ? thermalZone.color : _helpers6.default.config.palette.neutral;
	          } else if (_this12.currentMode === 'space_types') {
	            var spaceType = _helpers4.default.libraryObjectWithId(_this12.$store.state.models, model.space_type_id);
	            polygon.color = spaceType ? spaceType.color : _helpers6.default.config.palette.neutral;
	          } else if (_this12.currentMode === 'building_units') {
	            var buildingUnit = _helpers4.default.libraryObjectWithId(_this12.$store.state.models, model.building_unit_id);
	            polygon.color = buildingUnit ? buildingUnit.color : _helpers6.default.config.palette.neutral;
	          } else if (_this12.currentMode === 'pitched_roofs') {
	            var pitchedRoof = _helpers4.default.libraryObjectWithId(_this12.$store.state.models, model.pitched_roof_id);
	            polygon.color = pitchedRoof ? pitchedRoof.color : _helpers6.default.config.palette.neutral;
	          } else if (_this12.currentMode === 'construction_sets') {
	            var constructionSet = _helpers4.default.libraryObjectWithId(_this12.$store.state.models, model.construction_set_id);
	            polygon.color = constructionSet ? constructionSet.color : _helpers6.default.config.palette.neutral;
	          } else if (_this12.currentMode !== 'spaces') {
	            throw new Error('unknown assignable property: ' + _this12.currentMode);
	          }
	        }
	        return polygon;
	      });
	
	      return _.sortBy(_.compact(polygons), 'current');
	    }
	  })
	};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(27);
	
	var _helpers = __webpack_require__(50);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ImageUpload',
	  mounted: function mounted() {
	    window.eventBus.$on('uploadImage', this.promptUpload.bind(this));
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    pxPerRWU: function pxPerRWU(state) {
	      var _state$application$sc = state.application.scale.x,
	          pixels = _state$application$sc.pixels,
	          rwuRange = _state$application$sc.rwuRange;
	
	      return pixels / (rwuRange[1] - rwuRange[0]);
	    },
	
	    max_y: function max_y(state) {
	      return state.project.view.max_y;
	    },
	    min_y: function min_y(state) {
	      return state.project.view.min_y;
	    },
	    min_x: function min_x(state) {
	      return state.project.view.min_x;
	    },
	    max_x: function max_x(state) {
	      return state.project.view.max_x;
	    }
	  }), (0, _vuex.mapGetters)({
	    currentStory: 'application/currentStory'
	  })),
	  methods: {
	    promptUpload: function promptUpload() {
	      this.$refs.imageInput.click();
	    },
	    uploadImage: function uploadImage(event) {
	      var files = event.target.files;
	      var that = this;
	
	      var _loop = function _loop(i) {
	        var file = files[i];
	        var reader = new FileReader();
	
	        reader.addEventListener('load', function () {
	          var image = new Image();
	          image.onload = function () {
	            var rwuHeight = image.height / that.pxPerRWU / 4;
	            var rwuWidth = image.width / that.pxPerRWU / 4;
	            that.$store.dispatch('models/createImageForStory', {
	              story_id: that.currentStory.id,
	              src: image.src,
	
	              name: _helpers2.default.generateName(that.$store.state.models, 'images', that.currentStory),
	
	              height: rwuHeight,
	              width: rwuWidth,
	              x: (that.min_x + that.max_x) / 2,
	              y: (that.min_y + that.max_y) / 2,
	              naturalHeight: image.height,
	              naturalWidth: image.width
	            });
	            that.$refs.imageInput.value = '';
	          };
	          image.src = reader.result;
	        }, false);
	        if (file) {
	          reader.readAsDataURL(file);
	        }
	      };
	
	      for (var i = 0; i < files.length; i++) {
	        _loop(i);
	      }
	    }
	  }
	};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _info_icon = __webpack_require__(273);
	
	var _info_icon2 = _interopRequireDefault(_info_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Info',
	  components: {
	    InfoIcon: _info_icon2.default
	  }
	};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(27);
	
	var _helpers = __webpack_require__(16);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'inspector',
	  data: function data() {
	    return {
	      geometryInspector: true,
	      storyInspector: false
	    };
	  },
	
	  methods: {
	    startpoint: function startpoint(edgeRef) {
	      var edge = this.edgeForId(edgeRef.edge_id);
	      if (edgeRef.reverse) {
	        var _v = this.vertexForId(edge.v2);
	        return 'v2 ' + _v.id + ' (' + _v.x + ', ' + _v.y + ')';
	      }
	      var v = this.vertexForId(edge.v1);
	      return 'v1 ' + v.id + ' (' + v.x + ', ' + v.y + ')';
	    },
	    endpoint: function endpoint(edgeRef) {
	      var edge = this.edgeForId(edgeRef.edge_id);
	      if (!edgeRef.reverse) {
	        var _v2 = this.vertexForId(edge.v2);
	        return _v2.id + ' (v2) (' + _v2.x + ', ' + _v2.y + ')';
	      }
	      var v = this.vertexForId(edge.v1);
	      return v.id + ' (v1) (' + v.x + ', ' + v.y + ')';
	    },
	    edgeForId: function edgeForId(id) {
	      return _helpers2.default.edgeForId(id, this.currentStoryGeometry);
	    },
	    vertexForId: function vertexForId(id) {
	      return _helpers2.default.vertexForId(id, this.currentStoryGeometry);
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    currentStory: 'application/currentStory',
	    currentSubSelectionFace: 'application/currentSubSelectionFace',
	    currentStoryGeometry: 'application/currentStoryGeometry',
	    currentSpace: 'application/currentSpace',
	    currentShading: 'application/currentShading'
	  }))
	};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(375);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(374);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(27);
	
	var _libconfig = __webpack_require__(101);
	
	var _libconfig2 = _interopRequireDefault(_libconfig);
	
	var _EditableSelectList = __webpack_require__(719);
	
	var _EditableSelectList2 = _interopRequireDefault(_EditableSelectList);
	
	var _helpers = __webpack_require__(50);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _helpers3 = __webpack_require__(16);
	
	var _appconfig = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function keyForMode(mode) {
	  return mode === 'stories' ? 'currentStory' : _.includes(_appconfig.componentTypes, mode) ? 'currentComponentDef' : _.includes(_appconfig.assignableProperties, mode) ? 'currentSpaceProperty' : _.includes(['windows', 'daylighting_controls'], mode) ? 'currentComponentInstance' : 'currentSubSelection';
	}
	
	exports.default = {
	  name: 'Library',
	  props: ['objectTypes', 'mode', 'searchAvailable', 'compact', 'addNewOnHotkey'],
	  mounted: function mounted() {
	    document.body.addEventListener('keyup', this.hotkeyAddNew);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.body.removeEventListener('keyup', this.hotkeyAddNew);
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    currentStoryGeom: 'application/currentStoryGeometry'
	  }), {
	    objectTypesDisplay: function objectTypesDisplay() {
	      return this.objectTypes.map(function (ot) {
	        return {
	          val: ot,
	          display: _libconfig2.default[ot].displayName
	        };
	      });
	    },
	    columns: function columns() {
	      if (!_libconfig2.default[this.mode]) return [];
	      return _libconfig2.default[this.mode].columns;
	    },
	
	    currentStory: {
	      get: function get() {
	        return this.$store.getters['application/currentStory'];
	      },
	      set: function set(story) {
	        this.$store.dispatch('application/setCurrentStoryId', { id: story.id });
	      }
	    },
	
	    currentSubSelection: {
	      get: function get() {
	        return this.$store.getters['application/currentSubSelection'];
	      },
	      set: function set(item) {
	        this.$store.dispatch('application/setCurrentSubSelectionId', { id: item.id });
	      }
	    },
	    currentSpaceProperty: {
	      get: function get() {
	        return this.$store.getters['application/currentSpaceProperty'];
	      },
	      set: function set(item) {
	        this.$store.dispatch('application/setCurrentSpacePropertyId', { id: item.id });
	      }
	    },
	    currentComponentDef: {
	      get: function get() {
	        return this.$store.getters['application/currentComponentDefinition'];
	      },
	      set: function set(item) {
	        this.$store.dispatch('application/setCurrentComponentDefinitionId', { id: item.id });
	      }
	    },
	    currentComponentInstance: {
	      get: function get() {
	        return this.$store.getters['application/currentComponentInstance'];
	      },
	      set: function set(ci) {
	        this.$store.dispatch('application/setCurrentComponentInstanceId', { id: ci.id });
	      }
	    },
	
	    selectedObject: {
	      get: function get() {
	        return this[this.keyForCurrentMode];
	      },
	      set: function set(item) {
	        this[this.keyForCurrentMode] = item;
	      }
	    },
	    keyForCurrentMode: function keyForCurrentMode() {
	      return keyForMode(this.mode);
	    }
	  }, (0, _vuex.mapState)({
	    stories: function stories(state) {
	      return state.models.stories;
	    },
	    modeTab: function modeTab(state) {
	      return state.application.currentSelections.modeTab;
	    }
	  }), {
	    spaces: function spaces() {
	      return this.currentStory.spaces;
	    },
	    shading: function shading() {
	      return this.currentStory.shading;
	    },
	    images: function images() {
	      return this.currentStory.images;
	    },
	    windows: function windows() {
	      return this.currentStory.windows;
	    },
	    daylighting_controls: function daylighting_controls() {
	      return _.flatMap(this.currentStory.spaces, function (s) {
	        return s.daylighting_controls;
	      });
	    },
	    rows: function rows() {
	      return _.includes(['stories', 'spaces', 'shading', 'images', 'windows', 'daylighting_controls'], this.mode) ? this[this.mode] : this.$store.state.models.library[this.mode];
	    },
	    componentInstanceMode: function componentInstanceMode() {
	      return _.includes(['windows', 'daylighting_controls'], this.mode);
	    },
	    addRowPermitted: function addRowPermitted() {
	      return this.mode !== 'stories' || this.modeTab === 'floorplan';
	    },
	
	    renderByMode: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.mode;
	      },
	      set: function set(mode) {
	        this.$store.dispatch('application/setCurrentMode', { mode: mode });
	      }
	    }
	  }),
	  watch: {
	    rows: function rows() {
	      if (!(this.selectedObject && _.includes(_.map(this.rows, 'id'), this.selectedObject.id)) && this.rows.length > 0) {
	        this.selectedObject = this.rows[0];
	      }
	    },
	    mode: function mode(currMode, oldMode) {
	      if (keyForMode(currMode) === 'currentSpaceProperty') {
	        this.renderByMode = this.mode;
	      } else if (keyForMode(oldMode) === 'currentSpaceProperty') {
	        this.renderByMode = 'spaces';
	      }
	    }
	  },
	  methods: {
	    hotkeyAddNew: function hotkeyAddNew(evt) {
	      if (this.addNewOnHotkey && this.addRowPermitted && evt.ctrlKey && evt.key === 'a') {
	        this.createObject();
	      }
	    },
	    changeMode: function changeMode(newMode) {
	      if (!_.includes(this.objectTypes, newMode)) {
	        throw new Error('Unable to find ' + newMode + ' in options ' + (0, _stringify2.default)(this.objectTypes));
	      }
	      this.$emit('changeMode', newMode);
	    },
	    modifyObject: function modifyObject(rowId, colName, value) {
	      if (this.componentInstanceMode) {
	        return this.modifyComponentInstance(rowId, colName, value);
	      }
	      var row = _.find(this.rows, { id: rowId });
	      var result = _helpers2.default.setValueForKey(row, this.$store, this.mode, colName, value);
	      if (!result.success) {
	        window.eventBus.$emit('error', result.error);
	      }
	    },
	    modifyComponentInstance: function modifyComponentInstance(id, key, value) {
	      if (this.mode === 'windows') {
	        this.$store.dispatch('models/modifyWindow', { id: id, key: key, value: value, story_id: this.currentStory.id });
	      } else if (this.mode === 'daylighting_controls') {
	        this.$store.dispatch('models/modifyDaylightingControl', { id: id, key: key, value: value, story_id: this.currentStory.id });
	      } else {
	        throw new Error('unrecognized component mode "' + this.mode + '"');
	      }
	    },
	    createObject: function createObject() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$duplicate = _ref.duplicate,
	          duplicate = _ref$duplicate === undefined ? false : _ref$duplicate;
	
	      if (duplicate) {
	        var height = this.currentStory.floor_to_ceiling_height;
	        this.$store.dispatch('models/initStory');
	        this.$store.dispatch('models/updateStoryWithData', { story: this.currentStory, floor_to_ceiling_height: height });
	        this.$store.dispatch('application/setCurrentTool', { tool: 'Rectangle' });
	      } else {
	        switch (this.mode) {
	          case 'stories':
	            this.$store.dispatch('models/initStory');
	            return;
	          case 'spaces':
	            this.$store.dispatch('models/initSpace', { story: this.currentStory });
	            break;
	          case 'shading':
	            this.$store.dispatch('models/initShading', { story: this.currentStory });
	            break;
	          case 'images':
	            window.eventBus.$emit('uploadImage');
	            break;
	          case 'windows':
	          case 'daylighting_controls':
	            window.eventBus.$emit('error', 'Create components by clicking where you would like it to be');
	            break;
	          default:
	            this.$store.dispatch('models/createObjectWithType', { type: this.mode });
	            break;
	        }
	      }
	      this.selectLatest();
	    },
	    duplicateRow: function duplicateRow(row) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var newName, copyNum;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!_this.stories.find(function (story) {
	                  return story.id === _this.selectedObject.id;
	                })) {
	                  _context.next = 4;
	                  break;
	                }
	
	                _this.cloneStory(_this.selectedObject);
	                _context.next = 11;
	                break;
	
	              case 4:
	                _this.createObject();
	                _context.next = 7;
	                return _this.$nextTick();
	
	              case 7:
	                newName = row.name;
	
	                while (_.find(_this.rows, { name: newName })) {
	                  copyNum = newName.match(/\((\d+)\)/);
	
	                  newName = copyNum ? newName.slice(0, copyNum.index) + '(' + (+copyNum[1] + 1) + ')' : newName + ' (2)';
	                }
	                _this.modifyObject(_this.selectedObject.id, 'name', newName);
	                _this.columns.forEach(function (_ref2) {
	                  var key = _ref2.name,
	                      readonly = _ref2.readonly,
	                      privateKey = _ref2.private;
	
	                  if (key === 'id' || key === 'name' || key === 'color') return;
	                  if (readonly || privateKey) return;
	                  if (_this.selectedObject[key] === row[key]) return;
	                  _this.modifyObject(_this.selectedObject.id, key, row[key]);
	                });
	
	              case 11:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    selectLatest: function selectLatest() {
	      var newestRow = _.maxBy(this.rows, function (r) {
	        return +r.id;
	      });
	      if (!newestRow) {
	        return;
	      }
	      this.selectedObject = newestRow;
	    },
	    cloneStory: function cloneStory(story) {
	      this.$store.dispatch('application/setCurrentStoryId', { id: story.id });
	
	      var _replaceIdsForCloning = (0, _helpers3.replaceIdsForCloning)(this.currentStoryGeom),
	          clonedGeometry = _replaceIdsForCloning.clonedGeometry,
	          idMap = _replaceIdsForCloning.idMap;
	
	      this.createObject({ duplicate: true });
	
	      var _modelHelpers$replace = _helpers2.default.replaceIdsUpdateInfoForCloning(story, idMap, this.state, this.currentStory),
	          clonedStory = _modelHelpers$replace.clonedStory;
	
	      this.destroyDuplicateSpaces();
	      this.$store.dispatch('models/cloneStory', clonedStory);
	      this.$store.dispatch('geometry/cloneStoryGeometry', clonedGeometry);
	      for (var i = this.currentStory.shading.length - 1; i >= 0; i--) {
	        this.$store.dispatch('models/destroyShading', {
	          shading: this.currentStory.shading[i],
	          story: this.currentStory
	        });
	      }
	    },
	    destroyDuplicateSpaces: function destroyDuplicateSpaces() {
	      this.$store.dispatch('models/destroySpace', {
	        space: this.currentStory.spaces[0],
	        story: this.currentStory
	      });
	    },
	    destroyObject: function destroyObject(object) {
	      var _this2 = this;
	
	      switch (this.mode) {
	        case 'stories':
	          this.$store.dispatch('models/destroyStory', { story: object });
	          return;
	        case 'spaces':
	          this.$store.dispatch('models/destroySpace', {
	            space: object,
	            story: this.$store.state.models.stories.find(function (story) {
	              return story[_this2.mode].find(function (o) {
	                return o.id === object.id;
	              });
	            })
	          });
	          break;
	        case 'shading':
	          this.$store.dispatch('models/destroyShading', {
	            shading: object,
	            story: this.$store.state.models.stories.find(function (story) {
	              return story[_this2.mode].find(function (o) {
	                return o.id === object.id;
	              });
	            })
	          });
	          break;
	        case 'images':
	          this.$store.dispatch('models/destroyImage', {
	            image: object,
	            story: this.$store.state.models.stories.find(function (story) {
	              return story[_this2.mode].find(function (o) {
	                return o.id === object.id;
	              });
	            })
	          });
	          break;
	        case 'window_definitions':
	          this.$store.dispatch('models/destroyWindowDef', { object: object });
	          break;
	        case 'daylighting_control_definitions':
	          this.$store.dispatch('models/destroyDaylightingControlDef', { object: object });
	          break;
	        case 'door_definitions':
	          this.$store.dispatch('models/destroyDoorDef', { object: object });
	          break;
	        case 'windows':
	          this.$store.dispatch('models/destroyWindow', { story_id: this.currentStory.id, object: object });
	          break;
	        case 'daylighting_controls':
	          this.$store.dispatch('models/destroyDaylightingControl', { story_id: this.currentStory.id, object: object });
	          break;
	        default:
	          this.$store.dispatch('models/destroyObject', { object: object });
	          break;
	      }
	    }
	  },
	  components: {
	    EditableSelectList: _EditableSelectList2.default
	  }
	};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _delete = __webpack_require__(191);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _copy_icon = __webpack_require__(272);
	
	var _copy_icon2 = _interopRequireDefault(_copy_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'LibrarySelect',
	  props: ['rows', 'selectedItemId', 'selectItem', 'destroyItem', 'duplicateRow'],
	  components: {
	    Delete: _delete2.default,
	    Copy: _copy_icon2.default
	  }
	};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueSwatches = __webpack_require__(801);
	
	var _vueSwatches2 = _interopRequireDefault(_vueSwatches);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ColorPickerModal',
	  props: ['value'],
	  computed: {
	    color: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(newVal) {
	        this.$emit('change', newVal);
	      }
	    }
	  },
	  mounted: function mounted() {
	    document.addEventListener('keydown', this.closeOnEsc);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.closeOnEsc);
	  },
	
	  methods: {
	    closeOnEsc: function closeOnEsc(e) {
	      if (e.keyCode === 27) {
	        this.$emit('close');
	      }
	    }
	  },
	  components: {
	    Swatches: _vueSwatches2.default
	  }
	};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _svgs = __webpack_require__(195);
	
	var _svgs2 = _interopRequireDefault(_svgs);
	
	var _NonChromeWarning = __webpack_require__(732);
	
	var _NonChromeWarning2 = _interopRequireDefault(_NonChromeWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'MapModal',
	  data: function data() {
	    return {
	      address: ''
	    };
	  },
	
	  computed: {
	    online: function online() {
	      return window.api && window.api.config ? window.api.config.online : true;
	    },
	
	    mapEnabled: {
	      get: function get() {
	        return this.$store.state.project.map.enabled;
	      },
	      set: function set(enabled) {
	        this.$store.dispatch('project/setMapEnabled', { enabled: enabled });
	      }
	    },
	    tool: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.tool;
	      },
	      set: function set(val) {
	        this.$store.dispatch('application/setCurrentTool', { tool: val });
	      }
	    }
	  },
	  methods: {
	    importFloorplanAsFile: function importFloorplanAsFile(event) {
	      var _this = this;
	
	      var file = event.target.files[0];
	      var reader = new FileReader();
	      reader.addEventListener('load', function () {
	        _this.importFloorplan(reader.result);
	      }, false);
	
	      if (file) {
	        reader.readAsText(file);
	      }
	    },
	    importFloorplan: function importFloorplan(data) {
	      this.$store.dispatch('importFloorplan', {
	        clientWidth: document.getElementById('svg-grid').clientWidth,
	        clientHeight: document.getElementById('svg-grid').clientHeight,
	        data: JSON.parse(data)
	      });
	      this.$emit('close');
	    }
	  },
	  components: (0, _extends3.default)({}, _svgs2.default, {
	    NonChromeWarning: _NonChromeWarning2.default
	  })
	};

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ModalBase',
	  props: ['title'],
	  methods: {
	    close: function close() {
	      this.$emit('close');
	    }
	  }
	};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _ModalBase = __webpack_require__(271);
	
	var _ModalBase2 = _interopRequireDefault(_ModalBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SaveAsModal',
	  props: [],
	  mounted: function mounted() {
	    this.$refs.downloadName.focus();
	  },
	
	  computed: {
	    enable3DPreview: {
	      get: function get() {
	        return this.$store.state.project.preview3D.enabled;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      exportType: 'floorspace'
	    };
	  },
	
	  methods: {
	    downloadFile: function downloadFile() {
	      var a = document.createElement('a');
	      var data = (0, _stringify2.default)(this.$store.getters['exportData']);
	      this.$emit('close');
	
	      var blobData = data;
	      if (this.exportType !== 'floorspace') {
	        blobData = Module.floorplanToThreeJS(data, false);
	      }
	
	      var blob = new Blob([blobData], {
	        type: 'text/json;charset=utf-8'
	      });
	      a.setAttribute('href', URL.createObjectURL(blob));
	      a.setAttribute('download', this.$refs.downloadName.value + '.json');
	      a.click();
	
	      console.log('exported data for: ' + this.exportType);
	    }
	  },
	  components: {
	    ModalBase: _ModalBase2.default
	  }
	};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(27);
	
	var _ModalBase = __webpack_require__(271);
	
	var _ModalBase2 = _interopRequireDefault(_ModalBase);
	
	var _Info = __webpack_require__(724);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	var _ExpandableDrawer = __webpack_require__(721);
	
	var _ExpandableDrawer2 = _interopRequireDefault(_ExpandableDrawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Settings',
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    ground: function ground(state) {
	      return state.project.ground;
	    },
	    mapEnabled: function mapEnabled(state) {
	      return state.project.map.enabled;
	    }
	  }), {
	    floor_offset: {
	      get: function get() {
	        return this.ground.floor_offset;
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/modifyGround', { key: 'floor_offset', val: val });
	      }
	    },
	    azimuth_angle: {
	      get: function get() {
	        return this.ground.azimuth_angle;
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/modifyGround', { key: 'azimuth_angle', val: val });
	      }
	    },
	    tilt_slope: {
	      get: function get() {
	        return this.ground.tilt_slope;
	      },
	      set: function set(val) {
	        this.$store.dispatch('project/modifyGround', { key: 'tilt_slope', val: val });
	      }
	    },
	    northAxis: {
	      get: function get() {
	        return this.$store.state.project.north_axis + '\xB0';
	      },
	      set: function set(northAxis) {
	        this.$store.dispatch('project/setNorthAxis', { north_axis: northAxis });
	      }
	    }
	  }),
	  components: {
	    ModalBase: _ModalBase2.default,
	    Info: _Info2.default,
	    ExpandableDrawer: _ExpandableDrawer2.default
	  }
	};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vuex = __webpack_require__(27);
	
	var _utilities = __webpack_require__(102);
	
	var _helpers = __webpack_require__(75);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _helpers3 = __webpack_require__(50);
	
	var _helpers4 = _interopRequireDefault(_helpers3);
	
	var _ResizeEvents = __webpack_require__(194);
	
	var _ResizeEvents2 = _interopRequireDefault(_ResizeEvents);
	
	var _Library = __webpack_require__(726);
	
	var _Library2 = _interopRequireDefault(_Library);
	
	var _LibrarySelect = __webpack_require__(270);
	
	var _LibrarySelect2 = _interopRequireDefault(_LibrarySelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullWidth = void 0;
	var collapsedWidth = 8;
	exports.default = {
	  name: 'navigation',
	  data: function data() {
	    return {
	      libraryExpanded: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    currentComponent: 'application/currentComponent'
	  }), (0, _vuex.mapState)({
	    modeTab: function modeTab(state) {
	      return state.application.currentSelections.modeTab;
	    }
	  }), {
	    currentStory: {
	      get: function get() {
	        return this.$store.getters['application/currentStory'];
	      },
	      set: function set(story) {
	        this.$store.dispatch('application/setCurrentStoryId', { id: story.id });
	      }
	    },
	    currentSubSelection: {
	      get: function get() {
	        return this.$store.getters['application/currentSubSelection'];
	      },
	      set: function set(item) {
	        this.$store.dispatch('application/setCurrentSubSelectionId', { id: item ? item.id : null });
	      }
	    },
	
	    spaces: function spaces() {
	      return this.currentStory.spaces;
	    },
	    shading: function shading() {
	      return this.currentStory.shading;
	    },
	    images: function images() {
	      return this.currentStory.images;
	    },
	    objectTypesForTab: function objectTypesForTab() {
	      switch (this.modeTab) {
	        case 'floorplan':
	          return ['spaces', 'shading', 'images'];
	        case 'shading':
	          return ['shading'];
	        case 'components':
	          return ['window_definitions', 'daylighting_control_definitions', 'door_definitions'];
	        case 'assign':
	          return ['building_units', 'thermal_zones', 'space_types', 'construction_sets', 'pitched_roofs'];
	      }
	    },
	
	    mode: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.mode;
	      },
	      set: function set(mode) {
	        this.$store.dispatch('application/setCurrentMode', { mode: mode });
	      }
	    },
	    subselectionType: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.subselectionType;
	      },
	      set: function set(sst) {
	        this.$store.dispatch('application/setCurrentSubselectionType', { subselectionType: sst });
	      }
	    }
	  }),
	  methods: {
	    resetSize: function resetSize() {
	      if (this.libraryExpanded) {
	        return;
	      }
	    },
	    setWidthForOpenLibrary: function setWidthForOpenLibrary() {
	      this.$emit('expanded', !!this.libraryExpanded);
	      _ResizeEvents2.default.$emit('resize');
	    }
	  },
	  watch: {
	    libraryExpanded: function libraryExpanded() {
	      this.setWidthForOpenLibrary();
	    },
	    objectTypesForTab: function objectTypesForTab(val) {
	      if (!_lodash2.default.includes(val, this.subselectionType)) {
	        if (this.modeTab === 'assign') {
	          this.subselectionType = 'thermal_zones';
	        } else {
	          this.subselectionType = val[0];
	        }
	      }
	    }
	  },
	  components: {
	    Library: _Library2.default
	  }
	};

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  computed: {
	    isChrome: function isChrome() {
	      var isChromium = window.chrome || window.qt,
	          winNav = window.navigator,
	          vendorName = winNav.vendor,
	          isOpera = winNav.userAgent.indexOf("OPR") > -1,
	          isIEedge = winNav.userAgent.indexOf("Edge") > -1,
	          isIOSChrome = winNav.userAgent.match("CriOS");
	
	      if (isIOSChrome) {
	        return false;
	      } else if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }
	};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PrettySelect',
	  props: ['options', 'value', 'label', 'disabled'],
	  computed: {
	    normalizedOpts: function normalizedOpts() {
	      if (_lodash2.default.isArray(this.options)) {
	        if (!this.options.length) {
	          return [];
	        }
	        if (_lodash2.default.has(this.options[0], 'val') && _lodash2.default.has(this.options[0], 'display')) {
	          return this.options;
	        }
	        if (_lodash2.default.isString(this.options[0])) {
	          return this.options.map(function (o) {
	            return { val: o, display: o };
	          });
	        }
	      }
	      console.warn('unrecognized options structure', this.options);
	      return this.options;
	    }
	  }
	};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(75);
	
	var _PrettySelect = __webpack_require__(127);
	
	var _PrettySelect2 = _interopRequireDefault(_PrettySelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: {
	    renderableProperties: function renderableProperties() {
	      return ['spaces', 'building_units', 'thermal_zones', 'space_types', 'construction_sets', 'pitched_roofs'];
	    },
	    renderableOptions: function renderableOptions() {
	      return this.renderableProperties.map(function (p) {
	        return {
	          display: (0, _helpers.displayNameForMode)(p),
	          val: p
	        };
	      });
	    },
	
	    currentMode: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.mode;
	      },
	      set: function set(mode) {
	        this.$store.dispatch('application/setCurrentMode', { mode: mode });
	      }
	    }
	  },
	  components: {
	    PrettySelect: _PrettySelect2.default
	  }
	};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _portalVue = __webpack_require__(265);
	
	var _appconfig = __webpack_require__(28);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'TextureSelect',
	  props: ['value', 'label', 'disabled'],
	  data: function data() {
	    return {
	      open: false
	    };
	  },
	
	  computed: {
	    textures: function textures() {
	      return _appconfig.textures;
	    }
	  },
	  methods: {
	    choose: function choose(texture) {
	      this.$emit('change', texture);
	      this.open = false;
	    },
	    ulStyle: function ulStyle() {
	      var bb = this.$el && this.$el.getBoundingClientRect();
	      if (!bb) return {};
	      return {
	        left: bb.left + 'px',
	        top: bb.top + bb.height - 17 + 'px',
	        width: bb.width + 'px'
	      };
	    }
	  },
	  components: {
	    Portal: _portalVue.Portal
	  }
	};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(38);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _from = __webpack_require__(198);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _keys = __webpack_require__(56);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _appconfig = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Textures',
	  data: function data() {
	    return {
	      modifiers: {
	        '-highlight': 'green',
	        '-selected': 'green',
	        '-facing-selection': 'blue',
	        '': '#222'
	      }
	    };
	  },
	  mounted: function mounted() {
	    this.loadCssStyles();
	    this.checkTexturesList();
	  },
	
	  methods: {
	    loadCssStyles: function loadCssStyles() {
	      var css = document.createElement('style');
	      css.type = 'text/css';
	      if (css.styleSheet) {
	        css.styleSheet.cssText = this.styles;
	      } else {
	        css.appendChild(document.createTextNode(this.styles));
	      }
	      document.head.appendChild(css);
	    },
	    checkTexturesList: function checkTexturesList() {
	      var missingTextures = _lodash2.default.difference(_appconfig.textures, _lodash2.default.map(this.patterns, 'id')),
	          extraTextures = _lodash2.default.difference(_lodash2.default.map(this.patterns, 'id'), _appconfig.textures);
	      if (missingTextures.length) {
	        console.error('[warning]: Textures were added to Textures.vue, but not to appconfig.js.\n  This will cause those textures not to be used. The following are missing from appconfig:\n  ' + missingTextures);
	      }
	      if (extraTextures.length) {
	        console.error('[warning]: Textures were added to appconfig.js, but not to Textures.vue.\n  Those textures will not be visible. The following are missing from Textures.vue:\n  ' + extraTextures);
	      }
	    }
	  },
	  computed: {
	    modSuffixes: function modSuffixes() {
	      return _lodash2.default.filter((0, _keys2.default)(this.modifiers), _lodash2.default.identity);
	    },
	    patterns: function patterns() {
	      var _this = this;
	
	      return _lodash2.default.reject((0, _from2.default)(this.$el.querySelectorAll('pattern')), function (p) {
	        return _this.modSuffixes.some(function (ms) {
	          return _lodash2.default.endsWith(p.getAttribute('id'), ms);
	        });
	      });
	    },
	    cssStyles: function cssStyles() {
	      return this.patterns.map(function (pattern) {
	        var id = pattern.getAttribute('id'),
	            width = pattern.getAttribute('width'),
	            height = pattern.getAttribute('height'),
	            contents = pattern.innerHTML,
	            wrapped = '<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'' + width + '\' height=\'' + height + '\'>' + contents + '</svg>';
	        return '\n            .texture-' + id + ' {\n              background-image: url("data:image/svg+xml;base64,' + btoa(wrapped) + '");\n              background-repeat: repeat;\n            }';
	      });
	    },
	    windowStyles: function windowStyles() {
	      return _lodash2.default.map(this.patterns, function (p) {
	        return p.getAttribute('id');
	      }).map(function (id) {
	        return '\n            #grid svg .polygons .window .hatch[data-texture="' + id + '"] {\n              fill: url(#' + id + ');\n            }\n            #grid svg .polygons .window .facing-selection .hatch[data-texture="' + id + '"] {\n              fill: url(#' + id + '-facing-selection);\n            }\n            #grid svg .polygons .window .selected .hatch[data-texture="' + id + '"] {\n              fill: url(#' + id + '-selected);\n            }\n            #grid svg .highlight .window .hatch[data-texture="' + id + '"] {\n              fill: url(#' + id + '-highlight);\n            }\n          ';
	      });
	    },
	    styles: function styles() {
	      return [].concat((0, _toConsumableArray3.default)(this.cssStyles), (0, _toConsumableArray3.default)(this.windowStyles)).join('\n');
	    }
	  }
	};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vuex = __webpack_require__(27);
	
	var _SaveAsModal = __webpack_require__(729);
	
	var _SaveAsModal2 = _interopRequireDefault(_SaveAsModal);
	
	var _Settings = __webpack_require__(730);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _PrettySelect = __webpack_require__(127);
	
	var _PrettySelect2 = _interopRequireDefault(_PrettySelect);
	
	var _helpers = __webpack_require__(75);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _svgs = __webpack_require__(195);
	
	var _svgs2 = _interopRequireDefault(_svgs);
	
	var _RenderByDropdown = __webpack_require__(733);
	
	var _RenderByDropdown2 = _interopRequireDefault(_RenderByDropdown);
	
	var _ComponentInstanceEditBar = __webpack_require__(717);
	
	var _ComponentInstanceEditBar2 = _interopRequireDefault(_ComponentInstanceEditBar);
	
	var _appconfig = __webpack_require__(28);
	
	var _appconfig2 = _interopRequireDefault(_appconfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'toolbar',
	  data: function data() {
	    return {
	      componentTypes: {
	        daylighting_control_definitions: 'Daylighting Control Definitions',
	        window_definitions: 'Window Definitions'
	      },
	      showSaveModal: false,
	      visibleComponentType: null,
	      showGroundPropsModal: false
	    };
	  },
	
	  methods: {
	    setImageTool: function setImageTool() {
	      this.tool = 'Image';
	      if (this.currentStory.images.length === 0) {
	        window.eventBus.$emit('uploadImage');
	      }
	    },
	    zoomToFit: function zoomToFit() {
	      window.eventBus.$emit('zoomToFit');
	    },
	    exportData: function exportData() {
	      this.showSaveModal = true;
	      return this.$store.getters['exportData'];
	    },
	    open3DPreviewer: function open3DPreviewer() {
	      localStorage.setItem("floorplan3DExport", (0, _stringify2.default)(application.$store.getters['exportData']));
	      window.open('3DViewer');
	    },
	    importDataAsFile: function importDataAsFile(event, type) {
	      var _this = this;
	
	      var file = event.target.files[0];
	      var reader = new FileReader();
	
	      reader.addEventListener('load', function () {
	        var data = void 0;
	        try {
	          data = JSON.parse(reader.result);
	        } catch (e) {
	          window.eventBus.$emit('error', 'Invalid JSON');
	          return;
	        }
	        if (type === 'library') {
	          _this.$store.dispatch('importLibrary', { data: data });
	        } else if (type === 'floorplan') {
	          _this.$store.dispatch('importFloorplan', {
	            clientWidth: document.getElementById('svg-grid').clientWidth,
	            clientHeight: document.getElementById('svg-grid').clientHeight,
	            data: data
	          });
	        }
	      }, false);
	
	      if (file) {
	        reader.readAsText(file);
	      }
	    },
	    undo: function undo() {
	      this.$store.timetravel.undo();
	    },
	    redo: function redo() {
	      this.$store.timetravel.redo();
	    },
	    updateUnits: function updateUnits(val) {
	      if (this.allowSettingUnits) {
	        this.rwUnits = val;
	      } else {
	        window.eventBus.$emit('error', 'Units must be set before any geometry is drawn.');
	      }
	    },
	    displayNameForMode: function displayNameForMode(mode) {
	      return _helpers2.default.displayNameForMode(mode);
	    }
	  },
	  computed: (0, _extends3.default)({
	    latestCreatedCompId: function latestCreatedCompId() {
	      return _.chain(this.allComponents).map('defs').flatten().map('id').map(Number).max().value() + '';
	    },
	    allComponents: function allComponents() {
	      var _this2 = this;
	
	      return _appconfig.componentTypes.map(function (ct) {
	        return {
	          defs: _this2.$store.state.models.library[ct],
	          name: _appconfig2.default.modes[ct],
	          type: ct
	        };
	      });
	    },
	    currentComponentType: function currentComponentType() {
	      return this.currentComponent.type;
	    },
	    currentComponentDefinition: function currentComponentDefinition() {
	      return this.currentComponent.definition;
	    }
	  }, (0, _vuex.mapGetters)({
	    currentSpaceProperty: 'application/currentSpaceProperty',
	    currentStory: 'application/currentStory'
	  }), (0, _vuex.mapState)({
	    mapEnabled: function mapEnabled(state) {
	      return state.project.map.enabled;
	    },
	    timetravelInitialized: function timetravelInitialized(state) {
	      return state.timetravelInitialized;
	    },
	    showImportExport: function showImportExport(state) {
	      return state.project.show_import_export;
	    },
	    allowSettingUnits: function allowSettingUnits(state) {
	      return false;
	    } }), {
	    currentSubselectionType: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.subselectionType;
	      },
	      set: function set(sst) {
	        this.$store.dispatch('application/setCurrentSubselectionType', { subselectionType: sst });
	      }
	    },
	    enable3DPreview: {
	      get: function get() {
	        return this.$store.state.project.preview3D.enabled;
	      }
	    },
	    availableTools: function availableTools() {
	      var tools = [];
	      switch (this.modeTab) {
	        case 'floorplan':
	          tools = ['Rectangle', 'Polygon', 'Eraser', 'Select', 'Image'];
	          break;
	        case 'shading':
	          tools = ['Rectangle', 'Polygon', 'Eraser', 'Select'];
	          break;
	        case 'components':
	          tools = ['Place Component'];
	          break;
	        case 'assign':
	          tools = ['Apply Property'];
	          break;
	        default:
	          break;
	      }
	      if (this.previousStoryVisible && (this.modeTab === 'floorplan' || this.currentMode === 'shading')) {
	        tools.push('Fill');
	      }
	      return tools;
	    },
	
	    currentMode: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.mode;
	      },
	      set: function set(mode) {
	        this.$store.dispatch('application/setCurrentMode', { mode: mode });
	      }
	    },
	    modeTab: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.modeTab;
	      },
	      set: function set(mt) {
	        this.$store.dispatch('application/setCurrentModeTab', { modeTab: mt });
	      }
	    },
	    gridVisible: {
	      get: function get() {
	        return this.$store.state.project.grid.visible;
	      },
	      set: function set(visible) {
	        this.$store.dispatch('project/setGridVisible', { visible: visible });
	      }
	    },
	    mapVisible: {
	      get: function get() {
	        return this.$store.state.project.map.visible;
	      },
	      set: function set(visible) {
	        this.$store.dispatch('project/setMapVisible', { visible: visible });
	      }
	    },
	    previousStoryVisible: {
	      get: function get() {
	        return this.$store.state.project.previous_story.visible;
	      },
	      set: function set(visible) {
	        this.$store.dispatch('project/setPreviousStoryVisible', { visible: visible });
	      }
	    },
	    tool: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.tool;
	      },
	      set: function set(tool) {
	        this.$store.dispatch('application/setCurrentTool', { tool: tool });
	      }
	    },
	
	    spacing: {
	      get: function get() {
	        return this.$store.state.project.grid.spacing;
	      },
	      set: function set(spacing) {
	        this.$store.dispatch('project/setSpacing', { spacing: spacing });
	      }
	    },
	
	    currentComponent: {
	      get: function get() {
	        return this.$store.getters['application/currentComponent'];
	      },
	      set: function set(item) {
	        if (!item || !item.definition || !item.definition.id) {
	          return;
	        }
	        this.$store.dispatch('application/setCurrentComponentDefinitionId', { id: item.definition.id });
	      }
	    },
	    rwUnits: {
	      get: function get() {
	        return this.$store.state.project.config.units === 'ip' ? 'ft' : 'm';
	      },
	      set: function set(units) {
	        this.$store.dispatch('project/setUnits', { units: units === 'ft' ? 'ip' : 'si' });
	      }
	    },
	    snapMode: {
	      get: function get() {
	        return this.$store.state.application.currentSelections.snapMode;
	      },
	      set: function set(snapMode) {
	        this.$store.dispatch('application/setCurrentSnapMode', { snapMode: snapMode });
	      }
	    }
	  }),
	  watch: {
	    modeTab: function modeTab() {
	      if (this.modeTab === 'assign' && this.currentSpaceProperty) {
	        this.currentMode = this.currentSpaceProperty.type;
	      } else {
	        this.currentMode = 'spaces';
	      }
	    },
	    tool: function tool(val) {
	      if (this.availableTools.indexOf(val) === -1 && val !== 'Map') {
	        this.tool = this.availableTools[0];
	      }
	      if (this.tool === 'Image' && this.currentSubselectionType !== 'images') {
	        this.currentSubselectionType = 'images';
	      } else if (this.tool !== 'Image' && this.currentSubselectionType === 'images') {
	        this.currentSubselectionType = 'spaces';
	      }
	    },
	    availableTools: function availableTools() {
	      if (!_.includes(this.availableTools, this.tool)) {
	        this.tool = this.availableTools[0];
	      }
	    },
	    currentSubselectionType: function currentSubselectionType(val) {
	      if (val === 'images' && this.tool !== 'Image') {
	        this.tool = 'Image';
	      } else if (val !== 'images' && this.tool === 'Image') {
	        this.tool = this.availableTools[0];
	      }
	    },
	    latestCreatedCompId: function latestCreatedCompId() {
	      this.$store.dispatch('application/setCurrentComponentDefinitionId', { id: this.latestCreatedCompId });
	    }
	  },
	  components: (0, _extends3.default)({
	    PrettySelect: _PrettySelect2.default,
	    SaveAsModal: _SaveAsModal2.default,
	    Settings: _Settings2.default,
	    RenderByDropdown: _RenderByDropdown2.default,
	    ComponentInstanceEditBar: _ComponentInstanceEditBar2.default
	  }, _svgs2.default)
	};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(57);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.drawWindow = drawWindow;
	exports.drawWindowGuideline = drawWindowGuideline;
	exports.drawDaylightingControl = drawDaylightingControl;
	exports.drawDaylightingControlGuideline = drawDaylightingControlGuideline;
	exports.drawImage = drawImage;
	exports.drawWall = drawWall;
	exports.default = drawMethods;
	
	var _d = __webpack_require__(85);
	
	var d3 = _interopRequireWildcard(_d);
	
	__webpack_require__(646);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(16);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function boxAroundWindow(_ref) {
	  var xScale = _ref.xScale,
	      yScale = _ref.yScale,
	      edge = _ref.edge,
	      offset = _ref.offset;
	
	  var _unitPerpVector = (0, _helpers.unitPerpVector)(edge.start, edge.end),
	      dx = _unitPerpVector.dx,
	      dy = _unitPerpVector.dy;
	
	  return [[xScale(edge.start.x) + offset * dx, yScale(edge.start.y) + offset * dy], [xScale(edge.start.x) - offset * dx, yScale(edge.start.y) - offset * dy], [xScale(edge.end.x) - offset * dx, yScale(edge.end.y) - offset * dy], [xScale(edge.end.x) + offset * dx, yScale(edge.end.y) + offset * dy], [xScale(edge.start.x) + offset * dx, yScale(edge.start.y) + offset * dy]];
	}
	
	function drawWindowToWallRatio(xScale, yScale, el, datum) {
	  d3.select(el).selectAll('.single-window, .repeating-windows').remove();
	  var selection = d3.select(el).selectAll('.window-wall-ratio').data([datum]);
	  var wwrE = selection.enter().append('g').attr('class', 'window-wall-ratio');
	  wwrE.append('path').attr('class', 'hatch');
	
	  var line = d3.line();
	
	  var wwr = selection.merge(wwrE);
	  wwr.classed('selected', function (d) {
	    return d.selected;
	  });
	  wwr.classed('facing-selection', function (d) {
	    return d.facingSelection;
	  });
	  wwr.select('.hatch').attr('d', line(boxAroundWindow({ edge: datum, xScale: xScale, yScale: yScale, offset: 8 }))).attr('data-texture', datum.texture || 'diagonal-stripes-4');
	}
	
	function drawDoor(xScale, yScale, el, datum) {
	  var selection = d3.select(el).selectAll('.door').data([datum]);
	  var doorE = selection.enter().append('g').attr('class', 'door');
	  doorE.append('path').attr('class', 'hatch');
	
	  var line = d3.line();
	  var door = selection.merge(doorE);
	  door.exit().remove();
	  door.classed('selected', function (d) {
	    return d.selected;
	  });
	  door.classed('facing-selection', function (d) {
	    return d.facingSelection;
	  });
	  door.select('.hatch').attr('d', line(boxAroundWindow({ edge: datum, xScale: xScale, yScale: yScale, offset: 8 }))).attr('data-texture', datum.texture);
	}
	
	function drawSingleWindow(xScale, yScale, el, datum) {
	  d3.select(el).selectAll('.window-wall-ratio, .repeating-windows').remove();
	
	  var selection = d3.select(el).selectAll('.single-window').data([datum]);
	  var windowE = selection.enter().append('g').attr('class', 'single-window');
	  windowE.append('line').attr('class', 'pane');
	  windowE.append('circle');
	  windowE.append('line').attr('class', 'start-linecap');
	  windowE.append('line').attr('class', 'end-linecap');
	
	  var windw = selection.merge(windowE);
	  windw.classed('selected', function (d) {
	    return d.selected;
	  });
	  windw.classed('facing-selection', function (d) {
	    return d.facingSelection;
	  });
	  windw.select('line.pane').attr('x1', function (d) {
	    return xScale(d.start.x);
	  }).attr('y1', function (d) {
	    return yScale(d.start.y);
	  }).attr('x2', function (d) {
	    return xScale(d.end.x);
	  }).attr('y2', function (d) {
	    return yScale(d.end.y);
	  });
	  windw.each(function (d) {
	    var _unitPerpVector2 = (0, _helpers.unitPerpVector)(d.start, d.end),
	        dx = _unitPerpVector2.dx,
	        dy = _unitPerpVector2.dy,
	        linecapOffset = 6;
	
	    var $this = d3.select(this);
	    $this.select('.start-linecap').attr('x1', xScale(d.start.x) + linecapOffset * dx).attr('y1', yScale(d.start.y) + linecapOffset * dy).attr('x2', xScale(d.start.x) - linecapOffset * dx).attr('y2', yScale(d.start.y) - linecapOffset * dy);
	    $this.select('.end-linecap').attr('x1', xScale(d.end.x) + linecapOffset * dx).attr('y1', yScale(d.end.y) + linecapOffset * dy).attr('x2', xScale(d.end.x) - linecapOffset * dx).attr('y2', yScale(d.end.y) - linecapOffset * dy);
	    if (d.selected || d.facingSelection) {
	      $this.raise();
	    }
	  });
	  windw.select('circle').attr('cx', function (d) {
	    return xScale(d.center.x);
	  }).attr('cy', function (d) {
	    return yScale(d.center.y);
	  }).attr('r', '2');
	}
	
	function drawRepeatingWindows(xScale, yScale, el, datum) {
	  var start = datum.start,
	      end = datum.end,
	      width = datum.width,
	      spacing = datum.spacing;
	
	  d3.select(el).selectAll('.window-wall-ratio, .single-window').remove();
	
	  var selection = d3.select(el).selectAll('.repeating-windows').data([datum]);
	  var rwE = selection.enter().append('g').attr('class', 'repeating-windows');
	  rwE.append('path').attr('class', 'box');
	  rwE.append('g').attr('class', 'sub-windows');
	
	  var line = d3.line();
	
	  var rw = selection.merge(rwE);
	  rw.classed('selected', function (d) {
	    return d.selected;
	  });
	  rw.classed('facing-selection', function (d) {
	    return d.facingSelection;
	  });
	  rw.select('.box').attr('d', line(boxAroundWindow({ edge: datum, xScale: xScale, yScale: yScale, offset: 6 })));
	
	  var direction = (0, _helpers.unitVector)(start, end),
	      centers = (0, _helpers.repeatingWindowCenters)({ start: start, end: end, spacing: spacing, width: width });
	  var widthX = direction.dx * width,
	      widthY = direction.dy * width;
	  var windows = centers.map(function (thisCenter) {
	    return (0, _extends3.default)({}, datum, {
	      center: thisCenter,
	      start: { x: thisCenter.x - widthX / 2, y: thisCenter.y - widthY / 2 },
	      end: { x: thisCenter.x + widthX / 2, y: thisCenter.y + widthY / 2 }
	    });
	  });
	  var windw = rw.select('.sub-windows').selectAll('.sub-window').data(windows);
	  windw.exit().remove();
	  windw.merge(windw.enter().append('g').attr('class', 'sub-window')).each(function (d) {
	    drawSingleWindow(xScale, yScale, this, d);
	  });
	}
	
	function drawWindow() {
	  var xScale = _lodash2.default.identity,
	      yScale = _lodash2.default.identity;
	  function chart(selection) {
	    selection.exit().remove();
	    selection.merge(selection.enter().append('g').attr('class', 'window')).each(function (d) {
	      if (d.windowOrDoor === 'door') {
	        drawDoor(xScale, yScale, this, d);
	      } else if (d.window_definition_mode === 'Single Window') {
	        drawSingleWindow(xScale, yScale, this, d);
	      } else if (d.window_definition_mode === 'Window to Wall Ratio') {
	        drawWindowToWallRatio(xScale, yScale, this, d);
	      } else if (d.window_definition_mode === 'Repeating Windows') {
	        drawRepeatingWindows(xScale, yScale, this, d);
	      } else {
	        throw new Error('unexpected window_definition_mode: ' + d.window_definition_mode);
	      }
	    });
	  }
	
	  chart.xScale = function (_) {
	    if (!arguments.length) return xScale;
	    xScale = _;
	    return chart;
	  };
	  chart.yScale = function (_) {
	    if (!arguments.length) return yScale;
	    yScale = _;
	    return chart;
	  };
	
	  return chart;
	}
	
	function distanceMeasure() {
	  var xScale = _lodash2.default.identity,
	      yScale = _lodash2.default.identity,
	      lineOffset = 20,
	      labelPosition = 1;
	  function chart(selection) {
	    selection.exit().remove();
	    var measureE = selection.enter().append('g').attr('class', 'distance-measure').attr('transform', function (d) {
	      var _unitPerpVector3 = (0, _helpers.unitPerpVector)(d.start, d.end),
	          dx = _unitPerpVector3.dx,
	          dy = _unitPerpVector3.dy,
	          offX = lineOffset * dx,
	          offY = lineOffset * dy;
	
	      return 'translate(' + offX + ', ' + offY + ')';
	    });
	    measureE.append('line');
	    measureE.append('text');
	    measureE.append('path').attr('class', 'start');
	    measureE.append('path').attr('class', 'end');
	
	    var measure = selection.merge(measureE);
	
	    measure.select('text').attr('x', function (d) {
	      return (1 - labelPosition) * xScale(d.start.x) + labelPosition * xScale(d.end.x);
	    }).attr('y', function (d) {
	      return (1 - labelPosition) * yScale(d.start.y) + labelPosition * yScale(d.end.y);
	    }).attr('dominant-baseline', 'text-before-edge').attrs(function (d) {
	      var _unitPerpVector4 = (0, _helpers.unitPerpVector)(d.start, d.end),
	          dx = _unitPerpVector4.dx,
	          dy = _unitPerpVector4.dy,
	          offset = 4;
	
	      return {
	        dx: dx * offset,
	        dy: dy * offset
	      };
	    }).text(function (d) {
	      var distance = (0, _helpers.distanceBetweenPoints)(d.start, d.end),
	          roundDistance = Math.round(distance * 100) / 100;
	      return '' + roundDistance;
	    });
	    measure.select('line').attrs(function (d) {
	      var _unitVector = (0, _helpers.unitVector)(d.start, d.end),
	          dx = _unitVector.dx,
	          dy = _unitVector.dy,
	          offset = 11.5,
	          offX = dx * offset,
	          offY = dy * offset;
	
	      return {
	        x1: xScale(d.start.x) + offX,
	        y1: yScale(d.start.y) - offY,
	        x2: xScale(d.end.x) - offX,
	        y2: yScale(d.end.y) + offY
	      };
	    });
	    var arrowHead = 'M -6,-2 V 2 L0,0 Z',
	        rotate = function rotate(d) {
	      var angle = (0, _helpers.edgeDirection)(d) * 180 / Math.PI,
	          adjust = d.start.x === d.end.x ? d.start.y > d.end.y ? 0 : 180 : d.start.x > d.end.x ? 0 : 180;
	
	      return adjust - angle;
	    };
	
	    measure.select('path.start').attr('transform', function (d) {
	      return 'translate(' + xScale(d.start.x) + ', ' + yScale(d.start.y) + ') scale(2) rotate(' + rotate(d) + ')';
	    }).attr('d', arrowHead);
	
	    measure.select('path.end').attr('transform', function (d) {
	      return 'translate(' + xScale(d.end.x) + ', ' + yScale(d.end.y) + ') scale(2) rotate(' + (180 + rotate(d)) + ')';
	    }).attr('d', arrowHead);
	  }
	  chart.xScale = function (_) {
	    if (!arguments.length) return xScale;
	    xScale = _;
	    return chart;
	  };
	  chart.yScale = function (_) {
	    if (!arguments.length) return yScale;
	    yScale = _;
	    return chart;
	  };
	  chart.lineOffset = function (_) {
	    if (!arguments.length) return lineOffset;
	    lineOffset = _;
	    return chart;
	  };
	  chart.labelPosition = function (_) {
	    if (!arguments.length) return labelPosition;
	    if (_ < 0 || _ > 1) {
	      console.warn('Expected labelPosition to be in [0, 1] (got ' + _ + ')');
	    }
	    labelPosition = _;
	    return chart;
	  };
	
	  return chart;
	}
	
	function drawWindowGuideline() {
	  var xScale = _lodash2.default.identity,
	      yScale = _lodash2.default.identity;
	  var drawMeasure = distanceMeasure();
	  function chart(selection) {
	    drawMeasure.xScale(xScale).yScale(yScale);
	    selection.exit().remove();
	    selection.merge(selection.enter().append('g').classed('window-guideline component-guideline', true)).selectAll('.distance-measure').data(selection.merge(selection.enter()).data().map(function (d) {
	      return { start: d.edge_start, end: d.center };
	    })).filter(function (d) {
	      return d.window_definition_mode === 'Single Window';
	    }).call(drawMeasure);
	  }
	
	  chart.xScale = function (_) {
	    if (!arguments.length) return xScale;
	    xScale = _;
	    return chart;
	  };
	  chart.yScale = function (_) {
	    if (!arguments.length) return yScale;
	    yScale = _;
	    return chart;
	  };
	  return chart;
	}
	
	function drawDaylightingControl() {
	  var xScale = _lodash2.default.identity,
	      yScale = _lodash2.default.identity;
	
	  function chart(selection) {
	    selection.exit().remove();
	    var dcE = selection.enter().append('g').attr('class', 'daylighting-control');
	    dcE.append('circle').attr('class', 'bg');
	    dcE.append('path').attr('class', 'quadrants');
	    var dc = selection.merge(dcE);
	    dc.classed('selected', function (d) {
	      return d.selected;
	    });
	    dc.classed('facing-selection', function (d) {
	      return d.facingSelection;
	    });
	    dc.select('circle.bg').attr('cx', function (d) {
	      return xScale(d.x);
	    }).attr('cy', function (d) {
	      return yScale(d.y);
	    }).attr('r', 10);
	    dc.select('path.quadrants').attr('d', function (d) {
	      var x = xScale(d.x),
	          y = yScale(d.y),
	          r = 10;
	      return 'M' + x + ' ' + y + ' L' + (x + r) + ' ' + y + ' A ' + r + ' ' + r + ' 0 0 1 ' + x + ' ' + (y + r) + ' L ' + x + ' ' + (y - r) + ' A ' + r + ' ' + r + ' 0 0 0 ' + (x - r) + ' ' + y + ' Z';
	    });
	    dc.each(function (d) {
	      if (d.selected || d.facingSelection) {
	        d3.select(this).raise();
	      }
	    });
	  }
	
	  chart.xScale = function (_) {
	    if (!arguments.length) return xScale;
	    xScale = _;
	    return chart;
	  };
	  chart.yScale = function (_) {
	    if (!arguments.length) return yScale;
	    yScale = _;
	    return chart;
	  };
	  return chart;
	}
	
	function drawDaylightingControlGuideline() {
	  var xScale = _lodash2.default.identity,
	      yScale = _lodash2.default.identity;
	  var drawMeasure = distanceMeasure().lineOffset(0).labelPosition(0.5);
	  function chart(selection) {
	    drawMeasure.xScale(xScale).yScale(yScale);
	    selection.exit().remove();
	    var guideE = selection.enter().append('g').classed('daylighting-control-guideline component-guideline', true);
	
	    var data = _lodash2.default.flatMap(selection.merge(selection.enter()).data(), function (d) {
	      var dir = (0, _helpers.unitVector)(d.nearestEdge.v1, d.nearestEdge.v2),
	          v = { start: d.loc, end: d.nearestEdge.proj },
	          dotProduct = (v.end.x - v.start.x) * dir.dx + (v.end.y - v.start.y) * dir.dy,
	          parallel = {
	        start: v.start,
	        end: {
	          x: v.start.x + dotProduct * dir.dx,
	          y: v.start.y + dotProduct * dir.dy
	        }
	      },
	          perp = {
	        start: parallel.end,
	        end: v.end
	      };
	      return [v, perp, parallel].filter(function (_ref2) {
	        var start = _ref2.start,
	            end = _ref2.end;
	        return (0, _helpers.distanceBetweenPoints)(start, end) > 0.01;
	      });
	    });
	    var guide = selection.merge(guideE);
	    guide.selectAll('.distance-measure').data(data).call(drawMeasure);
	  }
	
	  chart.xScale = function (_) {
	    if (!arguments.length) return xScale;
	    xScale = _;
	    return chart;
	  };
	  chart.yScale = function (_) {
	    if (!arguments.length) return yScale;
	    yScale = _;
	    return chart;
	  };
	  return chart;
	}
	var invRoot2 = 1 / Math.sqrt(2);
	var RESIZE_CURSORS = [{ vec: { x: 1, y: 0 }, cursor: 'ew-resize' }, { vec: { x: -1, y: 0 }, cursor: 'ew-resize' }, { vec: { x: 0, y: 1 }, cursor: 'ns-resize' }, { vec: { x: 0, y: -1 }, cursor: 'ns-resize' }, { vec: { x: invRoot2, y: invRoot2 }, cursor: 'nwse-resize' }, { vec: { x: -1 * invRoot2, y: -1 * invRoot2 }, cursor: 'nwse-resize' }, { vec: { x: invRoot2, y: -1 * invRoot2 }, cursor: 'nesw-resize' }, { vec: { x: -1 * invRoot2, y: invRoot2 }, cursor: 'nesw-resize' }];
	function bestResizeCursor(xOff, yOff, rotation) {
	  var norm = Math.sqrt(xOff * xOff + yOff * yOff),
	      x = xOff / norm,
	      y = yOff / norm,
	      a = Math.PI * rotation / 180,
	      pt = {
	    x: x * Math.cos(a) - y * Math.sin(a),
	    y: x * Math.sin(a) + y * Math.cos(a)
	  };
	
	  return _lodash2.default.minBy(RESIZE_CURSORS, function (c) {
	    return (0, _helpers.distanceBetweenPoints)(c.vec, pt);
	  }).cursor;
	}
	var rotateCursor = 'url(data:image/svg+xml;base64,' + btoa('<svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="25.6" height="25.6" viewBox="0 0 25.6 25.6">' + '  <path transform="scale(0.5)" d="M25.6,44.8c7.9406,0,14.4-6.4594,14.4-14.4s-6.4594-14.4-14.4-14.4v9.6L9.6,12.8L25.6,0v9.6c11.4688,0,20.8,9.3313,20.8,20.8s-9.3313,20.8-20.8,20.8S4.8,41.8688,4.8,30.4h6.4C11.2,38.3406,17.6594,44.8,25.6,44.8z"/>' + '</svg>') + ') 12.8 12.8, pointer';
	
	function drawImage() {
	  var xScale = _lodash2.default.identity,
	      yScale = _lodash2.default.identity,
	      updateImage = _lodash2.default.identity,
	      selectImage = _lodash2.default.identity;
	  function chart(selection) {
	    var pxPerRWU = (xScale(100) - xScale(0)) / 100;
	
	    var startX = void 0,
	        startY = void 0,
	        currX = void 0,
	        currY = void 0;
	    var offset = function offset(d) {
	      var x = currX - startX,
	          y = currY - startY,
	          invR = -1 * d.r * Math.PI / 180;
	      return {
	        dx: x * Math.cos(invR) - y * Math.sin(invR),
	        dy: x * Math.sin(invR) + y * Math.cos(invR)
	      };
	    },
	        moveable = d3.drag().on('start', function () {
	      d3.event.sourceEvent.stopPropagation();
	      var _d3$mouse = d3.mouse(document.querySelector('#grid svg'));
	
	      var _d3$mouse2 = (0, _slicedToArray3.default)(_d3$mouse, 2);
	
	      startX = _d3$mouse2[0];
	      startY = _d3$mouse2[1];
	
	      currX = currY = undefined;
	    }).on('drag', function (d) {
	      var _d3$mouse3 = d3.mouse(document.querySelector('#grid svg'));
	
	      var _d3$mouse4 = (0, _slicedToArray3.default)(_d3$mouse3, 2);
	
	      currX = _d3$mouse4[0];
	      currY = _d3$mouse4[1];
	
	      var _offset = offset(d),
	          dx = _offset.dx,
	          dy = _offset.dy;
	
	      d3.select(this).attr('transform', 'translate(' + dx + ', ' + dy + ')');
	    }).on('end', function (d) {
	      if (typeof currX === 'undefined') {
	        return;
	      }
	
	      var _offset2 = offset(d),
	          dx = _offset2.dx,
	          dy = _offset2.dy;
	
	      updateImage({
	        image: d,
	        x: d.x + (currX - startX) / pxPerRWU,
	        y: d.y - (currY - startY) / pxPerRWU
	      });
	    });
	
	    var scaleTransform = function scaleTransform(d) {
	      var pxCenter = { x: xScale(d.x), y: yScale(d.y) },
	          pxOrigin = {
	        x: pxCenter.x + (pxCenter.x - startX),
	        y: pxCenter.y + (pxCenter.y - startY)
	      },
	          startVec = {
	        x: startX - pxOrigin.x,
	        y: startY - pxOrigin.y
	      },
	          distCurrToOrigin = (0, _helpers.distanceBetweenPoints)({ x: currX, y: currY }, pxOrigin),
	          distStartToOrigin = (0, _helpers.distanceBetweenPoints)({ x: startX, y: startY }, pxOrigin),
	          currVec = {
	        x: distCurrToOrigin * startVec.x / distStartToOrigin,
	        y: distCurrToOrigin * startVec.y / distStartToOrigin
	      },
	          scale = distCurrToOrigin / distStartToOrigin,
	          translate = {
	        x: (currVec.x - startVec.x) / 2,
	        y: (currVec.y - startVec.y) / 2
	      },
	          transform = d3.zoomIdentity.translate(translate.x, translate.y).scale(scale);
	      return transform;
	    },
	        resizeable = d3.drag().on('start', function () {
	      d3.event.sourceEvent.stopPropagation();
	
	      var _d3$mouse5 = d3.mouse(document.querySelector('#grid svg'));
	
	      var _d3$mouse6 = (0, _slicedToArray3.default)(_d3$mouse5, 2);
	
	      startX = _d3$mouse6[0];
	      startY = _d3$mouse6[1];
	
	      currX = currY = undefined;
	    }).on('drag', function (d) {
	      var _d3$mouse7 = d3.mouse(document.querySelector('#grid svg'));
	
	      var _d3$mouse8 = (0, _slicedToArray3.default)(_d3$mouse7, 2);
	
	      currX = _d3$mouse8[0];
	      currY = _d3$mouse8[1];
	
	      d3.select(this.parentNode.parentNode).attr('transform', scaleTransform(d));
	    }).on('end', function (d) {
	      if (typeof currX === 'undefined') {
	        return;
	      }
	      var trans = scaleTransform(d);
	      updateImage({
	        image: d,
	        width: d.width * trans.k,
	        height: d.height * trans.k,
	        x: d.x + trans.x / pxPerRWU,
	        y: d.y - trans.y / pxPerRWU
	      });
	    });
	
	    var rotationAngle = function rotationAngle(d) {
	      var pxOrigin = { x: xScale(d.x), y: yScale(d.y) },
	          startAngle = (0, _helpers.edgeDirection)({ start: pxOrigin, end: { x: startX, y: startY } }),
	          currAngle = (0, _helpers.edgeDirection)({ start: pxOrigin, end: { x: currX, y: currY } });
	      return 180 * (currAngle - startAngle) / Math.PI + 180 * (xScale(d.x) > currX !== xScale(d.x) > startX);
	    },
	        rotateable = d3.drag().on('start', function () {
	      d3.event.sourceEvent.stopPropagation();
	
	      var _d3$mouse9 = d3.mouse(document.querySelector('#grid svg'));
	
	      var _d3$mouse10 = (0, _slicedToArray3.default)(_d3$mouse9, 2);
	
	      startX = _d3$mouse10[0];
	      startY = _d3$mouse10[1];
	
	      currX = currY = undefined;
	    }).on('drag', function (d) {
	      var _d3$mouse11 = d3.mouse(document.querySelector('#grid svg'));
	
	      var _d3$mouse12 = (0, _slicedToArray3.default)(_d3$mouse11, 2);
	
	      currX = _d3$mouse12[0];
	      currY = _d3$mouse12[1];
	
	      d3.select(this.parentNode.parentNode).attr('transform', 'rotate(' + rotationAngle(d) + ')');
	    }).on('end', function (d) {
	      if (typeof currX === 'undefined') {
	        return;
	      }
	      var rotation = rotationAngle(d);
	      updateImage({
	        image: d,
	        r: rotation + d.r
	      });
	    });
	
	    selection.exit().remove();
	    var imageGroupE = selection.enter().append('g').attr('class', 'image-group');
	    var moveableWrapperE = imageGroupE.append('g').attr('class', 'moveable-wrapper');
	    moveableWrapperE.append('image');
	    var controlsE = moveableWrapperE.append('g').attr('class', 'controls');
	    controlsE.append('line').attr('class', 'rotation-to-center');
	    controlsE.append('circle').attr('class', 'rotation-handle');
	    ['tl', 'tr', 'bl', 'br'].forEach(function (corner) {
	      return controlsE.append('circle').attr('class', 'corner ' + corner);
	    });
	
	    var imageGroup = selection.merge(imageGroupE);
	
	    imageGroup.attr('transform', function (d) {
	      return 'translate(' + xScale(d.x) + ', ' + yScale(d.y) + ') rotate(' + d.r + ')';
	    });
	
	    imageGroup.select('image').attr('x', function (d) {
	      return -1 * pxPerRWU * d.width / 2;
	    }).attr('y', function (d) {
	      return -1 * pxPerRWU * d.height / 2;
	    }).attr('width', function (d) {
	      return pxPerRWU * d.width;
	    }).attr('height', function (d) {
	      return pxPerRWU * d.height;
	    }).attr('opacity', function (d) {
	      return d.opacity;
	    }).attr('xlink:href', function (d) {
	      return d.src;
	    });
	
	    imageGroup.select('.moveable-wrapper').attr('transform', 'translate(0,0)').style('cursor', function (d) {
	      return d.current ? 'move' : d.clickable ? 'pointer' : null;
	    }).style('pointer-events', function (d) {
	      return d.current ? 'auto' : 'none';
	    });
	
	    imageGroup.select('.controls').attr('display', function (d) {
	      return d.current ? '' : 'none';
	    });
	
	    imageGroup.each(function (d) {
	      var ig = d3.select(this);
	      if (!d.clickable) {
	        ig.on('click', null);
	      } else {
	        ig.on('click', function (d) {
	          d3.event.stopPropagation();
	          selectImage(d);
	        });
	      }
	      if (!d.current) {
	        ig.select('.moveable-wrapper, .rotation-handle, .corner').on('.drag', null);
	      } else {
	        ig.select('.moveable-wrapper').call(moveable);
	
	        ig.select('.controls .center').attr('cx', 0).attr('cy', 0).attr('r', 3);
	
	        ig.select('.controls .rotation-handle').attr('cx', 0).attr('cy', pxPerRWU * d.height * 0.7).attr('r', 5).style('cursor', rotateCursor).call(rotateable);
	        ig.select('.controls .rotation-to-center').attr('x1', 0).attr('y1', pxPerRWU * d.height / 2).attr('x2', 0).attr('y2', pxPerRWU * d.height * 0.7 - 5);
	        _lodash2.default.forIn({ tl: [-1, -1], tr: [1, -1], bl: [-1, 1], br: [1, 1] }, function (_ref3, label) {
	          var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	              xOff = _ref4[0],
	              yOff = _ref4[1];
	
	          ig.select('.controls .' + label).attr('cx', xOff * pxPerRWU * d.width / 2).attr('cy', yOff * pxPerRWU * d.height / 2).attr('r', 5).style('cursor', bestResizeCursor(xOff, yOff, d.r)).call(resizeable);
	        });
	      }
	    });
	  }
	
	  chart.xScale = function (_) {
	    if (!arguments.length) return xScale;
	    xScale = _;
	    return chart;
	  };
	  chart.yScale = function (_) {
	    if (!arguments.length) return yScale;
	    yScale = _;
	    return chart;
	  };
	  chart.updateImage = function (_) {
	    if (!arguments.length) return updateImage;
	    updateImage = _;
	    return chart;
	  };
	  chart.selectImage = function (_) {
	    if (!arguments.length) return selectImage;
	    selectImage = _;
	    return chart;
	  };
	  return chart;
	}
	
	function drawWall() {
	  var xScale = _lodash2.default.identity,
	      yScale = _lodash2.default.identity;
	  var line = d3.line().x(function (d) {
	    return xScale(d.x);
	  }).y(function (d) {
	    return yScale(d.y);
	  });
	  function chart(selection) {
	    selection.exit().remove();
	    var wallE = selection.enter().append('path').attr('class', 'wall');
	
	    var wall = selection.merge(wallE);
	
	    wall.attr('d', function (d) {
	      return line([d.start, d.end]);
	    }).attr('class', function (d) {
	      return 'wall ' + (d.interior ? 'interior' : 'exterior');
	    }).attr('data-edge-id', function (d) {
	      return d.id;
	    });
	  }
	
	  chart.xScale = function (_) {
	    if (!arguments.length) return xScale;
	    xScale = _;
	    return chart;
	  };
	  chart.yScale = function (_) {
	    if (!arguments.length) return yScale;
	    yScale = _;
	    return chart;
	  };
	  return chart;
	}
	
	function drawMethods(_ref5) {
	  var xScale = _ref5.xScale,
	      yScale = _ref5.yScale,
	      updateImage = _ref5.updateImage,
	      selectImage = _ref5.selectImage;
	
	
	  return {
	    drawWindow: drawWindow().xScale(xScale).yScale(yScale),
	    drawWindowGuideline: drawWindowGuideline().xScale(xScale).yScale(yScale),
	    drawDaylightingControl: drawDaylightingControl().xScale(xScale).yScale(yScale),
	    drawDaylightingControlGuideline: drawDaylightingControlGuideline().xScale(xScale).yScale(yScale),
	    drawImage: drawImage().xScale(xScale).yScale(yScale).updateImage(updateImage).selectImage(selectImage),
	    drawWall: drawWall().xScale(xScale).yScale(yScale)
	  };
	}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _slicedToArray2 = __webpack_require__(57);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _toConsumableArray2 = __webpack_require__(38);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(76);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _d = __webpack_require__(85);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _polylabel = __webpack_require__(704);
	
	var _polylabel2 = _interopRequireDefault(_polylabel);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _snapping = __webpack_require__(128);
	
	var _helpers = __webpack_require__(16);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _helpers3 = __webpack_require__(50);
	
	var _helpers4 = _interopRequireDefault(_helpers3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ticksInRange(start, stop, spacing) {
	  return _lodash2.default.range(Math.ceil(start / spacing) * spacing, stop, spacing);
	}
	
	function transformDiff(t1, t2) {
	  return new d3.zoomIdentity.constructor(t2.k / t1.k, (t2.x / t2.k - t1.x / t1.k) * t2.k, (t2.y / t2.k - t1.y / t1.k) * t2.k);
	}
	
	exports.default = {
	  gridClicked: function gridClicked() {
	    if (this.currentTool === 'Eraser' || (this.currentTool === 'Rectangle' || this.currentTool === 'Polygon') && (this.currentSpace || this.currentShading)) {
	      this.addPoint();
	    }
	    if (this.currentTool === 'Place Component') {
	      this.placeOrSelectComponent();
	    }
	    if (this.currentTool === 'Image') {
	      this.deselectImages();
	    }
	    if (this.currentTool === 'Apply Property') {
	      this.assignProperty();
	    }
	  },
	  assignProperty: function assignProperty() {
	    var _this = this;
	
	    if (!this.currentSpaceProperty) {
	      return;
	    }
	    var gridCoords = d3.mouse(this.$refs.grid),
	        gridPoint = { x: gridCoords[0], y: gridCoords[1] },
	        rwuPoint = this.gridPointToRWU(gridPoint),
	        space = this.currentStory.spaces.find(function (sp) {
	      var face = _lodash2.default.find(_this.denormalizedGeometry.faces, { id: sp.face_id });
	      if (!face) {
	        return false;
	      }
	      return _helpers2.default.pointInFace(rwuPoint, face.vertices);
	    });
	    if (!space) {
	      return;
	    }
	    this.$store.dispatch('models/updateSpaceWithData', (0, _defineProperty3.default)({
	      space: space
	    }, this.spacePropertyKey, this.currentSpaceProperty.id));
	  },
	  deselectImages: function deselectImages() {
	    this.$store.dispatch('application/setCurrentSubSelectionId', this.currentStory.spaces[0]);
	  },
	  componentToSelect: function componentToSelect() {
	    var gridCoords = d3.mouse(this.$refs.grid),
	        gridPoint = { x: gridCoords[0], y: gridCoords[1] },
	        rwuPoint = this.gridPointToRWU(gridPoint),
	        component = _lodash2.default.minBy(this.currentComponentTypeLocs(rwuPoint), function (ci) {
	      return (0, _helpers.distanceBetweenPoints)(ci, rwuPoint);
	    }),
	        distToComp = component && (0, _helpers.distanceBetweenPoints)(component, rwuPoint);
	    if (!component || distToComp > this.spacing / 2) {
	      return null;
	    }
	    return component;
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    if ((e.keyCode === 8 || e.keyCode === 46) && !_lodash2.default.includes(['input', 'textarea'], document.activeElement.tagName.toLowerCase())) {
	      this.deleteElement();
	    }
	  },
	  deleteElement: function deleteElement() {
	    if (this.modeTab === 'components') {
	      this.removeSelectedComponent();
	    }
	  },
	  removeSelectedComponent: function removeSelectedComponent() {
	    var component = this.currentComponentInstance;
	    if (!component) {
	      return;
	    }
	    var payload = { story_id: this.currentStory.id, object: { id: component.id } };
	    if (component.type === 'windows') {
	      this.$store.dispatch('models/destroyWindow', payload);
	    } else if (component.type === 'daylighting_controls') {
	      this.$store.dispatch('models/destroyDaylightingControl', payload);
	    } else if (component.type === 'doors') {
	      this.$store.dispatch('models/destroyDoor', payload);
	    } else {
	      console.error('unrecognized component to remove: ' + component);
	    }
	  },
	  placeOrSelectComponent: function placeOrSelectComponent() {
	    var toSelect = d3.event.shiftKey ? false : this.componentToSelect();
	    if (toSelect) {
	      this.currentComponentInstanceId = toSelect.id;
	      return;
	    }
	
	    if (this.currentComponentType === 'daylighting_control_definitions') {
	      this.placeDaylightingControl();
	    } else if (this.currentComponentType === 'window_definitions' || this.currentComponentType === 'door_definitions') {
	      this.placeWindowOrDoor();
	    } else {
	      throw new Error('unrecognized componentType: ' + this.currentComponentType);
	    }
	  },
	  highlightComponentToSelect: function highlightComponentToSelect() {
	    if (d3.event.shiftKey) {
	      return null;
	    }
	    var component = this.componentToSelect();
	    this.componentFacingSelection = component && component.id;
	    if (!component) {} else if (component.type === 'windows' || component.type === 'doors') {
	      this.highlightWindowGuideline(component);
	    } else if (component.type === 'daylighting_controls') {
	      this.highlightDaylightingControlGuideline(component);
	    } else {
	      throw new Error('unrecognized componentType: ' + this.currentComponentType);
	    }
	    return component;
	  },
	  placeWindowOrDoor: function placeWindowOrDoor() {
	    var _payload;
	
	    var gridCoords = d3.mouse(this.$refs.grid),
	        gridPoint = { x: gridCoords[0], y: gridCoords[1] },
	        rwuPoint = this.gridPointToRWU(gridPoint),
	        loc = (0, _snapping.snapWindowToEdge)(this.snapMode, this.spaceEdges, rwuPoint, this.currentComponentDefinition, this.spacing * 2, this.spacing),
	        windowOrDoor = this.currentComponentType === 'window_definitions' ? 'Window' : 'Door';
	
	    if (!loc) {
	      return;
	    }
	
	    var payload = (_payload = {
	      story_id: this.currentStory.id,
	      edge_id: loc.edge_id
	    }, (0, _defineProperty3.default)(_payload, windowOrDoor.toLowerCase() + '_definition_id', this.currentComponentDefinition.id), (0, _defineProperty3.default)(_payload, 'alpha', loc.alpha), _payload);
	    this.$store.dispatch('models/create' + windowOrDoor, payload);
	  },
	  raiseOrLowerImages: function raiseOrLowerImages() {
	    if (this.currentTool === 'Image') {
	      d3.select('#grid svg .images').raise();
	    } else {
	      d3.select('#grid svg .images').lower();
	    }
	  },
	  placeDaylightingControl: function placeDaylightingControl() {
	    var gridCoords = d3.mouse(this.$refs.grid),
	        gridPoint = { x: gridCoords[0], y: gridCoords[1] },
	        rwuPoint = {
	      x: this.gridToRWU(gridPoint.x, 'x'),
	      y: this.gridToRWU(gridPoint.y, 'y')
	    },
	        loc = (0, _snapping.snapToVertexWithinFace)(this.snapMode, this.spaceFaces, rwuPoint, this.spacing);
	
	    if (!loc) {
	      return;
	    }
	
	    var payload = (0, _extends3.default)({
	      story_id: this.currentStory.id,
	      face_id: loc.face_id,
	      daylighting_control_definition_id: this.currentComponentDefinition.id
	    }, loc);
	    this.$store.dispatch('models/createDaylightingControl', payload);
	  },
	  addPoint: function addPoint() {
	    var gridCoords = d3.mouse(this.$refs.grid),
	        gridPoint = { x: gridCoords[0], y: gridCoords[1] },
	        snapTarget = this.findSnapTarget(gridPoint);
	
	    if (snapTarget.type === 'vertex' && snapTarget.origin && this.currentTool === 'Polygon') {
	      this.savePolygonFace();
	      return;
	    }
	
	    var newPoint = snapTarget.type === 'edge' ? snapTarget.projection : snapTarget;
	    this.points.push(newPoint);
	    this.drawPoints();
	
	    if (this.currentTool === 'Eraser' && this.points.length === 2) {
	      this.eraseRectangularSelection();
	    }
	    if (this.currentTool === 'Rectangle' && this.points.length === 2) {
	      this.saveRectangularFace();
	    }
	  },
	  highlightSnapTarget: function highlightSnapTarget(e) {
	    if (!(this.currentTool === 'Eraser' || this.currentTool === 'Place Component' && this.currentComponentDefinition || (this.currentTool === 'Rectangle' || this.currentTool === 'Polygon') && (this.currentSpace || this.currentShading))) {
	      return;
	    }
	
	    this.clearHighlights();
	
	    var gridPoint = void 0;
	    if (d3.event instanceof MouseEvent) {
	      var gridCoords = d3.mouse(this.$refs.grid);
	      gridPoint = { x: gridCoords[0], y: gridCoords[1] };
	    } else {
	      gridPoint = this.lastMousePosition;
	    }
	    if (!gridPoint) {
	      return;
	    }
	
	    if (this.currentTool === 'Place Component') {
	      this.highlightComponentToPlaceOrSelect(gridPoint);
	      return;
	    }
	
	    var snapTarget = this.findSnapTarget(gridPoint);
	
	    var guidePoint = snapTarget.type === 'edge' ? snapTarget.projection : snapTarget;
	
	    var ellipsePoint = snapTarget.synthetic ? snapTarget.originalPt : guidePoint;
	    this.drawGuideLines(e, guidePoint);
	
	    if (snapTarget.type === 'vertex') {
	      d3.select('#grid svg').append('ellipse').attr('cx', this.rwuToGrid(ellipsePoint.x, 'x')).attr('cy', this.rwuToGrid(ellipsePoint.y, 'y')).attr('rx', 5).attr('ry', 5).classed('highlight', true).attr('data-transform-plz', '').attr('vector-effect', 'non-scaling-stroke');
	    } else {
	      d3.select('#grid svg').append('ellipse').attr('cx', this.rwuToGrid(ellipsePoint.x, 'x')).attr('cy', this.rwuToGrid(ellipsePoint.y, 'y')).attr('rx', 3).attr('ry', 3).classed('gridpoint', true).attr('data-transform-plz', '').attr('vector-effect', 'non-scaling-stroke');
	    }
	
	    if (snapTarget.type === 'edge' && this.currentTool !== 'Eraser') {
	      d3.select('#grid svg').append('line').attr('x1', this.rwuToGrid(snapTarget.v1GridCoords.x, 'x')).attr('y1', this.rwuToGrid(snapTarget.v1GridCoords.y, 'y')).attr('x2', this.rwuToGrid(snapTarget.v2GridCoords.x, 'x')).attr('y2', this.rwuToGrid(snapTarget.v2GridCoords.y, 'y')).attr('stroke-width', 1).classed('highlight', true).attr('data-transform-plz', '').attr('vector-effect', 'non-scaling-stroke');
	    }
	
	    this.lastMousePosition = gridPoint;
	  },
	  clearHighlights: function clearHighlights() {
	    d3.selectAll('#grid .highlight, #grid .gridpoint, #grid .guideline').remove();
	    this.componentFacingSelection = null;
	  },
	  clearComponentHighlights: function clearComponentHighlights() {
	    d3.selectAll('#grid .highlight, #grid .component-guideline').remove();
	    this.componentFacingSelection = null;
	  },
	  highlightComponentToPlaceOrSelect: function highlightComponentToPlaceOrSelect(gridPoint) {
	    if (this.highlightComponentToSelect()) {
	      return;
	    }
	
	    this.highlightComponentToPlace(gridPoint);
	  },
	  highlightComponentToPlace: function highlightComponentToPlace(gridPoint) {
	    if (this.currentComponentType === 'window_definitions') {
	      this.highlightWindow(gridPoint);
	    } else if (this.currentComponentType === 'daylighting_control_definitions') {
	      this.highlightDaylightingControl(gridPoint);
	    } else if (this.currentComponentType === 'door_definitions') {
	      this.highlightDoor(gridPoint);
	    } else {
	      throw new Error('unrecognized componentType: ' + this.currentComponentType);
	    }
	  },
	  highlightWindow: function highlightWindow(gridPoint) {
	    var rwuPoint = this.gridPointToRWU(gridPoint),
	        loc = (0, _snapping.snapWindowToEdge)(this.snapMode, this.spaceEdges, rwuPoint, this.currentComponentDefinition, this.spacing * 2, this.spacing);
	
	    if (!loc) {
	      return;
	    }
	
	    if (this.currentComponentDefinition.window_definition_mode !== 'Single Window' && _lodash2.default.filter(this.windowCenterLocs(rwuPoint), { edge_id: loc.edge_id }).filter(function (w) {
	      return w.window_definition_mode !== 'Single Window';
	    }).length) {
	      return;
	    }
	    d3.select('#grid svg').append('g').classed('highlight', true).selectAll('.window').data([(0, _extends3.default)({}, loc, {
	      window_definition_mode: this.currentComponentDefinition.window_definition_mode,
	      width: this.currentComponentDefinition.width,
	      spacing: this.currentComponentDefinition.window_spacing,
	      texture: this.currentComponentDefinition.texture
	    })]).call(this.drawWindow);
	    this.highlightWindowGuideline(loc);
	  },
	  highlightDoor: function highlightDoor(gridPoint) {
	    var rwuPoint = this.gridPointToRWU(gridPoint),
	        loc = (0, _snapping.snapWindowToEdge)(this.snapMode, this.spaceEdges, rwuPoint, this.currentComponentDefinition, this.spacing * 2, this.spacing);
	
	    if (!loc) {
	      return;
	    }
	
	    d3.select('#grid svg').append('g').classed('highlight', true).selectAll('.window').data([(0, _extends3.default)({}, loc, {
	      window_definition_mode: null,
	      windowOrDoor: 'door',
	      width: this.currentComponentDefinition.width,
	      texture: this.currentComponentDefinition.texture
	    })]).call(this.drawWindow);
	    this.highlightWindowGuideline(loc);
	  },
	  highlightWindowGuideline: function highlightWindowGuideline(loc) {
	    d3.select('#grid svg').append('g').classed('guideline', true).selectAll('.window-guideline').data([loc]).call(this.drawWindowGuideline);
	  },
	  highlightDaylightingControl: function highlightDaylightingControl(gridPoint) {
	    var rwuPoint = this.gridPointToRWU(gridPoint),
	        loc = (0, _snapping.snapToVertexWithinFace)(this.snapMode, this.spaceFaces, rwuPoint, this.spacing);
	    if (!loc) {
	      return;
	    }
	    d3.select('#grid svg').append('g').classed('highlight', true).selectAll('.daylighting-control').data([loc]).call(this.drawDaylightingControl);
	
	    this.highlightDaylightingControlGuideline(loc);
	  },
	  highlightDaylightingControlGuideline: function highlightDaylightingControlGuideline(loc) {
	    var face = _lodash2.default.find(this.denormalizedGeometry.faces, { id: loc.face_id }),
	        windows = this.windowsOnFace(face),
	        nearestEdge = (0, _snapping.findClosestWindow)(windows, loc) || (0, _snapping.findClosestEdge)(face.edges, loc);
	    d3.select('#grid svg').append('g').classed('guideline', true).selectAll('.daylighting-control-guideline').data([{ loc: loc, nearestEdge: nearestEdge }]).call(this.drawDaylightingControlGuideline);
	  },
	  drawGuideLines: function drawGuideLines(e, guidePoint) {
	    var _this2 = this;
	
	    if (!this.points.length) {
	      return;
	    }
	
	    this.eraseGuidelines();
	
	    var guidelinePoints = void 0,
	        guidelinePaths = void 0;
	
	    if (this.currentTool === 'Polygon') {
	      guidelinePoints = [guidePoint, this.points[this.points.length - 1]];
	      guidelinePaths = [guidelinePoints];
	    } else if (this.currentTool === 'Rectangle' || this.currentTool === 'Eraser') {
	      guidelinePoints = [this.points[0], { x: guidePoint.x, y: this.points[0].y }, guidePoint, { x: this.points[0].x, y: guidePoint.y }, this.points[0]];
	
	      guidelinePaths = [[guidelinePoints[0], guidelinePoints[1]], [guidelinePoints[1], guidelinePoints[2]]];
	    }
	
	    var guidelineArea = this.currentTool === 'Polygon' ? [].concat((0, _toConsumableArray3.default)(this.points), [guidePoint, this.points[0]]) : guidelinePoints,
	        guidelinePolys = [guidelineArea, this.points],
	        svg = d3.select('#grid svg');
	
	    svg.selectAll('.guideline-line').append('path').datum(guidelinePoints).attr('fill', 'none').classed('guideline guideline-line', true).attr('vector-effect', 'non-scaling-stroke').attr('data-transform-plz', '').attr('d', d3.line().x(function (d) {
	      return _this2.rwuToGrid(d.x, 'x');
	    }).y(function (d) {
	      return _this2.rwuToGrid(d.y, 'y');
	    })).lower();
	
	    svg.selectAll('.guideline-area').data(guidelinePolys).enter().append('polygon').attr('points', function (d) {
	      return d.map(function (p) {
	        return [_this2.rwuToGrid(p.x, 'x'), _this2.rwuToGrid(p.y, 'y')].join(',');
	      }).join(' ');
	    }).classed('guideline guideline-area guideLine', true).attr('vector-effect', 'non-scaling-stroke').attr('data-transform-plz', '').attr('fill', function () {
	      if (_this2.currentTool === 'Eraser') {
	        return 'none';
	      }
	      if (_this2.currentSpace) {
	        return _this2.currentSpace.color;
	      }
	      if (_this2.currentShading) {
	        return _this2.currentShading.color;
	      }
	      return null;
	    });
	
	    if (this.currentTool === 'Eraser') {
	      return;
	    }
	
	    svg.selectAll('.guideline-text').data(guidelinePaths).enter().append('text').attr('x', function (d) {
	      return _this2.rwuToGrid(d[0].x, 'x') + (_this2.rwuToGrid(d[1].x, 'x') - _this2.rwuToGrid(d[0].x, 'x')) / 2;
	    }).attr('y', function (d) {
	      return _this2.rwuToGrid(d[0].y, 'y') + (_this2.rwuToGrid(d[1].y, 'y') - _this2.rwuToGrid(d[0].y, 'y')) / 2;
	    }).attr('dx', -1.25 * (this.transform.k > 1 ? 1 : this.transform.k) + 'em').attr('data-transform-plz', '').text(function (d) {
	      var dist = _this2.distanceBetweenPoints(d[0], d[1]);
	      return dist ? dist.toFixed(2) : '';
	    }).classed('guideline guideline-text guideline-dist', true).attr('font-family', 'sans-serif').attr('fill', 'red').style('font-size', '1em');
	
	    if (guidelineArea.length > 3) {
	      var areaPoints = guidelineArea.map(function (p) {
	        var x = p.x,
	            y = p.y;
	        return { x: x, y: y, X: x, Y: y };
	      }),
	          _polygonLabelPosition = this.polygonLabelPosition(areaPoints),
	          x = _polygonLabelPosition.x,
	          y = _polygonLabelPosition.y,
	          area = _polygonLabelPosition.area,
	          areaTextNoUnits = area ? area.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '',
	          areaText = areaTextNoUnits + ' ' + (this.units === 'ip' ? 'ft' : 'm') + '\xB2';
	
	
	      if (x === null || y === null) {
	        return;
	      }
	
	      svg.append('text').attr('x', this.rwuToGrid(x, 'x')).attr('y', this.rwuToGrid(y, 'y')).text(areaText).classed('guideline guideline-text guideline-area-text guideLine', true).attr('data-transform-plz', '').attr('text-anchor', 'middle').attr('font-family', 'sans-serif').attr('fill', 'red').style('font-size', '1em').raise();
	    }
	
	    d3.selectAll('.vertical, .horizontal').lower();
	  },
	  eraseGuidelines: function eraseGuidelines() {
	    d3.selectAll('#grid .guideline').remove();
	  },
	  escapeAction: function escapeAction(e) {
	    if (e.code === 'Escape' || e.which === 27) {
	      this.points = [];
	      this.clearHighlights();
	      d3.selectAll('#grid .point-path').remove();
	    }
	  },
	  savePolygonFace: function savePolygonFace() {
	    this.clearHighlights();
	    d3.selectAll('#grid .point-path').remove();
	
	    var payload = {
	      points: [].concat((0, _toConsumableArray3.default)(this.points))
	    };
	
	    if (this.currentSpace) {
	      payload.model_id = this.currentSpace.id;
	    } else if (this.currentShading) {
	      payload.model_id = this.currentShading.id;
	    }
	
	    this.$store.dispatch('geometry/createFaceFromPoints', payload);
	
	    this.points = [];
	  },
	  saveRectangularFace: function saveRectangularFace() {
	    this.clearHighlights();
	    d3.selectAll('#grid .point-path').remove();
	
	    var payload = {};
	
	    payload.points = [this.points[0], { x: this.points[1].x, y: this.points[0].y }, this.points[1], { x: this.points[0].x, y: this.points[1].y }];
	
	    if (this.currentSpace) {
	      payload.model_id = this.currentSpace.id;
	    } else if (this.currentShading) {
	      payload.model_id = this.currentShading.id;
	    }
	    this.$store.dispatch('geometry/createFaceFromPoints', payload);
	
	    this.points = [];
	  },
	  eraseRectangularSelection: function eraseRectangularSelection() {
	    this.clearHighlights();
	    d3.selectAll('#grid .point-path').remove();
	
	    var payload = {
	      points: [this.points[0], { x: this.points[1].x, y: this.points[0].y }, this.points[1], { x: this.points[0].x, y: this.points[1].y }]
	    };
	
	    this.$store.dispatch('geometry/eraseSelection', payload);
	
	    this.points = [];
	  },
	  drawPoints: function drawPoints() {
	    var _this3 = this;
	
	    d3.selectAll('#grid .point-path').remove();
	
	    var pointPath = d3.select('#grid svg').selectAll('ellipse.point-path').data(this.points);
	
	    pointPath.merge(pointPath.enter().append('ellipse').attr('class', 'point-path')).classed('origin', function (d, ix) {
	      return ix === 0;
	    }).attr('data-transform-plz', '').attr('cx', function (d) {
	      return _this3.rwuToGrid(d.x, 'x');
	    }).attr('cy', function (d) {
	      return _this3.rwuToGrid(d.y, 'y');
	    }).attr('rx', function (d, ix) {
	      return ix === 0 ? 7 : 2;
	    }).attr('ry', function (d, ix) {
	      return ix === 0 ? 7 : 2;
	    }).attr('vector-effect', 'non-scaling-stroke').attr('fill', function (d, ix) {
	      return ix === 0 ? 'none' : '';
	    });
	
	    d3.select('#grid svg').append('path').attr('class', 'point-path').datum(this.points).attr('fill', 'none').attr('vector-effect', 'non-scaling-stroke').attr('data-transform-plz', '').attr('d', d3.line().x(function (d) {
	      return _this3.rwuToGrid(d.x, 'x');
	    }).y(function (d) {
	      return _this3.rwuToGrid(d.y, 'y');
	    })).lower();
	
	    d3.selectAll('.vertical, .horizontal').lower();
	  },
	  registerDrag: function registerDrag() {
	    var polygons = d3.select('#grid svg').selectAll('polygon');
	
	    this.deregisterD3Events(polygons);
	    if (this.currentTool === 'Select') {
	      this.registerSelectEvents(polygons);
	    } else if (this.currentTool === 'Fill') {
	      this.registerFillEvents(polygons);
	    }
	  },
	  deregisterD3Events: function deregisterD3Events(polygons) {
	    polygons.on('.drag', null).on('click', null);
	  },
	  registerFillEvents: function registerFillEvents(polygons) {
	    var _this4 = this;
	
	    polygons.on('click', function (d) {
	      if (_this4.currentSpace || _this4.currentShading) {
	        _this4.points = [].concat((0, _toConsumableArray3.default)(d.points));
	        _this4.savePolygonFace();
	      }
	    });
	  },
	  registerSelectEvents: function registerSelectEvents(polygons) {
	    var _this5 = this;
	
	    var startX = void 0,
	        startY = void 0;
	
	    var drag = d3.drag().on('start', function (d) {
	      var _d3$mouse = d3.mouse(_this5.$refs.grid);
	
	      var _d3$mouse2 = (0, _slicedToArray3.default)(_d3$mouse, 2);
	
	      startX = _d3$mouse2[0];
	      startY = _d3$mouse2[1];
	
	      if (d.previous_story) {
	        return;
	      }
	
	      _this5.currentSubSelection = _helpers4.default.modelForFace(_this5.$store.state.models, d.face_id);
	    }).on('drag', function (d) {
	      if (d.previous_story) {
	        return;
	      }
	
	      var _d3$mouse3 = d3.mouse(_this5.$refs.grid),
	          _d3$mouse4 = (0, _slicedToArray3.default)(_d3$mouse3, 2),
	          currX = _d3$mouse4[0],
	          currY = _d3$mouse4[1];
	
	      d3.select('#poly-' + d.face_id).attr('transform', function () {
	        return 'translate(' + (currX - startX) + ', ' + (currY - startY) + ')';
	      });
	    }).on('end', function (d) {
	      if (d.previous_story) {
	        return;
	      }
	
	      var _d3$mouse5 = d3.mouse(_this5.$refs.grid),
	          _d3$mouse6 = (0, _slicedToArray3.default)(_d3$mouse5, 2),
	          endX = _d3$mouse6[0],
	          endY = _d3$mouse6[1];
	
	      _this5.$store.dispatch('geometry/moveFaceByOffset', {
	        face_id: d.face_id,
	        dx: _this5.gridToRWU(endX, 'x') - _this5.gridToRWU(startX, 'x'),
	        dy: _this5.gridToRWU(endY, 'y') - _this5.gridToRWU(startY, 'y')
	      });
	    });
	    polygons.call(drag);
	  },
	  drawPolygons: function drawPolygons() {
	    var _this6 = this;
	
	    this.recalcScales();
	
	    var poly = d3.select('#grid svg .polygons').selectAll('g.poly').data(this.polygons, function (d) {
	      return d.face_id;
	    });
	
	    poly.exit().remove();
	    var polyEnter = poly.enter().append('g').attr('class', 'poly');
	    polyEnter.append('polygon');
	    polyEnter.append('text').attr('class', 'polygon-text');
	    polyEnter.append('g').attr('class', 'windows');
	    polyEnter.append('g').attr('class', 'doors');
	    polyEnter.append('g').attr('class', 'daylighting-controls');
	
	    poly = polyEnter.merge(poly).classed('current', function (d) {
	      return d.current;
	    }).classed('previousStory', function (d) {
	      return d.previous_story;
	    }).classed('poly', true).attr('data-model-type', function (d) {
	      return d.modelType;
	    }).attr('id', function (p) {
	      return 'poly-' + p.face_id;
	    }).attr('transform', null);
	
	    poly.select('polygon').attr('id', function (d) {
	      return 'face-' + d.face_id;
	    }).attr('points', function (d) {
	      return d.points.map(function (p) {
	        return [_this6.rwuToGrid(p.x, 'x'), _this6.rwuToGrid(p.y, 'y')].join(',');
	      }).join(' ');
	    }).attr('fill', function (d) {
	      return d.color;
	    }).attr('vector-effect', 'non-scaling-stroke');
	
	    poly.select('text').attr('id', function (p) {
	      return 'text-' + p.face_id;
	    }).attr('x', function (p) {
	      return _this6.rwuToGrid(p.labelPosition.x, 'x');
	    }).attr('y', function (p) {
	      return _this6.rwuToGrid(p.labelPosition.y, 'y');
	    }).text(function (p) {
	      return p.name;
	    }).attr('text-anchor', 'middle').style('font-size', '14px').style('font-weight', 'bold').attr('font-family', 'sans-serif').attr('fill', 'red').classed('polygon-text', true);
	
	    poly.select('.windows').selectAll('.window').data(function (d) {
	      return d.windows;
	    }).call(this.drawWindow);
	
	    poly.select('.doors').selectAll('.window').data(function (d) {
	      return d.doors;
	    }).call(this.drawWindow);
	
	    poly.select('.daylighting-controls').selectAll('.daylighting-control').data(function (d) {
	      return d.daylighting_controls;
	    }).call(this.drawDaylightingControl);
	
	    this.registerDrag();
	
	    poly.order();
	  },
	  drawWalls: function drawWalls() {
	    d3.select('#grid svg .walls').selectAll('.wall').data(this.walls, function (d) {
	      return d.id;
	    }).call(this.drawWall);
	  },
	  drawImages: function drawImages() {
	    d3.select('#grid svg .images').selectAll('.image-group').data(this.images, function (d) {
	      return d.id;
	    }).call(this.drawImage);
	  },
	  draw: function draw() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        zoomEnd = _ref.zoomEnd;
	
	    this.transformAtLastRender = (0, _extends3.default)({}, this.transform);
	    d3.selectAll('[data-transform-plz]').attr('transform', '');
	
	    this.drawPolygons();
	    this.drawWalls();
	    this.drawImages();
	    this.raiseOrLowerImages();
	
	    var redrawPoints = zoomEnd && this.points.length > 0;
	    if (redrawPoints) {
	      this.highlightSnapTarget();
	      this.drawPoints();
	    }
	  },
	  findSnapTarget: function findSnapTarget(gridPoint) {
	    var _this7 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var snapOnlyToEdges = options.edge_component;
	
	    var rwuPoint = {
	      x: this.gridToRWU(gridPoint.x, 'x'),
	      y: this.gridToRWU(gridPoint.y, 'y')
	    };
	    if (this.snapMode === 'grid-strict') {
	      return this.strictSnapTargets(rwuPoint)[0];
	    }
	
	    if (this.snapMode === 'grid-verts-edges') {
	      var realPoint = this.gridPointToRWU(gridPoint);
	      var targets = [].concat((0, _toConsumableArray3.default)((0, _snapping.vertexSnapTargets)(this.currentStoryGeometry.vertices, this.spacing, realPoint)), (0, _toConsumableArray3.default)(this.snappingEdgeData(realPoint)), (0, _toConsumableArray3.default)((0, _snapping.gridSnapTargets)(this.spacing, realPoint)), (0, _toConsumableArray3.default)(this.polygonOriginPoint())).map(function (target) {
	        var penaltyFactor = target.type === 'edge' ? 1.4 : 1.0;
	        return (0, _extends3.default)({}, target, {
	          dist: penaltyFactor * (0, _helpers.distanceBetweenPoints)(target, realPoint),
	          dx: realPoint.x - target.x,
	          dy: realPoint.y - target.y
	        });
	      });
	
	      var orderedTargets = _lodash2.default.orderBy(targets, ['dist', 'origin', 'type'], ['asc', 'asc', 'desc']);
	      return orderedTargets[0] || (0, _extends3.default)({
	        type: 'gridpoint'
	      }, realPoint);
	    }
	
	    if (snapOnlyToEdges) {
	      var _snappingEdge = this.snappingEdgeData(rwuPoint);
	      return _snappingEdge[0] || (0, _extends3.default)({
	        type: 'gridpoint'
	      }, rwuPoint);
	    }
	
	    var snappingVertex = this.snappingVertexData(rwuPoint);
	    if (snappingVertex) {
	      return snappingVertex;
	    }
	
	    var snappingEdge = this.snappingEdgeData(rwuPoint);
	    if (snappingEdge.length > 0) {
	      return snappingEdge[0];
	    }
	
	    if (this.gridVisible) {
	      var xTickSpacing = this.rwuToGrid(this.spacing + this.min_x, 'x'),
	          yTickSpacing = this.rwuToGrid(this.max_y - this.spacing, 'y');
	      var snapTarget = {
	        type: 'gridpoint',
	        x: this.round(gridPoint.x, xTickSpacing) - 0.5,
	        y: this.round(gridPoint.y, yTickSpacing) - 0.5
	      };
	
	      snapTarget.x = Math.abs(gridPoint.x - (snapTarget.x - xTickSpacing)) > Math.abs(gridPoint.x - snapTarget.x) ? snapTarget.x : snapTarget.x - xTickSpacing;
	      snapTarget.y = Math.abs(gridPoint.y - (snapTarget.y - yTickSpacing)) > Math.abs(gridPoint.y - snapTarget.y) ? snapTarget.y : snapTarget.y - yTickSpacing;
	
	      return snapTarget;
	    } else if (this.points.length) {
	        var snappableAngles = [-180, -90, 0, 90, 180];
	        var lastPoint = this.points[this.points.length - 1];
	
	        var thetaDeg = Math.atan2(lastPoint.y - gridPoint.y, lastPoint.x - gridPoint.x) * (180 / Math.PI);
	
	        var snapCoords;
	        snappableAngles.some(function (angle) {
	          if (Math.abs(thetaDeg - angle) < _this7.$store.getters['project/angleTolerance']) {
	            if (angle === -180 || angle === 0 || angle === 180) {
	              return {
	                x: gridPoint.x,
	                y: _this7.rotatePoint(lastPoint, gridPoint, angle - thetaDeg).y
	              };
	            } else if (angle === -90 || angle === 90) {
	              return {
	                x: _this7.rotatePoint(lastPoint, gridPoint, angle - thetaDeg).x,
	                y: gridPoint.y
	              };
	            }
	          }
	        });
	
	        if (snapCoords) {
	          return (0, _extends3.default)({
	            type: 'gridpoint'
	          }, snapCoords);
	        }
	      }
	
	    return (0, _extends3.default)({
	      type: 'gridpoint'
	    }, gridPoint);
	  },
	  polygonOriginPoint: function polygonOriginPoint() {
	    if (this.points.length >= 3 && this.currentTool === 'Polygon') {
	      return [(0, _extends3.default)({}, this.points[0], {
	        origin: true,
	        type: 'vertex'
	      })];
	    }
	    return [];
	  },
	  strictSnapTargets: function strictSnapTargets(location) {
	    var snappableVertices = [].concat((0, _toConsumableArray3.default)(this.currentStoryGeometry.vertices), (0, _toConsumableArray3.default)(this.previousStoryGeometry ? this.previousStoryGeometry.vertices : []), (0, _toConsumableArray3.default)(this.polygonOriginPoint()));
	
	    return (0, _snapping.snapTargets)(snappableVertices, this.spacing, location);
	  },
	  snappingVertexData: function snappingVertexData(point) {
	    var _this8 = this;
	
	    var snappableVertices = [].concat((0, _toConsumableArray3.default)(this.currentStoryGeometry.vertices));
	
	    if (this.previousStoryGeometry) {
	      snappableVertices = snappableVertices.concat(JSON.parse((0, _stringify2.default)(this.previousStoryGeometry.vertices)));
	    }
	
	    if (this.points.length >= 3 && this.currentTool === 'Polygon') {
	      snappableVertices.push((0, _extends3.default)({}, this.points[0], {
	        origin: true }));
	    }
	
	    if (this.points.length === 1 && this.currentTool === 'Rectangle') {
	      snappableVertices = snappableVertices.concat(_helpers2.default.syntheticRectangleSnaps(snappableVertices, this.points[0], point));
	    }
	
	    if (!snappableVertices.length) {
	      return null;
	    }
	
	    var nearestVertex = snappableVertices.reduce(function (a, b) {
	      var aDist = _this8.distanceBetweenPoints(a, point);
	      var bDist = _this8.distanceBetweenPoints(b, point);
	      return aDist < bDist ? a : b;
	    });
	
	    if (this.distanceBetweenPoints(nearestVertex, point) < this.$store.getters['project/snapTolerance']) {
	      return (0, _extends3.default)({}, nearestVertex, {
	        type: 'vertex'
	      });
	    }
	  },
	  snappingEdgeData: function snappingEdgeData(point) {
	    var _this9 = this;
	
	    var snappableEdges = [].concat((0, _toConsumableArray3.default)(this.currentStoryGeometry.edges));
	
	    if (this.previousStoryGeometry) {
	      snappableEdges = snappableEdges.concat(this.previousStoryGeometry.edges.map(function (e) {
	        return (0, _extends3.default)({}, e, {
	          previous_story: true
	        });
	      }));
	    }
	
	    if (snappableEdges.length === 0) {
	      return [];
	    }
	
	    var distyEdges = _lodash2.default.map(snappableEdges, function (edge) {
	      var aStoryGeometry = edge.previous_story ? _this9.previousStoryGeometry : _this9.currentStoryGeometry,
	          aV1 = _helpers2.default.vertexForId(edge.v1, aStoryGeometry),
	          aV2 = _helpers2.default.vertexForId(edge.v2, aStoryGeometry),
	          aProjection = (0, _helpers.projectionOfPointToLine)(point, { p1: aV1, p2: aV2 }),
	          aDist = (0, _helpers.distanceBetweenPoints)(aProjection, point);
	      return (0, _extends3.default)({}, edge, {
	        projection: aProjection,
	        dist: aDist,
	        v1Coords: aV1,
	        V2Coords: aV2
	      });
	    });
	    var nearestEdge = _lodash2.default.minBy(distyEdges, 'dist');
	
	    if (nearestEdge.dist < this.$store.getters['project/snapTolerance']) {
	      return [{
	        snappingEdge: nearestEdge,
	        dist: nearestEdge.dist,
	        type: 'edge',
	
	        projection: nearestEdge.projection,
	        v1GridCoords: nearestEdge.v1Coords,
	        v2GridCoords: nearestEdge.V2Coords,
	        x: nearestEdge.projection.x,
	        y: nearestEdge.projection.y
	      }];
	    }
	    return [];
	  },
	  distanceBetweenPoints: function distanceBetweenPoints(p1, p2) {
	    var dx = Math.abs(p1.x - p2.x),
	        dy = Math.abs(p1.y - p2.y);
	    return Math.sqrt(dx * dx + dy * dy);
	  },
	  round: function round(n, x) {
	    var result,
	        sign = n < 0 ? -1 : 1;
	    n = Math.abs(n);
	    if (n % x < x / 2) {
	      result = n - n % x;
	    } else {
	      result = n + x - n % x;
	    }
	
	    result *= sign;
	    return result;
	  },
	  rotatePoint: function rotatePoint(center, point, angle) {
	    var radians = angle * Math.PI / 180.0,
	        cos = Math.cos(radians),
	        sin = Math.sin(radians),
	        dX = point.x - center.x,
	        dY = point.y - center.y;
	
	    return {
	      x: cos * dX - sin * dY + center.x,
	      y: sin * dX + cos * dY + center.y
	    };
	  },
	  resolveBounds: function resolveBounds() {
	    var currXExtent = [this.min_x, this.max_x],
	        currYExtent = [this.min_y, this.max_y];
	    var plusMargin = function plusMargin(_ref2) {
	      var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	          i = _ref3[0],
	          s = _ref3[1];
	
	      var d = (s - i) / 20;
	      return [i - d, s + d];
	    };
	    if (this.visibleVerts.length) {
	      currXExtent = plusMargin(d3.extent(this.allVertices, function (d) {
	        return d.x;
	      }));
	      currYExtent = plusMargin(d3.extent(this.allVertices, function (d) {
	        return d.y;
	      }));
	    }
	
	    var width = this.$refs.gridParent.clientWidth,
	        height = this.$refs.gridParent.clientHeight,
	        _fitToAspectRatio = (0, _helpers.fitToAspectRatio)(currXExtent, currYExtent, width / height, 'expand'),
	        xExtent = _fitToAspectRatio.xExtent,
	        yExtent = _fitToAspectRatio.yExtent;
	
	
	    this.dimensions = {
	      min_x: xExtent[0],
	      max_x: xExtent[1],
	      min_y: yExtent[0],
	      max_y: yExtent[1]
	    };
	    _lodash2.default.defer(function () {
	      window.eventBus.$emit('boundsResolved');
	    });
	  },
	  nullTransform: function nullTransform() {
	    d3.select(this.$refs.grid).call(this.zoomBehavior.transform, d3.zoomIdentity);
	  },
	  renderGrid: function renderGrid() {
	    var w = this.$refs.gridParent.clientWidth,
	        h = this.$refs.gridParent.clientHeight;
	
	    this.resolveBounds();
	
	    this.$store.dispatch('application/setScaleX', {
	      scaleX: {
	        pixels: w,
	        rwuRange: [this.min_x, this.max_x]
	      }
	    });
	
	    this.$store.dispatch('application/setScaleY', {
	      scaleY: {
	        pixels: h,
	        rwuRange: [this.min_y, this.max_y]
	      }
	    });
	
	    this.calcGrid();
	
	    this.nullTransform();
	
	    this.draw();
	  },
	  reloadGridAndScales: function reloadGridAndScales() {
	    this.zoomXScale = null;
	    this.zoomYScale = null;
	    this.resolveBounds();
	    this.renderGrid();
	  },
	  recalcScales: function recalcScales() {
	    var width = this.$refs.gridParent.clientWidth,
	        height = this.$refs.gridParent.clientHeight;
	
	    this.xScale = d3.scaleLinear().domain([this.min_x, this.max_x]).range([0, width]);
	    this.yScale = d3.scaleLinear().domain([this.min_y, this.max_y]).range([height, 0]);
	    this.zoomXScale = this.zoomXScale || this.xScale.copy();
	    this.zoomYScale = this.zoomYScale || this.yScale.copy();
	  },
	  calcGrid: function calcGrid() {
	    var _this10 = this;
	
	    this.recalcScales();
	    var width = this.$refs.gridParent.clientWidth,
	        height = this.$refs.gridParent.clientHeight;
	    var svg = d3.select('#grid svg'),
	        strokeWidth = 1,
	        fontSize = '14px';
	
	    svg.attr('height', height).attr('width', width);
	    this.axis.x = svg.selectAll('g.axis--x').data([undefined]);
	
	    this.axis.x = this.axis.x.merge(this.axis.x.enter().append('g').attr('class', 'axis axis--x')).attr('stroke-width', strokeWidth).style('font-size', fontSize).style('display', this.gridVisible ? 'inline' : 'none');
	
	    this.axis.y = svg.selectAll('g.axis--y').data([undefined]);
	
	    this.axis.y = this.axis.y.merge(this.axis.y.enter().append('g').attr('class', 'axis axis--y')).attr('class', 'axis axis--y').attr('stroke-width', strokeWidth).style('font-size', fontSize).style('display', this.gridVisible ? 'inline' : 'none');
	
	    this.updateGrid();
	
	    this.zoomBehavior = d3.zoom().scaleExtent([0, Infinity]).on('zoom', function () {
	      var transform = d3.event.transform;
	
	      _this10.transform = (0, _extends3.default)({}, transform);
	
	      var newScaleX = transform.rescaleX(_this10.zoomXScale),
	          newScaleY = transform.rescaleY(_this10.zoomYScale);
	
	      var xDomain = newScaleX.domain();
	      var yDomain = newScaleY.domain();
	      _this10.dimensions = {
	        min_x: xDomain[0],
	        max_x: xDomain[1],
	        min_y: yDomain[0],
	        max_y: yDomain[1]
	      };
	
	      _this10.axis_generator.x.scale(newScaleX);
	      _this10.axis_generator.y.scale(newScaleY);
	      _this10.updateGrid();
	
	      _this10.padTickY(-12);
	
	      _this10.translateEntities();
	      _this10.clearComponentHighlights();
	    }).on('end', function () {
	      _this10.draw({ zoomEnd: true });
	    });
	
	    svg.call(this.zoomBehavior);
	    svg.on('mousemove', this.handleMouseMove).on('click', this.gridClicked);
	  },
	  transformTo: function transformTo(t) {
	    d3.select(this.$refs.grid).call(this.zoomBehavior.transform, t);
	  },
	  zoomBy: function zoomBy(factor) {
	    var newScale = this.transform.k * factor;
	    d3.select(this.$refs.grid).transition().duration(400).call(this.zoomBehavior.transform, d3.zoomIdentity.scale(newScale));
	  },
	  zoomToFit: function zoomToFit() {
	    var _this11 = this,
	        _d3$zoomIdentity;
	
	    var width = this.$refs.grid.clientWidth,
	        height = this.$refs.grid.clientHeight;
	
	    if (!this.allVertices.length) {
	      return;
	    }
	
	    var xExtent = d3.extent(this.allVertices, function (d) {
	      return _this11.zoomXScale(d.x);
	    }),
	        yExtent = d3.extent(this.allVertices, function (d) {
	      return _this11.zoomYScale(d.y);
	    }),
	        dx = xExtent[1] - xExtent[0],
	        dy = yExtent[1] - yExtent[0],
	        x = (xExtent[0] + xExtent[1]) / 2,
	        y = (yExtent[0] + yExtent[1]) / 2,
	        scale = 0.9 / Math.max(dx / width, dy / height),
	        translate = [width / 2 - scale * x, height / 2 - scale * y],
	        svg = d3.select('#grid svg'),
	        transform = (_d3$zoomIdentity = d3.zoomIdentity).translate.apply(_d3$zoomIdentity, translate).scale(scale);
	
	    svg.call(this.zoomBehavior.transform, transform);
	  },
	  scaleTo: function scaleTo(scale) {
	    var _d3$zoomIdentity2;
	
	    var width = this.$refs.grid.clientWidth,
	        height = this.$refs.grid.clientHeight,
	        x = (this.zoomXScale(this.max_x) + this.zoomXScale(this.min_x)) / 2,
	        y = (this.zoomYScale(this.max_y) + this.zoomYScale(this.min_y)) / 2,
	        translate = [width / 2 - scale * x, height / 2 - scale * y];
	    d3.select(this.$refs.grid).call(this.zoomBehavior.transform, (_d3$zoomIdentity2 = d3.zoomIdentity).translate.apply(_d3$zoomIdentity2, translate).scale(scale));
	  },
	  translateEntities: function translateEntities() {
	
	    d3.selectAll('[data-transform-plz]').attr('transform', transformDiff(this.transformAtLastRender, d3.event.transform));
	  },
	  showOrHideAxes: function showOrHideAxes() {
	    this.axis.x.style('visibility', this.gridVisible ? 'visible' : 'hidden');
	    this.axis.y.style('visibility', this.gridVisible ? 'visible' : 'hidden');
	  },
	  updateGrid: function updateGrid() {
	    if (!this.axis.x || !this.axis.y) {
	      return;
	    }
	    var width = this.$refs.gridParent.clientWidth,
	        height = this.$refs.gridParent.clientHeight,
	        rwuWidth = this.max_x - this.min_x,
	        rwuHeight = this.max_y - this.min_y,
	        xTicks = ticksInRange(this.min_x, this.max_x, this.spacing),
	        yTicks = ticksInRange(this.min_y, this.max_y, this.spacing);
	
	    this.reduceTicks = yTicks.length > 250 || xTicks.length > 250;
	
	    this.axis_generator.x = this.axis_generator.x || d3.axisBottom(this.xScale);
	    this.axis_generator.x.tickSize(height).tickPadding(-20).tickFormat(this.reduceTicks ? _lodash2.default.identity : this.formatTickX.bind(this, Math.floor(10 * (width / height))));
	
	    this.axis_generator.y = this.axis_generator.y || d3.axisRight(this.yScale);
	    this.axis_generator.y.tickSize(width).tickPadding(-25).tickFormat(this.reduceTicks ? _lodash2.default.identity : this.formatTickY.bind(this, 10));
	
	    if (this.reduceTicks) {
	      this.axis_generator.x.tickValues(null).ticks(5 * (rwuWidth / rwuHeight));
	      this.axis_generator.y.tickValues(null).ticks(5);
	    } else {
	      this.axis_generator.x.ticks(null).tickValues(xTicks);
	      this.axis_generator.y.ticks(null).tickValues(yTicks);
	    }
	
	    this.axis.y.call(this.axis_generator.y);
	    this.axis.x.call(this.axis_generator.x);
	  },
	  rwuToGrid: function rwuToGrid(rwu, axis) {
	    var scale = void 0;
	    if (axis === 'x') {
	      scale = this.xScale;
	    } else if (axis === 'y') {
	      scale = this.yScale;
	    }
	    return scale(rwu);
	  },
	  gridToRWU: function gridToRWU(gridValue, axis) {
	    var scale = void 0;
	    if (axis === 'x') {
	      scale = this.xScale;
	    } else if (axis === 'y') {
	      scale = this.yScale;
	    }
	    var result = scale.invert(gridValue);
	
	    return Math.round(result * 100000000000) / 100000000000;
	  },
	  gridPointToRWU: function gridPointToRWU(pt) {
	    return {
	      x: this.gridToRWU(pt.x, 'x'),
	      y: this.gridToRWU(pt.y, 'y')
	    };
	  },
	  rwuPointToGrid: function rwuPointToGrid(pt) {
	    return {
	      x: this.rwuToGrid(pt.x, 'x'),
	      y: this.rwuToGrid(pt.y, 'y')
	    };
	  },
	  polygonLabelPosition: function polygonLabelPosition(pointsIn) {
	    var points = [pointsIn.map(function (p) {
	      return [p.x, p.y];
	    })],
	        area = Math.abs(Math.round(_helpers2.default.areaOfSelection(pointsIn))),
	        _ref4 = area ? (0, _polylabel2.default)(points, 1.0) : [null, null],
	        _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
	        x = _ref5[0],
	        y = _ref5[1];
	
	
	    return { x: x, y: y, area: area };
	  },
	  formatTickX: function formatTickX(maxTicks, val) {
	    var rangeX = this.max_x - this.min_x,
	        spacing = this.spacing,
	        spacingScaled = Math.ceil(rangeX / maxTicks / spacing) * spacing;
	
	    return spacingScaled === 0 || val % spacingScaled === 0 ? val : '';
	  },
	  formatTickY: function formatTickY(maxTicks, val) {
	    var rangeY = this.max_y - this.min_y,
	        spacing = this.spacing,
	        spacingScaled = Math.ceil(rangeY / maxTicks / spacing) * spacing;
	
	    return spacingScaled === 0 || val % spacingScaled === 0 ? val : '';
	  },
	  padTickY: function padTickY(paddingPerDigit) {
	    var min = Math.abs(this.min_y),
	        max = Math.abs(this.max_y),
	        numDigits = (min < max ? max : min).toFixed(0).length,
	        yPadding = paddingPerDigit * numDigits;
	
	    this.axis.y.call(this.axis_generator.y.tickPadding(yPadding));
	  }
	};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(27);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _index = __webpack_require__(333);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(197);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(338);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(343);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _export = __webpack_require__(351);
	
	var _export2 = _interopRequireDefault(_export);
	
	var _importFloorplan = __webpack_require__(354);
	
	var _importFloorplan2 = _interopRequireDefault(_importFloorplan);
	
	var _importLibrary = __webpack_require__(355);
	
	var _importLibrary2 = _interopRequireDefault(_importLibrary);
	
	var _unitConversion = __webpack_require__(132);
	
	var _mutations = __webpack_require__(349);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	  strict: ("production") !== 'production',
	  modules: {
	    application: _index2.default,
	    project: _index4.default,
	    geometry: _index6.default,
	    models: _index8.default
	  },
	  getters: {
	    exportData: _export2.default
	  },
	  actions: {
	    importFloorplan: _importFloorplan2.default,
	    importLibrary: _importLibrary2.default,
	    changeUnits: function changeUnits(context, _ref) {
	      var newUnits = _ref.newUnits;
	
	      var oldUnits = context.state.project.config.units;
	      console.log('moving from ' + oldUnits + ' to ' + newUnits);
	      if (oldUnits !== 'ip' && oldUnits !== 'si') {
	        console.error('Expected data.project.config.units to be "ip" or "si", received "' + oldUnits + '"');
	      }
	      if (newUnits !== 'ip' && newUnits !== 'si') {
	        console.error('Expected oldUnits to be "ip" or "si", received "' + newUnits + '"');
	      }
	      context.commit('changeUnits', (0, _unitConversion.convertState)(context.state, oldUnits, newUnits));
	      context.dispatch('project/setUnits', { units: newUnits });
	    }
	  },
	  mutations: _mutations2.default
	});
	
	exports.default = store;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _appconfig = __webpack_require__(28);
	
	var _helpers = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  setCurrentStoryId: function setCurrentStoryId(context, payload) {
	    var id = payload.id;
	
	    if (context.rootState.models.stories.map(function (s) {
	      return s.id;
	    }).indexOf(id) !== -1) {
	      context.commit('setCurrentStoryId', { id: id });
	    }
	  },
	  setCurrentSubSelectionId: function setCurrentSubSelectionId(context, payload) {
	    var id = payload.id;
	
	    if (context.getters.currentStory && (context.getters.currentStory.spaces.find(function (i) {
	      return i.id === id;
	    }) || context.getters.currentStory.shading.find(function (i) {
	      return i.id === id;
	    }) || context.getters.currentStory.images.find(function (i) {
	      return i.id === id;
	    }))) {
	      context.commit('setCurrentSubSelectionId', { id: id });
	    }
	  },
	  setCurrentComponentId: function setCurrentComponentId(context, payload) {
	    var id = payload.id;
	
	    if (context.getters.currentStory && (context.getters.currentStory.windows.find(function (i) {
	      return i.id === id;
	    }) || context.getters.currentStory.daylighting_controls.find(function (i) {
	      return i.id === id;
	    }))) {
	      context.commit('setCurrentComponentId', { id: id });
	    }
	  },
	  setCurrentComponentDefinitionId: function setCurrentComponentDefinitionId(context, payload) {
	    var id = payload.id;
	
	    if (context.rootState.models.library.daylighting_control_definitions.find(function (i) {
	      return i.id === id;
	    }) || context.rootState.models.library.window_definitions.find(function (i) {
	      return i.id === id;
	    }) || context.rootState.models.library.door_definitions.find(function (i) {
	      return i.id === id;
	    })) {
	      context.commit('setCurrentComponentDefinitionId', { id: id });
	    } else if (id !== 'undefined') {
	      throw new Error('unable to set component definition -- couldn\'t find one with id ' + id);
	    }
	  },
	  setCurrentComponentInstanceId: function setCurrentComponentInstanceId(context, payload) {
	    var id = payload.id;
	
	    if (!(0, _helpers.componentInstanceById)(context.getters.currentStory, id)) {
	      console.error('unable to find an instance with that id on the current story');
	    } else {
	      context.commit('setCurrentComponentInstanceId', payload);
	    }
	  },
	  setCurrentSnapMode: function setCurrentSnapMode(context, _ref) {
	    var snapMode = _ref.snapMode;
	
	    if (!_lodash2.default.includes(['grid-strict', 'grid-verts-edges'], snapMode)) {
	      throw new Error('Unknown grid mode ' + snapMode);
	    }
	    context.commit('setCurrentSnapMode', { snapMode: snapMode });
	  },
	  setCurrentModeTab: function setCurrentModeTab(context, _ref2) {
	    var modeTab = _ref2.modeTab;
	
	    context.commit('setCurrentModeTab', { modeTab: modeTab });
	  },
	  setCurrentSubselectionType: function setCurrentSubselectionType(context, _ref3) {
	    var subselectionType = _ref3.subselectionType;
	
	    context.commit('setCurrentSubselectionType', { subselectionType: subselectionType });
	  },
	  setCurrentTool: function setCurrentTool(context, payload) {
	    var tool = payload.tool;
	
	    if (context.state.tools.indexOf(tool) !== -1) {
	      context.commit('setCurrentTool', { tool: tool });
	    }
	  },
	  setCurrentMode: function setCurrentMode(context, payload) {
	    var mode = payload.mode;
	
	    if (mode === 'spaces' || _lodash2.default.includes(_appconfig.assignableProperties, mode)) {
	      context.commit('setCurrentMode', { mode: mode });
	    } else {
	      console.error('unrecognized view-by option: ' + mode);
	    }
	  },
	  setCurrentSpacePropertyId: function setCurrentSpacePropertyId(context, payload) {
	    var id = payload.id;
	
	    if (!id || (0, _helpers.spacePropertyById)(context.rootState.models.library, id)) {
	      context.commit('setCurrentSpacePropertyId', { id: id });
	    } else {
	      console.error('unable to find space property with id: ' + id);
	    }
	  },
	  setScaleX: function setScaleX(context, payload) {
	    var scaleX = payload.scaleX;
	
	    context.commit('setScaleX', { scaleX: scaleX });
	  },
	  setScaleY: function setScaleY(context, payload) {
	    var scaleY = payload.scaleY;
	
	    context.commit('setScaleY', { scaleY: scaleY });
	  }
	};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(16);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _helpers3 = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  currentStory: function currentStory(state, getters, rootState) {
	    console.log('trying to get currentStory', rootState.models.stories);return rootState.models.stories.find(function (s) {
	      return s.id === state.currentSelections.story_id;
	    });
	  },
	  currentSubSelection: function currentSubSelection(state, getters) {
	    var currentStory = getters['currentStory'];
	    if (!currentStory) {
	      return null;
	    }
	    var subSelectionId = state.currentSelections.subselection_ids[currentStory.id];
	    return currentStory.spaces.find(function (i) {
	      return i.id === subSelectionId;
	    }) || currentStory.shading.find(function (i) {
	      return i.id === subSelectionId;
	    }) || currentStory.images.find(function (i) {
	      return i.id === subSelectionId;
	    });
	  },
	  currentSubSelectionType: function currentSubSelectionType(state, getters) {
	    var currentStory = getters['currentStory'];
	    if (!currentStory) {
	      return null;
	    }
	    var subSelectionId = state.currentSelections.subselection_ids[currentStory.id];
	    if (currentStory.spaces.find(function (i) {
	      return i.id === subSelectionId;
	    })) {
	      return 'spaces';
	    } else if (currentStory.shading.find(function (i) {
	      return i.id === subSelectionId;
	    })) {
	      return 'shading';
	    } else if (currentStory.images.find(function (i) {
	      return i.id === subSelectionId;
	    })) {
	      return 'images';
	    }
	    return null;
	  },
	  currentSpace: function currentSpace(state, getters) {
	    return getters.currentSubSelectionType === 'spaces' ? getters.currentSubSelection : null;
	  },
	  currentShading: function currentShading(state, getters) {
	    return getters.currentSubSelectionType === 'shading' ? getters.currentSubSelection : null;
	  },
	  currentImage: function currentImage(state, getters) {
	    return getters.currentSubSelectionType === 'images' ? getters.currentSubSelection : null;
	  },
	  currentComponent: function currentComponent(state, getters, rootState) {
	    var componentDefinitionId = state.currentSelections.component_definition_id;
	    var type = void 0,
	        definition = void 0;
	    if (definition = rootState.models.library.window_definitions.find(function (i) {
	      return i.id === componentDefinitionId;
	    })) {
	      type = 'window_definitions';
	    } else if (definition = rootState.models.library.daylighting_control_definitions.find(function (i) {
	      return i.id === componentDefinitionId;
	    })) {
	      type = 'daylighting_control_definitions';
	    } else if (definition = _lodash2.default.find(rootState.models.library.door_definitions, { id: componentDefinitionId })) {
	      type = 'door_definitions';
	    }
	    return { type: type, definition: definition };
	  },
	  currentComponentDefinition: function currentComponentDefinition(state, getters) {
	    return getters['currentComponent']['definition'];
	  },
	  currentComponentInstance: function currentComponentInstance(state, getters) {
	    var compDefId = state.currentSelections.component_instance_id;
	    if (!compDefId) {
	      return null;
	    }
	    return (0, _helpers3.componentInstanceById)(getters['currentStory'], compDefId);
	  },
	  currentSpaceProperty: function currentSpaceProperty(state, getters, rootState) {
	    var spacePropertyId = state.currentSelections.space_property_id,
	        library = rootState.models.library;
	    return (0, _helpers3.spacePropertyById)(library, spacePropertyId);
	  },
	  currentStoryGeometry: function currentStoryGeometry(state, getters, rootState) {
	    var currentStory = getters['currentStory'];
	    if (!currentStory) {
	      return null;
	    }
	    return rootState.geometry.find(function (g) {
	      return g.id === currentStory.geometry_id;
	    });
	  },
	  currentStoryDenormalizedGeom: function currentStoryDenormalizedGeom(state, getters) {
	    var currentStoryGeom = getters['currentStoryGeometry'];
	    if (!currentStoryGeom) {
	      return null;
	    }
	    return _helpers2.default.denormalize(currentStoryGeom);
	  },
	  currentSubSelectionFace: function currentSubSelectionFace(state, getters) {
	    if (getters['currentSubSelection'] && getters['currentSubSelection'].face_id) {
	      return getters['currentStoryGeometry'].faces.find(function (f) {
	        return f.id === getters['currentSubSelection'].face_id;
	      });
	    }
	    return null;
	  }
	};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(331);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _mutations = __webpack_require__(334);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _getters = __webpack_require__(332);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var d3 = __webpack_require__(85);
	
	exports.default = {
	  namespaced: true,
	  state: {
	    currentSelections: {
	      story: null,
	      story_id: null,
	      subselection_ids: {},
	
	      component_id: null,
	      component_definition_id: null,
	      component_instance_id: null,
	
	      space_property_id: null,
	
	      tool: 'Rectangle',
	      mode: 'spaces',
	      snapMode: 'grid-strict',
	      modeTab: 'floorplan',
	      subselectionType: 'spaces'
	    },
	    modes: ['spaces', 'shading', 'building_units', 'thermal_zones', 'pitched_roofs', 'space_types', 'images'],
	    tools: ['Pan', 'Drag', 'Rectangle', 'Polygon', 'Eraser', 'Select', 'Map', 'Fill', 'Place Component', 'Image', 'Apply Property'],
	
	    scale: {
	      x: d3.scaleLinear().range([0, 0]).domain([0, 0]),
	      y: d3.scaleLinear().range([0, 0]).domain([0, 0])
	    }
	  },
	  actions: _actions2.default,
	  mutations: _mutations2.default,
	  getters: _getters2.default
	};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(76);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  setCurrentStoryId: function setCurrentStoryId(state, payload) {
	    state.currentSelections.story_id = payload.id;
	  },
	  setCurrentSubSelectionId: function setCurrentSubSelectionId(state, payload) {
	    var storyId = state.currentSelections.story_id;
	    if (!storyId) {
	      console.error('expected a story to be selected, in order to set a subselection');
	      return;
	    }
	    state.currentSelections.subselection_ids = (0, _extends4.default)({}, state.currentSelections.subselection_ids, (0, _defineProperty3.default)({}, storyId, payload.id));
	  },
	  setCurrentComponentId: function setCurrentComponentId(state, payload) {
	    state.currentSelections.component_id = payload.id;
	  },
	  setCurrentComponentDefinitionId: function setCurrentComponentDefinitionId(state, payload) {
	    state.currentSelections.component_definition_id = payload.id;
	  },
	  setCurrentComponentInstanceId: function setCurrentComponentInstanceId(state, payload) {
	    state.currentSelections.component_instance_id = payload.id;
	  },
	  setCurrentSpacePropertyId: function setCurrentSpacePropertyId(state, payload) {
	    state.currentSelections.space_property_id = payload.id;
	  },
	  setCurrentSnapMode: function setCurrentSnapMode(state, payload) {
	    state.currentSelections.snapMode = payload.snapMode;
	  },
	  setCurrentModeTab: function setCurrentModeTab(state, payload) {
	    state.currentSelections.modeTab = payload.modeTab;
	  },
	  setCurrentSubselectionType: function setCurrentSubselectionType(state, payload) {
	    state.currentSelections.subselectionType = payload.subselectionType;
	  },
	  setCurrentTool: function setCurrentTool(state, payload) {
	    state.currentSelections.tool = payload.tool;
	  },
	  setCurrentMode: function setCurrentMode(state, payload) {
	    state.currentSelections.mode = payload.mode;
	  },
	  setScaleX: function setScaleX(state, payload) {
	    state.scale.x = payload.scaleX;
	  },
	  setScaleY: function setScaleY(state, payload) {
	    state.scale.y = payload.scaleY;
	  }
	};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(76);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.getOrCreateVertex = getOrCreateVertex;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _factory = __webpack_require__(130);
	
	var _factory2 = _interopRequireDefault(_factory);
	
	var _helpers = __webpack_require__(16);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _createFaceFromPoints = __webpack_require__(336);
	
	var _createFaceFromPoints2 = _interopRequireDefault(_createFaceFromPoints);
	
	var _componentPreservationSociety = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getOrCreateVertex(geometry, coords) {
	  return _helpers2.default.vertexForCoordinates(coords, geometry) || _factory2.default.Vertex(coords.x, coords.y);
	}
	
	exports.default = {
	  initGeometry: function initGeometry(context, payload) {
	    var story_id = payload.story_id;
	
	    var geometry = new _factory2.default.Geometry();
	    context.commit('initGeometry', { geometry: geometry });
	
	    context.dispatch('models/updateStoryWithData', {
	      story: context.rootState.models.stories.find(function (s) {
	        return s.id === story_id;
	      }),
	      geometry_id: geometry.id
	    }, { root: true });
	  },
	  destroyGeometry: function destroyGeometry(_ref, geometryId) {
	    var commit = _ref.commit;
	
	    commit('destroyGeometry', { id: geometryId });
	  },
	  eraseSelection: function eraseSelection(context, payload) {
	    var points = payload.points,
	        geometry_id = context.rootGetters['application/currentStoryGeometry'].id;
	
	
	    (0, _componentPreservationSociety.withPreservedComponents)(context, geometry_id, function () {
	      var eraseResult = (0, _createFaceFromPoints.eraseSelection)(points, context);
	
	      if (!eraseResult) {
	        window.eventBus.$emit('error', 'Operation cancelled - no split faces');
	      }
	    });
	
	    context.dispatch('trimGeometry', { geometry_id: geometry_id });
	  },
	  moveFaceByOffset: function moveFaceByOffset(context, payload) {
	    var face_id = payload.face_id,
	        dx = payload.dx,
	        dy = payload.dy,
	        currentStoryGeometry = context.rootGetters['application/currentStoryGeometry'],
	        face = _helpers2.default.faceForId(face_id, currentStoryGeometry),
	        movedPoints = _helpers2.default.verticesForFaceId(face.id, currentStoryGeometry).map(function (v) {
	      return {
	        x: v.x + dx,
	        y: v.y + dy
	      };
	    }),
	        newGeoms = (0, _createFaceFromPoints.newGeometriesOfOverlappedFaces)(movedPoints, _helpers2.default.exceptFace(currentStoryGeometry, face_id));
	
	    if (newGeoms.error) {
	      window.eventBus.$emit('error', 'Operation cancelled - ' + newGeoms.error);
	
	      window.eventBus.$emit('reload-grid');
	      return;
	    }
	
	    var movedGeom = (0, _createFaceFromPoints.validateFaceGeometry)(movedPoints, currentStoryGeometry);
	    if (!movedGeom.success) {
	      window.eventBus.$emit('error', movedGeom.error);
	      window.eventBus.$emit('reload-grid');
	      return;
	    }
	
	    var movementsByFaceId = (0, _defineProperty3.default)({}, face_id, { dx: dx, dy: dy });
	
	    (0, _componentPreservationSociety.withPreservedComponents)(context, currentStoryGeometry.id, movementsByFaceId, function () {
	      newGeoms.forEach(function (newGeom) {
	        return context.dispatch('replaceFacePoints', newGeom);
	      });
	
	      context.dispatch('replaceFacePoints', {
	        geometry_id: currentStoryGeometry.id,
	        face_id: face_id,
	        vertices: movedGeom.vertices,
	        edges: movedGeom.edges,
	        dx: dx,
	        dy: dy
	      });
	    });
	
	    context.dispatch('trimGeometry', { geometry_id: currentStoryGeometry.id });
	  },
	
	  createFaceFromPoints: _createFaceFromPoints2.default,
	
	  destroyFaceAndDescendents: function destroyFaceAndDescendents(context, payload) {
	    var geometry_id = payload.geometry_id,
	        face = payload.face;
	
	
	    var geometry = context.state.find(function (g) {
	      return g.id === geometry_id;
	    }),
	        expVertices = face.edgeRefs.map(function (edgeRef) {
	      var edge = _helpers2.default.edgeForId(edgeRef.edge_id, geometry),
	          vertexId = edgeRef.reverse ? edge.v2 : edge.v1;
	      return _helpers2.default.vertexForId(vertexId, geometry);
	    }).filter(function (v) {
	      return _helpers2.default.facesForVertexId(v.id, geometry).length < 2;
	    }),
	        expEdgeRefs = face.edgeRefs.filter(function (edgeRef) {
	      return _helpers2.default.facesForEdgeId(edgeRef.edge_id, geometry).length < 2;
	    });
	
	    context.commit('destroyGeometry', { id: face.id });
	    expEdgeRefs.forEach(function (edgeRef) {
	      return context.commit('destroyGeometry', { id: edgeRef.edge_id });
	    });
	    expVertices.forEach(function (vertex) {
	      return context.commit('destroyGeometry', { id: vertex.id });
	    });
	  },
	  replaceFacePoints: function replaceFacePoints(context, _ref2) {
	    var geometry_id = _ref2.geometry_id,
	        face_id = _ref2.face_id,
	        vertices = _ref2.vertices,
	        edges = _ref2.edges;
	
	    var geom = _lodash2.default.find(context.state, { id: geometry_id });
	
	    var spacing = context.rootState.project.grid.spacing;
	
	    var replacementVertIds = _lodash2.default.chain(vertices).map(function (vert) {
	      var gVert = _lodash2.default.find(geom.vertices, function (v) {
	        return (0, _helpers.distanceBetweenPoints)(v, vert) < spacing / 20;
	      });
	      if (!gVert) return null;
	      if (vert.id === gVert.id) return null;
	      return [vert.id, gVert.id];
	    }).compact().fromPairs().value();
	
	    var updatedVertices = vertices.map(function (v) {
	      return (0, _extends3.default)({}, v, {
	        id: replacementVertIds[v.id] || v.id
	      });
	    });
	    var updatedEdges = edges.map(function (e) {
	      return (0, _extends3.default)({}, e, {
	        v1: replacementVertIds[e.v1] || e.v1,
	        v2: replacementVertIds[e.v2] || e.v2
	      });
	    });
	
	    updatedEdges.forEach(function (edge) {
	      var gEdge = _lodash2.default.find(geom.edges, { v1: edge.v1, v2: edge.v2 }) || _lodash2.default.find(geom.edges, { v1: edge.v2, v2: edge.v1 });
	      if (!gEdge) return;
	      if (edge.id === gEdge.id) return;
	      edge.id = gEdge.id;
	      edge.reverse = gEdge.v1 !== edge.v1;
	    });
	    context.commit('replaceFacePoints', {
	      geometry_id: geometry_id,
	      vertices: updatedVertices,
	      edges: updatedEdges,
	      face_id: face_id
	    });
	  },
	  trimGeometry: function trimGeometry(_ref3, _ref4) {
	    var rootState = _ref3.rootState,
	        commit = _ref3.commit;
	    var geometry_id = _ref4.geometry_id;
	
	    var story = _lodash2.default.find(rootState.models.stories, { geometry_id: geometry_id }),
	        vertsReferencedByDCs = _lodash2.default.flatMap(story.spaces, function (s) {
	      return _lodash2.default.map(s.daylighting_controls, 'vertex_id');
	    });
	
	    commit('trimGeometry', { geometry_id: geometry_id, vertsReferencedElsewhere: vertsReferencedByDCs });
	  },
	  cloneStoryGeometry: function cloneStoryGeometry(context, payload) {
	    var currentStory = context.rootGetters['application/currentStoryGeometry'];
	    context.commit('updateClonedGeometry', { newGeom: payload, currentStoryId: currentStory.id });
	  }
	};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(199);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(38);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(76);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(57);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.default = createFaceFromPoints;
	exports.newGeometriesOfOverlappedFaces = newGeometriesOfOverlappedFaces;
	exports.eraseSelection = eraseSelection;
	exports.findExistingEdge = findExistingEdge;
	exports.matchOrCreateEdges = matchOrCreateEdges;
	exports.errOnTooFewVerts = errOnTooFewVerts;
	exports.errOnDuplicateVerts = errOnDuplicateVerts;
	exports.errOnVertexIntersectsEdge = errOnVertexIntersectsEdge;
	exports.errOnEdgeIntersectsEdge = errOnEdgeIntersectsEdge;
	exports.validateFaceGeometry = validateFaceGeometry;
	exports.edgesToSplit = edgesToSplit;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _factory = __webpack_require__(130);
	
	var _factory2 = _interopRequireDefault(_factory);
	
	var _helpers = __webpack_require__(16);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _helpers3 = __webpack_require__(50);
	
	var _helpers4 = _interopRequireDefault(_helpers3);
	
	var _utilities = __webpack_require__(102);
	
	var _componentPreservationSociety = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createFaceFromPoints(context, payload) {
	  var model_id = payload.model_id,
	      points = payload.points;
	
	
	  if ((0, _utilities.uniq)(points).length < 3) {
	    return;
	  }
	
	  var currentStoryGeometry = context.rootGetters['application/currentStoryGeometry'];
	  var target = _helpers4.default.libraryObjectWithId(context.rootState.models, model_id);
	
	  var existingFace = target.face_id ? _helpers2.default.faceForId(target.face_id, currentStoryGeometry) : null;
	  var facePoints = void 0;
	
	  if (existingFace) {
	    var existingFaceVertices = _helpers2.default.verticesForFaceId(existingFace.id, currentStoryGeometry);
	    facePoints = _helpers2.default.setOperation('union', existingFaceVertices, points);
	    if (facePoints.error) {
	      window.eventBus.$emit('error', 'Operation cancelled - ' + facePoints.error);
	      return;
	    }
	  } else {
	    facePoints = points;
	  }
	
	  var faceGeometry = validateFaceGeometry(facePoints, context.rootGetters['application/currentStoryGeometry'], context.rootGetters['project/snapTolerance']);
	  if (!faceGeometry.success) {
	    window.eventBus.$emit('error', faceGeometry.error);
	    console.error(faceGeometry.error);
	    return;
	  }
	
	  var newGeoms = newGeometriesOfOverlappedFaces(facePoints, _helpers2.default.exceptFace(currentStoryGeometry, existingFace && existingFace.id));
	
	  if (newGeoms.error) {
	    window.eventBus.$emit('error', 'Operation cancelled - ' + newGeoms.error);
	    return;
	  }
	
	  var newEdges = faceGeometry.edges.slice();
	  var newVertices = faceGeometry.vertices.slice();
	  (0, _componentPreservationSociety.withPreservedComponents)(context, currentStoryGeometry.id, function () {
	    var oldEdgeLength = currentStoryGeometry.edges.length,
	        oldVertexLength = currentStoryGeometry.vertices.length;
	
	    newGeoms.forEach(function (newGeom) {
	      return context.dispatch('replaceFacePoints', newGeom);
	    });
	
	    newEdges = newEdges.concat(currentStoryGeometry.edges.slice(oldEdgeLength));
	    newVertices = newVertices.concat(currentStoryGeometry.vertices.slice(oldVertexLength));
	
	    storeFace(faceGeometry, target, context, existingFace);
	
	    context.dispatch('trimGeometry', { geometry_id: currentStoryGeometry.id });
	
	    splitEdges(context, newEdges, newVertices);
	  });
	}
	
	function newGeometriesOfOverlappedFaces(points, geometry) {
	  if (points.length < 3 || !_helpers2.default.areaOfSelection(points)) {
	    return false;
	  }
	
	  var geom = _helpers2.default.denormalize(geometry);
	  var intersectedFaces = geom.faces.filter(function (face) {
	    var inter = _helpers2.default.intersection(face.vertices, points);
	
	    return inter.error || inter.length > 0;
	  });
	
	  var newFaceVertices = intersectedFaces.map(function (existingFace) {
	    return _helpers2.default.difference(existingFace.vertices, points);
	  });
	
	  var errantCase = _lodash2.default.find(newFaceVertices, 'error');
	  if (errantCase) {
	    return errantCase;
	  }
	
	  var newFaceGeometries = newFaceVertices.map(function (verts) {
	    return validateFaceGeometry(verts, geometry);
	  });
	
	  var errantGeometry = _lodash2.default.find(newFaceGeometries, 'error');
	  if (errantGeometry) {
	    return errantGeometry;
	  }
	
	  return _lodash2.default.zip(intersectedFaces, newFaceGeometries).map(function (_ref) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	        face = _ref2[0],
	        _ref2$ = _ref2[1],
	        vertices = _ref2$.vertices,
	        edges = _ref2$.edges;
	
	    return {
	      geometry_id: geometry.id,
	      face_id: face.id,
	      vertices: vertices,
	      edges: edges
	    };
	  });
	}
	
	function eraseSelection(points, context) {
	  var currentStoryGeometry = context.rootGetters['application/currentStoryGeometry'];
	
	  if (points.length < 3 || !_helpers2.default.areaOfSelection(points)) {
	    return false;
	  }
	
	  var newGeoms = newGeometriesOfOverlappedFaces(points, currentStoryGeometry);
	
	  if (newGeoms.error) {
	    window.eventBus.$emit('error', 'Operation cancelled - ' + newGeoms.error);
	    return false;
	  }
	
	  var oldEdgeLength = currentStoryGeometry.edges.length,
	      oldVertexLength = currentStoryGeometry.vertices.length;
	
	  newGeoms.forEach(function (newGeom) {
	    return context.dispatch('replaceFacePoints', newGeom);
	  });
	
	  var newEdges = currentStoryGeometry.edges.slice(oldEdgeLength),
	      newVertices = currentStoryGeometry.vertices.slice(oldVertexLength);
	
	  splitEdges(context, newEdges, newVertices);
	
	  return true;
	}
	
	function storeFace(_ref3, target, context, existingFace) {
	  var vertices = _ref3.vertices,
	      edges = _ref3.edges;
	
	  var _context$dispatch;
	
	  var currentStoryGeometry = context.rootGetters['application/currentStoryGeometry'];
	  var face = existingFace || new _factory2.default.Face([]);
	
	  context.dispatch('replaceFacePoints', {
	    face_id: face.id,
	    geometry_id: currentStoryGeometry.id,
	    vertices: vertices,
	    edges: edges
	  });
	
	  context.dispatch(target.type === 'space' ? 'models/updateSpaceWithData' : 'models/updateShadingWithData', (_context$dispatch = {}, (0, _defineProperty3.default)(_context$dispatch, target.type, target), (0, _defineProperty3.default)(_context$dispatch, 'face_id', face.id), _context$dispatch), {
	    root: true
	  });
	}
	
	function findExistingEdge(v1, v2, edges) {
	  var sharedEdge = edges.find(function (e) {
	    return e.v1 === v1.id && e.v2 === v2.id || e.v2 === v1.id && e.v1 === v2.id;
	  });
	
	  return sharedEdge && (0, _extends3.default)({}, sharedEdge, {
	    reverse: sharedEdge.v1 === v2.id
	  });
	}
	
	function matchOrCreateEdge(existingEdges) {
	  return function (_ref4) {
	    var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
	        v1 = _ref5[0],
	        v2 = _ref5[1];
	
	    return findExistingEdge(v1, v2, existingEdges) || new _factory2.default.Edge(v1.id, v2.id);
	  };
	}
	
	function matchOrCreateEdges(vertices, existingEdges) {
	  if (!vertices.length) {
	    return [];
	  }
	  return _lodash2.default.zip(vertices, [].concat((0, _toConsumableArray3.default)(vertices.slice(1)), [vertices[0]])).map(matchOrCreateEdge(existingEdges));
	}
	
	function InvalidFaceGeometry(message) {
	  this.message = message;
	}
	InvalidFaceGeometry.prototype = new Error();
	
	function errOnTooFewVerts(vertices) {
	  if (vertices.length < 3) {
	    throw new InvalidFaceGeometry('can\'t make a polygon with fewer than three vertices: ' + (0, _stringify2.default)(vertices));
	  }
	}
	
	function errOnDuplicateVerts(vertices) {
	  vertices.forEach(function (vertex) {
	    if (_lodash2.default.find(vertices, { x: vertex.x, y: vertex.y }).length >= 2) {
	      throw new InvalidFaceGeometry('Duplicate vertex at (' + vertex.x + ', ' + vertex.y + ')');
	    }
	  });
	}
	
	function errOnVertexIntersectsEdge(vertices, edges) {
	  edges.forEach(function (_ref6) {
	    var v1id = _ref6.v1,
	        v2id = _ref6.v2;
	
	    var v1 = _lodash2.default.find(vertices, { id: v1id }),
	        v2 = _lodash2.default.find(vertices, { id: v2id });
	
	    vertices.forEach(function (v) {
	      if (v.id === v1id || v.id === v2id) {
	        return;
	      }
	
	      if (!_helpers2.default.ptsAreCollinear(v1, v2, v)) {
	        return;
	      }
	
	      var positionAlongEdge = _lodash2.default.reject([(v.x - v1.x) / (v2.x - v1.x), (v.y - v1.y) / (v2.y - v1.y)], isNaN)[0];
	
	      if (positionAlongEdge > 1 || positionAlongEdge < 0) {
	        return;
	      }
	      throw new InvalidFaceGeometry('An edge is being touched by a vertex on the same face at (' + v.x + ', ' + v.y + ')');
	    });
	  });
	}
	
	function errOnEdgeIntersectsEdge(vertices, edges) {
	  (0, _utilities.allPairs)(edges).forEach(function (_ref7) {
	    var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
	        e1 = _ref8[0],
	        e2 = _ref8[1];
	
	    var e1v1 = _lodash2.default.find(vertices, { id: e1.v1 }),
	        e1v2 = _lodash2.default.find(vertices, { id: e1.v2 }),
	        e2v1 = _lodash2.default.find(vertices, { id: e2.v1 }),
	        e2v2 = _lodash2.default.find(vertices, { id: e2.v2 });
	
	    var intersection = _helpers2.default.intersectionOfLines(e1v1, e1v2, e2v1, e2v2);
	    if (intersection) {
	      throw new InvalidFaceGeometry('Self intersection at ' + intersection.x + ', ' + intersection.y);
	    }
	  });
	}
	
	function validateFaceGeometry(points, currentStoryGeometry) {
	
	  if (points.length === 0) {
	    return {
	      success: true,
	      vertices: [],
	      edges: []
	    };
	  }
	  if (points.length <= 2) {
	    return { success: false, error: 'need at least 3 points to make a face' };
	  }
	
	  var faceVertices = points.map(function (point) {
	    return _helpers2.default.vertexForCoordinates(point, currentStoryGeometry) || new _factory2.default.Vertex(point.x, point.y);
	  });
	
	  faceVertices = (0, _utilities.dropConsecutiveDups)(faceVertices);
	
	  var faceEdges = matchOrCreateEdges(faceVertices, currentStoryGeometry.edges);
	
	  try {
	    errOnTooFewVerts(faceVertices);
	    errOnDuplicateVerts(faceVertices);
	    errOnVertexIntersectsEdge(faceVertices, faceEdges);
	    errOnEdgeIntersectsEdge(faceVertices, faceEdges);
	  } catch (e) {
	    if (e instanceof InvalidFaceGeometry) {
	      return {
	        success: false,
	        error: e.message
	      };
	    }
	
	    throw e;
	  }
	
	  return {
	    success: true,
	    vertices: faceVertices,
	    edges: faceEdges
	  };
	}
	
	function edgesFromVerts(verts, existingEdges) {
	  return _lodash2.default.zip(verts.slice(0, -1), verts.slice(1)).map(matchOrCreateEdge(existingEdges));
	}
	
	function replacementEdgeRefs(geometry, dyingEdgeId, newEdges) {
	  var affectedFaces = _helpers2.default.facesForEdgeId(dyingEdgeId, geometry);
	
	  var replaceEdgeRefs = affectedFaces.map(function (affectedFace) {
	    var dyingEdgeReversed = _lodash2.default.find(affectedFace.edgeRefs, { edge_id: dyingEdgeId }).reverse;
	
	    var replacementEdges = newEdges.map(function (_ref9) {
	      var id = _ref9.id,
	          reverse = _ref9.reverse;
	      return {
	        id: id,
	
	        reverse: !reverse !== !dyingEdgeReversed
	      };
	    });
	
	    if (dyingEdgeReversed) {
	      replacementEdges.reverse();
	    }
	
	    return {
	      type: 'replaceEdgeRef',
	      geometry_id: geometry.id,
	      edge_id: dyingEdgeId,
	      face_id: affectedFace.id,
	      newEdges: replacementEdges
	    };
	  });
	
	  return replaceEdgeRefs;
	}
	
	function edgesToSplit(geometry, spacing, newEdges, newVertices) {
	  var priorIterationEdges = [];
	
	  function determineEdges(geometry, edge, splittingVertices) {
	    if (splittingVertices.length === 0) {
	      return false;
	    }
	
	    var startpoint = _helpers2.default.vertexForId(edge.v1, geometry),
	        endpoint = _helpers2.default.vertexForId(edge.v2, geometry);
	
	    splittingVertices = _lodash2.default.sortBy(splittingVertices, function (v) {
	      return (0, _helpers.distanceBetweenPoints)(v, startpoint);
	    });
	
	    splittingVertices = [startpoint].concat((0, _toConsumableArray3.default)(splittingVertices), [endpoint]);
	
	    var newEdges = edgesFromVerts(splittingVertices, [].concat((0, _toConsumableArray3.default)(geometry.edges), priorIterationEdges)),
	        replaceEdgeRefs = replacementEdgeRefs(geometry, edge.id, newEdges);
	
	    priorIterationEdges.push.apply(priorIterationEdges, (0, _toConsumableArray3.default)(newEdges));
	    return {
	      edgeToDelete: edge.id,
	      newEdges: newEdges,
	      replaceEdgeRefs: replaceEdgeRefs
	    };
	  }
	
	  if (newEdges && newVertices) {
	    var obj = {};
	    newEdges.forEach(function (edge) {
	      var splittingVertices = _helpers2.default.splittingVerticesForEdgeId(edge, geometry, spacing);
	      var edgeInfo = determineEdges(geometry, edge, splittingVertices);
	      if (edgeInfo) {
	        obj[edgeInfo.edgeToDelete] = edgeInfo;
	      }
	    });
	
	    geometry.edges.forEach(function (edge) {
	      var splittingVertices = _helpers2.default.splittingVerticesForEdgeId(edge, geometry, spacing, newVertices);
	      var edgeInfo = determineEdges(geometry, edge, splittingVertices);
	      if (edgeInfo) {
	        obj[edgeInfo.edgeToDelete] = edgeInfo;
	      }
	    });
	
	    return (0, _entries2.default)(obj).map(function (_ref10) {
	      var _ref11 = (0, _slicedToArray3.default)(_ref10, 2),
	          _ = _ref11[0],
	          value = _ref11[1];
	
	      return value;
	    });
	  }
	
	  return geometry.edges.map(function (edge) {
	    var splittingVertices = _helpers2.default.splittingVerticesForEdgeId(edge, geometry, spacing);
	    return determineEdges(geometry, edge, splittingVertices);
	  }).filter(function (e) {
	    return e;
	  });
	}
	
	function splitEdges(context, newEdges, newVertices) {
	  var currentStoryGeometry = context.rootGetters['application/currentStoryGeometry'],
	      currentProjectSpacing = context.rootState.project.grid.spacing,
	      edgeChanges = edgesToSplit(currentStoryGeometry, currentProjectSpacing, newEdges, newVertices);
	
	  edgeChanges.forEach(function (payload) {
	    return context.commit((0, _extends3.default)({
	      type: 'splitEdge',
	      geometry_id: currentStoryGeometry.id
	    }, payload));
	  });
	}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(16);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _checkGeometry = __webpack_require__(357);
	
	var _checkGeometry2 = _interopRequireDefault(_checkGeometry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    denormalized: function denormalized(state) {
	        return state.map(function (g) {
	            return _helpers2.default.denormalize(g);
	        });
	    },
	    errors: function errors(state, getters) {
	        return _lodash2.default.flatMap(getters['denormalized'], _checkGeometry2.default);
	    },
	    exportData: function exportData(state, getters, rootState, rootGetters) {
	        return state.map(function (geometry) {
	            return {
	                id: geometry.id,
	                vertices: geometry.vertices.map(function (vertex) {
	                    return {
	                        id: vertex.id,
	                        x: Number(vertex.x),
	                        y: Number(vertex.y),
	                        edge_ids: _helpers2.default.edgesForVertexId(vertex.id, geometry).map(function (e) {
	                            return e.id;
	                        })
	                    };
	                }),
	
	                edges: geometry.edges.map(function (edge) {
	                    return {
	                        id: edge.id,
	                        vertex_ids: [edge.v1, edge.v2],
	                        face_ids: _helpers2.default.facesForEdgeId(edge.id, geometry).map(function (f) {
	                            return f.id;
	                        })
	                    };
	                }),
	
	                faces: geometry.faces.map(function (face) {
	                    return {
	                        id: face.id,
	                        edge_ids: face.edgeRefs.map(function (eR) {
	                            return eR.edge_id;
	                        }),
	
	                        edge_order: face.edgeRefs.map(function (eR) {
	                            return eR.reverse ? 0 : 1;
	                        })
	                    };
	                })
	            };
	        });
	    }
	};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(335);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _mutations = __webpack_require__(339);
	
	var mutations = _interopRequireWildcard(_mutations);
	
	var _getters = __webpack_require__(337);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    namespaced: true,
	
	    state: [],
	    actions: _actions2.default,
	    mutations: mutations,
	    getters: _getters2.default
	};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(38);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _set = __webpack_require__(371);
	
	var _set2 = _interopRequireDefault(_set);
	
	exports.trimGeometry = trimGeometry;
	exports.initGeometry = initGeometry;
	exports.createVertex = createVertex;
	exports.createFace = createFace;
	exports.destroyGeometry = destroyGeometry;
	exports.createEdgeRef = createEdgeRef;
	exports.setEdgeRefsForFace = setEdgeRefsForFace;
	exports.destroyEdgeRef = destroyEdgeRef;
	exports.replaceEdgeRef = replaceEdgeRef;
	exports.ensureVertsExist = ensureVertsExist;
	exports.ensureEdgesExist = ensureEdgesExist;
	exports.splitEdge = splitEdge;
	exports.replaceFacePoints = replaceFacePoints;
	exports.updateClonedGeometry = updateClonedGeometry;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function trimGeometry(state, _ref) {
	  var geometry_id = _ref.geometry_id,
	      vertsReferencedElsewhere = _ref.vertsReferencedElsewhere;
	
	  var geometry = _lodash2.default.find(state, { id: geometry_id }),
	      edgesInUse = new _set2.default(_lodash2.default.flatMap(geometry.faces, function (f) {
	    return _lodash2.default.map(f.edgeRefs, 'edge_id');
	  })),
	      vertsOnEdges = _lodash2.default.flatMap(geometry.edges.filter(function (e) {
	    return edgesInUse.has(e.id);
	  }), function (e) {
	    return [e.v1, e.v2];
	  }),
	      verticesInUse = new _set2.default([].concat((0, _toConsumableArray3.default)(vertsReferencedElsewhere || []), (0, _toConsumableArray3.default)(vertsOnEdges)));
	  var newEdges = geometry.edges.filter(function (e) {
	    return edgesInUse.has(e.id);
	  });
	  var newVerts = geometry.vertices.filter(function (v) {
	    return verticesInUse.has(v.id);
	  });
	  var missingEdges = _lodash2.default.difference([].concat((0, _toConsumableArray3.default)(edgesInUse)), _lodash2.default.map(newEdges, 'id'));
	  if (missingEdges.length) {
	    console.error('An edge is referenced by a face, but does not exist!', (0, _stringify2.default)(geometry));
	  }
	  var missingVerts = _lodash2.default.difference(vertsOnEdges, _lodash2.default.map(newVerts, 'id'));
	  if (missingVerts.length) {
	    console.error('A vertex is referenced by a face, but does not exist!', (0, _stringify2.default)(geometry));
	  }
	  geometry.vertices = newVerts;
	  geometry.edges = newEdges;
	  geometry.faces = geometry.faces.filter(function (face) {
	    return face.edgeRefs.length > 0;
	  });
	}
	
	function initGeometry(state, payload) {
	  var geometry = payload.geometry;
	
	  state.push(geometry);
	}
	
	function createVertex(state, payload) {
	  var geometry_id = payload.geometry_id,
	      vertex = payload.vertex;
	
	  state.find(function (g) {
	    return g.id === geometry_id;
	  }).vertices.push(vertex);
	}
	function createFace(state, payload) {
	  var geometry_id = payload.geometry_id,
	      face = payload.face;
	
	  state.find(function (g) {
	    return g.id === geometry_id;
	  }).faces.push(face);
	}
	
	function destroyGeometry(state, payload) {
	  var id = payload.id;
	
	  for (var i = 0; i < state.length; i++) {
	    var g = state[i];
	    if (g.id === id) {
	      state.splice(state.findIndex(function (g) {
	        return g.id === id;
	      }), 1);
	      break;
	    } else if (~g.faces.map(function (f) {
	      return f.id;
	    }).indexOf(id)) {
	      g.faces.splice(g.faces.findIndex(function (f) {
	        return f.id === id;
	      }), 1);
	      break;
	    } else if (~g.edges.map(function (e) {
	      return e.id;
	    }).indexOf(id)) {
	      g.edges.splice(g.edges.findIndex(function (e) {
	        return e.id === id;
	      }), 1);
	      g.faces.forEach(function (face) {
	        face.edgeRefs.forEach(function (edgeRef) {
	          if (id === edgeRef.edge_id) {
	            face.edgeRefs.splice(face.edgeRefs.findIndex(function (r) {
	              return r.edge_id === id;
	            }), 1);
	          }
	        });
	      });
	      break;
	    } else if (~g.vertices.map(function (v) {
	      return v.id;
	    }).indexOf(id)) {
	      g.vertices.splice(g.vertices.findIndex(function (v) {
	        return v.id === id;
	      }), 1);
	      break;
	    }
	  }
	}
	
	function createEdgeRef(state, payload) {
	  var geometry_id = payload.geometry_id,
	      face_id = payload.face_id,
	      edgeRef = payload.edgeRef,
	      geometry = state.find(function (g) {
	    return g.id === geometry_id;
	  }),
	      face = geometry.faces.find(function (f) {
	    return f.id === face_id;
	  }),
	      edge = geometry.edges.find(function (e) {
	    return e.id === edgeRef.edge_id;
	  });
	
	
	  if (edge) {
	    face.edgeRefs.push(edgeRef);
	  }
	}
	
	function setEdgeRefsForFace(state, payload) {
	  var geometry_id = payload.geometry_id,
	      face_id = payload.face_id,
	      edgeRefs = payload.edgeRefs,
	      geometry = state.find(function (g) {
	    return g.id === geometry_id;
	  }),
	      face = geometry.faces.find(function (f) {
	    return f.id === face_id;
	  });
	
	  face.edgeRefs = edgeRefs.filter(function (ref) {
	    return geometry.edges.find(function (e) {
	      return e.id === ref.edge_id;
	    });
	  });
	}
	
	function destroyEdgeRef(state, payload) {
	  var geometry_id = payload.geometry_id,
	      face_id = payload.face_id,
	      edge_id = payload.edge_id,
	      geometry = state.find(function (g) {
	    return g.id === geometry_id;
	  }),
	      face = geometry.faces.find(function (f) {
	    return f.id === face_id;
	  });
	
	  face.edgeRefs.splice(face.edgeRefs.findIndex(function (eR) {
	    return eR.edge_id === edge_id;
	  }), 1);
	}
	
	function replaceEdgeRef(state, payload) {
	  var _face$edgeRefs;
	
	  var geometry_id = payload.geometry_id,
	      face_id = payload.face_id,
	      edge_id = payload.edge_id,
	      newEdges = payload.newEdges,
	      geometry = state.find(function (g) {
	    return g.id === geometry_id;
	  }),
	      face = geometry.faces.find(function (f) {
	    return f.id === face_id;
	  }),
	      edgeRefIx = _lodash2.default.findIndex(face.edgeRefs, { edge_id: edge_id });
	
	  (_face$edgeRefs = face.edgeRefs).splice.apply(_face$edgeRefs, [edgeRefIx, 1].concat((0, _toConsumableArray3.default)(newEdges.map(function (_ref2) {
	    var newEdgeId = _ref2.id,
	        reverse = _ref2.reverse;
	    return {
	      edge_id: newEdgeId,
	      reverse: reverse
	    };
	  }))));
	}
	
	function ensureVertsExist(state, _ref3) {
	  var geometry_id = _ref3.geometry_id,
	      vertices = _ref3.vertices;
	
	  var geometry = _lodash2.default.find(state, { id: geometry_id });
	  vertices.forEach(function (v) {
	    return _lodash2.default.find(geometry.vertices, { id: v.id }) || geometry.vertices.push(v);
	  });
	}
	
	function ensureEdgesExist(state, _ref4) {
	  var geometry_id = _ref4.geometry_id,
	      edges = _ref4.edges;
	
	  var geometry = _lodash2.default.find(state, { id: geometry_id });
	  edges.forEach(function (e) {
	    return _lodash2.default.find(geometry.edges, { id: e.id }) || geometry.edges.push(e);
	  });
	}
	
	function splitEdge(state, _ref5) {
	  var geometry_id = _ref5.geometry_id,
	      edgeToDelete = _ref5.edgeToDelete,
	      newEdges = _ref5.newEdges,
	      replaceEdgeRefs = _ref5.replaceEdgeRefs;
	
	  ensureEdgesExist(state, { geometry_id: geometry_id, edges: newEdges });
	  replaceEdgeRefs.forEach(function (replacement) {
	    return replaceEdgeRef(state, replacement);
	  });
	  destroyGeometry(state, { id: edgeToDelete });
	}
	
	function replaceFacePoints(state, _ref6) {
	  var geometry_id = _ref6.geometry_id,
	      vertices = _ref6.vertices,
	      edges = _ref6.edges,
	      face_id = _ref6.face_id;
	
	  var geometry = _lodash2.default.find(state, { id: geometry_id });
	
	  ensureVertsExist(state, { geometry_id: geometry_id, vertices: vertices });
	
	  ensureEdgesExist(state, { geometry_id: geometry_id, edges: edges, vertices: vertices });
	  var face = _lodash2.default.find(geometry.faces, { id: face_id });
	  if (!face) {
	    face = { id: face_id, edgeRefs: [] };
	    geometry.faces.push(face);
	  }
	
	  face.edgeRefs = edges.map(function (e) {
	    return {
	      edge_id: e.id,
	      reverse: !!e.reverse
	    };
	  });
	}
	
	function updateClonedGeometry(state, payload) {
	  var newGeometry = state.find(function (story) {
	    return story.id === payload.currentStoryId;
	  });
	  newGeometry.edges = payload.newGeom.edges;
	  newGeometry.faces = payload.newGeom.faces;
	  newGeometry.vertices = payload.newGeom.vertices;
	}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(87);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(56);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _libconfig = __webpack_require__(101);
	
	var _libconfig2 = _interopRequireDefault(_libconfig);
	
	var _factory = __webpack_require__(131);
	
	var _factory2 = _interopRequireDefault(_factory);
	
	var _generateId = __webpack_require__(55);
	
	var _generateId2 = _interopRequireDefault(_generateId);
	
	var _factory3 = __webpack_require__(130);
	
	var _factory4 = _interopRequireDefault(_factory3);
	
	var _helpers = __webpack_require__(50);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _helpers3 = __webpack_require__(16);
	
	var _helpers4 = _interopRequireDefault(_helpers3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  initStory: function initStory(context) {
	    var name = _helpers2.default.generateName(context.state, 'stories');
	    var story = new _factory2.default.Story(name);
	
	    context.commit('initStory', { story: story });
	
	    context.dispatch('geometry/initGeometry', { story_id: story.id }, { root: true });
	
	    context.dispatch('initSpace', { story: story });
	    context.dispatch('initShading', { story: story });
	    context.dispatch('selectStory', { story: story });
	  },
	  initSpace: function initSpace(context, payload) {
	    var story = context.state.stories.find(function (s) {
	      return s.id === payload.story.id;
	    }),
	        name = _helpers2.default.generateName(context.state, 'spaces', story),
	        space = new _factory2.default.Space(name);
	
	    context.commit('initSpace', { story: story, space: space });
	  },
	  initShading: function initShading(context, payload) {
	    var story = context.state.stories.find(function (s) {
	      return s.id === payload.story.id;
	    }),
	        name = _helpers2.default.generateName(context.state, 'shading', story),
	        shading = new _factory2.default.Shading(name);
	
	    context.commit('initShading', { story: story, shading: shading });
	  },
	  destroyStory: function destroyStory(context, payload) {
	    var stories = context.state.stories;
	    var storyIndex = stories.findIndex(function (s) {
	      return s.id === payload.story.id;
	    });
	    var story = stories[storyIndex];
	
	    context.commit('destroyStory', { story: story });
	    context.dispatch('geometry/destroyGeometry', story.geometry_id, { root: true });
	    if (stories.length === 0) {
	      context.dispatch('initStory');
	    } else {
	      context.dispatch('selectStory', { story: stories[storyIndex - 1] });
	    }
	  },
	  destroySpace: function destroySpace(context, payload) {
	    var story = context.state.stories.find(function (s) {
	      return s.id === payload.story.id;
	    }),
	        space = story.spaces.find(function (s) {
	      return s.id === payload.space.id;
	    });
	
	    context.commit('destroySpace', {
	      space: space,
	      story: story
	    });
	    var geom = context.rootGetters['application/currentStoryGeometry'];
	    var face = geom.faces.find(function (f) {
	      return f.id === space.face_id;
	    });
	    if (face) {
	      var edges = geom.edges.filter(function (edge) {
	        return face.edgeRefs.map(function (er) {
	          return er.edge_id;
	        }).includes(edge.id);
	      });
	      edges.forEach(function (edge) {
	        var windows = story.windows.filter(function (w) {
	          return w.edge_id === edge.id;
	        });
	        windows.forEach(function (window) {
	          return context.dispatch('destroyWindow', {
	            story_id: story.id,
	            object: window
	          });
	        });
	      });
	
	      context.dispatch('geometry/destroyFaceAndDescendents', {
	        face: face,
	        geometry_id: geom.id
	      }, { root: true });
	    }
	  },
	  destroyShading: function destroyShading(context, payload) {
	    var story = context.state.stories.find(function (s) {
	      return s.id === payload.story.id;
	    }),
	        shading = story.shading.find(function (s) {
	      return s.id === payload.shading.id;
	    });
	
	    context.commit('destroyShading', {
	      shading: shading,
	      story: story
	    });
	
	    var face = context.rootGetters['application/currentStoryGeometry'].faces.find(function (f) {
	      return f.id === shading.face_id;
	    });
	    if (face) {
	      context.dispatch('geometry/destroyFaceAndDescendents', {
	        face: face,
	        geometry_id: context.rootGetters['application/currentStoryGeometry'].id
	      }, { root: true });
	    }
	  },
	  destroyImage: function destroyImage(context, payload) {
	    var story = context.state.stories.find(function (s) {
	      return s.id === payload.story.id;
	    }),
	        image = story.images.find(function (i) {
	      return i.id === payload.image.id;
	    });
	
	    context.commit('destroyImage', {
	      image: image,
	      story: story
	    });
	  },
	  destroyWindowDef: function destroyWindowDef(context, payload) {
	    context.commit('destroyWindowsByDefinition', payload.object);
	    context.commit('destroyObject', payload);
	  },
	  destroyDaylightingControlDef: function destroyDaylightingControlDef(context, payload) {
	    context.commit('destroyDaylightingControlsByDefinition', payload.object);
	    context.commit('destroyObject', payload);
	  },
	  destroyDoorDef: function destroyDoorDef(context, payload) {
	    context.commit('destroyDoorsByDefinition', payload.object);
	    context.commit('destroyObject', payload);
	  },
	  destroyObject: function destroyObject(context, payload) {
	    context.commit('destroyObject', {
	      object: payload.object
	    });
	  },
	  updateStoryWithData: function updateStoryWithData(context, payload) {
	    var story = context.state.stories.find(function (s) {
	      return s.id === payload.story.id;
	    }),
	        validProperties = (0, _keys2.default)(_libconfig2.default.stories.keymap),
	        cleanedPayload = {};
	
	    for (var key in payload) {
	      if (payload.hasOwnProperty(key) && ~validProperties.indexOf(key)) {
	        cleanedPayload[key] = payload[key];
	      }
	    }
	    cleanedPayload.story = story;
	
	    context.commit('updateStoryWithData', cleanedPayload);
	  },
	  updateSpaceWithData: function updateSpaceWithData(context, payload) {
	    var space = context.getters.allSpaces.find(function (s) {
	      return s.id === payload.space.id;
	    }),
	        validProperties = (0, _keys2.default)(space),
	        cleanedPayload = {};
	
	    for (var key in payload) {
	      if (payload.hasOwnProperty(key) && ~validProperties.indexOf(key)) {
	        cleanedPayload[key] = payload[key];
	      }
	    }
	    cleanedPayload.space = space;
	
	    context.commit('updateSpaceWithData', cleanedPayload);
	  },
	  updateShadingWithData: function updateShadingWithData(context, payload) {
	    var shading = context.getters.allShading.find(function (s) {
	      return s.id === payload.shading.id;
	    }),
	        validProperties = (0, _keys2.default)(shading),
	        cleanedPayload = {};
	
	    for (var key in payload) {
	      if (payload.hasOwnProperty(key) && ~validProperties.indexOf(key)) {
	        cleanedPayload[key] = payload[key];
	      }
	    }
	    cleanedPayload.shading = shading;
	
	    context.commit('updateShadingWithData', cleanedPayload);
	  },
	  updateImageWithData: function updateImageWithData(context, payload) {
	    var image = context.getters.allImages.find(function (i) {
	      return i.id === payload.image.id;
	    }),
	        validProperties = _lodash2.default.difference((0, _keys2.default)(image), ['src', 'naturalWidth', 'naturalHeight']);
	
	    if (payload.scale) {
	      payload.height = payload.scale * image.naturalHeight;
	      payload.width = payload.scale * image.naturalWidth;
	    }
	    var cleanedPayload = _lodash2.default.pick(payload, validProperties);
	    cleanedPayload.image = image;
	
	    context.commit('updateImageWithData', cleanedPayload);
	  },
	  updateWindowDefinitionWithData: function updateWindowDefinitionWithData(_ref, payload) {
	    var state = _ref.state,
	        dispatch = _ref.dispatch;
	    var id = payload.object.id;
	
	
	    var windowDefnDefaults = _lodash2.default.pick((0, _factory.getDefaults)('WindowDefinition'), ['height', 'width', 'window_spacing', 'wwr']);
	
	    if (payload.window_definition_mode === 'Window to Wall Ratio') {
	      (0, _assign2.default)(payload, windowDefnDefaults, {
	        height: null,
	        width: null,
	        window_spacing: null
	      });
	    } else if (payload.window_definition_mode === 'Repeating Windows') {
	      (0, _assign2.default)(payload, windowDefnDefaults, {
	        wwr: null
	      });
	    } else if (payload.window_definition_mode === 'Single Window') {
	      (0, _assign2.default)(payload, windowDefnDefaults, {
	        wwr: null,
	        window_spacing: null
	      });
	    } else if (payload.window_definition_mode) {
	      throw new Error('unrecognized window_definition_mode: ' + payload.window_definition_mode);
	    }
	
	    if (_lodash2.default.includes(['Window to Wall Ratio', 'Repeating Windows'], payload.window_definition_mode)) {
	      var windowsToDelete = _lodash2.default.flatMap(state.stories, function (story) {
	        return _lodash2.default.chain(story.windows).filter({ window_definition_id: id }).groupBy('edge_id').values().flatMap(_lodash2.default.tail).map(function (w) {
	          return { story_id: story.id, object: { id: w.id } };
	        }).value();
	      });
	
	      windowsToDelete.forEach(function (pl) {
	        return dispatch('destroyWindow', pl);
	      });
	    }
	
	    dispatch('updateObjectWithData', payload);
	  },
	  updateObjectWithData: function updateObjectWithData(context, payload) {
	    var object = _helpers2.default.libraryObjectWithId(context.state, payload.object.id);
	    payload.object = object;
	
	    context.commit('updateObjectWithData', payload);
	  },
	  createImageForStory: function createImageForStory(context, payload) {
	    var story = context.state.stories.find(function (s) {
	      return s.id === payload.story_id;
	    });
	    var name = _helpers2.default.generateName(context.state, 'images', story);
	    var image = new _factory2.default.Image(name, payload.src);
	
	    image.height = payload.height;
	    image.width = payload.width;
	    image.x = payload.x;
	    image.y = payload.y;
	    image.naturalWidth = payload.naturalWidth;
	    image.naturalHeight = payload.naturalHeight;
	
	    context.commit('createImageForStory', {
	      story_id: story.id,
	      image: image
	    });
	  },
	  createObjectWithType: function createObjectWithType(context, payload) {
	    var type = payload.type,
	        name = _helpers2.default.generateName(context.state, type),
	        object = new _helpers2.default.map[type].init({ name: name });
	
	    context.commit('initObject', { type: type, object: object });
	  },
	  selectStory: function selectStory(context, payload) {
	    var story = payload.story;
	    context.dispatch('application/setCurrentStoryId', { id: story.id }, { root: true });
	  },
	  cloneStory: function cloneStory(context, payload) {
	    var currentStory = context.rootGetters['application/currentStory'];
	    context.commit('cloneObjectArray', { storyInfo: payload, currentStory: currentStory });
	  },
	  createWindow: function createWindow(context, payload) {
	    var story_id = payload.story_id,
	        edge_id = payload.edge_id,
	        window_definition_id = payload.window_definition_id,
	        alpha = payload.alpha,
	        story = _lodash2.default.find(context.state.stories, { id: story_id }),
	        windowDefn = _lodash2.default.find(context.state.library.window_definitions, { id: window_definition_id }),
	        geometry = story && _lodash2.default.find(context.rootState.geometry, { id: story.geometry_id }),
	        edge = geometry && _lodash2.default.find(geometry.edges, { id: edge_id });
	
	    if (!story) {
	      throw new Error('Story not found');
	    } else if (!windowDefn) {
	      throw new Error('Window Definition not found');
	    } else if (!geometry) {
	      throw new Error('Geometry not found');
	    } else if (!edge) {
	      throw new Error('Edge not found');
	    } else if (alpha < 0 || alpha > 1) {
	      throw new Error('Alpha must be between 0 and 1');
	    }
	
	    var windowsOnEdge = _lodash2.default.filter(story.windows, { edge_id: edge_id }).map(function (w) {
	      return (0, _extends3.default)({}, w, {
	        window_definition_mode: _lodash2.default.find(context.state.library.window_definitions, { id: w.window_definition_id }).window_definition_mode
	      });
	    });
	    var windowsToDelete = void 0;
	    if (windowDefn.window_definition_mode === 'Single Window') {
	      windowsToDelete = _lodash2.default.reject(windowsOnEdge, { window_definition_mode: 'Single Window' });
	    } else {
	      windowsToDelete = windowsOnEdge;
	    }
	    windowsToDelete.forEach(function (w) {
	      return context.commit('destroyWindow', { story_id: story_id, object: { id: w.id } });
	    });
	
	    context.commit('createWindow', (0, _extends3.default)({}, payload, {
	      id: _generateId2.default.generate(),
	      name: (0, _generateId.genName)(windowDefn.name)
	    }));
	  },
	  createWindows: function createWindows(context, payload) {
	    var deletes = [];
	    var creates = [];
	
	    payload.forEach(function (p) {
	      var story_id = p.story_id,
	          edge_id = p.edge_id,
	          window_definition_id = p.window_definition_id,
	          alpha = p.alpha,
	          story = _lodash2.default.find(context.state.stories, { id: story_id }),
	          windowDefn = _lodash2.default.find(context.state.library.window_definitions, { id: window_definition_id }),
	          geometry = story && _lodash2.default.find(context.rootState.geometry, { id: story.geometry_id }),
	          edge = geometry && _lodash2.default.find(geometry.edges, { id: edge_id });
	
	      if (!story) {
	        throw new Error('Story not found');
	      } else if (!windowDefn) {
	        throw new Error('Window Definition not found');
	      } else if (!geometry) {
	        throw new Error('Geometry not found');
	      } else if (!edge) {
	        throw new Error('Edge not found');
	      } else if (alpha < 0 || alpha > 1) {
	        throw new Error('Alpha must be between 0 and 1');
	      }
	
	      var windowsOnEdge = _lodash2.default.filter(story.windows, { edge_id: edge_id }).map(function (w) {
	        return (0, _extends3.default)({}, w, {
	          window_definition_mode: _lodash2.default.find(context.state.library.window_definitions, { id: w.window_definition_id }).window_definition_mode
	        });
	      });
	      var windowsToDelete = void 0;
	      if (windowDefn.window_definition_mode === 'Single Window') {
	        windowsToDelete = _lodash2.default.reject(windowsOnEdge, { window_definition_mode: 'Single Window' });
	      } else {
	        windowsToDelete = windowsOnEdge;
	      }
	      windowsToDelete.forEach(function (w) {
	        return deletes.push({ story_id: story_id, object: { id: w.id } });
	      });
	
	      creates.push((0, _extends3.default)({}, p, {
	        id: _generateId2.default.generate(),
	        name: (0, _generateId.genName)(windowDefn.name)
	      }));
	    });
	
	    context.commit('destroyWindows', deletes);
	    context.commit('createWindows', creates);
	  },
	  createDoor: function createDoor(context, payload) {
	    var story_id = payload.story_id,
	        edge_id = payload.edge_id,
	        door_definition_id = payload.door_definition_id,
	        alpha = payload.alpha,
	        story = _lodash2.default.find(context.state.stories, { id: story_id }),
	        doorDefn = _lodash2.default.find(context.state.library.door_definitions, { id: door_definition_id }),
	        geometry = story && _lodash2.default.find(context.rootState.geometry, { id: story.geometry_id }),
	        edge = geometry && _lodash2.default.find(geometry.edges, { id: edge_id });
	
	    if (!story) {
	      throw new Error('Story not found');
	    } else if (!doorDefn) {
	      throw new Error('Door Definition not found');
	    } else if (!geometry) {
	      throw new Error('Geometry not found');
	    } else if (!edge) {
	      throw new Error('Edge not found');
	    } else if (alpha < 0 || alpha > 1) {
	      throw new Error('Alpha must be between 0 and 1');
	    }
	
	    context.commit('createDoor', (0, _extends3.default)({}, payload, {
	      id: _generateId2.default.generate(),
	      name: (0, _generateId.genName)(doorDefn.name)
	    }));
	  },
	  createDoors: function createDoors(context, payload) {
	    var arr = payload.map(function (p) {
	      var story_id = p.story_id,
	          edge_id = p.edge_id,
	          door_definition_id = p.door_definition_id,
	          alpha = p.alpha,
	          story = _lodash2.default.find(context.state.stories, { id: story_id }),
	          doorDefn = _lodash2.default.find(context.state.library.door_definitions, { id: door_definition_id }),
	          geometry = story && _lodash2.default.find(context.rootState.geometry, { id: story.geometry_id }),
	          edge = geometry && _lodash2.default.find(geometry.edges, { id: edge_id });
	
	      if (!story) {
	        throw new Error('Story not found');
	      } else if (!doorDefn) {
	        throw new Error('Door Definition not found');
	      } else if (!geometry) {
	        throw new Error('Geometry not found');
	      } else if (!edge) {
	        throw new Error('Edge not found');
	      } else if (alpha < 0 || alpha > 1) {
	        throw new Error('Alpha must be between 0 and 1');
	      }
	
	      return (0, _extends3.default)({}, p, {
	        id: _generateId2.default.generate(),
	        name: (0, _generateId.genName)(doorDefn.name)
	      });
	    });
	
	    context.commit('createDoors', arr);
	  },
	  createDaylightingControl: function createDaylightingControl(context, payload) {
	    var story_id = payload.story_id,
	        face_id = payload.face_id,
	        daylighting_control_definition_id = payload.daylighting_control_definition_id,
	        x = payload.x,
	        y = payload.y,
	        story = _lodash2.default.find(context.state.stories, { id: story_id }),
	        daylightingDefn = _lodash2.default.find(context.state.library.daylighting_control_definitions, { id: daylighting_control_definition_id }),
	        geometry = story && _lodash2.default.find(context.rootState.geometry, { id: story.geometry_id }),
	        face = geometry && _lodash2.default.find(geometry.faces, { id: face_id }),
	        vertex = geometry && (_helpers4.default.vertexForCoordinates({ x: x, y: y }, geometry) || _factory4.default.Vertex(x, y));
	
	    if (!story) {
	      throw new Error('Story not found');
	    } else if (!daylightingDefn) {
	      throw new Error('Daylighting Control Definition not found');
	    } else if (!geometry) {
	      throw new Error('Geometry not found');
	    } else if (!face) {
	      throw new Error('Face not found');
	    } else if (!vertex.id) {
	      throw new Error('Unable to find or create vertex');
	    }
	    context.commit('geometry/ensureVertsExist', { geometry_id: geometry.id, vertices: [vertex] }, { root: true });
	    context.commit('createDaylightingControl', (0, _extends3.default)({}, payload, {
	      vertex_id: vertex.id,
	      id: _generateId2.default.generate(),
	      name: (0, _generateId.genName)(daylightingDefn.name)
	    }));
	  },
	  destroyDaylightingControl: function destroyDaylightingControl(_ref2, payload) {
	    var commit = _ref2.commit;
	
	    commit('destroyDaylightingControl', payload);
	  },
	  destroyWindow: function destroyWindow(_ref3, payload) {
	    var commit = _ref3.commit;
	
	    commit('destroyWindow', payload);
	  },
	  destroyWindows: function destroyWindows(_ref4, payload) {
	    var commit = _ref4.commit;
	
	    commit('destroyWindows', payload);
	  },
	  destroyDoor: function destroyDoor(_ref5, payload) {
	    var commit = _ref5.commit;
	
	    commit('destroyDoor', payload);
	  },
	  destroyDoors: function destroyDoors(_ref6, payload) {
	    var commit = _ref6.commit;
	
	    commit('destroyDoors', payload);
	  },
	  modifyDaylightingControl: function modifyDaylightingControl(_ref7, payload) {
	    var commit = _ref7.commit;
	
	    commit('modifyDaylightingControl', payload);
	  },
	  modifyWindow: function modifyWindow(_ref8, payload) {
	    var commit = _ref8.commit;
	
	    commit('modifyWindow', payload);
	  },
	  modifyDoor: function modifyDoor(_ref9, payload) {
	    var commit = _ref9.commit;
	
	    commit('modifyDoor', payload);
	  },
	  destroyAllComponents: function destroyAllComponents(_ref10, _ref11) {
	    var commit = _ref10.commit;
	    var story_id = _ref11.story_id;
	
	    commit('dropDaylightingControls', { story_id: story_id });
	    commit('dropWindows', { story_id: story_id });
	    commit('dropDoors', { story_id: story_id });
	  }
	};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(77);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.number = number;
	exports.bool = bool;
	exports.gt0orNull = gt0orNull;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function number(n, col) {
	  if (n === '' || n === null) {
	    return _lodash2.default.has(col, 'default') ? col.default : col.nullable ? null : 0;
	  }
	  return +n;
	}
	function bool(b) {
	  return (typeof b === 'undefined' ? 'undefined' : (0, _typeof3.default)(b)) === (0, _typeof3.default)(true) ? b : b.toLowerCase() === 'true';
	}
	function gt0orNull(n) {
	  return +n || null;
	}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(38);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(56);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    allSpaces: function allSpaces(state, getters, rootState, rootGetters) {
	        return rootState.models.stories.reduce(function (spaces, story) {
	            return spaces.concat(story.spaces);
	        }, []);
	    },
	    allShading: function allShading(state, getters, rootState, rootGetters) {
	        return rootState.models.stories.reduce(function (shading, story) {
	            return shading.concat(story.shading);
	        }, []);
	    },
	    allImages: function allImages(state, getters, rootState, rootGetters) {
	        return rootState.models.stories.reduce(function (images, story) {
	            return images.concat(story.images);
	        }, []);
	    },
	    all: function all(state, getters, rootState, rootGetters) {
	        var objs = (0, _extends3.default)({}, rootState.models.library, {
	            stories: rootState.models.stories,
	            spaces: getters.allSpaces,
	            shading: getters.allShading,
	            images: getters.allImages
	        });
	
	        return (0, _keys2.default)(objs).reduce(function (out, key) {
	            out.push.apply(out, (0, _toConsumableArray3.default)(objs[key]));
	            return out;
	        }, []);
	    }
	};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(340);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _mutations = __webpack_require__(344);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _getters = __webpack_require__(342);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    namespaced: true,
	    state: {
	        stories: [],
	
	        library: {
	            building_units: [],
	            thermal_zones: [],
	            space_types: [],
	            construction_sets: [],
	            window_definitions: [],
	            daylighting_control_definitions: [],
	            pitched_roofs: [],
	            door_definitions: []
	        }
	    },
	    actions: _actions2.default,
	    mutations: _mutations2.default,
	    getters: _getters2.default
	};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(57);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(199);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _assign = __webpack_require__(87);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(50);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  initStory: function initStory(state, payload) {
	    state.stories.push(payload.story);
	  },
	  initSpace: function initSpace(state, payload) {
	    payload.story.spaces.push(payload.space);
	  },
	  initShading: function initShading(state, payload) {
	    payload.story.shading.push(payload.shading);
	  },
	  initObject: function initObject(state, payload) {
	    state.library[payload.type].push(payload.object);
	  },
	  destroySpace: function destroySpace(state, payload) {
	    payload.story.spaces.splice(payload.story.spaces.findIndex(function (s) {
	      return s.id === payload.space.id;
	    }), 1);
	  },
	  destroyShading: function destroyShading(state, payload) {
	    payload.story.shading.splice(payload.story.shading.findIndex(function (s) {
	      return s.id === payload.shading.id;
	    }), 1);
	  },
	  destroyImage: function destroyImage(state, payload) {
	    payload.story.images.splice(payload.story.images.findIndex(function (i) {
	      return i.id === payload.image.id;
	    }), 1);
	  },
	  destroyStory: function destroyStory(state, payload) {
	    state.stories.splice(state.stories.findIndex(function (s) {
	      return s.id === payload.story.id;
	    }), 1);
	  },
	  destroyObject: function destroyObject(state, _ref) {
	    var id = _ref.object.id;
	
	    state.library = _lodash2.default.mapValues(state.library, function (lst) {
	      return _lodash2.default.reject(lst, { id: id });
	    });
	  },
	  updateStoryWithData: function updateStoryWithData(state, payload) {
	    var story = payload.story;
	    delete payload.story;
	    (0, _assign2.default)(story, payload);
	  },
	  createImageForStory: function createImageForStory(state, payload) {
	    var story = state.stories.find(function (s) {
	      return s.id === payload.story_id;
	    });
	    story.images.push(payload.image);
	  },
	  updateSpaceWithData: function updateSpaceWithData(state, payload) {
	    var space = payload.space;
	    (0, _assign2.default)(space, payload);
	    delete space.space;
	  },
	  updateShadingWithData: function updateShadingWithData(state, payload) {
	    var shading = payload.shading;
	    (0, _assign2.default)(shading, payload);
	    delete shading.shading;
	  },
	  updateImageWithData: function updateImageWithData(state, payload) {
	    var image = payload.image;
	    (0, _assign2.default)(image, payload);
	    delete image.image;
	  },
	  updateObjectWithData: function updateObjectWithData(state, payload) {
	    var object = payload.object;
	    (0, _assign2.default)(object, payload);
	    delete object.object;
	  },
	  createWindow: function createWindow(state, _ref2) {
	    var story_id = _ref2.story_id,
	        edge_id = _ref2.edge_id,
	        window_definition_id = _ref2.window_definition_id,
	        alpha = _ref2.alpha,
	        id = _ref2.id,
	        name = _ref2.name;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id });
	    story.windows.push({
	      window_definition_id: window_definition_id,
	      edge_id: edge_id,
	      alpha: alpha,
	      id: id,
	      name: name
	    });
	  },
	  createWindows: function createWindows(state, payload) {
	    var obj = {};
	    payload.forEach(function (_ref3) {
	      var story_id = _ref3.story_id,
	          edge_id = _ref3.edge_id,
	          window_definition_id = _ref3.window_definition_id,
	          alpha = _ref3.alpha,
	          id = _ref3.id,
	          name = _ref3.name;
	
	      var window = {
	        window_definition_id: window_definition_id,
	        edge_id: edge_id,
	        alpha: alpha,
	        id: id,
	        name: name
	      };
	      if (obj[story_id]) {
	        obj[story_id].push(window);
	      } else {
	        obj[story_id] = [window];
	      }
	    });
	
	    (0, _entries2.default)(obj).forEach(function (_ref4) {
	      var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
	          key = _ref5[0],
	          value = _ref5[1];
	
	      var story = _lodash2.default.find(state.stories, { id: key });
	      story.windows = story.windows.concat(value);
	    });
	  },
	  createDoor: function createDoor(state, _ref6) {
	    var story_id = _ref6.story_id,
	        edge_id = _ref6.edge_id,
	        door_definition_id = _ref6.door_definition_id,
	        alpha = _ref6.alpha,
	        id = _ref6.id;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id });
	    story.doors.push({
	      door_definition_id: door_definition_id,
	      edge_id: edge_id,
	      alpha: alpha,
	      id: id,
	      name: name
	    });
	  },
	  createDoors: function createDoors(state, payload) {
	    var obj = {};
	    payload.forEach(function (_ref7) {
	      var story_id = _ref7.story_id,
	          edge_id = _ref7.edge_id,
	          door_definition_id = _ref7.door_definition_id,
	          alpha = _ref7.alpha,
	          id = _ref7.id;
	
	      var door = {
	        door_definition_id: door_definition_id,
	        edge_id: edge_id,
	        alpha: alpha,
	        id: id,
	        name: name
	      };
	      if (obj[story_id]) {
	        obj[story_id].push(door);
	      } else {
	        obj[story_id] = [door];
	      }
	    });
	
	    (0, _entries2.default)(obj).forEach(function (_ref8) {
	      var _ref9 = (0, _slicedToArray3.default)(_ref8, 2),
	          key = _ref9[0],
	          value = _ref9[1];
	
	      var story = _lodash2.default.find(state.stories, { id: key });
	      story.doors = story.doors.concat(value);
	    });
	  },
	  dropWindows: function dropWindows(state, _ref10) {
	    var story_id = _ref10.story_id;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id });
	    story.windows = [];
	  },
	  dropDoors: function dropDoors(state, _ref11) {
	    var story_id = _ref11.story_id;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id });
	    story.doors = [];
	  },
	  createDaylightingControl: function createDaylightingControl(state, _ref12) {
	    var story_id = _ref12.story_id,
	        face_id = _ref12.face_id,
	        daylighting_control_definition_id = _ref12.daylighting_control_definition_id,
	        vertex_id = _ref12.vertex_id,
	        name = _ref12.name,
	        id = _ref12.id;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id }),
	        space = _lodash2.default.find(story.spaces, { face_id: face_id });
	
	    space.daylighting_controls.push({
	      daylighting_control_definition_id: daylighting_control_definition_id,
	      vertex_id: vertex_id,
	      id: id,
	      name: name
	    });
	  },
	  dropDaylightingControls: function dropDaylightingControls(state, _ref13) {
	    var story_id = _ref13.story_id;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id });
	    story.spaces = story.spaces.map(function (space) {
	      if (space.daylighting_controls.length === 0) {
	        return space;
	      } else {
	        return (0, _assign2.default)({}, space, { daylighting_controls: [] });
	      }
	    });
	  },
	  destroyWindowsByDefinition: function destroyWindowsByDefinition(state, _ref14) {
	    var id = _ref14.id;
	
	    state.stories.forEach(function (story) {
	      story.windows = _lodash2.default.reject(story.windows, { window_definition_id: id });
	    });
	  },
	  destroyDaylightingControlsByDefinition: function destroyDaylightingControlsByDefinition(state, _ref15) {
	    var id = _ref15.id;
	
	    state.stories.forEach(function (story) {
	      story.spaces.forEach(function (space) {
	        space.daylighting_controls = _lodash2.default.reject(space.daylighting_controls, { daylighting_control_definition_id: id });
	      });
	    });
	  },
	  destroyDoorsByDefinition: function destroyDoorsByDefinition(state, _ref16) {
	    var id = _ref16.id;
	
	    state.stories.forEach(function (story) {
	      story.doors = _lodash2.default.reject(story.doors, { door_definition_id: id });
	    });
	  },
	  destroyDaylightingControl: function destroyDaylightingControl(state, _ref17) {
	    var story_id = _ref17.story_id,
	        id = _ref17.object.id;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id });
	    story.spaces.forEach(function (space) {
	      space.daylighting_controls = _lodash2.default.reject(space.daylighting_controls, { id: id });
	    });
	  },
	  modifyDaylightingControl: function modifyDaylightingControl(state, _ref18) {
	    var story_id = _ref18.story_id,
	        id = _ref18.id,
	        key = _ref18.key,
	        value = _ref18.value;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id });
	    story.spaces.some(function (space) {
	      var dc = _lodash2.default.find(space.daylighting_controls, { id: id });
	      if (dc) {
	        dc[key] = value;
	        return true;
	      }
	
	      return false;
	    });
	  },
	  destroyWindow: function destroyWindow(state, _ref19) {
	    var story_id = _ref19.story_id,
	        id = _ref19.object.id;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id });
	    story.windows = _lodash2.default.reject(story.windows, { id: id });
	  },
	  destroyWindows: function destroyWindows(state, payload) {
	    var obj = {};
	
	    payload.forEach(function (_ref20) {
	      var story_id = _ref20.story_id,
	          id = _ref20.object.id;
	
	      if (obj[story_id]) {
	        obj[story_id].push(id);
	      } else {
	        obj[story_id] = [id];
	      }
	    });
	
	    (0, _entries2.default)(obj).forEach(function (_ref21) {
	      var _ref22 = (0, _slicedToArray3.default)(_ref21, 2),
	          key = _ref22[0],
	          value = _ref22[1];
	
	      var story = _lodash2.default.find(state.stories, { id: key });
	      story.windows = story.windows.filter(function (window) {
	        return value.indexOf(window.id) === -1;
	      });
	    });
	  },
	  destroyDoor: function destroyDoor(state, _ref23) {
	    var story_id = _ref23.story_id,
	        id = _ref23.object.id;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id });
	    story.doors = _lodash2.default.reject(story.doors, { id: id });
	  },
	  destroyDoors: function destroyDoors(state, payload) {
	    var obj = {};
	
	    payload.forEach(function (_ref24) {
	      var story_id = _ref24.story_id,
	          id = _ref24.object.id;
	
	      if (obj[story_id]) {
	        obj[story_id].push(id);
	      } else {
	        obj[story_id] = [id];
	      }
	    });
	
	    (0, _entries2.default)(obj).forEach(function (_ref25) {
	      var _ref26 = (0, _slicedToArray3.default)(_ref25, 2),
	          key = _ref26[0],
	          value = _ref26[1];
	
	      var story = _lodash2.default.find(state.stories, { id: key });
	      story.doors = story.doors.filter(function (window) {
	        return value.indexOf(window.id) === -1;
	      });
	    });
	  },
	  modifyWindow: function modifyWindow(state, _ref27) {
	    var story_id = _ref27.story_id,
	        id = _ref27.id,
	        key = _ref27.key,
	        value = _ref27.value;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id }),
	        windew = _lodash2.default.find(story.windows, { id: id });
	    windew[key] = value;
	  },
	  modifyDoor: function modifyDoor(state, _ref28) {
	    var story_id = _ref28.story_id,
	        id = _ref28.id,
	        key = _ref28.key,
	        value = _ref28.value;
	
	    var story = _lodash2.default.find(state.stories, { id: story_id }),
	        door = _lodash2.default.find(story.doors, { id: id });
	    door[key] = value;
	  },
	  cloneObjectArray: function cloneObjectArray(state, payload) {
	    var newStory = state.stories.find(function (story) {
	      return story.id === payload.currentStory.id;
	    });
	    newStory['spaces'] = payload.storyInfo['spaces'];
	    _helpers2.default.replaceSpaceNamesForCloning(state, 'spaces', payload.currentStory);
	    newStory['shading'] = payload.storyInfo['shading'];
	    newStory['doors'] = payload.storyInfo['doors'];
	    newStory['images'] = payload.storyInfo['images'];
	    newStory['windows'] = payload.storyInfo['windows'];
	  }
	};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: function name(object, store, value, type) {
	    var objs = store.getters['models/all'];
	
	    switch (type) {
	      case 'stories':
	        objs = store.state.models.stories;
	        break;
	      case 'spaces':
	        objs = store.getters['models/allSpaces'];
	        break;
	      case 'shading':
	        objs = store.getters['models/allShading'];
	        break;
	      case 'images':
	        objs = store.getters['models/allImages'];
	        break;
	      default:
	        objs = store.state.models.library[type];
	        break;
	    }
	    var error = '';
	    if (objs.filter(function (s) {
	      return s.name === value && s.id !== object.id;
	    }).length) {
	      error = 'Names must be unique.';
	    } else if (value === '') {
	      error = 'Names must be at least 1 characters long.';
	    }
	
	    return error ? { success: false, error: error } : { success: true };
	  },
	  number: function number(object, store, value, type) {
	    var error = '';
	    if (isNaN(value)) {
	      error = 'Value must be numeric.';
	    }
	
	    return error ? { success: false, error: error } : { success: true };
	  },
	  oneOf: function oneOf() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return function (object, store, value, type) {
	      if (!_lodash2.default.includes(args, value)) {
	        return { success: false, error: 'Expected one of ' + args + ', got ' + value };
	      }
	      return { success: true };
	    };
	  },
	  gt0: function gt0(object, story, value, type) {
	    return value > 0 ? { success: true } : { success: false, error: 'Expected value to be greater than zero' };
	  },
	  closedInterval: function closedInterval(start, end) {
	    return function (object, store, value, type) {
	      if (value < start || value > end) {
	        return { success: false, error: 'Must be between ' + start + ' and ' + end };
	      }
	      return { success: true };
	    };
	  },
	  halfOpenInterval: function halfOpenInterval(start, end) {
	    return function (object, store, value, type) {
	      if (value < start || value >= end) {
	        return { success: false, error: 'Must be greater than or equal ' + start + ' and less than ' + end };
	      }
	      return { success: true };
	    };
	  },
	  gt0orNull: function gt0orNull(object, story, value, type) {
	    if (value === null || value === '' || value > 0) {
	      return { success: true };
	    }
	    return { success: false, error: 'If provided, value must be greater than 0' };
	  }
	};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(56);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _validator = __webpack_require__(356);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  setUnits: function setUnits(_ref, payload) {
	    var commit = _ref.commit,
	        dispatch = _ref.dispatch,
	        rootState = _ref.rootState;
	
	    if (payload.units === 'm' || payload.units === 'ft') {
	      throw new Error('units must be "ip" or "si"');
	    } else if (payload.units === 'ip' || payload.units === 'si') {
	      commit('setUnits', payload);
	      rootState.models.stories.forEach(function (story) {
	        return dispatch('models/destroyStory', { story: story }, { root: true });
	      });
	    }
	  },
	  setLanguage: function setLanguage(context, payload) {
	    if (payload.language === 'EN-US') {
	      context.commit('setLanguage', payload);
	    }
	  },
	  setNorthAxis: function setNorthAxis(context, payload) {
	    var north_axis = payload.north_axis;
	
	    if (north_axis > 360 || north_axis < 0) {
	      return;
	    }
	    context.commit('setConfigNorthAxis', { north_axis: north_axis });
	    context.commit('setMapRotation', { rotation: north_axis * Math.PI / 180 });
	  },
	  setMapVisible: function setMapVisible(context, payload) {
	    if (typeof payload.visible === 'boolean') {
	      context.commit('setMapVisible', payload);
	    }
	  },
	  setPreview3DEnabled: function setPreview3DEnabled(context, payload) {
	    context.commit('setPreview3DEnabled', payload);
	  },
	  setMapEnabled: function setMapEnabled(context, payload) {
	    if (typeof payload.enabled === 'boolean') {
	      context.commit('setMapEnabled', payload);
	    }
	  },
	  setMapInitialized: function setMapInitialized(context, payload) {
	    if (typeof payload.initialized === 'boolean') {
	      context.commit('setMapInitialized', payload);
	    }
	  },
	  setGridVisible: function setGridVisible(context, payload) {
	    if (typeof payload.visible === 'boolean') {
	      context.commit('setGridVisible', payload);
	    }
	  },
	  setSpacing: function setSpacing(context, payload) {
	    context.commit('setSpacing', payload);
	  },
	  setViewMinX: function setViewMinX(context, payload) {
	    context.commit('setViewMinX', payload);
	  },
	  setViewMinY: function setViewMinY(context, payload) {
	    context.commit('setViewMinY', payload);
	  },
	  setViewMaxX: function setViewMaxX(context, payload) {
	    var validator = new _validator2.default(payload);
	    validator.validateInt('max_x');
	
	    validator.validateMin('max_x', context.state.view.min_x);
	    context.commit('setViewMaxX', validator.validatedPayload);
	  },
	  setViewMaxY: function setViewMaxY(context, payload) {
	    var validator = new _validator2.default(payload);
	    validator.validateInt('max_y');
	
	    validator.validateMin('max_y', context.state.view.min_y);
	    context.commit('setViewMaxY', validator.validatedPayload);
	  },
	  setDimensions: function setDimensions(context, payload) {
	    var validator = new _validator2.default(payload);
	
	    validator.validateInt('max_y');
	
	    validator.validateMin('max_y', context.state.view.min_y);
	
	    validator.validateInt('max_x');
	
	    validator.validateMin('max_x', context.state.view.min_x);
	
	    context.commit('setDimensions', payload);
	  },
	  setZoom: function setZoom(context, payload) {
	    context.commit('setMapZoom', payload);
	  },
	  setMapLatitude: function setMapLatitude(context, payload) {
	    var validator = new _validator2.default(payload);
	    validator.validateFloat('latitude');
	    validator.validateMax('latitude', 180);
	    validator.validateMin('latitude', -180);
	    context.commit('setMapLatitude', validator.validatedPayload);
	  },
	  setMapLongitude: function setMapLongitude(context, payload) {
	    var validator = new _validator2.default(payload);
	    validator.validateFloat('longitude');
	    validator.validateMax('longitude', 180);
	    validator.validateMin('longitude', -180);
	    context.commit('setMapLongitude', validator.validatedPayload);
	  },
	  setMapZoom: function setMapZoom(context, payload) {
	    var validator = new _validator2.default(payload);
	    validator.validateFloat('zoom');
	    context.commit('setMapZoom', { zoom: payload.zoom });
	  },
	  setMapRotation: function setMapRotation(context, payload) {
	    context.commit('setConfigNorthAxis', { north_axis: payload.rotation / (2 * Math.PI) * 360 });
	    context.commit('setMapRotation', { rotation: payload.rotation });
	  },
	  setPreviousStoryVisible: function setPreviousStoryVisible(context, payload) {
	    context.commit('setPreviousStoryVisible', { visible: payload.visible });
	  },
	  setShowImportExport: function setShowImportExport(context, payload) {
	    context.commit('setShowImportExport', payload);
	  },
	  zoomToFit: function zoomToFit(context, _ref2) {
	    var geometry_id = _ref2.geometry_id,
	        widthOverHeight = _ref2.widthOverHeight;
	
	    context.commit('setView', { xExtent: xExtent, yExtent: yExtent });
	  },
	  modifyGround: function modifyGround(_ref3, _ref4) {
	    var state = _ref3.state,
	        commit = _ref3.commit;
	    var key = _ref4.key,
	        val = _ref4.val;
	
	    var value = +val;
	    if (isNaN(value)) {
	      value = 0;
	    }
	    if (!_lodash2.default.includes((0, _keys2.default)(state.ground), key)) {
	      console.error('unrecognized ground property "' + key + '"');
	      return;
	    }
	    if (key === 'tilt_angle' && (value < 0 || value >= 90)) {
	      window.eventBus.$emit('error', 'Tilt Angle must be in [0, 90)');
	      return;
	    }
	    commit('modifyGround', { key: key, value: value });
	  }
	};

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  snapTolerance: function snapTolerance(state) {
	    var defaultTolerance = Math.abs(state.view.max_x - state.view.min_x) * 0.025;
	    return state.grid.visible ? state.grid.spacing * 0.5 : defaultTolerance;
	  },
	  angleTolerance: function angleTolerance() {
	    return 20;
	  }
	};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(87);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  setUnits: function setUnits(state, payload) {
	    if ('units' in payload) {
	      state.config.units = payload.units;
	    }
	    if ('editable' in payload) {
	      state.config.unitsEditable = payload.editable;
	    }
	  },
	  setLanguage: function setLanguage(state, payload) {
	    if ('language' in payload) {
	      state.config.language = payload.language;
	    }
	  },
	  setConfigNorthAxis: function setConfigNorthAxis(state, payload) {
	    if ('north_axis' in payload) {
	      state.north_axis = payload.north_axis;
	    }
	  },
	  setGridVisible: function setGridVisible(state, payload) {
	    if ('visible' in payload) {
	      state.grid.visible = payload.visible;
	    }
	  },
	  setSpacing: function setSpacing(state, payload) {
	    state.grid.spacing = payload.spacing;
	  },
	  setViewMinX: function setViewMinX(state, payload) {
	    if ('min_x' in payload) {
	      state.view.min_x = payload.min_x;
	    }
	  },
	  setViewMinY: function setViewMinY(state, payload) {
	    if ('min_y' in payload) {
	      state.view.min_y = payload.min_y;
	    }
	  },
	  setViewMaxX: function setViewMaxX(state, payload) {
	    if ('max_x' in payload) {
	      state.view.max_x = payload.max_x;
	    }
	  },
	  setViewMaxY: function setViewMaxY(state, payload) {
	    if ('max_y' in payload) {
	      state.view.max_y = payload.max_y;
	    }
	  },
	  setDimensions: function setDimensions(state, payload) {
	    state.view = (0, _assign2.default)({}, state.view, payload);
	  },
	  setPreview3DEnabled: function setPreview3DEnabled(state, payload) {
	    state.preview3D.enabled = payload.enabled;
	  },
	  setMapEnabled: function setMapEnabled(state, payload) {
	    if ('enabled' in payload) {
	      state.map.enabled = payload.enabled;
	    }
	  },
	  setMapInitialized: function setMapInitialized(state, payload) {
	    if ('initialized' in payload) {
	      state.map.initialized = payload.initialized;
	    }
	  },
	  setMapVisible: function setMapVisible(state, payload) {
	    if ('visible' in payload) {
	      state.map.visible = payload.visible;
	    }
	  },
	  setMapLatitude: function setMapLatitude(state, payload) {
	    if ('latitude' in payload) {
	      state.map.latitude = payload.latitude;
	    }
	  },
	  setMapLongitude: function setMapLongitude(state, payload) {
	    if ('longitude' in payload) {
	      state.map.longitude = payload.longitude;
	    }
	  },
	  setMapZoom: function setMapZoom(state, payload) {
	    if ('zoom' in payload) {
	      state.map.zoom = payload.zoom;
	    }
	  },
	  setMapRotation: function setMapRotation(state, payload) {
	    if ('rotation' in payload) {
	      state.map.rotation = payload.rotation;
	    }
	  },
	  setPreviousStoryVisible: function setPreviousStoryVisible(state, payload) {
	    if ('visible' in payload) {
	      state.previous_story.visible = payload.visible;
	    }
	  },
	  setShowImportExport: function setShowImportExport(state, payload) {
	    state.show_import_export = payload;
	  },
	  modifyGround: function modifyGround(state, _ref) {
	    var key = _ref.key,
	        value = _ref.value;
	
	    state.ground[key] = value;
	  }
	};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(87);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _project = __webpack_require__(197);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  importState: function importState(state, payload) {
	    state.project = (0, _assign2.default)(_project2.default.state, payload.project);
	    state.application = payload.application;
	    state.models = payload.models;
	    state.geometry = payload.geometry;
	  },
	  importLibrary: function importLibrary(state, payload) {
	    state.models.library = payload;
	  },
	  changeUnits: function changeUnits(state, newState) {
	    _lodash2.default.keys(state).forEach(function (k) {
	      state[k] = newState[k];
	    });
	  }
	};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var serializeState = function serializeState(state) {
	  return (0, _stringify2.default)(state);
	};
	var filteredActions = ['application/setScaleX', 'application/setCurrentTool', 'application/setScaleY', 'project/setSpacing', 'project/setViewMinX', 'project/setViewMinY', 'project/setViewMaxX', 'project/setViewMaxY', 'project/setDimensions', 'application/clearSubSelections', 'application/setCurrentStoryId', 'application/setCurrentStory', 'application/setCurrentSpace', 'application/setCurrentShading', 'application/setCurrentImage', 'application/setCurrentSpacePropertyId', 'application/setCurrentSubSelectionType', 'project/setPreviousStoryVisible', 'project/setGridVisible', 'project/setMapLatitude', 'project/setMapLongitude', 'project/setMapRotation'];
	var permanentActions = ['importFloorplan', 'project/setMapEnabled', 'project/setMapInitialized'];
	
	var logState = function logState(state) {
	  return state;
	};
	
	exports.default = {
	  store: null,
	  pastTimetravelStates: [],
	  futureTimetravelStates: [],
	  currentlyInBatch: false,
	  triggeringAction: '(none)',
	  init: function init(store) {
	    var that = this;
	    this.store = store;
	    store.timetravel = this;
	
	    this.pastTimetravelStates = [];
	    this.futureTimetravelStates = [];
	
	    this.store.replaceState((0, _extends3.default)({}, store.state, { timetravelInitialized: true }));
	
	    var originalReplaceState = store.replaceState;
	    store.replaceState = function overrideReplaceState() {
	      if (window.api) {
	        window.api.config.onChange();
	      }
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var newState = args[0];
	
	      newState.application.scale = this.state.application.scale;
	      newState.project.view = this.state.project.view;
	      newState.project.grid = this.state.project.grid;
	      newState.project.previous_story = this.state.project.previous_story;
	
	      originalReplaceState.apply(this, args);
	    };
	    var originalCommit = store.commit;
	    store.commit = function overrideCommit() {
	      if (window.api) {
	        window.api.config.onChange();
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      originalCommit.apply(this, args);
	    };
	
	    var originalDispatch = store.dispatch;
	    store.dispatch = function overrideDispatch() {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      var action = args[0];
	
	      if (!_lodash2.default.includes(filteredActions, action)) {
	        that.maybeSaveCheckpoint(action);
	        console.log('dispatching action:', args[0]);
	      }
	
	      originalDispatch.apply(this, args);
	    };
	  },
	  maybeSaveCheckpoint: function maybeSaveCheckpoint(action) {
	    var _this = this;
	
	    if (!this.currentlyInBatch) {
	      this.saveCheckpoint(action);
	    }
	
	    this.currentlyInBatch = true;
	    clearTimeout(this.resetBatchFlag);
	    this.resetBatchFlag = setTimeout(function () {
	      _this.currentlyInBatch = false;
	    }, 0);
	  },
	  saveCheckpoint: function saveCheckpoint(action) {
	    this.pastTimetravelStates.push({
	      triggeringAction: this.triggeringAction,
	      state: serializeState(this.store.state)
	    });
	    this.triggeringAction = action;
	    console.warn('saving state');
	    this.futureTimetravelStates = [];
	    this.potentiallyRollbackCheckpoint(action);
	  },
	  potentiallyRollbackCheckpoint: function potentiallyRollbackCheckpoint(action) {
	    var prevStates = this.pastTimetravelStates;
	    var store = this.store;
	    if (_lodash2.default.includes(permanentActions, action)) {
	      this.pastTimetravelStates = [];
	      this.futureTimetravelStates = [];
	      return;
	    }
	    _lodash2.default.defer(function () {
	      while (prevStates.length > 0 && _lodash2.default.isEqual(serializeState(store.state), prevStates[prevStates.length - 1].state)) {
	        console.log('current state matches previous, so rolling back', prevStates[prevStates.length - 1].triggeringAction);
	        prevStates.pop();
	      }
	    });
	  },
	  undo: function undo() {
	    if (!this.pastTimetravelStates.length) {
	      return;
	    }
	
	    var _pastTimetravelStates = this.pastTimetravelStates.pop(),
	        replacementState = _pastTimetravelStates.state,
	        triggeringAction = _pastTimetravelStates.triggeringAction;
	
	    var newState = JSON.parse(replacementState);
	    var oldAction = this.triggeringAction;
	    this.futureTimetravelStates.push({
	      triggeringAction: this.triggeringAction,
	      state: serializeState(this.store.state)
	    });
	    this.triggeringAction = triggeringAction;
	    this.store.replaceState(newState);
	    console.log('undo', newState);
	    window.eventBus.$emit('success', 'undo ' + oldAction);
	  },
	  redo: function redo() {
	    if (!this.futureTimetravelStates.length) {
	      return;
	    }
	
	    var _futureTimetravelStat = this.futureTimetravelStates.pop(),
	        replacementState = _futureTimetravelStat.state,
	        triggeringAction = _futureTimetravelStat.triggeringAction;
	
	    var newState = JSON.parse(replacementState);
	    this.pastTimetravelStates.push({
	      state: serializeState(this.store.state),
	      triggeringAction: this.triggeringAction
	    });
	    this.triggeringAction = triggeringAction;
	    this.store.replaceState(newState);
	    window.eventBus.$emit('success', 'redo ' + triggeringAction);
	    console.log('redo', newState);
	  },
	  logTimetravel: function logTimetravel() {
	    console.log('past:', this.pastTimetravelStates.map(function (s) {
	      return logState(s);
	    }));
	    console.log('current', logState(this.store.state));
	    console.log('future:', this.futureTimetravelStates.map(function (s) {
	      return logState(s);
	    }));
	  }
	};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = exportData;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _version = __webpack_require__(361);
	
	var _version2 = _interopRequireDefault(_version);
	
	var _helpers = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatHex(val) {
	  if (!val) {
	    return null;
	  }
	  if (val.length === 4) {
	    return '#' + val[1] + val[1] + val[2] + val[2] + val[3] + val[3];
	  }
	  return val;
	}
	
	function formatObject(obj) {
	  if (_lodash2.default.isArray(obj)) {
	    return obj.map(formatObject);
	  } else if (_lodash2.default.isObject(obj)) {
	    return _lodash2.default.mapValues(obj, function (val, key) {
	      if ((key === 'id' || key.indexOf('_id') >= 0) && _lodash2.default.isNumber(val)) {
	        return String(val);
	      }
	      if (key === 'color') {
	        return formatHex(val);
	      }
	      return formatObject(val);
	    });
	  }
	  return obj;
	}
	
	function mungeWindows(windows, geometry, windowDefs) {
	  var repeatingWindowDefs = _lodash2.default.chain(windowDefs).filter({ window_definition_mode: 'Repeating Windows' }).map(function (wd) {
	    return [wd.id, wd];
	  }).fromPairs().value();
	
	  return windows.map(function (w) {
	    var def = repeatingWindowDefs[w.window_definition_id];
	    if (def) {
	      var edge = _lodash2.default.find(geometry.edges, { id: w.edge_id });
	      var centers = (0, _helpers.repeatingWindowCenters)({
	        start: _lodash2.default.find(geometry.vertices, { id: edge.vertex_ids[0] }),
	        end: _lodash2.default.find(geometry.vertices, { id: edge.vertex_ids[1] }),
	        spacing: def.window_spacing,
	        width: def.width
	      });
	      return (0, _extends3.default)({}, w, {
	        alpha: _lodash2.default.map(centers, 'alpha')
	      });
	    }
	    return w;
	  });
	}
	
	function mungeStories(stories, geometries, windowDefs) {
	  return stories.map(function (story) {
	    var geometry = JSON.parse((0, _stringify2.default)(_lodash2.default.find(geometries, { id: story.geometry_id }) || { edges: [], vertices: [], faces: [] }));
	    return (0, _extends3.default)({}, story, {
	      spaces: story.spaces,
	      geometry: geometry,
	      windows: mungeWindows(story.windows, geometry, windowDefs),
	      geometry_id: undefined
	    });
	  });
	}
	
	function exportData(state, getters) {
	  var exportObject = (0, _extends3.default)({
	    application: state.application,
	    project: state.project,
	    stories: mungeStories(state.models.stories, getters['geometry/exportData'], state.models.library.window_definitions)
	  }, state.models.library, {
	    version: _version2.default
	  });
	  return formatObject(exportObject);
	}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = colorFactory;
	
	var _appconfig = __webpack_require__(28);
	
	var _appconfig2 = _interopRequireDefault(_appconfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var typeIndices = {};
	
	function colorFactory(type) {
	  typeIndices[type] = (typeIndices[type] || 0) + 1;
	  return _appconfig2.default.palette.colors[typeIndices[type] % _appconfig2.default.palette.colors.length];
	}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextTextureForType;
	
	var _appconfig = __webpack_require__(28);
	
	var typeIndices = {};
	
	function nextTextureForType(type) {
	  typeIndices[type] = (typeIndices[type] || 0) + 1;
	  return _appconfig.textures[typeIndices[type] % _appconfig.textures.length];
	}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(56);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = importFloorplan;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _generateId = __webpack_require__(55);
	
	var _generateId2 = _interopRequireDefault(_generateId);
	
	var _factory = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function maybeUpdateProject(project) {
	  if (project.config.north_axis) {
	    project.north_axis = project.north_axis || project.config.north_axis;
	    delete project.config.north_axis;
	  }
	  project.config.units = project.config.units === 'ft' ? 'ip' : project.config.units === 'm' ? 'si' : project.config.units;
	
	  return project;
	}
	
	function withHandleProp(arr) {
	  if (!arr || !arr.length) {
	    return [];
	  }
	  return arr.map(function (obj) {
	    return (0, _extends3.default)({
	      handle: null
	    }, obj);
	  });
	}
	
	function withWindowDefinitionDefaults(arr) {
	  if (!arr || !arr.length) return [];
	  return arr.map(function (obj) {
	    return (0, _extends3.default)({}, (0, _factory.getDefaults)('WindowDefinition'), {
	      window_definition_mode: obj.window_definition_type || (0, _factory.getDefaults)('WindowDefinition').window_definition_mode
	    }, obj, {
	      window_definition_type: undefined
	    });
	  });
	}
	
	function withStoryDefaults(stories) {
	  return stories.map(function (story) {
	    var multiplier = story.multiplier >= 1 ? story.multiplier : (0, _factory.getDefaults)('Story').multiplier;
	
	    return (0, _extends3.default)({}, (0, _factory.getDefaults)('Story'), story, {
	      spaces: story.spaces.map(function (space) {
	        return (0, _extends3.default)({}, (0, _factory.getDefaults)('Space'), space);
	      }),
	      shading: withHandleProp(story.shading),
	      multiplier: multiplier
	    });
	  });
	}
	
	function importFloorplan(context, payload) {
	  if (window.api) {
	    window.versionNumber = 0;
	  }
	  var options = payload.options || {};
	
	  var geometry = payload.data.stories.map(function (story) {
	    var faces = story.geometry.faces.map(function (face) {
	      var edgeRefs = face.edge_ids.map(function (id, index) {
	        return {
	          edge_id: id,
	          reverse: !face.edge_order[index]
	        };
	      });
	      return {
	        id: face.id,
	        edgeRefs: edgeRefs
	      };
	    });
	
	    var edges = story.geometry.edges.map(function (e) {
	      return {
	        id: e.id,
	        v1: e.vertex_ids[0],
	        v2: e.vertex_ids[1]
	      };
	    });
	    return {
	      id: story.geometry.id,
	      faces: faces,
	      edges: edges,
	      vertices: story.geometry.vertices
	    };
	  });
	
	  var stories = payload.data.stories.map(function (s) {
	    var story = (0, _extends3.default)({
	      geometry_id: s.geometry.id
	    }, s);
	    delete story.geometry;
	    return story;
	  });
	
	  function forEachNestedProp(obj, func) {
	    var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    if (_lodash2.default.isObject(obj)) {
	      (0, _keys2.default)(obj).forEach(function (k) {
	        return forEachNestedProp(obj[k], func, k);
	      });
	    } else if (_lodash2.default.isArray(obj)) {
	      obj.forEach(function (elem) {
	        return forEachNestedProp(elem, func);
	      });
	    } else {
	      func(propName, obj);
	    }
	  }
	
	  var largestId = 0;
	  forEachNestedProp(payload, function (k, v) {
	    if (k && k === 'id' && +v > largestId) {
	      largestId = +v;
	    }
	  });
	
	  largestId += 1;
	  _generateId2.default.setId(largestId);
	
	  context.commit('importState', {
	    project: maybeUpdateProject(payload.data.project),
	    application: context.state.application,
	    models: {
	      stories: withStoryDefaults(stories),
	      library: {
	        building_units: withHandleProp(payload.data.building_units),
	        thermal_zones: withHandleProp(payload.data.thermal_zones),
	        space_types: withHandleProp(payload.data.space_types),
	        construction_sets: withHandleProp(payload.data.construction_sets),
	        window_definitions: withWindowDefinitionDefaults(payload.data.window_definitions),
	        daylighting_control_definitions: payload.data.daylighting_control_definitions || [],
	        pitched_roofs: (payload.data.pitched_roofs || []).map(function (pr) {
	          return (0, _extends3.default)({
	            shed_direction: null
	          }, pr);
	        }),
	        door_definitions: withHandleProp(payload.data.door_definitions)
	      }
	    },
	    geometry: geometry
	  });
	  _lodash2.default.defer(function () {
	    context.dispatch('application/setCurrentStoryId', { id: stories[0].id }, { root: true });
	
	    stories.forEach(function (story) {
	      return context.dispatch('geometry/trimGeometry', { geometry_id: story.geometry_id });
	    });
	    if (!options.noReloadGrid) {
	      _lodash2.default.defer(function () {
	        return window.eventBus.$emit('zoomToFit');
	      });
	    }
	  });
	
	  if (!options.noReloadGrid) {
	    document.getElementById('svg-grid').dispatchEvent(new Event('reloadGrid'));
	  }
	}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = importLibrary;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _generateId = __webpack_require__(55);
	
	var _generateId2 = _interopRequireDefault(_generateId);
	
	var _appconfig = __webpack_require__(28);
	
	var _unitConversion = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function importLibrary(context, payload) {
	  var count = 0;
	  _appconfig.libraryTypes.forEach(function (type) {
	    if (!payload.data[type] || !payload.data[type].length) {
	      return;
	    }
	    var existingNames = context.state.models.library[type].map(function (o) {
	      if (/_\d+[\w\s]?$/.test(o.name)) {
	        return o.name.split('_').slice(0, -1).join('_');
	      }
	      return o.name;
	    });
	    payload.data[type] = payload.data[type].map(function (obj) {
	      var importObj = obj;
	      importObj.id = _generateId2.default.generate();
	
	      var duplicateCount = existingNames.filter(function (n) {
	        return n === obj.name;
	      }).length;
	      if (duplicateCount) {
	        importObj.name += '_' + duplicateCount;
	      }
	      count += 1;
	      return importObj;
	    });
	  });
	
	  var projectSystem = context.state.project.config.units;
	  var librarySystemRaw = _lodash2.default.get(payload, 'data.project.config.units');
	  var librarySystem = librarySystemRaw === 'ft' ? 'ip' : librarySystemRaw === 'm' ? 'si' : librarySystemRaw;
	
	  if (librarySystem !== 'ip' && librarySystem !== 'si') {
	    console.warn('Expected data.project.config.units to be "ip" or "si", received "' + librarySystemRaw + '"');
	    console.warn('unable to determine units of library -- using project units');
	    librarySystem = projectSystem;
	  }
	  var localUnitsPayload = (0, _unitConversion.convertLibrary)(payload.data, librarySystem, projectSystem);
	
	  window.eventBus.$emit('success', 'Imported ' + count + ' object' + (count !== 1 ? 's' : ''));
	
	  context.commit('importLibrary', _lodash2.default.fromPairs(['building_units', 'thermal_zones', 'space_types', 'construction_sets', 'window_definitions', 'daylighting_control_definitions', 'pitched_roofs'].map(function (k) {
	    return [k, context.state.models.library[k].concat(localUnitsPayload[k] || [])];
	  })));
	}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Validator;
	function Validator(payload) {
	    var validatedPayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var invalidKeys = [];
	    return {
	        invalidKeys: invalidKeys,
	        validatedPayload: validatedPayload,
	        validateLength: function validateLength(key) {
	            var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	            if (!(key in payload) || invalidKeys.indexOf(key) !== -1) {
	                return;
	            }
	            if (key in payload && payload[key].length >= minLength) {
	                validatedPayload[key] = payload[key];
	            } else {
	                delete validatedPayload[key];
	                invalidKeys.push(key);
	            }
	        },
	        validateMin: function validateMin(key) {
	            var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	            if (!(key in payload) || invalidKeys.indexOf(key) !== -1) {
	                return;
	            }
	            if (payload[key] > min) {
	                validatedPayload[key] = payload[key];
	            } else {
	                delete validatedPayload[key];
	                invalidKeys.push(key);
	            }
	        },
	        validateMax: function validateMax(key) {
	            var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	            if (!(key in payload) || invalidKeys.indexOf(key) !== -1) {
	                return;
	            }
	            if (key in payload && payload[key] < max) {
	                validatedPayload[key] = payload[key];
	            } else {
	                delete validatedPayload[key];
	                invalidKeys.push(key);
	            }
	        },
	        validateFloat: function validateFloat(key) {
	            if (!(key in payload) || invalidKeys.indexOf(key) !== -1) {
	                return;
	            }
	            if (key in payload && !isNaN(parseFloat(payload[key]))) {
	                validatedPayload[key] = parseFloat(payload[key]);
	            } else {
	                delete validatedPayload[key];
	                invalidKeys.push(key);
	            }
	        },
	        validateInt: function validateInt(key) {
	            if (!(key in payload) || invalidKeys.indexOf(key) !== -1) {
	                return;
	            }
	            if (key in payload && !isNaN(parseInt(payload[key]))) {
	                validatedPayload[key] = parseInt(payload[key]);
	            } else {
	                delete validatedPayload[key];
	                invalidKeys.push(key);
	            }
	        },
	        validateBoolean: function validateBoolean(key) {
	            if (!(key in payload) || invalidKeys.indexOf(key) !== -1) {
	                return;
	            }
	            if (key in payload) {
	                validatedPayload[key] = !!payload[key];
	            } else {
	                delete validatedPayload[key];
	                invalidKeys.push(key);
	            }
	        }
	    };
	}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(38);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(33);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _slicedToArray2 = __webpack_require__(57);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.checkVertexList = checkVertexList;
	exports.checkFace = checkFace;
	exports.default = checkGeometry;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _helpers = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function checkVertexList(vertices) {
	  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'list of vertices';
	
	  var errors = [];
	  vertices.map(function (v, ix, a) {
	    return [a[ix === 0 ? a.length - 1 : ix - 1], a[ix], a[(ix + 1) % a.length]];
	  }).forEach(function (_ref) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
	        fst = _ref2[0],
	        snd = _ref2[1],
	        thd = _ref2[2];
	
	    if ((0, _helpers.ptsAreCollinear)(fst, snd, thd) && (0, _helpers.distanceBetweenPoints)(fst, snd) > (0, _helpers.distanceBetweenPoints)(fst, thd)) {
	      errors.push(name + ' has a backwards section (' + (0, _stringify2.default)(fst) + ' -> ' + (0, _stringify2.default)(snd) + ' -> ' + (0, _stringify2.default)(thd) + ')');
	    }
	  });
	  return errors;
	}
	
	function checkFace(face) {
	  return checkVertexList(face.vertices, 'face ' + face.id);
	}
	
	function checkGeometry(geom) {
	  var errors = [],
	      vertPos = function vertPos(v) {
	    return v.x + ':' + v.y;
	  },
	      vertPosToId = _lodash2.default.fromPairs(geom.vertices.map(function (v) {
	    return [vertPos(v), v.id];
	  })),
	      edgePos = function edgePos(e) {
	    return Math.min(+e.v1.id, +e.v2.id) + ':' + Math.max(+e.v1.id, +e.v2.id);
	  },
	      edgePosToId = _lodash2.default.fromPairs(geom.edges.map(function (e) {
	    return [edgePos(e), e.id];
	  }));
	
	  geom.vertices.forEach(function (vert) {
	    if (vert.id !== vertPosToId[vertPos(vert)]) {
	      errors.push('vertex ' + vert.id + ' is a duplicate of ' + vertPosToId[vertPos(vert)]);
	    }
	  });
	
	  geom.edges.forEach(function (edge) {
	    if (edge.v1.id === edge.v2.id || vertPos(edge.v1) === vertPos(edge.v2)) {
	      errors.push('edge ' + edge.id + ' is of length zero');
	    }
	    if (edge.id !== edgePosToId[edgePos(edge)]) {
	      errors.push('edge ' + edge.id + ' is a duplicate of ' + edgePosToId[edgePos(edge)]);
	    }
	  });
	
	  geom.faces.map(checkFace).forEach(function (errs) {
	    return errors.push.apply(errors, (0, _toConsumableArray3.default)(errs));
	  });
	
	  return errors;
	}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.brightness = brightness;
	function brightness(r, g, b) {
	
	  return (r * 299 + g * 587 + b * 114) / 1000;
	}

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = d3AwareThrottle;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var d3 = __webpack_require__(85);
	var d3Selection = __webpack_require__(73);
	
	function d3Debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      lastD3Event,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError('Expected a function');
	  }
	  wait = _lodash2.default.toNumber(wait) || 0;
	  if (_lodash2.default.isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? Math.max(_lodash2.default.toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis,
	        saveD3Event = d3.event;
	
	    d3Selection.event = lastD3Event;
	    lastD3Event = lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    d3Selection.event = saveD3Event;
	    return result;
	  }
	
	  function leadingEdge(time) {
	    lastInvokeTime = time;
	
	    timerId = setTimeout(timerExpired, wait);
	
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? Math.min(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
	  }
	
	  function timerExpired() {
	    var time = _lodash2.default.now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastD3Event = lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastD3Event = lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(_lodash2.default.now());
	  }
	
	  function debounced() {
	    var time = _lodash2.default.now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	    lastD3Event = d3.event;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	function d3AwareThrottle(func, wait) {
	  return d3Debounce(func, wait, {
	    leading: true,
	    trailing: true,
	    maxWait: wait
	  });
	}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _freeze = __webpack_require__(367);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _isFrozen = __webpack_require__(368);
	
	var _isFrozen2 = _interopRequireDefault(_isFrozen);
	
	exports.default = deepFreeze;
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deepFreeze(obj) {
	  _lodash2.default.forOwn(obj, function (value) {
	    if (_lodash2.default.isObject(value)) {
	      deepFreeze(value);
	    }
	  });
	
	  if (!(0, _isFrozen2.default)(obj)) {
	    (0, _freeze2.default)(obj);
	  }
	  return obj;
	}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '0.7.0';

/***/ }),
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(693)
	__webpack_require__(694)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(301),
	  /* template */
	  __webpack_require__(762),
	  /* scopeId */
	  "data-v-c1b60834",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(673)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(302),
	  /* template */
	  __webpack_require__(737),
	  /* scopeId */
	  "data-v-031586be",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(681)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(303),
	  /* template */
	  __webpack_require__(745),
	  /* scopeId */
	  "data-v-3d99eee3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(304),
	  /* template */
	  __webpack_require__(747),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(678)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(305),
	  /* template */
	  __webpack_require__(742),
	  /* scopeId */
	  "data-v-306f4abb",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(688)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(306),
	  /* template */
	  __webpack_require__(755),
	  /* scopeId */
	  "data-v-746cecc8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(683)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(307),
	  /* template */
	  __webpack_require__(748),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(308),
	  /* template */
	  __webpack_require__(750),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(692)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(310),
	  /* template */
	  __webpack_require__(761),
	  /* scopeId */
	  "data-v-a8e9dfbe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(311),
	  /* template */
	  __webpack_require__(749),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(691)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(312),
	  /* template */
	  __webpack_require__(759),
	  /* scopeId */
	  "data-v-987d60e8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(687)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(313),
	  /* template */
	  __webpack_require__(754),
	  /* scopeId */
	  "data-v-73ec12ee",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(314),
	  /* template */
	  __webpack_require__(760),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(676)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(316),
	  /* template */
	  __webpack_require__(740),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(695)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(317),
	  /* template */
	  __webpack_require__(763),
	  /* scopeId */
	  "data-v-d56d6c28",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(680)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(319),
	  /* template */
	  __webpack_require__(744),
	  /* scopeId */
	  "data-v-3c3490f3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(677)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(320),
	  /* template */
	  __webpack_require__(741),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(685)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(321),
	  /* template */
	  __webpack_require__(752),
	  /* scopeId */
	  "data-v-64bc751c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(689)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(322),
	  /* template */
	  __webpack_require__(756),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(324),
	  /* template */
	  __webpack_require__(757),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(679)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(325),
	  /* template */
	  __webpack_require__(743),
	  /* scopeId */
	  "data-v-309036ee",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(684)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(326),
	  /* template */
	  __webpack_require__(751),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(682)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(327),
	  /* template */
	  __webpack_require__(746),
	  /* scopeId */
	  "data-v-40563b8d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "canvas",
	    attrs: {
	      "id": "canvas"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "id": "north_axis",
	      "height": "1792",
	      "viewBox": "0 0 1792 1792",
	      "width": "1792",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "transform": ("rotate(" + _vm.northAxis + ")")
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M1277 493q-9 19-29 19h-224v1248q0 14-9 23t-23 9H800q-14 0-23-9t-9-23V512H544q-21 0-29-19t5-35L870 74q10-10 23-10 14 0 24 10l355 384q13 16 5 35z"
	    }
	  })]), _vm._v(" "), (_vm.mapEnabled) ? _c('map-view', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mapVisible),
	      expression: "mapVisible"
	    }]
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.col.readonly || !_vm.col.input_type) ? _c('span', {
	    class: {
	      numeric: _vm.col.numeric
	    }
	  }, [_vm._v("\n  " + _vm._s(_vm.value) + "\n")]) : (_vm.col.input_type === 'text') ? _c('input', {
	    class: {
	      numeric: _vm.col.numeric
	    },
	    attrs: {
	      "disabled": _vm.disabled,
	      "placeholder": _vm.col.nullable && _vm.row[_vm.col.name] === null ? '(none)' : null
	    },
	    domProps: {
	      "value": _vm.value
	    },
	    on: {
	      "keydown": _vm.blurOnEnter,
	      "blur": function($event) {
	        _vm.onChange($event.target.value);
	        _vm.$forceUpdate()
	      }
	    }
	  }) : (_vm.col.input_type === 'color') ? _c('div', {
	    staticClass: "color-wrapper"
	  }, [_c('input', {
	    staticClass: "input-color",
	    style: (_vm.colorStyles),
	    attrs: {
	      "disabled": _vm.disabled,
	      "readonly": ""
	    },
	    domProps: {
	      "value": _vm.row[_vm.col.name]
	    },
	    on: {
	      "click": function($event) {
	        _vm.showColorModal = true
	      }
	    }
	  }), _vm._v(" "), (_vm.showColorModal) ? _c('ColorPickerModal', {
	    attrs: {
	      "value": _vm.row[_vm.col.name]
	    },
	    on: {
	      "close": function($event) {
	        _vm.showColorModal = false
	      },
	      "change": _vm.onChange
	    }
	  }) : _vm._e()], 1) : (_vm.col.input_type === 'select') ? _c('pretty-select', {
	    attrs: {
	      "options": _vm.selectData,
	      "value": _vm.row[_vm.col.name],
	      "disabled": _vm.disabled
	    },
	    on: {
	      "change": function (val) { return _vm.onChange(val); }
	    }
	  }) : (_vm.col.input_type === 'texture') ? _c('TextureSelect', {
	    attrs: {
	      "value": _vm.row[_vm.col.name],
	      "disabled": _vm.disabled
	    },
	    on: {
	      "change": function (val) { return _vm.onChange(val); }
	    }
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('aside', [_c('div', {
	    staticClass: "overlay",
	    on: {
	      "click": _vm.close
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "modal"
	  }, [_c('span', [_c('svg', {
	    staticClass: "close-button",
	    attrs: {
	      "viewBox": "0 0 256 256",
	      "xmlns": "http://www.w3.org/2000/svg"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M137.05 128l75.476-75.475c2.5-2.5 2.5-6.55 0-9.05s-6.55-2.5-9.05 0L128 118.948 52.525 43.474c-2.5-2.5-6.55-2.5-9.05 0s-2.5 6.55 0 9.05L118.948 128l-75.476 75.475c-2.5 2.5-2.5 6.55 0 9.05 1.25 1.25 2.888 1.876 4.525 1.876s3.274-.624 4.524-1.874L128 137.05l75.475 75.476c1.25 1.25 2.888 1.875 4.525 1.875s3.275-.624 4.525-1.874c2.5-2.5 2.5-6.55 0-9.05L137.05 128z"
	    }
	  })])]), _vm._v(" "), _c('header', [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_vm._t("default")], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "color-picker-modal"
	  }, [_c('div', {
	    staticClass: "modal-mask"
	  }, [_c('div', {
	    staticClass: "modal-wrapper",
	    on: {
	      "click": function($event) {
	        _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-container",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-body"
	  }, [_c('swatches', {
	    attrs: {
	      "inline": "",
	      "show-fallback": ""
	    },
	    model: {
	      value: (_vm.color),
	      callback: function($$v) {
	        _vm.color = $$v
	      },
	      expression: "color"
	    }
	  })], 1)])])])])])
	},staticRenderFns: []}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ModalBase', {
	    staticClass: "settings-modal",
	    attrs: {
	      "title": "Settings"
	    },
	    on: {
	      "close": function($event) {
	        _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "settings"
	  }, [_c('p', [_c('label', {
	    staticClass: "input-text"
	  }, [_vm._v("\n        North Axis\n        "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number.lazy",
	      value: (_vm.northAxis),
	      expression: "northAxis",
	      modifiers: {
	        "number": true,
	        "lazy": true
	      }
	    }],
	    attrs: {
	      "type": "text",
	      "disabled": _vm.mapEnabled
	    },
	    domProps: {
	      "value": (_vm.northAxis)
	    },
	    on: {
	      "change": function($event) {
	        _vm.northAxis = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])]), _vm._v(" "), _c('ExpandableDrawer', {
	    staticClass: "ground-props-drawer",
	    attrs: {
	      "title": "Ground Properties"
	    }
	  }, [_c('p', [_c('label', {
	    staticClass: "input-text"
	  }, [_vm._v("\n          Floor Offset\n          "), _c('Info', [_vm._v("\n            Specifies the vertical offset between the building floor and the ground plane.\n            Use a value < 0 for buildings with below-grade spaces, or a value > 0 for,\n            e.g., buildings on piers.\n          ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.floor_offset),
	      expression: "floor_offset"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.floor_offset)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.floor_offset = $event.target.value
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('p', [_c('label', {
	    staticClass: "input-text"
	  }, [_vm._v("\n          Azimuth Angle\n          "), _c('Info', [_vm._v("\n            Direction of the ground plane, in clockwise degrees from the\n            positive y-axis when viewed from above.\n          ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.azimuth_angle),
	      expression: "azimuth_angle"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.azimuth_angle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.azimuth_angle = $event.target.value
	      }
	    }
	  })], 1)]), _vm._v(" "), _c('p', [_c('label', {
	    staticClass: "input-text"
	  }, [_vm._v("\n          Tilt Slope\n          "), _c('Info', [_vm._v("\n            Slope of the ground plane from horizontal. For example, a value of 1 implies a 45° angle.\n          ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tilt_slope),
	      expression: "tilt_slope"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.tilt_slope)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tilt_slope = $event.target.value
	      }
	    }
	  })], 1)])]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.$emit('close')
	      }
	    }
	  }, [_vm._v("Okay")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "edit-bar"
	  }, [_vm._l((_vm.columns), function(col) {
	    return _c('span', {
	      key: col.name,
	      attrs: {
	        "data-column": col.name
	      }
	    }, [_c('GenericInput', {
	      attrs: {
	        "col": col,
	        "row": _vm.row,
	        "onChange": _vm.updateRow.bind(null, _vm.row.id, col.name)
	      }
	    })], 1)
	  }), _vm._v(" "), _c('span', {
	    staticClass: "destroy",
	    on: {
	      "click": function($event) {
	        _vm.destroy()
	      }
	    }
	  }, [_c('Delete', {
	    staticClass: "button"
	  })], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "input-select"
	  }, [(!_vm.disabled) ? _c('button', {
	    class: ("texture-" + _vm.value),
	    on: {
	      "click": function($event) {
	        _vm.open = !_vm.open
	      },
	      "blur": function($event) {
	        _vm.open = false
	      }
	    }
	  }, [_c('span', {
	    staticClass: "svg-background"
	  }), _vm._v(" "), _c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 13 14",
	      "height": "10px"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M.5 0v14l11-7-11-7z",
	      "transform": "translate(13) rotate(90)"
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.open) ? _c('Portal', {
	    attrs: {
	      "to": "texture-options"
	    }
	  }, [_c('ul', {
	    style: (_vm.ulStyle())
	  }, _vm._l((_vm.textures), function(texture) {
	    return _c('li', {
	      key: texture,
	      class: ( _obj = {
	        selected: texture === _vm.value,
	      }, _obj[("texture-" + texture)] = true, _obj ),
	      on: {
	        "mousedown": function($event) {
	          _vm.choose(texture)
	        }
	      }
	    })
	    var _obj;
	  }))]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ModalBase', {
	    staticClass: "save-as-modal",
	    attrs: {
	      "title": "Save Floorplan As"
	    },
	    on: {
	      "close": function($event) {
	        _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "grid-container"
	  }, [(_vm.enable3DPreview) ? _c('div', {
	    staticClass: "export-label"
	  }, [_vm._v("Export Format:")]) : _vm._e(), _vm._v(" "), (_vm.enable3DPreview) ? _c('div', {
	    staticClass: "export-input"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.exportType),
	      expression: "exportType"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "export-input-floorspace",
	      "value": "floorspace"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.exportType, "floorspace")
	    },
	    on: {
	      "change": function($event) {
	        _vm.exportType = "floorspace"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "export-input-floorspace"
	    }
	  }, [_vm._v("Floorspace.js")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.exportType),
	      expression: "exportType"
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "export-input-threejs",
	      "value": "threejs"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.exportType, "threejs")
	    },
	    on: {
	      "change": function($event) {
	        _vm.exportType = "threejs"
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "export-input-threejs"
	    }
	  }, [_vm._v("ThreeJS")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "filename-label"
	  }, [_vm._v("Filename:")]), _vm._v(" "), _c('div', {
	    staticClass: "filename-input"
	  }, [_c('input', {
	    ref: "downloadName",
	    attrs: {
	      "type": "text",
	      "id": "download-name",
	      "spellcheck": "false"
	    },
	    domProps: {
	      "value": _vm.floorplan
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.downloadFile($event)
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "download-button",
	    on: {
	      "click": _vm.downloadFile
	    }
	  }, [_vm._v("Download")])])])
	},staticRenderFns: []}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "map-container"
	    }
	  }, [_c('div', {
	    ref: "map",
	    style: ({
	      'pointer-events': _vm.tool === 'Map' ? 'all' : 'none'
	    }),
	    attrs: {
	      "id": "map"
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.tool === 'Map'),
	      expression: "tool === 'Map'"
	    }],
	    attrs: {
	      "id": "autocomplete"
	    }
	  }, [_c('span', {
	    staticClass: "input-text"
	  }, [_c('input', {
	    ref: "addressSearch",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search for a location"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.tool === 'Map'),
	      expression: "tool === 'Map'"
	    }],
	    attrs: {
	      "id": "help-text"
	    }
	  }, [_c('p', [_vm._v("Drag the map and/or search to set desired location.  Use alt+shift to rotate the north axis. Click 'Done' when finished.")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": _vm.finishSetup
	    }
	  }, [_vm._v("Done")])]), _vm._v(" "), (_vm.mapModalVisible && !_vm.mapInitialized) ? _c('map-modal', {
	    on: {
	      "close": function($event) {
	        _vm.mapModalVisible = false;
	        _vm.showReticle()
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('svg', {
	    attrs: {
	      "id": "reticle"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    attrs: {
	      "id": "toolbar"
	    }
	  }, [_c('section', {
	    attrs: {
	      "id": "top"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "navigation-head"
	    }
	  }, [(_vm.showImportExport) ? _c('div', {
	    staticClass: "import-export-buttons"
	  }, [_c('input', {
	    ref: "importLibrary",
	    attrs: {
	      "type": "file"
	    },
	    on: {
	      "change": function($event) {
	        _vm.importDataAsFile($event, 'library')
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    ref: "importInput",
	    attrs: {
	      "type": "file"
	    },
	    on: {
	      "change": function($event) {
	        _vm.importDataAsFile($event, 'floorplan')
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "title": "Open Floorplan"
	    }
	  }, [_c('open-floorplan-svg', {
	    staticClass: "button",
	    attrs: {
	      "id": "import"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.$refs.importInput.click()
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    attrs: {
	      "title": "Save Floorplan"
	    }
	  }, [_c('save-floorplan-svg', {
	    staticClass: "button",
	    attrs: {
	      "id": "export"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.exportData($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    attrs: {
	      "title": "Import Library"
	    }
	  }, [_c('import-library-svg', {
	    staticClass: "button",
	    nativeOn: {
	      "click": function($event) {
	        _vm.$refs.importLibrary.click()
	      }
	    }
	  })], 1), _vm._v(" "), (_vm.enable3DPreview) ? _c('div', {
	    attrs: {
	      "title": "Open 3D Previewer"
	    }
	  }, [_c('globe-icon-svg', {
	    staticClass: "button",
	    nativeOn: {
	      "click": function($event) {
	        _vm.open3DPreviewer($event)
	      }
	    }
	  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "undo-redo"
	    }
	  }, [_c('div', {
	    attrs: {
	      "title": "undo"
	    }
	  }, [_c('undo-svg', {
	    staticClass: "button",
	    class: {
	      'disabled': !_vm.timetravelInitialized
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.undo($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    attrs: {
	      "title": "redo"
	    }
	  }, [_c('redo-svg', {
	    staticClass: "button",
	    class: {
	      'disabled': !_vm.timetravelInitialized
	    },
	    attrs: {
	      "disabled": !_vm.timetravelInitialized
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.redo($event)
	      }
	    }
	  })], 1)])]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "id": "mode-tabs"
	    }
	  }, [_c('li', {
	    staticClass: "tab",
	    class: {
	      active: _vm.modeTab === 'floorplan'
	    },
	    attrs: {
	      "data-modetab": "floorplan"
	    },
	    on: {
	      "click": function($event) {
	        _vm.modeTab = 'floorplan'
	      }
	    }
	  }, [_c('span', [_vm._v("\n          Floorplan\n          "), _c('tab-floorplan-svg', {
	    staticClass: "icon"
	  })], 1)]), _vm._v(" "), _c('li', {
	    staticClass: "tab",
	    class: {
	      active: _vm.modeTab === 'assign'
	    },
	    on: {
	      "click": function($event) {
	        _vm.modeTab = 'assign'
	      }
	    }
	  }, [_c('span', [_vm._v("\n          Assignments\n          "), _c('tab-assign-svg', {
	    staticClass: "icon"
	  })], 1)]), _vm._v(" "), _c('li', {
	    staticClass: "tab",
	    class: {
	      active: _vm.modeTab === 'components'
	    },
	    attrs: {
	      "data-modetab": "components"
	    },
	    on: {
	      "click": function($event) {
	        _vm.modeTab = 'components'
	      }
	    }
	  }, [_c('span', [_vm._v("\n          Components\n          "), _c('tool-component-svg', {
	    staticClass: "icon"
	  })], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "grid-settings"
	    }
	  }, [_c('div', {
	    staticClass: "input-checkbox"
	  }, [_c('label', [_vm._v("Story Below")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.previousStoryVisible),
	      expression: "previousStoryVisible"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.previousStoryVisible) ? _vm._i(_vm.previousStoryVisible, null) > -1 : (_vm.previousStoryVisible)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.previousStoryVisible,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.previousStoryVisible = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.previousStoryVisible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.previousStoryVisible = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), (_vm.mapEnabled) ? _c('div', {
	    staticClass: "input-checkbox"
	  }, [_c('label', [_vm._v("map")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mapVisible),
	      expression: "mapVisible"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.mapVisible) ? _vm._i(_vm.mapVisible, null) > -1 : (_vm.mapVisible)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.mapVisible,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.mapVisible = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.mapVisible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.mapVisible = $$c
	        }
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "input-checkbox"
	  }, [_c('label', [_vm._v("grid")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.gridVisible),
	      expression: "gridVisible"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.gridVisible) ? _vm._i(_vm.gridVisible, null) > -1 : (_vm.gridVisible)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.gridVisible,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.gridVisible = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.gridVisible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.gridVisible = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "input-number"
	  }, [_c('label', [_vm._v("spacing")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number.lazy",
	      value: (_vm.spacing),
	      expression: "spacing",
	      modifiers: {
	        "number": true,
	        "lazy": true
	      }
	    }],
	    domProps: {
	      "value": (_vm.spacing)
	    },
	    on: {
	      "change": function($event) {
	        _vm.spacing = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  }), _vm._v(" "), (!_vm.allowSettingUnits) ? _c('label', [_vm._v(_vm._s(_vm.rwUnits))]) : _vm._e()]), _vm._v(" "), (_vm.allowSettingUnits) ? _c('PrettySelect', {
	    ref: "unitsSelect",
	    attrs: {
	      "options": ['ft', 'm'],
	      "value": _vm.rwUnits
	    },
	    on: {
	      "change": _vm.updateUnits
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "title": "settings"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showGroundPropsModal = true
	      }
	    }
	  }, [_c('SettingsGear', {
	    staticClass: "button"
	  })], 1)], 1)]), _vm._v(" "), _c('section', {
	    class: _vm.modeTab,
	    attrs: {
	      "id": "bottom"
	    }
	  }, [(_vm.modeTab === 'floorplan') ? [_c('div', {
	    attrs: {
	      "id": "instructions"
	    }
	  }, [_vm._v("Draw a floorplan and import images")]), _vm._v(" "), _c('div', {
	    staticClass: "tools-list tools",
	    attrs: {
	      "id": "drawing-tools"
	    }
	  }, [_c('div', {
	    class: {
	      active: _vm.tool === 'Rectangle'
	    },
	    attrs: {
	      "data-tool": "Rectangle",
	      "title": "Rectangle"
	    },
	    on: {
	      "click": function($event) {
	        _vm.tool = 'Rectangle'
	      }
	    }
	  }, [_c('tool-draw-rectangle-svg', {
	    staticClass: "button"
	  })], 1), _vm._v(" "), _c('div', {
	    class: {
	      active: _vm.tool === 'Polygon'
	    },
	    attrs: {
	      "data-tool": "Polygon",
	      "title": "Polygon"
	    },
	    on: {
	      "click": function($event) {
	        _vm.tool = 'Polygon'
	      }
	    }
	  }, [_c('tool-draw-polygon-svg', {
	    staticClass: "button"
	  })], 1), _vm._v(" "), _c('div', {
	    class: {
	      active: _vm.tool === 'Fill'
	    },
	    attrs: {
	      "data-tool": "Fill",
	      "title": "Fill"
	    },
	    on: {
	      "click": function($event) {
	        _vm.tool = 'Fill'
	      }
	    }
	  }, [_c('tool-fill-svg', {
	    staticClass: "button"
	  })], 1), _vm._v(" "), _c('div', {
	    class: {
	      active: _vm.tool === 'Eraser'
	    },
	    attrs: {
	      "data-tool": "Eraser",
	      "title": "Eraser"
	    },
	    on: {
	      "click": function($event) {
	        _vm.tool = 'Eraser'
	      }
	    }
	  }, [_c('tool-erase-svg', {
	    staticClass: "button"
	  })], 1), _vm._v(" "), _c('div', {
	    class: {
	      active: _vm.tool === 'Image'
	    },
	    attrs: {
	      "data-tool": "Image",
	      "title": "Image"
	    },
	    on: {
	      "click": _vm.setImageTool
	    }
	  }, [_c('tool-image-svg', {
	    staticClass: "button"
	  })], 1)])] : _vm._e(), _vm._v(" "), (_vm.modeTab === 'components') ? [_c('div', {
	    attrs: {
	      "id": "instructions"
	    }
	  }, [(!_vm.currentComponentDefinition) ? _c('span', [_vm._v("Add fenestration, daylighting, and PV")]) : _c('span', [_vm._v("Click to place a " + _vm._s(_vm.currentComponentDefinition.name))])]), _vm._v(" "), _c('ComponentInstanceEditBar')] : _vm._e(), _vm._v(" "), (_vm.modeTab === 'assign') ? [_c('div', {
	    attrs: {
	      "id": "instructions"
	    }
	  }, [_vm._v("Assign thermal zones, etc, to spaces")])] : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "grid-tools"
	    }
	  }, [_c('RenderByDropdown'), _vm._v(" "), _c('div', {
	    attrs: {
	      "title": "zoom to fit"
	    }
	  }, [_c('ZoomToFitSvg', {
	    staticClass: "button",
	    nativeOn: {
	      "click": function($event) {
	        _vm.zoomToFit($event)
	      }
	    }
	  })], 1)], 1)], 2), _vm._v(" "), _c('section', {
	    staticClass: "modals"
	  }, [(_vm.showSaveModal) ? _c('SaveAsModal', {
	    on: {
	      "close": function () {
	        _vm.showSaveModal = false;
	      }
	    }
	  }) : (_vm.showGroundPropsModal) ? _c('Settings', {
	    on: {
	      "close": function($event) {
	        _vm.showGroundPropsModal = false
	      }
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('span')])
	}]}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showInstanceEditor) ? _c('EditBar', {
	    attrs: {
	      "row": _vm.componentInstance,
	      "columns": _vm.visibleColumns,
	      "updateRow": _vm.modifyComponentInstance,
	      "destroy": _vm.destroyComponent
	    }
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "editable-table"
	  }, [_c('el-table', {
	    attrs: {
	      "data": _vm.sortedRows,
	      "height": "calc(50vh - 105px)",
	      "empty-text": "No data"
	    },
	    on: {
	      "sort-change": _vm.sortChange
	    }
	  }, [_c('TableColumn', {
	    staticClass: "select",
	    attrs: {
	      "prop": "select",
	      "label": "",
	      "width": "35",
	      "fixed": true
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "select",
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.selectRow(scope.row)
	            }
	          }
	        }, [_c('input', {
	          attrs: {
	            "type": "radio"
	          },
	          domProps: {
	            "checked": _vm.selectedItemId === scope.row.id
	          }
	        })])]
	      }
	    }])
	  }), _vm._v(" "), _vm._l((_vm.visibleColumns), function(col) {
	    return _c('TableColumn', {
	      key: col.name,
	      attrs: {
	        "data-column": col.name,
	        "prop": col.name,
	        "label": col.displayName,
	        "class-name": ("column__" + (col.name)),
	        "width": "154",
	        "fixed": col.name == 'name',
	        "sortable": "custom"
	      },
	      scopedSlots: _vm._u([{
	        key: "default",
	        fn: function(scope) {
	          return [_c('generic-input', {
	            attrs: {
	              "col": col,
	              "row": scope.row,
	              "onChange": _vm.updateRow.bind(null, scope.row.id, col.name)
	            }
	          })]
	        }
	      }])
	    })
	  }), _vm._v(" "), _c('TableColumn', {
	    staticClass: "duplicate",
	    attrs: {
	      "prop": "duplicate",
	      "label": "",
	      "width": "35"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "duplicate",
	          attrs: {
	            "title": "duplicate"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.duplicateRow(scope.row)
	            }
	          }
	        }, [_c('Copy', {
	          staticClass: "button"
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('TableColumn', {
	    staticClass: "destroy",
	    attrs: {
	      "prop": "destroy",
	      "label": "",
	      "width": "35"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('div', {
	          staticClass: "destroy",
	          attrs: {
	            "title": "delete"
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.deleteRow(scope.row)
	            }
	          }
	        }, [_c('Delete', {
	          staticClass: "button"
	        })], 1)]
	      }
	    }])
	  })], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    ref: "imageInput",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "file",
	      "accept": "image/jpeg,image/png,image/svg,image/gif",
	      "id": "upload-image-input"
	    },
	    on: {
	      "change": _vm.uploadImage
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'expandable-drawer': true,
	      expanded: _vm.expanded,
	    }
	  }, [_c('p', {
	    staticClass: "title",
	    on: {
	      "click": function($event) {
	        _vm.expanded = !_vm.expanded
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.caret) + " " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), (_vm.expanded) ? _c('p', [_vm._t("default")], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    attrs: {
	      "id": "pattern-defs"
	    }
	  }, [_c('defs', [_vm._l((_vm.modifiers), function(color, modifier) {
	    return [_c('pattern', {
	      attrs: {
	        "id": ("circles-2" + modifier),
	        "patternUnits": "userSpaceOnUse",
	        "width": "5",
	        "height": "5"
	      }
	    }, [_c('rect', {
	      attrs: {
	        "width": "5",
	        "height": "5",
	        "fill": "#fff",
	        "fill-opacity": "0.7"
	      }
	    }), _vm._v(" "), _c('circle', {
	      attrs: {
	        "cx": "1.5",
	        "cy": "1.5",
	        "r": "1.5",
	        "fill": color
	      }
	    })]), _vm._v(" "), _c('pattern', {
	      attrs: {
	        "id": ("circles-5" + modifier),
	        "patternUnits": "userSpaceOnUse",
	        "width": "9",
	        "height": "9"
	      }
	    }, [_c('rect', {
	      attrs: {
	        "width": "9",
	        "height": "9",
	        "fill": "#fff",
	        "fill-opacity": "0.7"
	      }
	    }), _vm._v(" "), _c('circle', {
	      attrs: {
	        "cx": "3",
	        "cy": "3",
	        "r": "3",
	        "fill": color
	      }
	    })]), _vm._v(" "), _c('pattern', {
	      attrs: {
	        "id": ("circles-8" + modifier),
	        "patternUnits": "userSpaceOnUse",
	        "width": "10",
	        "height": "10"
	      }
	    }, [_c('rect', {
	      attrs: {
	        "width": "10",
	        "height": "10",
	        "fill": "#fff",
	        "fill-opacity": "0.7"
	      }
	    }), _vm._v(" "), _c('circle', {
	      attrs: {
	        "cx": "4.5",
	        "cy": "4.5",
	        "r": "4.5",
	        "fill": color
	      }
	    })]), _vm._v(" "), _c('pattern', {
	      attrs: {
	        "id": ("diagonal-stripe-1" + modifier),
	        "patternUnits": "userSpaceOnUse",
	        "width": "10",
	        "height": "10"
	      }
	    }, [_c('rect', {
	      attrs: {
	        "width": "10",
	        "height": "10",
	        "fill": "#fff",
	        "fill-opacity": "0.7"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M-1,1 l2,-2\n                 M0,10 l10,-10\n                 M9,11 l2,-2",
	        "stroke": color,
	        "stroke-width": "1"
	      }
	    })]), _vm._v(" "), _c('pattern', {
	      attrs: {
	        "id": ("diagonal-stripe-4" + modifier),
	        "patternUnits": "userSpaceOnUse",
	        "width": "10",
	        "height": "10"
	      }
	    }, [_c('rect', {
	      attrs: {
	        "width": "10",
	        "height": "10",
	        "fill": "#fff",
	        "fill-opacity": "0.7"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M-1,1 l2,-2\n                 M0,10 l10,-10\n                 M9,11 l2,-2",
	        "stroke": color,
	        "stroke-width": "3"
	      }
	    })]), _vm._v(" "), _c('pattern', {
	      attrs: {
	        "id": ("diagonal-stripe-6" + modifier),
	        "patternUnits": "userSpaceOnUse",
	        "width": "10",
	        "height": "10"
	      }
	    }, [_c('rect', {
	      attrs: {
	        "width": "10",
	        "height": "10",
	        "fill": color
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M-1,1 l2,-2\n                 M0,10 l10,-10\n                 M9,11 l2,-2",
	        "stroke": "white",
	        "stroke-width": "1"
	      }
	    })]), _vm._v(" "), _c('pattern', {
	      attrs: {
	        "id": ("dots-5" + modifier),
	        "patternUnits": "userSpaceOnUse",
	        "width": "10",
	        "height": "10"
	      }
	    }, [_c('rect', {
	      attrs: {
	        "width": "10",
	        "height": "10",
	        "fill": "#fff",
	        "fill-opacity": "0.7"
	      }
	    }), _vm._v(" "), _c('rect', {
	      attrs: {
	        "x": "0",
	        "y": "0",
	        "width": "5",
	        "height": "5",
	        "fill": color
	      }
	    })]), _vm._v(" "), _c('pattern', {
	      attrs: {
	        "id": ("dots-8" + modifier),
	        "patternUnits": "userSpaceOnUse",
	        "width": "10",
	        "height": "10"
	      }
	    }, [_c('rect', {
	      attrs: {
	        "width": "10",
	        "height": "10",
	        "fill": "#fff",
	        "fill-opacity": "0.7"
	      }
	    }), _vm._v(" "), _c('rect', {
	      attrs: {
	        "x": "0",
	        "y": "0",
	        "width": "8",
	        "height": "8",
	        "fill": color
	      }
	    })]), _vm._v(" "), _c('pattern', {
	      attrs: {
	        "id": ("crosshatch" + modifier),
	        "patternUnits": "userSpaceOnUse",
	        "width": "8",
	        "height": "8"
	      }
	    }, [_c('rect', {
	      attrs: {
	        "width": "8",
	        "height": "8",
	        "fill": "#fff",
	        "fill-opacity": "0.7"
	      }
	    }), _vm._v(" "), _c('path', {
	      attrs: {
	        "d": "M0 0L8 8ZM8 0L0 8Z",
	        "stroke-width": "0.5",
	        "stroke": color,
	        "stroke-opacity": "0.8"
	      }
	    })]), _vm._v(" "), _c('pattern', {
	      attrs: {
	        "id": ("vertical-line" + modifier),
	        "patternUnits": "userSpaceOnUse",
	        "width": "4",
	        "height": "49"
	      }
	    }, [_c('rect', {
	      attrs: {
	        "width": "4",
	        "height": "50",
	        "fill": "#fff",
	        "fill-opacity": "0.8"
	      }
	    }), _vm._v(" "), _c('rect', {
	      attrs: {
	        "width": "2",
	        "height": "50",
	        "fill": "#fff",
	        "fill-opacity": "0.5"
	      }
	    }), _vm._v(" "), _c('rect', {
	      attrs: {
	        "x": "2",
	        "width": "1",
	        "height": "50",
	        "fill": color,
	        "fill-opacity": "0.5"
	      }
	    })])]
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "layout-navigation"
	    }
	  }, [_c('nav', {
	    attrs: {
	      "id": "navigation"
	    }
	  }, [_c('section', {
	    attrs: {
	      "id": "selections"
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "list"
	    }
	  }, [_c('Library', {
	    attrs: {
	      "objectTypes": ['stories'],
	      "mode": 'stories',
	      "compact": _vm.libraryExpanded !== 'stories'
	    },
	    on: {
	      "toggleCompact": function($event) {
	        _vm.libraryExpanded = (_vm.libraryExpanded === 'stories' ? false : 'stories')
	      }
	    }
	  }), _vm._v(" "), _c('Library', {
	    attrs: {
	      "addNewOnHotkey": "true",
	      "objectTypes": _vm.objectTypesForTab,
	      "mode": _vm.subselectionType,
	      "searchAvailable": true,
	      "compact": _vm.libraryExpanded !== 'subselection'
	    },
	    on: {
	      "changeMode": function (newMode) {
	        _vm.subselectionType = newMode;
	      },
	      "toggleCompact": function($event) {
	        _vm.libraryExpanded = (_vm.libraryExpanded === 'subselection' ? false : 'subselection')
	      }
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "library-select"
	  }, [_c('div', {
	    staticClass: "rows"
	  }, _vm._l((_vm.rows), function(item) {
	    return _c('div', {
	      key: item.id,
	      class: {
	        active: _vm.selectedItemId === item.id
	      },
	      attrs: {
	        "data-id": item.id
	      },
	      on: {
	        "click": function($event) {
	          _vm.selectItem(item)
	        }
	      }
	    }, [_c('span', {
	      style: ({
	        'background-color': item.color
	      })
	    }), _vm._v("\n        " + _vm._s(item.name) + "\n        "), _c('div', {
	      staticClass: "buttons"
	    }, [_c('a', {
	      staticClass: "duplicate",
	      attrs: {
	        "title": "duplicate"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          _vm.duplicateRow(item)
	        }
	      }
	    }, [_c('Copy', {
	      staticClass: "button"
	    })], 1), _vm._v(" "), _c('a', {
	      staticClass: "destroy",
	      attrs: {
	        "title": "delete"
	      },
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          _vm.destroyItem(item)
	        }
	      }
	    }, [_c('Delete', {
	      staticClass: "button"
	    })], 1)])])
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "inspector"
	    }
	  }, [_c('section', {
	    staticClass: "list",
	    attrs: {
	      "id": "geometry-list"
	    }
	  }, [_vm._l((_vm.currentStoryGeometry.faces), function(face) {
	    return (!_vm.currentSpace && !_vm.currentShading) ? [_c('header', [_c('h3', [_vm._v("Face " + _vm._s(face.id))])]), _vm._v(" "), _vm._l((face.edgeRefs), function(edgeRef) {
	      return _c('div', {
	        staticClass: "list-item"
	      }, [_vm._v("\n        edge " + _vm._s(edgeRef.edge_id) + " " + _vm._s(edgeRef.reverse ? 'reversed ' : '') + "\n        "), _c('br'), _vm._v("startpoint " + _vm._s(_vm.startpoint(edgeRef)) + "\n        "), _c('br'), _vm._v("endpoint " + _vm._s(_vm.endpoint(edgeRef)) + "\n      ")])
	    })] : _vm._e()
	  }), _vm._v(" "), (_vm.currentSubSelectionFace) ? [_c('header', [_c('h3', [_vm._v("Face " + _vm._s(_vm.currentSubSelectionFace.id) + " on " + _vm._s(_vm.currentSpace ? _vm.currentSpace.name : _vm.currentShading.name))])]), _vm._v(" "), _vm._l((_vm.currentSubSelectionFace.edgeRefs), function(edgeRef) {
	    return _c('div', {
	      staticClass: "list-item"
	    }, [_vm._v("\n        edge " + _vm._s(edgeRef.edge_id) + " " + _vm._s(edgeRef.reverse ? 'reversed ' : '') + "\n        "), _c('br'), _vm._v("startpoint " + _vm._s(_vm.startpoint(edgeRef)) + "\n        "), _c('br'), _vm._v("endpoint " + _vm._s(_vm.endpoint(edgeRef)) + "\n      ")])
	  })] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "editable-select-list",
	    class: {
	      'expanded': !_vm.compact
	    },
	    attrs: {
	      "data-object-type": _vm.selectedObjectType
	    }
	  }, [_c('div', {
	    staticClass: "controls"
	  }, [_c('div', {
	    staticClass: "control-group"
	  }, [(_vm.objectTypes.length > 1) ? _c('PrettySelect', {
	    attrs: {
	      "options": _vm.objectTypes,
	      "value": _vm.selectedObjectType
	    },
	    on: {
	      "change": function (val) { return _vm.$emit('selectObjectType', val); }
	    }
	  }) : _c('span', [_vm._v(_vm._s(_vm.objectTypes[0].display || _vm.objectTypes[0].displayName))]), _vm._v(" "), (_vm.addRow) ? _c('a', {
	    staticClass: "add-new",
	    attrs: {
	      "title": "Create new"
	    },
	    on: {
	      "click": _vm.addRow
	    }
	  }, [_c('AddNew', {
	    staticClass: "button"
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "control-group"
	  }, [_c('a', {
	    attrs: {
	      "title": _vm.compact ? 'expand' : 'contract'
	    },
	    on: {
	      "click": _vm.toggleCompact
	    }
	  }, [_c('DoubleArrows', {
	    staticClass: "button",
	    attrs: {
	      "transform": _vm.compact ? '' : 'scale(-1, 1)'
	    }
	  })], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "input-text search-spot"
	  }, [(_vm.searchAvailable) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    staticClass: "search-bar",
	    attrs: {
	      "placeholder": "search"
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.compact) ? _c('LibrarySelect', {
	    attrs: {
	      "rows": _vm.searchedRows,
	      "selectItem": _vm.selectRow,
	      "destroyItem": _vm.destroyRow,
	      "selectedItemId": _vm.selectedRowId,
	      "duplicateRow": _vm.duplicateRow
	    }
	  }) : _c('EditableTable', {
	    attrs: {
	      "selectRow": _vm.selectRow,
	      "selectedItemId": _vm.selectedRowId,
	      "columns": _vm.visibleColumns,
	      "rows": _vm.searchedRows,
	      "deleteRow": _vm.destroyRow,
	      "updateRow": _vm.editRow,
	      "duplicateRow": _vm.duplicateRow
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isChrome) ? _c('p', {
	    staticClass: "non-chrome-warning"
	  }, [_vm._v("\n  Warning. This web-app is currently only tested against recent versions of Chrome. \n")]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "render-by"
	  }, [_c('PrettySelect', {
	    attrs: {
	      "label": "View By",
	      "options": _vm.renderableOptions,
	      "value": _vm.currentMode
	    },
	    on: {
	      "change": function (val) {
	        _vm.currentMode = val
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "input-select"
	  }, [(_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('select', {
	    attrs: {
	      "disabled": _vm.disabled
	    },
	    on: {
	      "change": function($event) {
	        _vm.$emit('change', $event.target.value)
	      }
	    }
	  }, _vm._l((_vm.normalizedOpts), function(opt) {
	    return _c('option', {
	      domProps: {
	        "value": opt.val,
	        "selected": opt.val === _vm.value
	      }
	    }, [_vm._v(_vm._s(opt.display))])
	  })), _vm._v(" "), _c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "viewBox": "0 0 13 14",
	      "height": "10px"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M.5 0v14l11-7-11-7z",
	      "transform": "translate(13) rotate(90)"
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info"
	  }, [_c('InfoIcon', {
	    staticClass: "button"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "tooltip-text"
	  }, [_vm._t("default")], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('EditableSelectList', {
	    attrs: {
	      "selectedObjectType": _vm.mode,
	      "objectTypes": _vm.objectTypesDisplay,
	      "rows": _vm.rows,
	      "columns": _vm.columns,
	      "selectedRowId": _vm.selectedObject && _vm.selectedObject.id,
	      "selectRow": function (row) {
	        _vm.selectedObject = row;
	      },
	      "addRow": _vm.addRowPermitted && _vm.createObject,
	      "editRow": _vm.modifyObject,
	      "destroyRow": _vm.destroyObject,
	      "duplicateRow": _vm.duplicateRow,
	      "searchAvailable": _vm.searchAvailable,
	      "compact": _vm.compact
	    },
	    on: {
	      "toggleCompact": function (c) { return _vm.$emit('toggleCompact', c); },
	      "selectObjectType": _vm.changeMode
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "gridParent",
	    class: {
	      'reduce-ticks': _vm.reduceTicks
	    },
	    style: ({
	      'pointer-events': (_vm.currentTool === 'Drag' || _vm.currentTool === 'Map') ? 'none' : 'auto'
	    }),
	    attrs: {
	      "id": "grid"
	    }
	  }, [_c('svg', {
	    ref: "grid",
	    attrs: {
	      "id": "svg-grid"
	    }
	  }, [_c('g', {
	    staticClass: "axis axis--x"
	  }), _vm._v(" "), _c('g', {
	    staticClass: "axis axis--y"
	  }), _vm._v(" "), _c('g', {
	    staticClass: "images",
	    attrs: {
	      "data-transform-plz": ""
	    }
	  }), _vm._v(" "), _c('g', {
	    staticClass: "polygons",
	    attrs: {
	      "data-transform-plz": ""
	    }
	  }), _vm._v(" "), _c('g', {
	    staticClass: "walls",
	    attrs: {
	      "data-transform-plz": ""
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ("tool_" + (_vm.tool.toLowerCase())),
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('toolbar', {
	    class: {
	      'disabled-component': _vm.tool === 'Map'
	    }
	  }), _vm._v(" "), _c('div', {
	    class: {
	      'nav-on-top': _vm.navigationExpanded
	    },
	    attrs: {
	      "id": "layout-main"
	    }
	  }, [_c('navigation', {
	    class: {
	      'disabled-component': _vm.tool === 'Map'
	    },
	    on: {
	      "expanded": function (val) {
	        _vm.navigationExpanded = val;
	      }
	    }
	  }), _vm._v(" "), _c('main', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.error || _vm.success),
	      expression: "error || success"
	    }],
	    class: {
	      error: _vm.error, success: _vm.success
	    },
	    attrs: {
	      "id": "alert-text"
	    }
	  }, [_c('p', [_vm._v(_vm._s(_vm.error || _vm.success))])]), _vm._v(" "), _c('canvas-view'), _vm._v(" "), _c('grid-view')], 1)], 1), _vm._v(" "), _c('ImageUpload'), _vm._v(" "), _c('Textures'), _vm._v(" "), _c('PortalTarget', {
	    attrs: {
	      "name": "texture-options"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('aside', [_c('div', {
	    staticClass: "overlay"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "modal"
	  }, [_vm._m(0), _vm._v(" "), _c('NonChromeWarning'), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('p', [_c('a', {
	    staticClass: "quickstart-action new-floorplan",
	    on: {
	      "click": function($event) {
	        _vm.mapEnabled = false;
	        _vm.mapVisible = false;
	        _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("New")]), _vm._v(" "), _c('QuickstartIconNewFloorplan'), _vm._v(" "), _c('div', {
	    staticClass: "explanation"
	  }, [_vm._v("Create a new floorplan")])], 1)]), _vm._v(" "), _c('p', [_c('a', {
	    staticClass: "quickstart-action",
	    attrs: {
	      "disabled": !_vm.online
	    },
	    on: {
	      "click": function($event) {
	        _vm.mapEnabled = true;
	        _vm.tool = 'Map';
	        _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("New With Map")]), _vm._v(" "), _c('QuickstartIconNewMapFloorplan'), _vm._v(" "), _c('div', {
	    staticClass: "explanation"
	  }, [_vm._v("Create a new floorplan with a map")])], 1)]), _vm._v(" "), _c('p', [_c('a', {
	    staticClass: "quickstart-action open-floorplan",
	    attrs: {
	      "id": "import"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$refs.importInput.click()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("Open")]), _vm._v(" "), _c('QuickstartIconOpenFloorplan'), _vm._v(" "), _c('div', {
	    staticClass: "explanation"
	  }, [_vm._v("Open an existing floorplan")])], 1)]), _vm._v(" "), _c('input', {
	    ref: "importInput",
	    attrs: {
	      "id": "importInput",
	      "type": "file"
	    },
	    on: {
	      "change": _vm.importFloorplanAsFile
	    }
	  })])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('h2', [_vm._v("Quickstart")])])
	}]}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18.4 17.7V5H.6v13h18.2l-.4-.3zM1.6 6h15.8v11L13 13.7l-2.3 1.7L7 11.5 1.8 17h-.2V6z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"9.7","cy":"5.4","fill":"#39b54a","r":"5"}}),_c('path',{attrs:{"d":"M11.5 4.5h-1.2V3.3c0-.3-.2-.5-.5-.5h-.6c-.3 0-.5.2-.5.5v1.2H7.5c-.3 0-.5.2-.5.5v.6c0 .2.2.4.5.4h1.2v1.2c0 .3.2.5.5.5h.6c.3 0 .5-.2.5-.5V6h1.2c.3 0 .5-.2.5-.5V5c-.1-.3-.3-.5-.5-.5z","fill":"#58595b"}})])}}};

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"10.5","cy":"10","fill":"#39b54a","r":"7.9"}}),_c('path',{attrs:{"d":"M13.6 8.8h-1.9V6.9c0-.4-.3-.8-.8-.8H10c-.4 0-.8.3-.8.8v1.9H7.3c-.4 0-.8.3-.8.8v.9c0 .4.3.8.8.8h1.9v1.9c0 .4.3.8.8.8h.9c.4 0 .8-.3.8-.8v-1.9h1.9c.4 0 .8-.3.8-.8v-1c-.1-.4-.4-.7-.8-.7z","fill":"#58595b"}})])}}};

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.5 22l-3.3-5.5h6.7zM12.9 5.1c0-.9-.7-1.7-1.7-1.7-.9 0-1.7.7-1.7 1.7 0 .9.7 1.7 1.7 1.7.9 0 1.7-.8 1.7-1.7zm5.3 15.5h-2.9v1.1h7v-1.1h-1.7v-7.3h1.7v-1.1h-9.7v1.1h5.6v7.3zM6 16.7v.1c0 .3.2.5.5.5h1.6v1.5h.3v1l-2 .6v.5h.2v.1c-.1.1-.3.2-.3.4s.2.4.4.4.4-.2.4-.4-.1-.3-.3-.4v-.1l1.6-.2v.1h.1v.6h.2v.4H9v-1h.1v-.1l1.5.2v.1c-.1.1-.3.2-.3.4s.2.4.4.4.4-.2.4-.4-.1-.3-.3-.4v-.1h.2v-.5l-2-.5v-1h.3v-1.5h1.9c.3 0 .5-.2.5-.5v-.1c0-.2-.1-.3-.2-.4h1.3l-.8 4c-.1.5.3 1.1.8 1.2.6.1 1.1-.2 1.2-.8l1.1-5.3v-.4c-.1-.6-.5-1-1.1-1h-3.2l.4-1.9h3.9c.2 0 .3 0 .5-.1h4.2v-.5c.1 0 .1-.1.2-.1l.5.2 1.9-5-.6-.2-1.9 4.9h-.1c-.1 0-.2.1-.2.2H16v-.1c0-.5-.4-.9-.9-.9h-3.5l.2-1c.2-.9-.4-1.7-1.3-1.9l-.5-.1c-.8-.4-1.6.1-1.8 1L7.7 11l-.1.7V10c0-.3-.2-.5-.5-.5h-.5c-.3 0-.6.2-.6.5v3.8c0 .3.2.5.5.5v1.8c-.3.1-.5.3-.5.6zm1-1c.1.2.3.4.5.5H7v-.5z"}})])}}};

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.5 22l-3.3-5.5h6.7zm-8.5-.2H6v-19h13v19zm-12.1-.9H18v-17H6.9v17z"}}),_c('path',{attrs:{"d":"M11.8 15.9h5.8v4.3h-5.8zm0-5.7h5.8v4.3h-5.8zm0-5.8h5.8v4.3h-5.8z"}})])}}};

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.5 22l-3.3-5.5h6.7zM20.6 6.6c0-.1-.1-.2-.1-.3-.1.1-.1.2-.2.2-.7.8-1.3 1.7-2 2.5-.4.5-1 .6-1.5.2-.1-.1-.2-.2-.4-.3-.2-.2-.3-.4-.4-.7 0-.3.1-.6.3-.8.7-.8 1.3-1.7 2-2.5.1-.1.1-.2.2-.2-.1 0-.2 0-.3-.1-1.2-.2-2.5.3-3.4 1.3-.8 1-1 2.4-.6 3.6-.6.8-1.3 1.7-1.9 2.5L9.2 7.7c.2-.1.4-.3.6-.5 1.9-1.4 2.4-.2 2.9-.8.5-.6-2-2.2-4.1-.7-.1.2-.3.4-.5.5-.3-.2-.7-.3-1 0-.2.2-.3.5-.2.8-.6.5-1.1.8-1.3 1l-.1-.1c-.2-.3-.6-.3-.8-.1l-.7.5c-.3.2-.4.5-.2.8L5 10.8c.2.3.6.3.9.1l.7-.5c.3-.2.3-.6.1-.9.2-.2.7-.5 1.3-.9l3.4 4.7-.1.1c-.2.1-.3.3-.3.5-1.2 1.5-2.4 3.1-3.6 4.6-.2.3-.4.7-.3 1.1 0 .4.2.7.5 1 .1.1.2.2.4.3.6.5 1.5.4 2-.3.9-1.2 1.9-2.4 2.8-3.6l2.3 3.5c.3.4.8.4 1.1.2l2.2-1.6c.4-.3.4-.8.2-1.1l-3.4-4.1c.6-.7 1.1-1.5 1.7-2.2 1.2.2 2.4-.3 3.2-1.4.8-1.1 1-2.5.5-3.7z"}})])}}};

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.5 22l-3.3-5.5h6.7zM15.6 10.3l5.4 5.2L10.2 17zm-6.5 6.8l6-7.4-7.4-4-5.9 7.4z"}})])}}};

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.5 22l-3.3-5.5h6.7zM3 2.9v18h21v-18H3zm14.6 4H8.8l-2.6-2h14.1l-2.7 2zm-.6 2v6h-7v-6h7zm-9 .6v5.6l-3 2.6V7l3 2.5zm1.6 7.4h8.2l2.6 2H6.9l2.7-2zm9.4-1.8V8.8l3-2.6v11.4l-3-2.5z"}})])}}};

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.5 22l-3.3-5.5h6.7zm-6.4-8.9h-1.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h1.5c.3 0 .5.2.5.5s-.2.5-.5.5zm-15.3 0H4.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h1.5c.3 0 .5.2.5.5s-.2.5-.5.5zm6.9-6.3c-.3 0-.5-.2-.5-.5V4.8c0-.3.2-.5.5-.5s.5.2.5.5v1.5c0 .2-.2.5-.5.5zm0 14.8c-.3 0-.5-.2-.5-.5v-1.5c0-.3.2-.5.5-.5s.5.2.5.5v1.5c0 .2-.2.5-.5.5zm4.9-4.1l1.1 1m0 .5c-.1 0-.2 0-.3-.1l-1.1-1c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l1.1 1c.2.2.2.5 0 .7-.1.1-.3.1-.4.1zM6.8 7l1.1 1.1m0 .5c-.1 0-.3 0-.3-.1l-1.1-1c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l1.1 1c.2.2.2.5 0 .7-.2 0-.3.1-.4.1zm9.5-.7l1-1m-1 1.5c-.1 0-.3-.1-.4-.2-.2-.2-.2-.5 0-.7l1.1-1c.2-.2.5-.2.7 0 .2.2.2.5 0 .7l-1.1 1c-.1.2-.2.2-.3.2zm-10.9 10l1.1-1m-1.1 1.5c-.1 0-.3-.1-.4-.2-.1-.1-.1-.5.1-.7l1.1-1c.2-.2.5-.2.7 0 .2.2.2.5 0 .7l-1.1 1c-.1.2-.2.2-.4.2z"}}),_c('ellipse',{attrs:{"cx":"12.8","cy":"12.9","rx":"4.8","ry":"4.6"}})])}}};

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 2.9v19h13v-19H6zm12 1v8H7v-8h11zm-11 17v-8h11v8H7zM27.5 22l-3.3-5.5h6.7z"}})])}}};

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M25.5 6.3l-7.65-4.35v8.7zm-13.35 0L4.5 1.95v8.7z","fill":"#39b54a"}})])}}};

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"fill":"#FFF","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M17.6 12V0h-12v12h12zM16 1.6v8.8H7.2V1.6H16zM3.2 13.6H1.6V16H4v-1.6h-.8zM1.6 5.6h1.6v-.8H4V3.2H1.6zM12.8 14.4H12V16h2.4v-2.4h-1.6zM5.6 14.4h1.6V16H5.6zM8.8 14.4h1.6V16H8.8zM1.6 10.4h1.6V12H1.6zM1.6 7.2h1.6v1.6H1.6z"}})])}}};

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100","width":"83.541","height":"85.671"}},[_c('g',{attrs:{"fill":"none","stroke":"#555759","stroke-width":"4"}},[_c('path',{attrs:{"d":"M25.326 5.536C8.962 31.36 19.195 73.136 50.075 82.61M25.326 6.036C57.422 8.888 73.723 46.51 66.34 74.832M24.973 5.536l33.94 74.246M7.295 22.506C24.042 31.36 45.03 19.682 51.843 3.414M2.699 40.537C27.3 48.43 57.149 36.13 67.753 12.253M5.88 60.336c27.658 6.83 61.508-5.537 72.48-33.234"}}),_c('path',{attrs:{"d":"M81.53 42.344a39.766 40.836-.708 0 1-39.147 41.322A39.766 40.836-.708 0 1 2.007 43.557 39.766 40.836-.708 0 1 40.925 2.01a39.766 40.836-.708 0 1 40.596 39.874M16.84 74.832c24.58 8.653 55.44-4.151 64.701-28.991M81.093 48.863a39.766 40.836.708 0 1 .408-7.695"}})])])}}};

/***/ }),
/* 776 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"fill":"#FFF","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 99.999"}},[_c('path',{attrs:{"d":"M31.001 54.999h38a2 2 0 0 0 0-4h-38a2 2 0 0 0 0 4zM31.001 35.999h38a2 2 0 0 0 0-4h-38a2 2 0 0 0 0 4z"}}),_c('path',{attrs:{"d":"M95.001 70.007h-13V31.192c0-1.85-.853-3.594-2.31-4.73L53.812 6.269a5.999 5.999 0 0 0-7.36-.018l-26.12 20.193a6.003 6.003 0 0 0-2.33 4.748V70.006h-13v4h3v16.5c0 .824.675 1.5 1.5 1.5s1.5-.676 1.5-1.5v-16.5h2v16.5c0 .824.675 1.5 1.5 1.5s1.5-.676 1.5-1.5v-16.5h2v14.99c0 3.312 2.687 6 6 6h52c3.313 0 6-2.688 6-6v-14.99h2v16.5c0 .826.675 1.5 1.5 1.5s1.5-.674 1.5-1.5v-16.5h2v16.5c0 .826.675 1.5 1.5 1.5s1.5-.674 1.5-1.5v-16.5h3v-3.999zm-71-38.815l26.12-20.193 25.88 20.193V69.998h-52V31.192z"}})])}}};

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"fill":"#FFF","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},[_c('path',{staticStyle:{"text-indent":"0","text-transform":"none","block-progression":"tb"},attrs:{"d":"M20.3 8.5c-2.96 0-5.4 2.44-5.4 5.4v52.2c0 2.96 2.44 5.4 5.4 5.4h59.4c2.96 0 5.4-2.44 5.4-5.4V13.9c0-2.96-2.44-5.4-5.4-5.4zm0 3.6h59.4c1.028 0 1.8.772 1.8 1.8v37.04L70.166 39.607c-.684-.677-1.934-.65-2.588.056L56.244 51.784 38.666 34.206a1.814 1.814 0 0 0-2.475-.056L18.5 50.294V13.9c0-1.028.772-1.8 1.8-1.8zm35.1 3.6c-4.95 0-9 4.05-9 9s4.05 9 9 9 9-4.05 9-9-4.05-9-9-9zm0 3.6c3.004 0 5.4 2.396 5.4 5.4 0 3.004-2.396 5.4-5.4 5.4a5.373 5.373 0 0 1-5.4-5.4c0-3.004 2.396-5.4 5.4-5.4zM37.344 37.975l17.69 17.69c.684.678 1.934.65 2.588-.055l11.334-12.122L81.5 56.03V66.1c0 1.028-.772 1.8-1.8 1.8H20.3c-1.028 0-1.8-.772-1.8-1.8V55.188z","overflow":"visible","color":"#000"}})])}}};

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.6 18.4c-1-.6-1.5-.7-2.5-1.8-1.6-1.7-.9-2.4.1-2.2 1 .2 1.9-.9.8-2.4-1.1-1.5-2.4-1-2.5 0-.1 1.1-1 1.5-2.1-.5-.7-1.3-.7-1.8-.9-2.9 1.1-.2 1.5-.2 2.8-.9 2-1.1 1.6-2 .5-2.1-1.1-.1-1.5-1.4 0-2.5s2.6-.3 2.4.8c-.2 1 .5 1.7 2.2.1 1-1 1.2-1.5 1.8-2.5 1 .6 1.5.7 2.5 1.8 1.6 1.7.9 2.4-.1 2.2-1-.2-1.9.9-.8 2.4 1.1 1.5 2.4 1 2.5 0 .1-1.1 1-1.5 2.1.5.7 1.3.7 1.8.9 2.9l-9.7 7.1z","fill":"#878787"}}),_c('path',{attrs:{"d":"M19.9 7.6c-.5-.7-1-.9-1.3-.6-.2.1-.3.4-.4.8 0 .3-.2.6-.4.8-.5.4-1.3.3-2-.7v-.1c-.7-1-.6-1.9-.1-2.2.2-.2.5-.2.9-.2.4.1.7 0 .9-.1.3-.2.3-.7-.2-1.4-.1-.2-.3-.4-.5-.6-1-1-1.5-1.2-2.5-1.8-.1.1-.1.2-.2.4-.4.8-.6 1.2-1.6 2.1-.2.2-.4.4-.6.5-.9.6-1.4.5-1.6.2-.1-.2-.2-.5-.1-.9.1-.3 0-.7-.2-.9-.3-.4-1.1-.6-2.1.1h-.1c-1 .8-1.1 1.6-.8 2.1.2.2.4.4.8.4s.7.2.8.4c.3.4.2.8-.6 1.4-.2.1-.4.3-.7.4-1.3.7-1.7.7-2.9.9.2 1.1.2 1.6.9 2.9.1.3.3.5.4.7.5.7 1 .9 1.3.6.2-.1.3-.4.4-.8 0-.3.2-.6.4-.8.6-.3 1.4-.2 2.2.8v.1c.7 1 .6 1.8.1 2.2-.2.2-.6.2-.9.2-.4-.1-.7 0-.9.1-.3.2-.3.7.2 1.4.1.2.3.4.5.6 1 1 1.5 1.2 2.5 1.8l9.7-7.1c-.2-1.2-.2-1.7-.8-3-.2-.2-.3-.5-.5-.7zm-4.5.5c.3.4.7.7 1 .9.4.2.8.2 1.1.1.3-.1.5-.2.7-.5.2-.2.3-.5.3-.8 0-.3.2-.5.2-.5.1 0 .3.1.7.6.1.2.3.4.4.6.5 1 .6 1.5.8 2.2 0 .1 0 .2.1.3l-9.3 6.8c-.1 0-.2-.1-.2-.1-.7-.4-1.1-.6-1.9-1.4-.2-.2-.4-.4-.5-.6-.4-.5-.4-.8-.3-.8 0-.1.2-.1.6-.1.3.1.6 0 .9-.1.3-.1.5-.3.7-.6.2-.3.3-.7.2-1.1-.1-.4-.2-.8-.6-1.3v-.1c-.3-.3-.7-.6-1.1-.7-.4-.2-.8-.2-1.1-.1-.6.2-1 .7-1 1.3 0 .3-.2.5-.2.5-.1 0-.3-.1-.7-.6-.1-.2-.3-.4-.4-.6-.5-1-.6-1.5-.8-2.3V9h.1c.8-.2 1.4-.3 2.5-.9 1-.5 1.5-1 1.6-1.6.1-.3 0-.6-.2-.8-.2-.3-.6-.5-1.1-.5-.2 0-.4-.1-.5-.3-.1-.1-.1-.3-.1-.6.1-.2.2-.6.7-.9.5-.3.9-.5 1.3-.4.2 0 .3.1.4.2.1.2.1.4.1.6-.1.5 0 .9.2 1.2.2.2.4.4.7.4.5 0 1.2-.3 2-1.1.9-.9 1.2-1.4 1.6-2.1 0 0 0-.1.1-.1 0 0 .1 0 .1.1.7.4 1.1.6 1.9 1.4.2.2.4.4.5.6.4.5.4.8.3.8 0 .1-.2.1-.6.1-.6-.1-1.2.1-1.5.6-.2.3-.3.7-.2 1.1 0 .4.2.8.5 1.3z","fill":"#878787"}}),_c('path',{attrs:{"d":"M11.7 18.1c-1-.6-1.5-.7-2.5-1.8-1.6-1.7-.9-2.4.1-2.2 1 .2 1.9-.9.8-2.4-1.1-1.5-2.4-1-2.5 0-.1 1.1-1 1.5-2.1-.5-.7-1.3-.7-1.7-1-2.9 1.1-.2 1.6-.2 2.9-.9 2-1.1 1.6-2 .5-2.1-1.1-.1-1.5-1.4 0-2.5s2.6-.3 2.4.8c-.2 1 .5 1.7 2.2.1 1-1 1.2-1.5 1.8-2.5 1 .6 1.5.7 2.5 1.8 1.6 1.7.9 2.4-.1 2.2-1-.2-1.9.9-.8 2.4 1.1 1.5 2.4 1 2.5 0 .1-1.1 1-1.5 2.1.5.7 1.3.7 1.8.9 2.9l-9.7 7.1z","fill":"#878787"}}),_c('ellipse',{attrs:{"cx":"18.9","cy":"18.6","fill":"#fff","rx":"6.6","ry":"6.6","transform":"rotate(-45.001 18.912 18.561)"}}),_c('path',{attrs:{"d":"M16.4 20.9l5.2.4-.4-5.2-1.5 1.5-2.5-2.5-1.8 1.8 2.5 2.5z"}})])}}};

/***/ }),
/* 779 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"fill":"#FFF","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},[_c('path',{attrs:{"d":"M64.433 16.857l-1.932.693-1.527.913-1.024 1.091-.477 1.122v1.138l.489 1.084L60.997 24l1.55.95 1.937.688 2.186.331h2.301l2.192-.368 1.944-.69 1.512-.914 1.029-1.096.49-1.117-.016-1.139-.491-1.122-1.027-1.06-1.558-.955-1.937-.689-2.186-.331h-2.3z"}}),_c('path',{attrs:{"d":"M75.752 25.386c-.034.03-.057.066-.097.09L73.962 26.5c-.04.023-.083.036-.124.053-.015.006-.024.019-.04.024l-2.107.749c-.03.01-.06.008-.09.016-.021.005-.04.02-.062.023l-2.343.395a.936.936 0 0 1-.149.012h-2.442-.001a.842.842 0 0 1-.134-.01l-2.342-.356c-.025-.004-.043-.019-.067-.023-.033-.009-.066-.007-.1-.018l-2.106-.748c-.017-.007-.027-.02-.043-.026-.043-.018-.087-.03-.128-.055l-1.731-1.063c-.038-.023-.06-.059-.094-.087-.03-.024-.066-.036-.094-.065l-.294-.314v1.202l.492 1.123 1.027 1.093 1.548.914 1.95.694 2.185.367 2.302-.038 2.195-.333 1.932-.686 1.509-.947 1.035-1.103.492-1.124v-1.16l-.293.312c-.027.03-.063.041-.093.065zM43.926 2.813c.022-.002.04-.015.063-.015l1.358-.022-1.588-.838-1.612 1.145 1.715-.273c.022-.004.043.004.064.002z"}}),_c('path',{attrs:{"d":"M77.758 19.894l.087.197c.035.08.046.17.055.258.004.03.02.061.02.093l.018 1.515v4.408c-.002.06-.024.12-.038.18-.012.056-.014.118-.037.17v.005l-.63 1.437a.9.9 0 0 1-.16.243c-.003.004-.004.01-.009.013l-1.22 1.3c-.026.028-.061.04-.091.064-.032.025-.052.059-.087.081l-1.694 1.063c-.041.026-.087.04-.13.058-.019.008-.03.022-.047.028l-2.106.749c-.034.011-.068.01-.101.018-.024.005-.042.02-.066.023l-2.344.355a.788.788 0 0 1-.111.009l-.01.001-2.44.04H66.6a.916.916 0 0 1-.148-.013l-2.342-.394c-.024-.003-.042-.019-.063-.024-.03-.007-.059-.005-.09-.015l-2.106-.75c-.016-.005-.025-.018-.042-.023-.037-.017-.077-.027-.114-.05l-1.733-1.022c-.04-.024-.065-.062-.1-.091-.032-.025-.07-.038-.098-.069l-1.22-1.3c-.004-.004-.005-.01-.009-.013a.886.886 0 0 1-.16-.242l-.63-1.437-.001-.006c-.023-.053-.024-.113-.037-.17-.013-.06-.037-.12-.037-.18V20.491c0-.067.024-.134.04-.202.012-.05.011-.104.03-.15l.612-1.438c.021-.051.06-.087.091-.131.028-.044.045-.093.082-.132l1.22-1.3c.03-.03.068-.045.101-.071.033-.027.055-.062.093-.085l1.713-1.023c.025-.016.055-.016.08-.029.029-.013.048-.035.077-.046l2.091-.749c.026-.01.054-.004.08-.011s.048-.025.075-.03l2.342-.393c.026-.005.05.004.075.002s.049-.015.075-.015h1.356L55.183 7.97l.1.229.001.005c.023.054.025.114.038.17.013.06.035.12.036.18l.001.006V14.468c0 .067-.025.135-.041.203-.012.05-.012.102-.03.148h-.001l-.61 1.438a.88.88 0 0 1-.16.245c-.004.004-.005.01-.009.013l-1.2 1.299c-.027.03-.065.042-.096.067-.035.029-.059.068-.1.093l-1.733 1.043c-.035.022-.074.032-.111.049-.016.006-.026.019-.042.025l-2.088.768c-.031.013-.065.01-.096.018-.025.007-.046.022-.072.027l-2.342.374a.832.832 0 0 1-.141.012h-2.423a.84.84 0 0 1-.142-.012l-2.343-.374c-.023-.004-.04-.02-.063-.024-.031-.007-.063-.004-.094-.016l-2.125-.748c-.017-.006-.028-.019-.044-.026-.045-.019-.09-.032-.132-.058l-1.713-1.063c-.033-.02-.052-.054-.08-.077-.03-.022-.064-.034-.091-.061l-1.22-1.26c-.006-.005-.007-.013-.013-.018a.888.888 0 0 1-.166-.247l-.63-1.438c-.034-.08-.044-.167-.056-.255-.003-.031-.02-.063-.02-.095l-.019-1.515.002-.009-.002-.009.02-2.896v-.007l-.02-1.47.002-.012c0-.057.021-.115.034-.172.011-.06.015-.124.038-.179.001-.003 0-.007.002-.01l.134-.307-12.603 8.952 1.71-.274c.026-.004.048.005.073.003.025-.002.045-.014.07-.014h2.402c.025 0 .047.012.07.014.025.002.048-.006.072-.003l2.344.375c.026.004.046.02.072.027.026.006.052 0 .077.01l2.126.729c.031.01.054.035.083.05.03.013.062.015.09.03l1.732 1.044c.038.022.06.057.093.085.033.027.074.043.103.075l1.202 1.299c.034.037.048.083.075.124.026.04.063.07.084.116l.65 1.437c.002.004 0 .008.002.011.024.055.028.117.04.177.013.057.034.115.035.172l.002.011v5.912c0 .06-.024.12-.038.18-.012.057-.014.118-.037.17v.006l-.63 1.438a.906.906 0 0 1-.16.241c-.003.005-.004.01-.009.015l-1.2 1.28c-.028.028-.064.04-.095.065-.033.027-.056.064-.094.087l-1.712 1.043c-.038.023-.08.035-.119.052-.015.007-.025.02-.04.025l-2.107.768c-.033.011-.065.01-.097.017-.024.006-.044.021-.07.026l-2.344.374a.84.84 0 0 1-.14.012H24.612h-.002a.821.821 0 0 1-.14-.012l-2.363-.374c-.022-.004-.04-.018-.06-.023-.032-.007-.064-.005-.094-.016l-2.087-.728c-.016-.005-.026-.019-.04-.024-.043-.018-.087-.03-.128-.055l-1.732-1.044c-.039-.024-.062-.06-.097-.088-.03-.025-.067-.037-.095-.067l-1.202-1.28c-.002-.003-.003-.008-.007-.011a.896.896 0 0 1-.158-.239l-.65-1.456c0-.003 0-.006-.002-.007-.024-.056-.028-.122-.04-.182-.012-.057-.034-.113-.034-.17l-.002-.008V22.403c0-.051.021-.1.03-.151.012-.068.016-.139.042-.202l.131-.309-9.362 6.651L49.24 50.924c.3-.107.624-.05.868.154l36.973-26.26-9.322-4.924zm-19.27 15.875V40.16c0 .054-.021.099-.03.15-.011.066-.013.132-.039.198l-.002.002-.608 1.454a.895.895 0 0 1-.168.254c-.005.006-.007.014-.012.019l-1.22 1.28c-.026.027-.06.038-.089.06-.03.024-.048.058-.083.08l-1.712 1.082c-.046.029-.095.045-.143.064-.017.006-.027.02-.044.025l-2.107.73c-.027.009-.056.006-.083.014-.02.004-.035.018-.055.02l-2.343.413a.843.843 0 0 1-.155.015H47.173h-.001a.843.843 0 0 1-.156-.015l-2.344-.413c-.018-.003-.033-.016-.052-.02-.028-.007-.056-.005-.083-.014l-2.125-.729c-.017-.005-.026-.019-.042-.024-.045-.02-.092-.032-.134-.058l-1.713-1.043c-.038-.023-.062-.06-.095-.09-.03-.022-.065-.035-.092-.063l-1.22-1.299c-.003-.002-.004-.007-.006-.01a.881.881 0 0 1-.159-.235l-.65-1.439c-.001-.003 0-.007-.002-.01-.024-.055-.027-.117-.04-.177-.013-.057-.035-.115-.036-.173l-.002-.01V34.29l.001-.005c0-.06.024-.12.037-.18.013-.057.014-.118.038-.17v-.006l.63-1.437c.02-.046.057-.077.084-.118.03-.046.045-.096.084-.137l1.2-1.28c.03-.03.068-.045.1-.07.031-.025.053-.06.089-.083l1.713-1.043c.028-.018.062-.019.092-.033.03-.015.05-.038.082-.049l2.107-.729c.024-.008.049-.003.073-.01.022-.006.041-.02.065-.025l2.342-.413c.027-.005.054.004.08.002.027-.003.05-.016.076-.016h2.422c.025 0 .047.012.071.014.024.002.046-.006.07-.003l2.362.374c.026.004.047.02.072.027.027.006.055 0 .082.01l2.106.73c.034.012.057.037.09.053.032.016.066.018.096.037l1.713 1.082c.032.02.051.053.079.077.03.023.065.035.092.063l1.22 1.28c.036.037.052.085.08.127.027.04.064.07.085.116l.65 1.398.003.014c.026.056.03.119.044.179.012.057.033.114.035.17l.002.016v1.516z"}}),_c('path',{attrs:{"d":"M55.144 32.278l-1.532-.969-1.936-.67-2.207-.349h-2.277l-2.19.387-1.95.675-1.526.928-1.012 1.079-.492 1.122v1.133l.505 1.119 1.033 1.066 1.536.954 1.959.689 2.19.349h2.274l2.187-.386 1.953-.693 1.53-.915 1.024-1.089.475-1.122v-1.135l-.501-1.08zM50.831 77.08L87.893 50.7V26.449L50.831 52.772zM37.424 11.011l1.029 1.096 1.526.93 1.97.675 2.183.386 2.276-.037 2.197-.351 1.92-.67 1.544-.966 1.012-1.078.478-1.14V8.752l-.49-1.12-1.031-1.08-1.53-.931-1.95-.675-2.181-.385-2.296.037-2.198.351-1.94.67-1.523.947-1.014 1.098-.492 1.12.014 1.099z"}}),_c('path',{attrs:{"d":"M56.32 39.188c-.036.029-.06.066-.1.09l-1.713 1.025c-.038.022-.08.034-.12.051-.015.006-.024.02-.04.024l-2.108.748c-.028.01-.056.008-.086.016-.02.005-.038.019-.058.022l-2.343.413a.843.843 0 0 1-.156.015h-2.422a.829.829 0 0 1-.14-.012l-2.345-.373c-.022-.004-.04-.02-.063-.024-.031-.007-.063-.004-.094-.016l-2.126-.748c-.017-.006-.028-.019-.044-.026-.044-.019-.09-.032-.131-.058l-1.713-1.063c-.034-.021-.054-.055-.084-.08-.028-.021-.062-.033-.088-.06l-.324-.333v1.207l.509 1.126 1.032 1.099 1.526.93 1.971.675 2.19.386h2.27l2.19-.386 1.943-.672 1.53-.968 1.031-1.079.475-1.136v-1.15l-.275.293c-.028.027-.065.04-.095.064zM37.42 15.433l1.032 1.066 1.534.952 1.959.69 2.19.35h2.28l2.184-.35 1.926-.708 1.55-.933 1.007-1.09.478-1.125v-1.166l-.255.272c-.026.028-.062.04-.092.064-.031.025-.053.06-.088.083l-1.732 1.083c-.044.027-.091.04-.136.06-.016.006-.027.02-.044.026l-2.088.729c-.03.01-.062.009-.094.016-.02.006-.039.019-.061.023l-2.342.374a.88.88 0 0 1-.118.01l-.009.002-2.422.038h-.015a.826.826 0 0 1-.156-.014l-2.342-.413c-.02-.004-.034-.016-.053-.02-.028-.007-.055-.005-.082-.014l-2.126-.73c-.016-.005-.026-.018-.042-.024-.045-.018-.091-.031-.134-.057l-1.712-1.043c-.04-.024-.063-.06-.096-.09-.03-.023-.065-.035-.092-.063l-.313-.333.015 1.216.49 1.12zM19.002 25.907l1.545.932 1.929.672 2.216.389h2.265l2.19-.387 1.943-.671 1.528-.966 1.017-1.084.492-1.123v-1.093l-.51-1.128-1.014-1.098-1.54-.927-1.966-.673-2.192-.351h-2.262l-2.192.35-1.935.67-1.531.968-1.032 1.082-.473 1.116v1.118l.507 1.124zM5.707 54.46L49.03 77.333V52.85L5.707 29.997z"}}),_c('path',{attrs:{"d":"M19.002 30.337l1.545.932 1.925.671 2.21.35h2.282l2.186-.349 1.94-.707 1.534-.934 1.012-1.078.492-1.123v-1.2l-.274.293c-.027.027-.06.038-.09.062-.031.026-.052.06-.087.083l-1.713 1.082c-.045.03-.094.045-.143.064-.016.006-.027.02-.043.025l-2.107.729c-.028.01-.056.007-.083.014-.02.004-.035.018-.054.02l-2.344.415a.836.836 0 0 1-.156.014h-2.422a.889.889 0 0 1-.155-.014l-2.362-.414c-.022-.003-.038-.018-.059-.022-.027-.007-.055-.005-.082-.014l-2.087-.729c-.016-.005-.026-.018-.04-.024-.043-.018-.087-.03-.128-.055l-1.732-1.044c-.039-.023-.062-.06-.097-.088-.03-.024-.067-.037-.095-.067l-.295-.314v1.201l.508 1.141 1.014 1.08z"}})])}}};

/***/ }),
/* 780 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M25.7 25.4H4.2V9.8h21.5v15.6zM5.8 23.8h18.3V11.4H5.8v12.4z","fill":"#878787"}}),_c('path',{attrs:{"d":"M10.6 17.7h1.6v7h-1.6zm7.7-7.1h1.6v7h-1.6zM5 16h3.2v1.6H5z","fill":"#878787"}}),_c('circle',{attrs:{"cx":"14.9","cy":"8.4","fill":"#fff","r":"6.6"}}),_c('path',{attrs:{"d":"M11.6 8.3l3.3 4 3.4-4h-2.1V4.7h-2.5v3.6z"}})])}}};

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M26 14.4c-.3-1.2-1.7-.4-1.7-.5l-4.2 1c-.1.1-.3.1-.3 0-.1-.1-.1-.3 0-.3l6.6-4.2c.5-.4.5-1 .2-1.5-.4-.5-1-.5-1.5-.2l-6.6 4.2c-.1.1-.3.1-.3 0-.1-.1-.1-.3 0-.3l6.6-5.8c.5-.4.5-1.4.2-1.9-.4-.5-1-.5-1.5-.2L16.9 11c-.1.1-.3.1-.3 0-.1-.1-.1-.3 0-.3l3.9-5.5c.5-.4.8-1 .5-1.5-.4-.5-1.3-.5-1.8-.2L15 9l-2.7 2.1c-.1.1-.3.1-.3 0s-.1-.1 0-.2l.6-4.5c.1-.6-.3-1.1-.9-1.2-.6-.1-1.1.3-1.2.9 0 0-1.2 5.7-1.3 6.7-.1.9.4 1.7.5 1.9l4.6 5.9c.4.5 1.3.6 1.9.1l3.5-2.7.6-.5 5.2-1.9c.4-.4.6-.7.5-1.2z","fill":"#fff"}})])}}};

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.4 26.8H52v28.7H11.4zm13 28.6V41.2m15.7-.2V26.8m5.3 14.1H52m-40.6-1.5H18","fill":"none","stroke":"#878787","stroke-miterlimit":"10","stroke-width":"3.252"}}),_c('path',{attrs:{"d":"M43.3 13.6c0-6.8-5.5-12.3-12.3-12.3-6.8 0-12.3 5.4-12.3 12.2 0 1.4.3 3 .7 4L31 50.4l10.7-30.6c1-1.9 1.6-4 1.6-6.2z","fill":"#39b54a"}}),_c('path',{attrs:{"d":"M36.4 9.6h-3.1V6.5c0-.7-.6-1.2-1.2-1.2h-1.5c-.7 0-1.2.6-1.2 1.2v3.1h-3.1c-.7 0-1.2.6-1.2 1.2v1.5c0 .7.6 1.2 1.2 1.2h3.1v3.1c0 .7.6 1.2 1.2 1.2h1.5c.7 0 1.2-.6 1.2-1.2v-3.1h3.1c.7 0 1.2-.6 1.2-1.2v-1.5c0-.7-.5-1.2-1.2-1.2z","fill":"#58595b"}})])}}};

/***/ }),
/* 783 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M52.9 52.6H9V20.7h43.9v31.9zm-40.7-3.2h37.4V24H12.2v25.4z","fill":"#878787"}}),_c('path',{attrs:{"d":"M22 36.8h3.3V51H22zm15.7-14.4H41v14.2h-3.3zm6.9 12.5h6.6v3.3h-6.6zm-34-1.5h6.6v3.3h-6.6z","fill":"#878787"}}),_c('circle',{attrs:{"cx":"30.2","cy":"20.6","fill":"#39b54a","r":"12.9"}}),_c('path',{attrs:{"d":"M34.9 18.1h-3.1V15c0-.7-.6-1.2-1.2-1.2h-1.5c-.7 0-1.2.6-1.2 1.2v3.1h-3.1c-.7 0-1.2.6-1.2 1.2v1.5c0 .7.6 1.2 1.2 1.2h3.1v3.1c0 .7.6 1.2 1.2 1.2h1.5c.7 0 1.2-.6 1.2-1.2V22h3.1c.7 0 1.2-.6 1.2-1.2v-1.5c.1-.6-.5-1.2-1.2-1.2z","fill":"#58595b"}})])}}};

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M52.9 54.3H9V22.4h43.9v31.9zm-40.7-3.2h37.4V25.7H12.2v25.4z","fill":"#878787"}}),_c('path',{attrs:{"d":"M22 38.5h3.3v14.2H22zM37.7 24H41v14.2h-3.3zM10.6 35.1h6.6v3.3h-6.6z","fill":"#878787"}}),_c('circle',{attrs:{"cx":"31.8","cy":"19.5","fill":"#fff","r":"13.5"}}),_c('path',{attrs:{"d":"M24.1 19.3l6.8 8.2 6.9-8.2h-4.3v-7.2h-5.2v7.2z"}})])}}};

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M25.2 13.2L14.8 4.6V10H7.1c-1.4 0-2.5 1.3-2.5 2.9v.5c0 1.6 1.1 2.9 2.5 2.9h7.7v5.3l10.4-8.4z","fill":"#39b54a"}})])}}};

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M25.7 25.4H4.2V9.8h21.5v15.6zM5.8 23.8h18.3V11.4H5.8v12.4z","fill":"#878787"}}),_c('path',{attrs:{"d":"M10.6 17.7h1.6v7h-1.6zm7.7-7.1h1.6v7h-1.6zM5 16h3.2v1.6H5z","fill":"#878787"}}),_c('circle',{attrs:{"cx":"14.9","cy":"8.4","fill":"#fff","r":"6.6"}}),_c('path',{attrs:{"d":"M11.6 8.7l3.3-4 3.4 4h-2.1v3.6h-2.5V8.7z"}})])}}};

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.9 19.6l-2.4-.1c-.2 0-.4-.2-.4-.4v-.7c0-.5-.3-1.1-.8-1.3-.2-.1-.3-.1-.5-.1-.4 0-.8.1-1.1.4l-.5.5c-.1.1-.2.1-.3.1-.1 0-.2-.1-.3-.1L8 16.1c-.2-.2-.2-.4 0-.6l.5-.5c.4-.4.6-1 .4-1.5-.2-.5-.7-.9-1.3-.9h-.7c-.2 0-.4-.2-.4-.4l.1-2.4c0-.2.2-.4.4-.4h.7c.5 0 1.1-.3 1.3-.8.3-.5.2-1.2-.2-1.6l-.5-.5c-.2-.2-.2-.4 0-.6l1.8-1.6c.1-.1.2-.1.3-.1.1 0 .2.1.3.1l.5.5c.2.3.6.4 1 .4.2 0 .3 0 .5-.1.5-.2.9-.7.9-1.3v-.7c0-.2.2-.4.4-.4l2.4.1c.2 0 .4.2.4.4v.7c0 .5.3 1.1.8 1.3.1.1.3.1.5.1.4 0 .8-.1 1.1-.4l.5-.5c.1-.1.2-.1.3-.1.1 0 .2.1.3.1l1.6 1.8c.2.2.1.4 0 .6l-.5.5c-.4.4-.6 1-.4 1.5.2.5.7.9 1.3.9h.7c.2 0 .4.2.4.4l-.1 2.4c0 .2-.2.4-.4.4h-.7c-.5 0-1.1.3-1.3.8-.2.5-.1 1.1.3 1.5l.5.5c.2.2.2.4 0 .6l-1.8 1.6c-.1.1-.2.1-.3.1-.1 0-.2-.1-.3-.1l-.5-.5c-.2-.3-.6-.4-1-.4-.2 0-.3 0-.5.1-.5.2-.9.7-.9 1.3v.7c-.1.4-.3.5-.5.5zm-.9-11c-1.4 0-2.7 1.1-2.7 2.5 0 1.5 1.1 2.7 2.5 2.7 1.5 0 2.7-1.1 2.7-2.5.1-1.5-1-2.7-2.5-2.7z","fill":"#aaa"}})])}}};

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14.3 15.2c.8.4 1.6.6 2.6.4-.1.1-.1.2-.2.2L14 18.5c-1.2 1.2-2.7 1.8-4.4 1.3-3.1-.9-3.9-4.6-1.7-7 .9-1 1.9-1.9 2.8-2.8.4-.4.8-.8 1.2-1.1 1.6-1.2 3.9-1.2 5.3 0 .6.5.7 1.2.3 1.7-.4.5-1.1.5-1.7 0-.9-.7-2-.6-2.9.3-1.2 1.1-2.3 2.3-3.4 3.4-.2.2-.3.3-.4.5-.3.5-.4 1-.3 1.5.2 1.1 1.4 1.7 2.4 1.3.4-.2.8-.4 1.2-.7.7-.5 1.2-1.1 1.9-1.7-.1 0 0 0 0 0z","fill":"#aaa"}}),_c('path',{attrs:{"d":"M16.7 7.2c-1-.2-1.8-.3-2.6-.5l.2-.2 2.8-2.8c1.7-1.6 4.1-1.7 5.7-.3 1.8 1.5 1.9 4.2.3 6-1.2 1.4-2.6 2.6-3.9 3.9-1.6 1.5-4 1.5-5.6.2-.2-.2-.4-.5-.5-.8-.1-.5.1-.9.5-1.1.4-.2.8-.2 1.2.1 1.3.9 2.2.8 3.3-.3l3.2-3.2c.4-.5.7-1.1.7-1.8-.1-1.4-1.6-2.2-2.9-1.5-.3.2-.5.4-.8.6-.5.6-1.1 1.2-1.6 1.7z","fill":"#aaa"}})])}}};

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15.9 19.6l-2.4-.1c-.2 0-.4-.2-.4-.4v-.7c0-.5-.3-1.1-.8-1.3-.2-.1-.3-.1-.5-.1-.4 0-.8.1-1.1.4l-.5.5c-.1.1-.2.1-.3.1-.1 0-.2-.1-.3-.1L8 16.1c-.2-.2-.2-.4 0-.6l.5-.5c.4-.4.6-1 .4-1.5-.2-.5-.7-.9-1.3-.9h-.7c-.2 0-.4-.2-.4-.4l.1-2.4c0-.2.2-.4.4-.4h.7c.5 0 1.1-.3 1.3-.8.3-.5.2-1.2-.2-1.6l-.5-.5c-.2-.2-.2-.4 0-.6l1.8-1.6c.1-.1.2-.1.3-.1.1 0 .2.1.3.1l.5.5c.2.3.6.4 1 .4.2 0 .3 0 .5-.1.5-.2.9-.7.9-1.3v-.7c0-.2.2-.4.4-.4l2.4.1c.2 0 .4.2.4.4v.7c0 .5.3 1.1.8 1.3.1.1.3.1.5.1.4 0 .8-.1 1.1-.4l.5-.5c.1-.1.2-.1.3-.1.1 0 .2.1.3.1l1.6 1.8c.2.2.1.4 0 .6l-.5.5c-.4.4-.6 1-.4 1.5.2.5.7.9 1.3.9h.7c.2 0 .4.2.4.4l-.1 2.4c0 .2-.2.4-.4.4h-.7c-.5 0-1.1.3-1.3.8-.2.5-.1 1.1.3 1.5l.5.5c.2.2.2.4 0 .6l-1.8 1.6c-.1.1-.2.1-.3.1-.1 0-.2-.1-.3-.1l-.5-.5c-.2-.3-.6-.4-1-.4-.2 0-.3 0-.5.1-.5.2-.9.7-.9 1.3v.7c-.1.4-.3.5-.5.5zm-.9-11c-1.4 0-2.7 1.1-2.7 2.5 0 1.5 1.1 2.7 2.5 2.7 1.5 0 2.7-1.1 2.7-2.5.1-1.5-1-2.7-2.5-2.7z","fill":"#aaa"}})])}}};

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 3v16h22V3H4zm8 14v-6h-2v6H6v-6h2V9H6V5h12v6h2V5h4v5h-2v2h2v5H12z","fill":"#b2b2b2"}})])}}};

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.1 18.4H1.5l9.7-14.8h11.6z","fill":"#aaa"}}),_c('path',{attrs:{"d":"M18.8 18.4H7.2l9.7-14.8h11.6z","fill":"#aaa"}})])}}};

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18 21.5c-3.5 0-6.3-3.1-6.3-7.1 0-4 5.6-10.7 5.9-11L18 3l.4.5c.2.3 5.9 7 5.9 11 0 3.9-2.8 7-6.3 7zm0-16.9c-1.3 1.6-5.3 6.8-5.3 9.9 0 3.5 2.3 6.1 5.3 6.1s5.3-2.6 5.3-6.1c0-3.1-4-8.3-5.3-9.9z","fill":"#fff"}})])}}};

/***/ }),
/* 793 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18.6 6.9l-4 4.9-7.9-9.3-3.5 2.7 8.6 10.1-5.3 6.5h23.8l3.2-6.6-14.9-8.3zm11 14h-21l3.9-4.7.6.8 6 3.6-2.4-6.3-1.3-1.5L19 8.4l13.3 7.5-2.7 5z","fill":"#fff"}})])}}};

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16.3 7.9l-4.7-5.4L8 5.1l2.4 2.8H8v13h21v-13H16.3zM9 8.9h2.3l6.6 7.7 5.6 3.3H9v-11zm19 11h-4.2l-2.3-6-4.3-5H28v11z","fill":"#fff"}})])}}};

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"fill":"#FFF","xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 512 512"}},[_c('g',{attrs:{"transform":"matrix(.8 0 0 .8 1.6 0)"}},[_c('title',[_v("eraser")]),_c('path',{attrs:{"d":"M509.42 69.18a12.3 12.3 0 0 0-9.77-4.81H254.73a12.18 12.18 0 0 0-6.16 1.72l-.42-.37L41.63 284l-2.19 2.46.26.31a10.6 10.6 0 0 0-1 2.51L.41 432.16a12.31 12.31 0 0 0 11.91 15.46h245c3.92 0 7.42-1.67 11-5.28l201.45-213.4a20.06 20.06 0 0 0 3.55-6.22l36.93-137.87 1.36-5a12.37 12.37 0 0 0-2.19-10.67zM279.55 304.74l-31.71 118.33H28.31L60 304.74h219.55zM473.06 88.93L292.19 280.14h-213L260 88.93h213z"}})])])}}};

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18 2.7l2.2 3.1h-4.4zM7.3 12l3.2-2.2v4.4zM18 21.9l-2.2-3.2h4.4zM28.7 12l-3.2 2.2V9.8z","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.5 11.5h17.1v1H9.5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.5 3.7h1v17.1h-1z","fill":"#fff"}})])}}};

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.7 13.2L15 21.7v-5.3h7.7c1.4 0 2.5-1.3 2.5-2.9V13c0-1.6-1.1-2.9-2.5-2.9H15V4.6L4.7 13.2z","fill":"#bf0049"}})])}}};

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20.3 2.4c-4 0-7.2 3.2-7.2 7.1 0 1.6.5 3.1 1.5 4.3l-6.1 6s-.1 2 1.8 1.8c.2-.2 6.2-6.1 6.2-6.1 1.1.7 2.5 1.1 3.9 1.1 4 0 7.2-3.2 7.2-7.1 0-3.9-3.3-7.1-7.3-7.1zm0 13.2c-3.4 0-6.2-2.7-6.2-6s2.8-6 6.2-6c3.4 0 6.2 2.7 6.2 6 0 3.2-2.8 6-6.2 6z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.1 8.4h1.8V6.7c0-.4.3-.7.7-.7h.9c.4 0 .7.3.7.7v1.8H23c.4 0 .7.3.7.7v.8c0 .4-.3.7-.7.7h-1.8v1.8c0 .4-.3.7-.7.7h-.9c-.4 0-.7-.3-.7-.7v-1.8h-1.8c-.4 0-.7-.3-.7-.7v-.8c0-.4.4-.8.7-.8z","fill":"#fff"}})])}}};

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M21.4 13.8c.9-1.2 1.4-2.6 1.4-4.2 0-3.9-3.2-7-7.1-7-3.9 0-7.1 3.1-7.1 7s3.2 7 7.1 7c1.4 0 2.7-.4 3.9-1.1 0 0 5.9 5.7 6.1 6 1.9.2 1.8-1.8 1.8-1.8l-6.1-5.9zM9.7 9.6c0-3.3 2.7-5.9 6.1-5.9 3.3 0 6.1 2.7 6.1 5.9 0 3.3-2.7 5.9-6.1 5.9-3.4 0-6.1-2.7-6.1-5.9z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.9 8.5h-6.4c-.4 0-.8.4-.8.8v1c0 .4.4.8.8.8h6.4c.4 0 .8-.4.8-.8v-1c0-.4-.3-.8-.8-.8z","fill":"#fff"}})])}}};

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	module.exports = {render: function () {with(this){return _c('svg',{attrs:{"fill":"#FFF","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 256"}},[_c('path',{attrs:{"d":"M201.896 183.169l-53.23-53.23a71.682 71.682 0 0 1-18.728 18.727l53.23 53.23a9 9 0 0 0 12.729 0l6-6a9 9 0 0 0 0-12.727z"}}),_c('path',{attrs:{"d":"M153.668 89.768c0-35.234-28.666-63.9-63.901-63.9-35.234 0-63.9 28.666-63.9 63.9 0 35.234 28.666 63.9 63.9 63.9 35.236 0 63.9-28.666 63.9-63.9zm-63.9 48.6c-26.84 0-48.6-21.76-48.6-48.6s21.76-48.6 48.6-48.6c26.841 0 48.6 21.76 48.6 48.6s-21.759 48.6-48.6 48.6z"}}),_c('path',{attrs:{"d":"M63 117h54V63H63v54zm10.8-43.2h32.4v32.4H73.8V73.8z"}})])}}};

/***/ }),
/* 801 */,
/* 802 */,
/* 803 */
/***/ (function(module, exports) {

	module.exports = {XMLHttpRequest:XMLHttpRequest};

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.74ac4ec76d1754caf548.js